import React, { Component, createRef } from 'react';

// import { InsuranceDetailsSchemaSchema } from '../../../../schema/add-user';
import {
    roomtypeSchema,
    includesSchema, excludesSchema, excludesAddMoreSchema, basicDetailsSchema, signatureSchema,
} from './../../../schema/new-estimate-charges-cash';
import {
    InsuranceDetailsSchema, estimateBreakupFormatSchema, addonSchema, additionalProcedureSchema, preexistingConditionsSchema,
    basicSumInsuredSchema, ailmentSchema, interimSchema, additionalPackageSchema, nmePopupSchema
} from '../../../schema/insurance-form';
import Formcomponent from '../../../components/version2form_component';
import Tableantd from '../../../components/version2form_component/table/antd';
import hideInEXStore from './../../../reduxStore/dataEvent';
import rootReduxStore from './../../../reduxStore/rootStore';
import losReduxStore from '../../../reduxStore/losStore';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
// import CustomLoader from '../../../components/loader';
import { Modal, Spin, Select, Input, Tooltip, } from 'antd';
import Storage from '../../../services/local-store';
import moment from 'moment';
import bcrypt from 'bcryptjs';
import { optionsStore, excludesTableStore, excludesUpdateTableStore } from './../../../selectStore.jsx'
import { ConsoleSqlOutlined } from '@ant-design/icons';
import InsurancePreview from './insurance_preview';
import userTrackService from '../../../services/usertrack-service';
import html2PDF from 'jspdf-html2canvas';
import formDataPostService from '../../../services/httpformData';
import PatientCheckList_preview from './patientCheckln_preview';
const { base_url, getDigitalSignInfoByToken, sendDigitalSignLink, } = networkList;

const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};

const $ = require('jquery');
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2];
let dollarIndianLocale = Intl.NumberFormat('en-IN');
class Insurance_form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            'InsuranceDetailsSchema': JSON.parse(JSON.stringify(InsuranceDetailsSchema['feilds'])),
            'estimateBreakupFormatSchema': JSON.parse(JSON.stringify(estimateBreakupFormatSchema['feilds'])),
            'addonSchema': addonSchema['feilds'],
            roomtypeSchema: roomtypeSchema['feilds'],
            includesSchema: includesSchema['feilds'],
            excludesSchema: excludesSchema['feilds'],
            excludesAddMoreSchema: excludesAddMoreSchema['feilds'],
            additionalProcedureSchema: additionalProcedureSchema['feilds'],
            additionalPackageSchema: additionalPackageSchema['feilds'],
            preexistingConditionsSchema: preexistingConditionsSchema['feilds'],
            basicSumInsuredSchema: JSON.parse(JSON.stringify(basicSumInsuredSchema['feilds'])),
            ailmentSchema: ailmentSchema['feilds'],
            interimSchema: interimSchema['feilds'],
            form_openn: 'insurance',
            showPreExConditions: false,
            showAilment: false,
            showPackage: false,
            showAddprocedure: false,
            addText: '',
            pre_link: '',
            formFeilds: [],
            modal1Visible: false, // includes
            modal2Visible: false, // Excludes
            modal3Visible: false, // Rooms
            signModalVisible: false, // signature
            signModal2Visible: false, // signature
            img: false,
            img2: false,
            view_mode: false,
            total_estimate_amount: 0,
            includes_data: [],
            excludes_datarecounselling: [],
            inc_excludes_pack_id: [],
            inc_excludes_packages_ids: [],
            showEstimate: null,
            exculude_options: [],
            nmePopupSchema: [],
            inital_package_amount: 0,
            hideingEstimatbutton: true,
            MasterRoutineEstimates: {},
            configuration: [],
            nme_total_amount: 0,
            exclude_total_amount: 0,
            exludesiders: [],
            exludesconcatdata: [],
            packages_IN_EX: [],
            Insuranceerrors: [],
            basicsuminsureerrors: [],
            esterrors: [],
            ailmenteerrors: [],
            preview_modal: false,
            preview_PatientCheckin_model:false,
            preview_data: {},
            fc1_total_estimate_amount: 0,
            includearrya: [],
            additional_package_percent1: 0,
            additional_package_percent2: 0,
            room_upgrade_reasons: 0,
            allPackage: [],
            finalSubmit:false,
            Insu_Physician_Fees_ICU:0,
            consutations:[],
            slugforexcludedropdown:'',
            // 'nmePopupSchema': nmePopupSchema['feilds'],
            // basic_info: {}
            signatureSchema: signatureSchema['feilds'],
            signatureModal: false,
            generatedLink: null,
            isPreviewAttachments:false,
            previewFile: null,
            isGenerateSign: null,
            digital_sig_imgpath: null,
            patient_digsign_willing: null,
            insurance_total_estimation_date:"22-07-2023",
            enableCheckBox: false,
            nmeInfo: 5000,
            otp: Array(this.props.length).fill(''),
            showSuccessModal: false,
            errorMessage: '',
            showButtons: false,
            showInputFeilds: false,
            showLinks: false,
            otpLink: false,
            otpSent: false,
            patient_validate: false,
            checkboxDisabled: false,
            insurance_company_mou_flag: null,
            insuranceCompanyName: null,
            isModalShown: false,
        }
        this.timeoutId = null;
        //this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.carousel = React.createRef();
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }

    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible });
    }

    setModal2Visible(modal2Visible) {
        this.setState({ modal2Visible });
    }

    setModal3Visible(modal3Visible) {
        this.setState({ modal3Visible });
    }

    signModal(signModalVisible) {
        this.setState({ signModalVisible });
    }
    signsuccess() {
        this.signModal(false);
        this.setState({ img: true })
    }
    sign2Modal(signModal2Visible) {
        this.setState({ signModal2Visible });
    }
    sign2success() {
        this.sign2Modal(false);
        this.setState({ img2: true })
    }
    
    async componentDidMount() {
        let { counselling_details, basic_info } = this.props;
        hideInEXStore.subscribe(
            () => {
                const nme = hideInEXStore.getState();
                this.setState((state) => ({ nmePopupSchema: nme.nmePopupSchema, nmeInfo: nme.nmeInfo?nme.nmeInfo: 5000 }),
                    () => {
                        this.buttonClick4();
                        this.total_suming();
                    });
            });
        excludesTableStore.subscribe(() => {
            this.total_suming();
            const exludesider = excludesTableStore.getState();
            this.setState((state) => ({ exludesiders: exludesider.data }),
                () => {
                    this.total_suming();
                })

        });
        this.total_suming();
        console.log('basic_info insurance:', this.props.basic_info)
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const cd = params.get('cd');
        const locst = this.props.history.location.state;
        const est_date_of_admis = (locst && locst['est_admis_date']) ? locst['est_admis_date'] : null;
        console.log('est_date_of_admis:', est_date_of_admis)
        const est_admis_date = localStorage.getItem('est_admis_date');
        this.setState({ error_message: '', error_view: false });

        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
            if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE']) ){
                console.log('ttest');
             }else{
                 slug = 'finanical-counselling'; 
             }
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }
        await this.setState({slugforexcludedropdown:slug});
        // moment(data.RemedinetInsuranceStatus[0].preauth_submited_time).format('DD-MM-YYYY hh:mm A')
        switch (slug) {

            case 'view-finanical-counselling': {

                let { counselling_details } = this.props;
                let { estimation, additional_packages, additional_procedures, ailment_capping, interm_approval, pre_existing_condition } = counselling_details
                Storage.remove('fc_checklist_verified');
                this.setState({ view_details: false, loadding: true });
                let { addonSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, basicSumInsuredSchema, ailmentSchema, interimSchema, inital_package_amount, preexistingConditionsSchema, exclude_total_amount, includesSchema } = this.state;
                // Clear data starts
                estimateBreakupFormatSchema.map((feild, key) => {
                    feild.value = null;
                    feild.text = null;
                })
                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            if (table_name === 'room_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ip_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            // if (table_name === 'drug_admin_charges') {
                            //     if (feild.key_word === 'routine') {
                            //         if (sub_feild.name === 'qty') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'rate') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'amount') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //     }
                            // }
                            if (table_name === 'general_equipment_charges') {
                                if (feild.key_word === 'routine') {
                                    // if (sub_feild.name === 'general_highend_equipments') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ins_hospital_services') {
                                if (feild.key_word === 'mrd') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'room_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }

                                }
                            }
                            if (table_name === 'ins_physiotherapy_diet_charges') {
                                if (feild.key_word === 'dietician') {
                                    if (sub_feild.name === 'dietician') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(1, 3)
                                }
                            }
                            if (table_name === 'surgical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })
                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    additionalPackageSchema[key].Specification.table_body.length = 0;
                    
                })

                ailmentSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    ailmentSchema[key].Specification.add_more = true;
                    ailmentSchema[key].Specification.table_body.length = 0;
                })
                interimSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    interimSchema[key].Specification.add_more = true;
                    interimSchema[key].Specification.table_body.length = 0;
                })
                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    additionalProcedureSchema[key].Specification.table_body.length = 0;
                })

                preexistingConditionsSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.key_word !== "add_more") {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (feild.id === 1) {
                                    if (sub_feild.name === 'pre_ex_condition_name') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'onset_date') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                    } if (sub_feild.name === 'sum_insured_onset_Date') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                    } if (sub_feild.name === 'consider_si') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                    }
                                }
                                if (feild.id === 2) {
                                    if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                    }
                                    if (sub_feild.name === 'consider_si') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;

                                    }
                                }
                            })
                        } else {
                            preexistingConditionsSchema[key].Specification.table_body.splice(table_key, 1)
                        }

                    })
                })
                includesSchema.map((subTable, key) => {
                    subTable['title'] = '';
                    subTable['name'] = '';
                    if (includesSchema[key].id === 1) {
                        if (includesSchema[key].Specification.table_body.length > 0) {
                            includesSchema[key].Specification.table_body.length = 0;
                        }
                    } else {
                        includesSchema.splice(1, includesSchema.length)
                    }
                })
                this.setState({ includesSchema });

                // Clear data ends
                InsuranceDetailsSchema.map((feild, key) => {
                    if (feild.name === 'estimated_admission_date') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['e_date_of_admission'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['e_date_of_admission'];
                    }
                    if (feild.name === 'actual_admission_date') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['actual_date_of_admission'];
                    }
                    if (feild.name === 'diagnosis') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['diagnosis'];
                    }
                    if (feild.name === 'type_of_patient') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['type_of_patient_id'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['type_of_patient_name'];
                    }
                    if (feild.name === 'type_insurance') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['type_of_insurance'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['type_of_insurance_name'];
                        console.log('patientType1::::', InsuranceDetailsSchema[key]['text']);

                        if (counselling_details['type_of_insurance_name'] === 'Retail') {

                            console.log(preexistingConditionsSchema);
                            preexistingConditionsSchema[0].visible = true;
                            this.setState({ showPreExConditions: true });
                        } else {
                            preexistingConditionsSchema[0].visible = false;
                            this.setState({ showPreExConditions: false });
                        }
                    }
                    if (feild.name === 'insurance_status') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['insurance_status_id'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['insurance_status_name'];
                    }
                    if (feild.name === 'reason_if_denied') {
                        if (counselling_details['insurance_denied_reason']) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['insurance_denied_reason'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild.name === 'tpa_name') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['tpa_name'];
                    }
                    if (feild.name === 'insurance_company_name') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['insurance_company_name'];
                        InsuranceDetailsSchema[key]['tariff_mapped'] = counselling_details['tariff_mapped'];
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }
                    if (feild.name === 'employer_name_company') {
                        if (counselling_details['type_of_insurance_name'] && counselling_details['type_of_insurance_name'] === 'Corporate') {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['corporate_name'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild.name === 'policy_no') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['policy_number'];
                    }

                    if (feild.name === 'care_management') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['care_management'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['care_management_name'];
                        if (counselling_details['care_management']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (counselling_details['care_management'] == 1) { //medical
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                    }
                    if (counselling_details['care_management'] == 2) { //surgery
                        this.setState({ showAddprocedure: true })
                    }
                    if (counselling_details['estimate_type'] == 1) { //package
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
                        this.setState({ showPackage: true })
                    }
                    if (counselling_details['ailment_capping'] && counselling_details['ailment_capping'].length > 0) {
                        this.setState({ showAilment: true })
                    }
                    if (counselling_details['estimate_type'] == 2) { //nonpackage
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                    }
                    if (feild.name === 'estimate_type') {
                        if (counselling_details['estimate_type_name']) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['estimate_type'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['estimate_type_name'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        if (counselling_details['estimate_type']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['package_name'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['package_name'];
                        InsuranceDetailsSchema[key]['amount'] = counselling_details['package_amt'];
                        InsuranceDetailsSchema[key]['visible'] = true;
                        inital_package_amount = counselling_details['package_amt'];
                        if (counselling_details['package_id']) {
                            this.getExcludesIncludes(parseInt(counselling_details['package_id']), counselling_details['package_name'], 0);
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['length_of_stay'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['length_of_stay'];
                        if (counselling_details['length_of_stay']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'icu_stay') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['icu_stay'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['icu_stay'];
                        if (counselling_details['icu_stay']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_stay') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['room_stay'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['room_stay'];
                        if (counselling_details['room_stay']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'date_of_surgery') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['date_of_surgery'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['date_of_surgery'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }

                    }
                    if (feild.name === 'ins_surgery_procedure_name') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['surgery_procedure_id'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['procedure_name'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        if (counselling_details['surgery_procedure_id']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'ins_surgery_procedure_amount') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['surgery_procedure_amt'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['surgery_procedure_amt'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        if (counselling_details['surgery_procedure_amount']) {
                            // this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'ins_surgery_percent') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['surgery_procedure_percent'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['surgery_procedure_percent'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                    }
                })
                basicSumInsuredSchema.map((feild, key) => {
                    basicSumInsuredSchema[key]['disable'] = true
                    if (feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            basicSumInsuredSchema[key]['data'][sub_key]['disable'] = true
                        })
                    }
                    if (feild.name === 'basic_sum_insured') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['basic_sum_insured'];

                    }
                    if (feild.name === 'top_up_amount') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['buffer_top_up'];
                    }
                    if (feild.name === 'balance_sum_insured') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['balance_sum_insured'];
                    }
                    if (feild.name === 'ins_co_pay' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_copay_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['copay_percent'];
                            }
                            if (sub_feild.name === 'ins_copay_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['copay_amount'];
                            }
                        })
                    }
                    if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_percent'];
                            }
                            if (sub_feild.name === 'ins_room_eligible_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_amount'];
                            }
                        })
                    }
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['room_eligible_ward_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['room_eligible_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['room_eligible_ward_amount'];
                                basicSumInsuredSchema[key]['data'][sub_key]['package_charges']=counselling_details['main_package_actual_price'];
                            }
                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_ward_amount'];
                            }
                        })
                    }
                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['upgrade_room_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['upgrade_room_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['upgrade_room_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['upgrade_room_amount'];
                                basicSumInsuredSchema[key]['data'][sub_key]['package_charges']=counselling_details['upgrade_package_price'];
                            }
                            if (sub_feild.name === 'ins_upgrade_room_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['upgrade_room_amount'];
                            }
                        })
                    }
                    if (feild.name === 'ins_icu_eligible' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_eligible_percent'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['icu_eligible_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['icu_eligible_percent'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['icu_eligible_amount'];
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_eligible_amount'];
                            }
                        })
                    }
                    if (feild.name === 'ins_icu' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_type') {

                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['icu_ward_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['icu_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['icu_ward_amt'];
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_ward_amt'];
                            }
                        })
                    }
                    if (counselling_details['care_management'] == 1 || (counselling_details['care_management'] == 2 && counselling_details['estimate_type'] == 2) || (counselling_details['care_management'] == 2 && counselling_details['estimate_type'] !== 1)) {
                        if (feild.name === 'ins_select_difference') {
                            if (counselling_details['room_differance']!=="0.00") {
                                basicSumInsuredSchema[key]['value'] = '1';
                                basicSumInsuredSchema[key]['text'] = 'Room Difference';
                                basicSumInsuredSchema[key]['id'] = 1;
                                basicSumInsuredSchema[key]['visible'] = true;
                            }
                            if (counselling_details['pro_rata_differance']!=="0.00") {
                                basicSumInsuredSchema[key]['value'] = '2';
                                basicSumInsuredSchema[key]['text'] = 'Pro Rate Difference';
                                basicSumInsuredSchema[key]['id'] = 2;
                                basicSumInsuredSchema[key]['visible'] = true;
                            }
                            this.insurance_total();
                        }
                        if (feild.name === 'ins_room_difference_amount' && counselling_details['room_differance']!=="0.00") {
                            basicSumInsuredSchema[key]['value'] = counselling_details['room_differance'];
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                        if (feild.name === 'ins_pro_rata_difference_amount' && counselling_details['pro_rata_differance']!=="0.00") {
                            basicSumInsuredSchema[key]['value'] = counselling_details['pro_rata_differance'];
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                    }else{
                        if (feild.name === 'ins_select_difference') {
                            if (counselling_details['room_differance']==="0.00") {
                              
                                basicSumInsuredSchema[key]['visible'] = false;
                            }
                            if (counselling_details['pro_rata_differance']==="0.00") {
                               
                                basicSumInsuredSchema[key]['visible'] = false;
                            }
                            
                        }
                        if (feild.name === 'ins_room_difference_amount' && counselling_details['room_differance']) {
                            basicSumInsuredSchema[key]['visible'] = false;
                        }
                        if (feild.name === 'ins_pro_rata_difference_amount' && counselling_details['pro_rata_differance']) {
                            basicSumInsuredSchema[key]['visible'] = false;
                        }
                    }
                    if (feild.name === 'ins_icu_difference') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['icu_difference_amt'];
                    }
                    if (counselling_details['estimate_type'] == 1) {
                        if (feild.name === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['value'] = counselling_details['package_differance'];
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                    }
                    if (feild.name === 'ins_ailment_capping') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['ailment_capping_status'];
                        basicSumInsuredSchema[key]['text'] = counselling_details['ailment_capping_status_name'];
                        if (counselling_details['ailment_capping_status'] == 1) {
                            this.setState({ showAilment: true })
                        } else {
                            this.setState({ showAilment: false })
                        }
                    }
                    if (counselling_details['upgrade_room_amount']) {
                        if (feild.name === 'ins_room_upgrade_reason') {
                            basicSumInsuredSchema[key]['value'] = counselling_details['room_upgrade_reason'];
                            basicSumInsuredSchema[key]['text'] = counselling_details['room_upgrade_reason_name'];
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                    }

                })
                if (additional_packages.length > 0) {
                    additionalPackageSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalPackageSchema[secKey].visible = true;
                            additional_packages.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "ins_additional_package_name") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['package_id']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['package_name']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['amount']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalPackageSchema[secKey].Specification.table_body[additionalPackageSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id;
                                if (last_element === undefined) {
                                    last_id = packages_key;
                                }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "ins_additional_package_name") {
                                        obj['feilds'][key]['value'] = packages['package_id'];
                                        obj['feilds'][key]['text'] = packages['package_name'];
                                        obj['feilds'][key]['disable'] = true;
                                    }
                                    if (feild.name === "actualprice") {
                                        obj['feilds'][key]['value'] = packages['actual_price'];
                                        obj['feilds'][key]['text'] = packages['actual_price'];
                                        
                                    }
                                    if (feild.name === "percentage" ) {
                                        obj['feilds'][key]['value'] = packages['package_percentage'];
                                        obj['feilds'][key]['text'] = packages['package_percentage'];
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = packages['amount'];
                                        obj['feilds'][key]['text'] = packages['amount'];
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // alert('came');
                                this.getExcludesIncludes(parseInt(packages['package_id']), packages['package_name'], 1);

                                // }
                            })
                        }
                    })
                }
                else {
                    additionalPackageSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalPackageSchema[secKey].visible = false;
                        }
                    })
                }

                if (additional_procedures) {
                    additionalProcedureSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalProcedureSchema[secKey].visible = true;
                            additional_procedures.map((procedures, procedures_key) => {
                                // if (procedures_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "ins_add_procedure_name") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['procedure_id']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['procedure_name']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //                 delete additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['service']
                                //                 delete additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['header']
                                //                 delete additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['sub_header']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['amount']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalProcedureSchema[secKey].Specification.table_body[additionalProcedureSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id;
                                if (last_element === undefined) {
                                    last_id = procedures_key+1;
                                }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    delete obj['feilds'][key]['service']
                                    delete obj['feilds'][key]['header']
                                    delete obj['feilds'][key]['sub_header']
                                    if (feild.name === "ins_add_procedure_name") {
                                        obj['feilds'][key]['value'] = procedures['procedure_id'];
                                        obj['feilds'][key]['text'] = procedures['procedure_name'];
                                        obj['feilds'][key]['disable'] = true;
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = procedures['amount'];
                                        obj['feilds'][key]['text'] = procedures['amount'];
                                        obj['feilds'][key]['disable'] = true;
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }

                if (ailment_capping) {
                    ailmentSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            ailmentSchema[secKey].visible = true;
                            ailment_capping.map((procedures, procedures_key) => {
                                // if (procedures_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "ins_ail_surgery_procedure_name") {
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['surgery_id']
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['surgery_id_value']
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //                 delete ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['service']
                                //                 delete ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['header']
                                //                 delete ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['sub_header']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['surgery_amount']
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['surgery_amount']
                                //             }
                                //             if (feilds.name === "action") {
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['element'] = 'text';
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                    let last_element = ailmentSchema[secKey].Specification.table_body[ailmentSchema[secKey].Specification.table_body.length - 1];
                                    // let last_id = last_element['id'];
                                    let last_id
                                    if (last_element === undefined) {
                                        last_id = procedures_key;
                                    }

                                    let obj = {
                                        "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                        id: last_id,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = last_id + 1;
                                        if (feild.name === "ins_ail_surgery_procedure_name") {
                                            obj['feilds'][key]['value'] = procedures['surgery_id'];
                                            obj['feilds'][key]['text'] = procedures['surgery_id_value'];
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = procedures['surgery_amount'];
                                            obj['feilds'][key]['text'] = procedures['surgery_amount'];
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "action") {
                                            obj['feilds'][key]['element'] = 'text';
                                        }
                                    })
                                    data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }

                if (interm_approval) {
                    interimSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            interimSchema[secKey].visible = true;
                            interm_approval.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "interim_approval_amount") {
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['interim_amount']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['interim_amount']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //             }
                                //             if (feilds.name === "approx_bill_amount") {
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['approx_bill']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['approx_bill']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //             }
                                //             if (feilds.name === "case_no") {
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['case_no']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['case_no']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = interimSchema[secKey].Specification.table_body[interimSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id
                                if (last_element === undefined) {
                                    last_id = packages_key;
                                }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "interim_approval_amount") {
                                        obj['feilds'][key]['value'] = packages['interim_amount']
                                        obj['feilds'][key]['text'] = packages['interim_amount']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "approx_bill_amount") {
                                        obj['feilds'][key]['text'] = packages['approx_bill']
                                        obj['feilds'][key]['value'] = packages['approx_bill']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "case_no") {
                                        obj['feilds'][key]['text'] = packages['case_no']
                                        obj['feilds'][key]['value'] = packages['case_no']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }
                if (pre_existing_condition) {
                    preexistingConditionsSchema.map((subTable, key) => {
                        preexistingConditionsSchema[key].visible = true;
                        let table_body = subTable.Specification.table_body;
                        pre_existing_condition.map((preExist, preExistkey) => {
                            if (preExistkey === 0) {
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (feild.id === 1) {
                                            if (sub_feild.name === 'pre_ex_condition_name') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['condition_name'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['condition_name_value'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            }
                                            if (sub_feild.name === 'onset_date') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                            } if (sub_feild.name === 'sum_insured_onset_Date') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['sum_insured_onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['sum_insured_onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                            } if (sub_feild.name === 'consider_si') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['consider_sum_insured'] ? true : false;
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;

                                                // preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['consider_sum_insured'];

                                            }
                                        }
                                        if (feild.id === 2) {
                                            if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details['sum_insured_four_years_back_id'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details['sum_insured_four_years_back_id'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;


                                            }
                                            if (sub_feild.name === 'consider_si') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details['consider_si_four_years_back'] ? true : false;
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;

                                                // preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['condition_name'];   
                                            }
                                        }
                                    })
                                })
                            } else {

                                let last_element = preexistingConditionsSchema[key].Specification.table_body[interimSchema[key].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id
                                if (last_element === undefined) {
                                    last_id = preExistkey + 1;
                                }

                                let obj = {
                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                    id: last_id,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "pre_ex_condition_name") {
                                        obj['feilds'][key]['value'] = preExist['condition_name']
                                        obj['feilds'][key]['text'] = preExist['condition_name_value']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "onset_date") {
                                        obj['feilds'][key]['text'] = preExist['onset_data']
                                        obj['feilds'][key]['value'] = preExist['onset_data']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "sum_insured_onset_Date") {
                                        obj['feilds'][key]['text'] = preExist['sum_insured_onset_data']
                                        obj['feilds'][key]['value'] = preExist['sum_insured_onset_data']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "consider_si") {
                                        // obj['feilds'][key]['text'] = preExist['case_no']
                                        obj['feilds'][key]['value'] = preExist['consider_sum_insured'] ? true : false
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                subTable['Specification']['table_body'].push(obj);
                                // } 
                            }

                        })

                    })
                }

                console.log(preexistingConditionsSchema);

                if (estimation) {
                    addonSchema.map((subTable, key) => {
                        let service_ids = [];
                        let estimate_keys=[]

                        estimation.map((estimate, estimate_key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                if (estimate.header === subTable.header && feild.key_word === estimate.key_word && estimate.key_word !== 'add_more') {
                                    row.map((sub_feild, sub_table_key) => {
                                        // delete addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['service']
                                        // delete addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['header']
                                        // delete addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['sub_header']
                                        if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.name !== "action" && sub_feild.element!=='text') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['service']
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['service_name']
                                        }
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "rate") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                        }
                                        if (sub_feild.name === "percentage") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? (estimate['qty']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? (estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "amount") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                        }
                                    })
                                }
                                else if (estimate.header === subTable.header && estimate.key_word === 'add_more' && !estimate_keys.includes(estimate_key)) {
                                    const i_key = (addonSchema[key].Specification.table_body).length + 1;
                                    service_ids.push(estimate.service);
                                    estimate_keys.push(estimate_key)
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                        id: i_key,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                        // delete obj['feilds'][key]['service']
                                        // delete obj['feilds'][key]['header']
                                        // delete obj['feilds'][key]['sub_header']
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = i_key;
                                        if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action") {
                                            obj['feilds'][key]['value'] = estimate['service'];
                                            obj['feilds'][key]['text'] = estimate['service_name'];
                                        }
                                        if (feild.name === "qty") {
                                            obj['feilds'][key]['value'] = estimate['qty'];
                                            obj['feilds'][key]['text'] = estimate['qty'];
                                        }
                                        if (feild.name === "rate") {
                                            obj['feilds'][key]['value'] = estimate['rate'];
                                            obj['feilds'][key]['text'] = estimate['rate'];
                                        }
                                        if (feild.name === "percentage") {
                                            obj['feilds'][key]['value'] = estimate['qty'];
                                            obj['feilds'][key]['text'] = estimate['qty'];
                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = estimate['amount'];
                                            obj['feilds'][key]['text'] = estimate['amount'];
                                        }
                                        if (feild.name === "action") {
                                            obj['feilds'][key]['element'] = 'text';
                                        }
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                }
                            })
                        })
                        console.log('table_body', addonSchema[key].Specification.table_body);
                    })
                    addonSchema.map((subTable, key) => {
                        estimation.map((estimate, estimate_key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                })
                            })
                        })
                    })
                }

                if (counselling_details['care_management'] === 1) {     // 1 - mdeical, 2 - surgical
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === 'ins_surgical_charges') {
                            addonSchema[key].visible = false;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                })
                            })
                        }
                        if (subTable.name === 'ot_cath_pharmacy') {
                            addonSchema[key].visible = false;
                        }
                        if (subTable.name === 'ot_charges') {
                            addonSchema[key].visible = false;
                        }
                        if (subTable.name === 'ot_equipment') {
                            addonSchema[key].visible = false;
                        }
                        if (subTable.name === 'ins_medical_charges') {
                            addonSchema[key].visible = true;
                        }
                    })
                    this.setState({ showEstimate: false });
                }
                else {
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === 'ins_medical_charges') {
                            addonSchema[key].visible = false;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                })
                            })
                        }
                        if(subTable.name === 'ins_surgical_charges') {
                            addonSchema[key].visible = true;
                        }
                        if (subTable.name === 'ot_cath_pharmacy') {
                            addonSchema[key].visible = true;
                        }
                        if (subTable.name === 'ot_charges') {
                            addonSchema[key].visible = true;
                        }
                        if (subTable.name === 'ot_equipment') {
                            addonSchema[key].visible = true;
                        }
                    })
                }
                if (counselling_details['estimate_type'] === 1) {
                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_total_estimate_amount') {
                            estimateBreakupFormatSchema[key]['visible'] = true;
                            // estimateBreakupFormatSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'base_price') {
                            estimateBreakupFormatSchema[key]['visible'] = true;
                            // estimateBreakupFormatSchema[key]['value'] = null;
                        }
                    })
                    this.setState({ showEstimate: true, estimateBreakupFormatSchema, hideingEstimatbutton: false });
                } else {
                    this.setState({ showEstimate: false });
                }
                InsuranceDetailsSchema.map((feild, key) => {
                    InsuranceDetailsSchema[key]['disable'] = true;
                    // InsuranceDetailsSchema[key]['element'] = 'input';
                })


                let base_price = 0, excludes = 0, total_estimate_amount = 0;
                counselling_details['header_amount'].map((feild, key) => {
                    if (feild.base_price !== '' && feild.base_price !== null & feild.base_price !== undefined) {
                        base_price = feild.base_price;
                    }
                    if (feild.excludes !== '' && feild.excludes !== null & feild.excludes !== undefined) {
                        excludes = feild.excludes ? feild.excludes : 0;
                    }
                    if (feild.total_estimate_amount !== '' && feild.total_estimate_amount !== null & feild.total_estimate_amount !== undefined) {
                        total_estimate_amount = feild.total_estimate_amount;
                    }
                })

                estimateBreakupFormatSchema.map((feild, key) => {
                    estimateBreakupFormatSchema[key]['disable'] = true;
                    // estimateBreakupFormatSchema[key]['element'] = 'input';
                    if (feild.name === 'base_price') {
                        if (base_price) {
                            estimateBreakupFormatSchema[key]['value'] = base_price;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        } else {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                        }
                    }
                    if (feild.name === 'excludes') {
                        const examount = parseFloat(counselling_details['header_amount'] && counselling_details['header_amount'][0] ? counselling_details['header_amount'][0].excludes : 0)
                        estimateBreakupFormatSchema[key]['value'] = examount ? examount : 0;
                        estimateBreakupFormatSchema[key]['text'] = examount ? examount : 0;
                        this.setState({ exclude_total_amount: examount ? examount : 0 });
                    }
                    if (feild.name === 'initial_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['initial_approval_amount'];
                    }
                    if (feild.name === 'co_pay_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['copay_amount'];
                    }
                    if (feild.name === 'estimated_nme_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['nme_amount'];
                    }
                    if (feild.name === 'actual_nme_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['actual_nme_amount'];
                    }
                    if (feild.name === 'final_bill_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['final_bill_amount'];
                    }
                    if (feild.name === 'final_approval_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['final_approval_amount'];
                    }
                    if (feild.name === 'discount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['discount'];
                    }
                    if (feild.name === 'extra_deduction_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['extra_deduction'];
                    }
                    if (feild.name === 'remarks') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['remarks'];
                    }
                    if (feild.name === 'difference_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['differance_amount'];
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                    if (feild.name === 'ins_total_estimate_amount') {
                        estimateBreakupFormatSchema[key]['value'] = total_estimate_amount;
                    }
                    if (counselling_details['attendant_name']) {
                        if (feild.name === 'signature_of_patient_attendant') {
                            estimateBreakupFormatSchema[key]['value'] = 2;
                            estimateBreakupFormatSchema[key]['text'] = 'Attendant';
                        }
                    } else {
                        if (feild.name === 'signature_of_patient_attendant') {
                            estimateBreakupFormatSchema[key]['value'] = 1;
                            estimateBreakupFormatSchema[key]['text'] = 'Patient';
                        }
                    }
                    if (feild.name === 'attendant_name') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['attendant_name'];
                        estimateBreakupFormatSchema[key]['visible'] = counselling_details['attendant_name'] ? true : false;
                    }
                    if (feild.name === 'relation') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['patient_relation'];
                        estimateBreakupFormatSchema[key]['visible'] = counselling_details['patient_relation'] ? true : false;

                    }
                })

                InsuranceDetailsSchema.map((feild, key) => {
                    InsuranceDetailsSchema[key]['disable'] = true;
                })

                addonSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    addonSchema[key].Specification.add_more = false;
                })
                addonSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    addonSchema[key].Specification.add_more = false;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true
                            if (sub_feild.name === "action") {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["element"] = 'text'
                            }
                        })
                    })

                })
                // header amounts
                addonSchema.map((subTable, key) => {
                    if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                        let table_body = subTable.Specification.table_body;
                        let header_amount = 0;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                    // amount = parseFloat(amount) + parseFloat(sub_feild.value);
                                    header_amount = parseFloat(header_amount) + parseFloat(sub_feild.value);
                                }
                            })
                        })
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                })

                Storage.store('current_print', {
                    "counselling_id": counselling_details['counselling_id'],
                    "payment_type": counselling_details['payment_type_id'],
                    "care_management": counselling_details['care_management'],
                    "estimate_type": counselling_details['estimate_type']
                })
                hideInEXStore.dispatch({ type: 'NME_VIEW_DATA', data: { nme_view_data: counselling_details['NMEs'], status: true, page: 'view-finanical-counselling', nmeInfo: counselling_details['nme_extra_amount'] } })
                this.setState({ 'counselling_details': counselling_details, view_details: true, view_mode: true, addonSchema: addonSchema, InsuranceDetailsSchema: InsuranceDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, basicSumInsuredSchema: basicSumInsuredSchema, additionalProcedureSchema: additionalProcedureSchema, interimSchema: interimSchema, total_estimate_amount: total_estimate_amount, ailmentSchema: ailmentSchema, inital_package_amount, loadding: false, fc1_total_estimate_amount: total_estimate_amount }, () => {
                    if (counselling_details['excludes_data']) {
                        hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData: counselling_details['excludes_data']?counselling_details['excludes_data']:[], page: 'view-finanical-counselling' } })
                    }else{
                        hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData: [], page: 'view-finanical-counselling' } })
                    }
                    hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                });
                console.log('ins:', ailmentSchema)
            }
                break;
            case 'finanical-counselling': {
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema:[],los:null, status: true } })
                let { addonSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, excludesSchema, includesSchema, ailmentSchema, interimSchema, preexistingConditionsSchema,basicSumInsuredSchema } = this.state
                Storage.remove('fc_checklist_verified');
                this.setState({ showEstimate: true, loadding: true })
                InsuranceDetailsSchema.map((feild, key) => {
                    if (feild.name === 'estimated_admission_date') {
                        feild['value'] = est_date_of_admis ? moment(est_date_of_admis).format('YYYY-MM-DD') :est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):null;
                        // feild['disable'] = est_date_of_admis ? true : est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):false;
                    } else {
                        feild.value = null;
                    }
                })
                estimateBreakupFormatSchema.map((feild, key) => {
                    feild.value = null;
                    feild.text = null;
                    // if(feild.name === 'base_price'){

                    // }
                    // if(feild.name === 'excludes'){

                    // }
                    // if(feild.name === 'total_Estimate_amount'){

                    // }
                    // if(feild.name === 'name_of_the_fc'){
                    //     estimateBreakupFormatSchema[key]['value'] = JSON.parse(Storage.get('user'));
                    //     estimateBreakupFormatSchema[key]['text'] = JSON.parse(Storage.get('user'));
                    //     feild.disable = true;
                    // }
                    // if(feild.name === 'attendant_name'){
                    //     feild.disable = false;
                    // }
                    // if(feild.name === 'relation'){
                    //     feild.disable = false;
                    // }
                })
                basicSumInsuredSchema.map((feild, key) => {
                    feild.value = null;
                    feild.text = null;
                    if (feild['name'] === 'ins_package_difference') {
                        basicSumInsuredSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_select_difference') {
                        basicSumInsuredSchema[key]['value'] = null;
                    }
                    if (feild['name'] === "ins_room_difference_amount") {
                        basicSumInsuredSchema[key]['value'] = null;
                    }
                    if (feild['name'] === "ins_pro_rata_difference_amount") {
                        basicSumInsuredSchema[key]['value'] = null;
                    }
                    if (feild.name === 'ins_co_pay' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_copay_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
        
                            }
                            if (sub_feild.name === 'ins_copay_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = 0;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
        
                            }
                        })
                    }
                    if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null
                            }
                            if (sub_feild.name === 'ins_room_eligible_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                            }
                        })
                    }
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = null;
                            }
                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = null;
        
        
                            }
                        })
                    }
                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        // feild.data.length=0;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                            }
                            if (sub_feild.name === 'ins_upgrade_room_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = 0;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                            }
                        })
                    }
                    if (feild.name === 'ins_icu_eligible' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_percent') {
        
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                            }
                        })
                    }
                    if (feild.name === 'ins_icu' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_type') {
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = 0;
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
        
                            }
                        })
                    }
                    this.setState({ basicSumInsuredSchema: JSON.parse(JSON.stringify(basicSumInsuredSchema)) });
                })

                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            if (table_name === 'room_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ip_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }

                            if (table_name === 'general_equipment_charges') {
                                if (feild.key_word === 'routine') {
                                    // if (sub_feild.name === 'general_highend_equipments') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ins_hospital_services') {
                                if (feild.key_word === 'mrd') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'room_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }

                                }
                            }
                            if (table_name === 'ins_physiotherapy_diet_charges') {
                                if (feild.key_word === 'dietician') {
                                    if (sub_feild.name === 'dietician') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'surgical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })

                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    additionalPackageSchema[key].Specification.table_body.length=0;
                })

                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    additionalProcedureSchema[key].Specification.table_body.length=0;
                })
                ailmentSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    ailmentSchema[key].Specification.add_more = true;
                    ailmentSchema[key].Specification.table_body.length=0;
                })
                includesSchema.map((subTable, key) => {
                    if (includesSchema[key].id === 1) {
                        if (includesSchema[key].Specification.table_body.length > 0) {
                            includesSchema[key].Specification.table_body.length = 0;
                        }
                    } else {
                        includesSchema.splice(key, 1);
                    }
                })
                this.setState({ includesSchema });

                interimSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    interimSchema[key].Specification.add_more = true;
                    interimSchema[key].Specification.table_body.length=0;
                   
                })
                preexistingConditionsSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.key_word !== "add_more") {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (feild.id === 1) {
                                    if (sub_feild.name === 'pre_ex_condition_name') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    }
                                    if (sub_feild.name === 'onset_date') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    } if (sub_feild.name === 'sum_insured_onset_Date') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    } if (sub_feild.name === 'consider_si') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    }
                                }
                                if (feild.id === 2) {
                                    if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    }
                                    if (sub_feild.name === 'consider_si') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    }
                                }
                            })
                        } else {
                            preexistingConditionsSchema[key].Specification.table_body.splice(table_key, 1)
                        }

                    })
                })
                hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                hideInEXStore.dispatch({ type: 'NME_VIEW_DATA', data: { nme_view_data: [], status: true, page: 'finanical-counselling', nmeInfo: null } })
                hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })

                //rootReduxStore.dispatch({ type: 'INSURANCE_INFO', data:  {'InsuranceDetails': InsuranceDetailsSchema}})
                this.setState({ addonSchema: addonSchema, InsuranceDetailsSchema: InsuranceDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, interimSchema, ailmentSchema, loadding: false, preexistingConditionsSchema });
            }
                break;
            case 'recounselling': {
                // alert('recounselling')
                // let { counselling_details } = this.props;

                let { counselling_details,basic_info } = this.props;
                if(counselling_details['payment_type']==="Insurance"){
                let { estimation, additional_packages, additional_procedures, ailment_capping, interm_approval, pre_existing_condition } = counselling_details
                let { addonSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, basicSumInsuredSchema, ailmentSchema, interimSchema, inital_package_amount, preexistingConditionsSchema, includesSchema,allPackage } = this.state;
                this.setState({ showEstimate: false, loadding: true })
                estimateBreakupFormatSchema.map((feild, key) => {
                    feild.value = null;
                    feild.text = null;
                })
                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            if (table_name === 'room_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details &&counselling_details['room_stay']?counselling_details['room_stay']: null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details &&counselling_details['room_stay']?counselling_details['room_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details &&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details &&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ip_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details&&counselling_details['room_stay']?counselling_details['room_stay']: null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] =counselling_details&&counselling_details['room_stay']?counselling_details['room_stay']: null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details&&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details&&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            // if (table_name === 'drug_admin_charges') {
                            //     if (feild.key_word === 'routine') {
                            //         if (sub_feild.name === 'qty') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'rate') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'amount') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //     }
                            // }
                            if (table_name === 'general_equipment_charges') {
                                if (feild.key_word === 'routine') {
                                    // if (sub_feild.name === 'general_highend_equipments') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ins_hospital_services') {
                                if (feild.key_word === 'mrd') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'room_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details && counselling_details['room_stay']?counselling_details['room_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details && counselling_details['room_stay']?counselling_details['room_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details && counselling_details['room_stay']?counselling_details['room_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details && counselling_details['room_stay']?counselling_details['room_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }

                                }
                            }
                            if (table_name === 'ins_physiotherapy_diet_charges') {
                                if (feild.key_word === 'dietician') {
                                    if (sub_feild.name === 'dietician') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details && counselling_details['room_stay'] && counselling_details['icu_stay']?counselling_details['room_stay']+counselling_details['icu_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details && counselling_details['room_stay'] && counselling_details['icu_stay']?counselling_details['room_stay']+counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'surgical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })
                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    additionalPackageSchema[key].Specification.table_body.length = 0;
                    
                })

                ailmentSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    ailmentSchema[key].Specification.add_more = true;
                    ailmentSchema[key].Specification.table_body.length = 0;
                })
                interimSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    interimSchema[key].Specification.add_more = true;
                    interimSchema[key].Specification.table_body.length = 0;
                })
                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    additionalProcedureSchema[key].Specification.table_body.length = 0;
                })
                preexistingConditionsSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.key_word !== "add_more") {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (feild.id === 1) {
                                    if (sub_feild.name === 'pre_ex_condition_name') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    }
                                    if (sub_feild.name === 'onset_date') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;


                                    } if (sub_feild.name === 'sum_insured_onset_Date') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;


                                    } if (sub_feild.name === 'consider_si') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;


                                    }
                                }
                                if (feild.id === 2) {
                                    if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;


                                    }
                                    if (sub_feild.name === 'consider_si') {
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;

                                    }
                                }
                            })
                        } else {
                            preexistingConditionsSchema[key].Specification.table_body.splice(table_key, 1)
                        }

                    })
                })
                includesSchema.map((subTable, key) => {
                    if (includesSchema[key].id === 1) {
                        if (includesSchema[key].Specification.table_body.length > 0) {
                            includesSchema[key].Specification.table_body.length = 0;
                        }
                    } else {
                        includesSchema.splice(key, 1)
                    }
                })
                this.setState({ includesSchema });
                // clear data
               InsuranceDetailsSchema.map((feild, key) => {
                    if (feild.name === 'estimated_admission_date') {
                        InsuranceDetailsSchema[key]['value'] = est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):counselling_details['e_date_of_admission'];
                        InsuranceDetailsSchema[key]['text'] = est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):counselling_details['e_date_of_admission'];
                        // InsuranceDetailsSchema[key]['disable']=est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?true:false;
                        if (counselling_details['e_date_of_admission']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'actual_admission_date') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['a_date_of_admission'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['a_date_of_admission'];
                        if (counselling_details['a_date_of_admission']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }


                    if (feild.name === 'diagnosis') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['diagnosis'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['diagnosis'];
                        if (counselling_details['diagnosis']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'type_of_patient') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['type_of_patient_id'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['type_of_patient_name'];
                    }
                    if (feild.name === 'type_insurance') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['type_of_insurance'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['type_of_insurance_name'];
                        console.log('patientType2::::', InsuranceDetailsSchema[key]['text']);

                        if (counselling_details['type_of_insurance_name'] === 'Retail') {

                            console.log(preexistingConditionsSchema);
                            preexistingConditionsSchema[0].visible = true;
                            this.setState({ showPreExConditions: true });
                        } else {
                            preexistingConditionsSchema[0].visible = false;
                            this.setState({ showPreExConditions: false });
                        }
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }
                    if (feild.name === 'insurance_status') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['insurance_status_id'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['insurance_status_name'];
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }
                    if (feild.name === 'reason_if_denied') {
                        if (counselling_details['insurance_denied_reason']) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['insurance_denied_reason'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild.name === 'tpa_name') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['tpa_name'];
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }
                    if (feild.name === 'insurance_company_name') {
                        InsuranceDetailsSchema[key]['text'] = counselling_details['insurance_company_name'];
                        InsuranceDetailsSchema[key]['value'] = counselling_details['insurance_company_id'];
                        InsuranceDetailsSchema[key]['tariff_mapped'] = counselling_details['tariff_mapped'];
                        InsuranceDetailsSchema[key]['disable'] = false;
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        let  payload = {
                            "payment_type": 2,
                            "tariff_mapped": this.state.tariff_mapped?this.state.tariff_mapped:counselling_details['tariff_mapped'],
                            "procedure_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                            "unit_id": user_unit_id
                        }
                        try {
                                postService('getMasterconsutations', 'POST', {data:payload}).then(res => {
                                    if (res) {
                                        if (res.status) {
                                            if (res.data.length > 0) {
                                                this.setState({ consutations: res.data })
                                            }
                                            else {
                                                Modal.error({
                                                    title: 'Error message',
                                                    content: 'No service available',
                                                });
                                            }
                                        } 
                                    }
                                });
                            } catch (error) {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'Oops! something went wrong. Please,try again later'
                                });
                            }
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }
                    if (feild.name === 'employer_name_company') {
                        if (counselling_details['type_of_insurance_name'] && counselling_details['type_of_insurance_name'] === 'Corporate') {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['corporate_name'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        // InsuranceDetailsSchema[key]['tariff_mapped'] = 2
                    }
                    if (feild.name === 'policy_no') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['policy_number'];
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }

                    if (feild.name === 'care_management') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['care_management'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['care_management_name'];
                        InsuranceDetailsSchema[key]['disable'] = false;
                        // if (counselling_details['care_management']) {
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        // }
                    }
                    if (counselling_details['care_management'] == 1) { //medical
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                    }
                    if (counselling_details['care_management'] == 2) { //surgery
                        this.setState({ showAddprocedure: true })
                    }
                    if (counselling_details['estimate_type'] == 1) { //package
                        localStorage.setItem('type_of_package', 1)
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
                        this.setState({ showPackage: true, showEstimate: true,package_id:parseInt(counselling_details['package_id']) })
                    }

                    if (counselling_details['ailment_capping'] && counselling_details['ailment_capping'].length > 0) {
                        this.setState({ showAilment: true })
                    }
                    if (counselling_details['estimate_type'] == 2) { //nonpackage
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                    }
                    if (feild.name === 'estimate_type') {
                        if (counselling_details['estimate_type_name']) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['estimate_type'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['estimate_type_name'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        if (counselling_details['estimate_type']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['package_name'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['package_name'];
                        InsuranceDetailsSchema[key]['amount'] = counselling_details['package_amt'];
                        InsuranceDetailsSchema[key]['package_amt']=counselling_details['main_package_actual_price'];
                        inital_package_amount = counselling_details['package_amt'];
                        if (counselling_details['package_id']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                            this.getExcludesIncludes(parseInt(counselling_details['package_id']), counselling_details['package_name'], 0);

                        }
                    }

                    if (feild.name === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['length_of_stay'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['length_of_stay'];
                        if (counselling_details['length_of_stay']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'icu_stay') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['icu_stay'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['icu_stay'];
                        InsuranceDetailsSchema[key]['disable'] =counselling_details['estimate_type']==1?true: false;
                        if (counselling_details['icu_stay']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_stay') {
                        InsuranceDetailsSchema[key]['value'] = counselling_details['room_stay'];
                        InsuranceDetailsSchema[key]['text'] = counselling_details['room_stay'];
                        InsuranceDetailsSchema[key]['disable'] =counselling_details['estimate_type']==1?true: false;
                        if (counselling_details['room_stay']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'date_of_surgery') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['date_of_surgery'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['date_of_surgery'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }

                    if (feild.name === 'ins_surgery_procedure_name') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['procedure_id'] = counselling_details['surgery_procedure_id'];
                            InsuranceDetailsSchema[key]['value'] = counselling_details['surgery_procedure_id'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['procedure_name'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        if (counselling_details['surgery_procedure_id']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'ins_surgery_procedure_amount') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['surgery_procedure_amt'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['surgery_procedure_amt'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        if (counselling_details['surgery_procedure_amount']) {
                            this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'ins_surgery_percent') {
                        if (counselling_details['care_management'] == 2) {
                            InsuranceDetailsSchema[key]['value'] = counselling_details['surgery_procedure_percent'];
                            InsuranceDetailsSchema[key]['text'] = counselling_details['surgery_procedure_percent'];
                            InsuranceDetailsSchema[key]['visible'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['visible'] = false;
                        }
                        this.buttonClick2(InsuranceDetailsSchema, { "type": feild.name });
                    }
                })
                basicSumInsuredSchema.map((feild, key) => {
                    // basicSumInsuredSchema[key]['disable'] = true
                    if (feild.type && feild.type === 'group') {
                        let { data } = feild;
                        // data.map((sub_feild, sub_key) => {
                        //     basicSumInsuredSchema[key]['data'][sub_key]['disable'] = true
                        // })
                    }
                    if (feild.name === 'basic_sum_insured') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['basic_sum_insured'];
                        this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });
                    }
                    if (feild.name === 'top_up_amount') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['buffer_top_up'];
                        this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                    }
                    if (feild.name === 'balance_sum_insured') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['balance_sum_insured'];
                        this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                    }
                    if (feild.name === 'ins_co_pay' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_copay_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['copay_percent'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                            if (sub_feild.name === 'ins_copay_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['copay_amount'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['copay_amount'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                        })
                    }
                    if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_percent'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                            if (sub_feild.name === 'ins_room_eligible_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_amount'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                        })
                    }
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_ward_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['room_eligible_ward_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['room_eligible_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['room_eligible_ward_amount'];
                                basicSumInsuredSchema[key]['data'][sub_key]['package_charges']=counselling_details['main_package_actual_price'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['room_eligible_ward_amount'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                        })
                    }
                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                localStorage.setItem('room_eligible_ward_cost', counselling_details['upgrade_room_amount']);
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['upgrade_room_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['upgrade_room_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['upgrade_room_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['upgrade_room_amount'];
                                basicSumInsuredSchema[key]['data'][sub_key]['package_charges']=counselling_details['upgrade_package_price'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                            if (sub_feild.name === 'ins_upgrade_room_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['upgrade_room_amount'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                        })
                    }
                    if (feild.name === 'ins_icu_eligible' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_percent') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_eligible_percent'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['icu_eligible_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['icu_eligible_percent'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['icu_eligible_amount'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_eligible_amount'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                        })
                    }
                    if (feild.name === 'ins_icu' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_type') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['id'] = counselling_details['icu_ward_id'];
                                basicSumInsuredSchema[key]['data'][sub_key]['text'] = counselling_details['icu_ward_name'];
                                basicSumInsuredSchema[key]['data'][sub_key]['amount'] = counselling_details['icu_ward_amt'];
                                // basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_ward_id'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = counselling_details['icu_ward_amt'];
                                this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                            }
                        })
                    }
                    if (counselling_details['care_management'] == 1 || (counselling_details['care_management'] == 2 && counselling_details['estimate_type'] == 2) || (counselling_details['care_management'] == 2 && counselling_details['estimate_type'] == 1)) {
                        // if (counselling_details['care_management'] == 1 || (counselling_details['care_management'] == 2 && counselling_details['estimate_type']==2)) {
                        if (feild.name === 'ins_select_difference') {
                            if (counselling_details['room_differance'] !== "0.00" && counselling_details['room_differance'] !== null && counselling_details['room_differance'] !== null) {
                                basicSumInsuredSchema[key]['value'] = '1';
                                basicSumInsuredSchema[key]['text'] = 'Room Difference';
                                basicSumInsuredSchema[key]['id'] = 1;
                                basicSumInsuredSchema[key]['visible'] = true;

                            }
                            if (counselling_details['pro_rata_differance'] !== "0.00" && counselling_details['pro_rata_differance'] !== null && counselling_details['pro_rata_differance'] !== 0) {
                                basicSumInsuredSchema[key]['value'] = '2';
                                basicSumInsuredSchema[key]['text'] = 'Pro Rate Difference';
                                basicSumInsuredSchema[key]['id'] = 2;
                                basicSumInsuredSchema[key]['visible'] = true;
                            }
                            this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                        }
                        if (feild.name === 'ins_room_difference_amount' && counselling_details['room_differance']) {
                            basicSumInsuredSchema[key]['value'] = counselling_details['room_differance'];
                            basicSumInsuredSchema[key]['visible'] = true;
                            this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                        }
                        if (feild.name === 'ins_pro_rata_difference_amount' && counselling_details['pro_rata_differance']) {
                            basicSumInsuredSchema[key]['value'] = counselling_details['pro_rata_differance'];
                            basicSumInsuredSchema[key]['visible'] = true;
                            this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                        }
                    }
                    if (feild.name === 'ins_icu_difference') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['icu_difference_amt'];
                        this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                    }
                    if (counselling_details['estimate_type'] == 1) {
                        if (feild.name === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['value'] = counselling_details['package_differance'];
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                        this.setState({ hideingEstimatbutton: false })
                        this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                    }
                    if (feild.name === 'ins_ailment_capping') {
                        basicSumInsuredSchema[key]['value'] = counselling_details['ailment_capping_status'];
                        basicSumInsuredSchema[key]['text'] = counselling_details['ailment_capping_status_name'];
                        if (counselling_details['ailment_capping_status'] == 1) {
                            this.setState({ showAilment: true })
                        } else {
                            this.setState({ showAilment: false })
                        }
                        this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                    }
                    if (counselling_details['upgrade_room_amount']) {
                        if (feild.name === 'ins_room_upgrade_reason') {
                            basicSumInsuredSchema[key]['value'] = counselling_details['room_upgrade_reason'];
                            basicSumInsuredSchema[key]['text'] = counselling_details['room_upgrade_reason_name'];
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                        // this.buttonClick3(basicSumInsuredSchema, { "type": feild.name });

                    }

                })
                // let { estimation, additional_packages } = counselling_details
                if (additional_packages.length > 0) {
                    additionalPackageSchema.map((data, secKey) => {
                        additionalPackageSchema[secKey].visible = true;
                        if (secKey === 0) {
                            additional_packages.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "ins_additional_package_name") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['package_id']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['package_name']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['amount']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalPackageSchema[secKey].Specification.table_body[additionalPackageSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id
                                if (last_element === undefined) {
                                    last_id = packages_key;
                                }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: packages_key + 1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = packages_key + 1;
                                    if (feild.name === "ins_additional_package_name") {
                                        obj['feilds'][key]['value'] = packages['package_id'];
                                        obj['feilds'][key]['text'] = packages['package_name'];
                                    }
                                    if (feild.name === "actualprice") {
                                        obj['feilds'][key]['value'] = packages['actual_price'];
                                        obj['feilds'][key]['text'] = packages['actual_price'];
                                        
                                    }
                                    if (feild.name === "percentage" ) {
                                        obj['feilds'][key]['value'] = packages['package_percentage'];
                                        obj['feilds'][key]['text'] = packages['package_percentage'];
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = packages['amount'];
                                        obj['feilds'][key]['text'] = packages['amount'];
                                    }
                                })
                                let object = {
                                    'id': packages_key + 1,
                                    'package_name':packages['package_name'],
                                    'package_id': packages['package_id'],
                                    'package_amount': packages['actual_price']
                                }
                                allPackage.push(object);
                                data['Specification']['table_body'].push(obj);
                                this.getExcludesIncludes(parseInt(packages['package_id']), packages['package_name'], 1);
                                // }
                            })
                            this.setState({allPackage:allPackage});
                        }

                    })
                }

                if (additional_procedures.length > 0) {
                    additionalProcedureSchema.map((data, secKey) => {
                        additionalProcedureSchema[secKey].visible = true;
                        if (secKey === 0) {
                            additional_procedures.map((procedures, procedures_key) => {
                                // if (procedures_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "ins_add_procedure_name") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['procedure_id']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['procedure_id']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['amount']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalProcedureSchema[secKey].Specification.table_body[additionalProcedureSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id=procedures_key;
                                // if (last_element === undefined) {
                                //     last_id = procedures_key;
                                // }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id+1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "ins_add_procedure_name") {
                                        obj['feilds'][key]['value'] = procedures['procedure_id'];
                                        obj['feilds'][key]['text'] = procedures['procedure_name'];
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = procedures['amount'];
                                        obj['feilds'][key]['text'] = procedures['amount'];
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }
                if (ailment_capping) {
                    ailmentSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            ailmentSchema[secKey].visible = true;
                            ailment_capping.map((procedures, procedures_key) => {
                                // if (procedures_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "ins_ail_surgery_procedure_name") {
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['surgery_id']
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['surgery_id_value']
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = false
                                //                 delete ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['service']
                                //                 delete ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['header']
                                //                 delete ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['sub_header']

                                //             }
                                //             if (feilds.name === "amount") {
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['surgery_amount']
                                //                 ailmentSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['surgery_amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                    let last_element = ailmentSchema[secKey].Specification.table_body[ailmentSchema[secKey].Specification.table_body.length - 1];
                                    // let last_id = last_element['id'];
                                    let last_id=procedures_key
                                    // if (last_element === undefined) {
                                    //     last_id = procedures_key;
                                    // }

                                    let obj = {
                                        "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                        id: last_id+1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = last_id + 1;
                                        if (feild.name === "ins_ail_surgery_procedure_name") {
                                            obj['feilds'][key]['value'] = procedures['surgery_id'];
                                            obj['feilds'][key]['text'] = procedures['surgery_id_value'];
                                            obj['feilds'][key]['disable'] = true;
                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = procedures['surgery_amount'];
                                            obj['feilds'][key]['text'] = procedures['surgery_amount'];
                                        }
                                       
                                    })
                                    data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }

                if (interm_approval) {
                    interimSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            interimSchema[secKey].visible = true;
                            interm_approval.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "interim_approval_amount") {
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['interim_amount']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['interim_amount']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //             }
                                //             if (feilds.name === "approx_bill_amount") {
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['approx_bill']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['approx_bill']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //             }
                                //             if (feilds.name === "case_no") {
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['case_no']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['case_no']
                                //                 interimSchema[secKey].Specification.table_body[table_key].feilds[key]['disable'] = true
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = interimSchema[secKey].Specification.table_body[interimSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id=packages_key
                                // if (last_element === undefined) {
                                //     last_id = packages_key;
                                // }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id+1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "interim_approval_amount") {
                                        obj['feilds'][key]['value'] = packages['interim_amount']
                                        obj['feilds'][key]['text'] = packages['interim_amount']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "approx_bill_amount") {
                                        obj['feilds'][key]['text'] = packages['approx_bill']
                                        obj['feilds'][key]['value'] = packages['approx_bill']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "case_no") {
                                        obj['feilds'][key]['text'] = packages['case_no']
                                        obj['feilds'][key]['value'] = packages['case_no']
                                        obj['feilds'][key]['disable'] = true
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }
                if (pre_existing_condition) {
                    preexistingConditionsSchema.map((subTable, key) => {
                        preexistingConditionsSchema[key].visible = true;
                        let table_body = subTable.Specification.table_body;
                        pre_existing_condition.map((preExist, preExistkey) => {
                            if (preExistkey === 0) {
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (feild.id === 1) {
                                            if (sub_feild.name === 'pre_ex_condition_name') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['condition_name'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['condition_name_value'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            }
                                            if (sub_feild.name === 'onset_date') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;



                                            } if (sub_feild.name === 'sum_insured_onset_Date') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['sum_insured_onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['sum_insured_onset_data'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;



                                            } if (sub_feild.name === 'consider_si') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = preExist['consider_sum_insured'] ? true : false;
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;


                                                // preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['consider_sum_insured'];

                                            }
                                        }
                                        if (feild.id === 2) {
                                            if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details['sum_insured_four_years_back_id'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details['sum_insured_four_years_back_id'];
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;



                                            }
                                            if (sub_feild.name === 'consider_si') {
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details['consider_si_four_years_back'] ? true : false;
                                                preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;


                                                // preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = preExist['condition_name'];   
                                            }
                                        }
                                    })
                                })
                            } else {

                                let last_element = preexistingConditionsSchema[key].Specification.table_body[interimSchema[key].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id=preExistkey
                                // if (last_element === undefined) {
                                //     last_id = preExistkey + 1;
                                // }

                                let obj = {
                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                    id: last_id+1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "pre_ex_condition_name") {
                                        obj['feilds'][key]['value'] = preExist['condition_name']
                                        obj['feilds'][key]['text'] = preExist['condition_name_value']
                                        obj['feilds'][key]['disable'] = false
                                    }
                                    if (feild.name === "onset_date") {
                                        obj['feilds'][key]['text'] = preExist['onset_data']
                                        obj['feilds'][key]['value'] = preExist['onset_data']
                                        obj['feilds'][key]['disable'] = false
                                    }
                                    if (feild.name === "sum_insured_onset_Date") {
                                        obj['feilds'][key]['text'] = preExist['sum_insured_onset_data']
                                        obj['feilds'][key]['value'] = preExist['sum_insured_onset_data']
                                        obj['feilds'][key]['disable'] = false
                                    }
                                    if (feild.name === "consider_si") {
                                        // obj['feilds'][key]['text'] = preExist['case_no']
                                        obj['feilds'][key]['value'] = preExist['consider_sum_insured'] ? true : false
                                        obj['feilds'][key]['disable'] = false
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'action';
                                    }
                                })
                                subTable['Specification']['table_body'].push(obj);
                                // } 
                            }

                        })

                    })
                }

                if (estimation) {
                    addonSchema.map((subTable, key) => {
                        let service_ids = [];
                        let estimate_keys=[];
                        estimation.map((estimate, estimate_key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                if (estimate.header === subTable.header && feild.key_word === estimate.key_word && estimate.key_word !== 'add_more') {
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.name !== "action" && sub_feild.element!=='text') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['service']
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['service_name']
                                        }
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "rate") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                        }
                                        if (sub_feild.name === "percentage") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? (estimate['qty']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? (estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "amount") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                        }
                                    })
                                }
                                else if (estimate.header === subTable.header && estimate.key_word === 'add_more' && !estimate_keys.includes(estimate_key)) {
                                    const i_key = (addonSchema[key].Specification.table_body).length + 1;
                                    service_ids.push(estimate.service);
                                    estimate_keys.push(estimate_key)
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                        id: i_key,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = i_key;
                                        if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action") {
                                            obj['feilds'][key]['value'] = estimate['service'];
                                            obj['feilds'][key]['text'] = estimate['service_name'];
                                        }
                                        if (feild.name === "qty") {
                                            obj['feilds'][key]['value'] = estimate['qty'];
                                            obj['feilds'][key]['text'] = estimate['qty'];
                                        }
                                        if (feild.name === "rate") {
                                            obj['feilds'][key]['value'] = estimate['rate'];
                                            obj['feilds'][key]['text'] = estimate['rate'];
                                        }
                                        if (feild.name === "percentage") {
                                            obj['feilds'][key]['value'] = estimate['qty'];
                                            obj['feilds'][key]['text'] = estimate['qty'];
                                        }
                                        if (feild.name === "amount") {
                                            obj['feilds'][key]['value'] = estimate['amount'];
                                            obj['feilds'][key]['text'] = estimate['amount'];
                                        }
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                }
                            })
                        })
                        console.log('table_body', addonSchema[key].Specification.table_body);
                    })
                }

                let base_price = 0, excludes = 0, total_estimate_amounts = 0;
                counselling_details['header_amount'].map((feild, key) => {
                    if (feild.base_price !== '' && feild.base_price !== null & feild.base_price !== undefined) {
                        base_price = feild.base_price;
                    }
                    if (feild.excludes !== '' && feild.excludes !== null & feild.excludes !== undefined) {
                        excludes = feild.excludes ? feild.excludes : 0;
                    }
                    if (feild.total_estimate_amount !== '' && feild.total_estimate_amount !== null & feild.total_estimate_amount !== undefined) {
                        total_estimate_amounts = feild.total_estimate_amount;
                    }
                })
                estimateBreakupFormatSchema.map((feild, key) => {
                    // estimateBreakupFormatSchema[key]['disable'] = true;
                    // estimateBreakupFormatSchema[key]['element'] = 'input';
                    if (feild.name === 'base_price') {
                        if (base_price) {
                            estimateBreakupFormatSchema[key]['value'] = base_price;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        } else {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                        }
                    }
                    if (feild.name === 'excludes') {
                        const examount = parseFloat(counselling_details['header_amount'].length > 0 ? counselling_details['header_amount'][0].excludes : 0)
                        estimateBreakupFormatSchema[key]['value'] = examount ? examount : 0;
                        estimateBreakupFormatSchema[key]['text'] = examount ? examount : 0;
                        this.setState({ exclude_total_amount: examount ? examount : 0 });
                    }
                    if (feild.name === 'initial_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['initial_approval_amount'];
                    }
                    if (feild.name === 'co_pay_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['copay_amount'];
                    }
                    if (feild.name === 'estimated_nme_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['nme_amount'];
                    }
                    if (feild.name === 'actual_nme_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['actual_nme_amount'];
                    }
                    if (feild.name === 'final_bill_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['final_bill_amount'];
                    }
                    if (feild.name === 'final_approval_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['final_approval_amount'];
                    }
                    if (feild.name === 'discount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['discount'];
                    }
                    if (feild.name === 'extra_deduction_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['extra_deduction'];
                    }
                    if (feild.name === 'remarks') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['remarks'];
                    }
                    if (feild.name === 'difference_amount') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['differance_amount'];
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                    if (feild.name === 'ins_total_estimate_amount') {
                        estimateBreakupFormatSchema[key]['value'] = total_estimate_amounts;
                    }
                    if (counselling_details['attendant_name']) {
                        if (feild.name === 'signature_of_patient_attendant') {
                            estimateBreakupFormatSchema[key]['value'] = 2;
                            estimateBreakupFormatSchema[key]['text'] = 'Attendant';
                        }
                    } else {
                        if (feild.name === 'signature_of_patient_attendant') {
                            estimateBreakupFormatSchema[key]['value'] = 1;
                            estimateBreakupFormatSchema[key]['text'] = 'Patient';
                        }
                    }
                    if (feild.name === 'attendant_name') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['attendant_name'];
                        estimateBreakupFormatSchema[key]['visible'] = counselling_details['attendant_name'] ? true : false;
                    }
                    if (feild.name === 'relation') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['patient_relation'];
                        estimateBreakupFormatSchema[key]['visible'] = counselling_details['patient_relation'] ? true : false;

                    }
                })

                let total_estimate_amount = 0;
                counselling_details['header_amount'].map((feild, key) => {
                    total_estimate_amount = parseFloat(feild.total_estimate_amount);
                })
                // header amounts
                addonSchema.map((subTable, key) => {
                    if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                        let table_body = subTable.Specification.table_body;
                        let header_amount = 0;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                    // amount = parseFloat(amount) + parseFloat(sub_feild.value);
                                    header_amount = parseFloat(header_amount) + parseFloat(sub_feild.value);
                                }
                            })
                        })
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                })

                if (counselling_details['excludes_data']) {
                    hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: counselling_details['excludes_data'] } })
                    optionsStore.dispatch({ type: 'options_data', 'data': [] });
                    this.setState({ excludes_datarecounselling: counselling_details['excludes_data'] });
                }
                hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                hideInEXStore.dispatch({ type: 'NME_VIEW_DATA', data: { nme_view_data: counselling_details['NMEs'], status: true, page: 'recounselling',  nmeInfo: counselling_details['nme_extra_amount']} })
                this.setState({
                    allPackage:allPackage&&allPackage,
                    "InsuranceDetailsSchema": InsuranceDetailsSchema,
                    "addonSchema": addonSchema,
                    "basicSumInsuredSchema": basicSumInsuredSchema,
                    "estimateBreakupFormatSchema": estimateBreakupFormatSchema,
                    total_estimate_amount: total_estimate_amount, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, inital_package_amount, loadding: false,exludesiders:counselling_details['excludes_data'],
                }, () => {
                    // this.insurance_total('recouncelling');
                })
                }else{
                    let { addonSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, excludesSchema, includesSchema, ailmentSchema, interimSchema, preexistingConditionsSchema } = this.state
                    this.setState({ showEstimate: true, loadding: true })
                    InsuranceDetailsSchema.map((feild, key) => {
                        if (feild.name === 'estimated_admission_date') {
                            feild['value'] = est_date_of_admis ? moment(est_date_of_admis).format('YYYY-MM-DD') :est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):null;
                            // feild['disable'] = est_date_of_admis ? true : est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):false;
                        } else {
                            feild.value = null;
                        }
                    })
    
                    estimateBreakupFormatSchema.map((feild, key) => {
                        feild.value = null;
                        feild.text = null;
                        // if(feild.name === 'base_price'){
    
                        // }
                        // if(feild.name === 'excludes'){
    
                        // }
                        // if(feild.name === 'total_Estimate_amount'){
    
                        // }
                        // if(feild.name === 'name_of_the_fc'){
                        //     estimateBreakupFormatSchema[key]['value'] = JSON.parse(Storage.get('user'));
                        //     estimateBreakupFormatSchema[key]['text'] = JSON.parse(Storage.get('user'));
                        //     feild.disable = true;
                        // }
                        // if(feild.name === 'attendant_name'){
                        //     feild.disable = false;
                        // }
                        // if(feild.name === 'relation'){
                        //     feild.disable = false;
                        // }
                    })
    
                    addonSchema.map((subTable, key) => {
                        let table_name = subTable.name
                        addonSchema[key].header_amount = 0;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                // }
    
                                if (table_name === 'room_charges') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (table_name === 'room_investigation_charges') {
                                    addonSchema[key].Specification.add_more = true;
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'Routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ins_room_highend_investigations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'icu_investigation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'Routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_highend_investigations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ip_pharmacy_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'room_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'icu_pharmacy_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_cath_pharmacy') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
    
                                if (table_name === 'general_equipment_charges') {
                                    if (feild.key_word === 'routine') {
                                        // if (sub_feild.name === 'general_highend_equipments') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ins_general_highend_equipments') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_charges') {
    
                                    if (feild.key_word === 'ot_inst_disinfec') {
                                        if (sub_feild.name === 'ot_inst_disinfec') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
    
                                    }
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_hours') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_equipment') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_equipments') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'procedure_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'surgery_procedure_name') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'blood_bank_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'blood_components') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'cross_consultation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'dept_for_corss_consultations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ins_hospital_services') {
                                    if (feild.key_word === 'mrd') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'seropositive') {
                                        if (sub_feild.name === 'seropositive') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'isolation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'room_isolation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_isolation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
    
                                    }
                                }
                                if (table_name === 'ins_physiotherapy_diet_charges') {
                                    if (feild.key_word === 'dietician') {
                                        if (sub_feild.name === 'dietician') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'physiotherapys') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'surgical_charges') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'percentage') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (table_name === 'medical_charges') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'percentage') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                            })
                        })
                    })
    
                    additionalPackageSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        additionalPackageSchema[key].Specification.add_more = true;
                        additionalPackageSchema[key].Specification.table_body.length=0;
                        // table_body.map((feild, table_key) => {
                        //     if (table_body.length > 0) {
                        //         if (table_key === 0) {
                        //             let row = feild.feilds;
                        //             row.map((sub_feild, sub_table_key) => {
                        //                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                        //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                        //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                 }
                        //                 if (sub_feild.name === 'additional_package_name') {
                        //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                 }
                        //                 if (sub_feild.name === 'amount') {
                        //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                        //                 }
                        //             })
                        //         }
                        //         else {
                        //             additionalPackageSchema[key].Specification.table_body.splice(table_key, 1)
                        //         }
                        //     }
                        // })
                    })
    
                    additionalProcedureSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        additionalProcedureSchema[key].Specification.add_more = true;
                        additionalProcedureSchema[key].Specification.table_body.length=0;
                        // table_body.map((feild, table_key) => {
                        //     if (table_body.length > 0) {
                        //         if (table_key === 0) {
                        //             let row = feild.feilds;
                        //             row.map((sub_feild, sub_table_key) => {
                        //                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                        //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                        //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        //                 }
                        //                 if (sub_feild.name === 'additional_surgery_procedure_name') {
                        //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                 }
                        //                 if (sub_feild.name === 'amount') {
                        //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                        //                 }
                        //             })
                        //         }
                        //         else {
                        //             additionalProcedureSchema[key].Specification.table_body.splice(table_key, 1)
                        //         }
                        //     }
                        // })
                    })
                    ailmentSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        ailmentSchema[key].Specification.add_more = true;
                        ailmentSchema[key].Specification.table_body.length=0;
                        // table_body.map((feild, table_key) => {
                        //     if (table_body.length > 0) {
                        //         if (table_key === 0) {
                        //             let row = feild.feilds;
                        //             row.map((sub_feild, sub_table_key) => {
                        //                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        //                 }
                        //                 if (sub_feild.name === 'ins_ail_surgery_procedure_name') {
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        //                 }
                        //                 if (sub_feild.name === 'amount') {
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                        //                     ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        //                 }
                        //             })
                        //         }
                        //         else {
                        //             ailmentSchema[key].Specification.table_body.splice(table_key, 1)
                        //         }
                        //     }
                        // })
                    })
                    includesSchema.map((subTable, key) => {
                        if (includesSchema[key].id === 1) {
                            if (includesSchema[key].Specification.table_body.length > 0) {
                                includesSchema[key].Specification.table_body.length = 0;
                            }
                        } else {
                            includesSchema.splice(key, 1);
                        }
                    })
                    this.setState({ includesSchema });
    
                    interimSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        interimSchema[key].Specification.add_more = true;
                        interimSchema[key].Specification.table_body.length = 0;
                        // table_body.map((feild, table_key) => {
                        //     if (table_body.length > 0) {
                        //         if (table_key === 0) {
                        //             let row = feild.feilds;
                        //             row.map((sub_feild, sub_table_key) => {
                        //                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                 }
                        //                 if (sub_feild.name === 'approx_bill_amount') {
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = false;
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = false;
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                 }
                        //                 if (sub_feild.name === 'amount') {
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = false;
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = false;
                        //                     interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                        //                 }
                        //             })
                        //         }
                        //         else {
                        //             interimSchema[key].Specification.table_body.splice(table_key, 1)
                        //         }
                        //     }
                        // })
                    })
                    preexistingConditionsSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            if (feild.key_word !== "add_more") {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (feild.id === 1) {
                                        if (sub_feild.name === 'pre_ex_condition_name') {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    
                                        }
                                        if (sub_feild.name === 'onset_date') {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    
                                        } if (sub_feild.name === 'sum_insured_onset_Date') {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    
                                        } if (sub_feild.name === 'consider_si') {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    
                                        }
                                    }
                                    if (feild.id === 2) {
                                        if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    
                                        }
                                        if (sub_feild.name === 'consider_si') {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    
                                        }
                                    }
                                })
                            } else {
                                preexistingConditionsSchema[key].Specification.table_body.splice(table_key, 1)
                            }
    
                        })
                    })
                    hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                    hideInEXStore.dispatch({ type: 'NME_VIEW_DATA', data: { nme_view_data: [], status: true, page: 'finanical-counselling' } })
                    this.setState({ addonSchema: addonSchema, InsuranceDetailsSchema: InsuranceDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, interimSchema, ailmentSchema, loadding: false, preexistingConditionsSchema });
                }
        }
                break;
            default:
                break;

        }
        const {signatureSchema} = this.state;
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                signatureSchema[fei_key]["value"] = basic_info["phone_no"]
                signatureSchema[fei_key]["errors"] = []
            }
        })
        this.setState({signatureSchema})
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            InsuranceDetailsSchema: [],
            slugforexcludedropdown:'',
            signatureSchema: [],
        });
    }
    handleCancel = e => {
        this.setState({ visible: false })
    }


    cancel() {
        ;
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'add-cash':
                this
                    .props
                    .history
                    .push('/settings/cash');
                break;
        }
    }


    validateModalFeilds(formFeilds) {

        let errors = [];
        let role_id = null;
        let data_icu = 0;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'input' || feild['element'] === 'select' || feild['element'] === 'Select2multiple' || feild['element'] === 'datepicker' || feild['element'] === 'input2' || feild['element'] === 'select3')) {
                formFeilds[key]['errors'] = [];
                if ((feild.type === 'group' && feild.visible)) {
                    if (feild.name === 'ins_room_eligible') {
                        feild
                            .rules
                            .map((rule, rkey) => {
                                if (feild.data[0].value === null || feild.data[0].value === '' || feild.data[0].value === undefined) {
                                    formFeilds[key]['errors'].push({ 'message': rule.message });
                                    let obj = {
                                        id: feild['id'],
                                        false: false
                                    }
                                    errors.push(obj);
                                }
                            });
                    }
                    if (feild.name === 'ins_icu_eligible') {
                        feild
                            .rules
                            .map((rule, rkey) => {
                                if (feild.data[0].value === null || feild.data[0].value === '' || feild.data[0].value === undefined) {

                                    formFeilds[key]['errors'].push({ 'message': rule.message });
                                    let obj = {
                                        id: feild['id'],
                                        false: false
                                    }
                                    errors.push(obj);
                                } else {
                                    data_icu = feild.data[0].value;
                                }
                            });
                    }
                    if (feild.name === 'ins_icu' && data_icu != null && data_icu !== '' && data_icu !== undefined && data_icu !== 0) {
                        feild
                            .rules
                            .map((rule, rkey) => {
                                if (feild.data[0].value === null || feild.data[0].value === '' || feild.data[0].value === undefined) {

                                    formFeilds[key]['errors'].push({ 'message': rule.message });
                                    let obj = {
                                        id: feild['id'],
                                        false: false
                                    }
                                    errors.push(obj);
                                }
                            });
                    }


                }else {
                    if (!feild.disable && feild.visible) {             
                        feild
                            .rules
                            .map((rule, rkey) => {
                                if (feild.name === 'balance_sum_insured'){
                                    if (feild.value === 0){
                                        formFeilds[key]['errors'].push({ 'message': 'Bal Sum Insured Cannot be 0' })
                                        let obj = {
                                                        id: feild['id'],
                                                        false: false
                                                    }
                                                     errors.push(obj);
                                    }
                                    else if (feild.value === null) {
                                        formFeilds[key]['errors'].push({ 'message': !rule.message })
                                        let obj = {
                                                        id: feild['id'],
                                                        false: false
                                                    }
                                                     errors.push(obj);
                                    }
                                }
                                if ((feild['value'] === null) || (feild['value'] === '') || (feild['value'] === undefined)) {
                                    formFeilds[key]['errors'].push({ 'message': rule.message });
                                    let obj = {
                                        id: feild['id'],
                                        false: false
                                    }
                                     errors.push(obj);
                                }                                  
                                else {
                                    console.log('no', feild['name'], feild['value'])
                                     if(feild['name'] === "phonenumber"){
                                        let isvalid = this.validateMobileNumber(feild['value'])
                                        if(!isvalid){
                                            formFeilds[key]['errors'].push({ 'message': "Please Enter Valid Phone Number" });
                                            let obj={
                                                id:feild['id'],
                                                false:false
                                            }
                                            errors.push(obj);
                                        }else {
                                            formFeilds[key]['errors'] = [];
                                            errors.push(true);
                                        }
                                    }
                                    else if (feild.name === 'balance_sum_insured' && feild.value === 0){
                                        formFeilds[key]['errors'].push({ 'message': 'Bal Sum Insured Cannot be 0' })
                                        errors.push(false);
                                
                                    }else{
                                        formFeilds[key]['errors'] = [];
                                        errors.push(true);
                                    }
                                }
                            })

                    }
                }
            }

        })

        this.setState((state) => ({ formFeilds: formFeilds }));
        return errors;
    }
    validateailment(formFeilds) {
        let errors = [];
        let role_id = null;
        let { basicSumInsuredSchema } = this.state;

        basicSumInsuredSchema.map((feild, key) => {
            if (feild.name === 'ins_ailment_capping') {
                if (feild.value === '1') {
                    formFeilds.map((subTable, key) => {
                        if (subTable.title) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let feildss = feild.feilds;
                                feildss.map((feild, fkey) => {
                                    if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        if (!feild.disable && feild.visible) {
                                            feild.rules.map((rule, rkey) => {
                                                if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                                                    formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                                    let obj = {
                                                        id: feild['id'],
                                                        false: false
                                                    }
                                                    errors.push(obj);
                                                }
                                                else {
                                                    formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                                    errors.push(true);
                                                }
                                            })
                                        }
                                    }
                                })
                            })
                        }
                    })

                }
                else {
                    errors.push(true);
                }
            }

        })

        console.log('error', errors)
        this.setState((state) => ({ ailmentSchema: formFeilds }));
        return errors;
    }

    buttonClick(feilds, button, tab) {
        let payload = {};
        feilds.map((feild, key) => {
            if (feild.element !== 'button') {
                payload[feild['name']] = feild['value']
            }

        })

        let errors = this.validateModalFeilds(feilds)
        if (!errors.includes(false)) {

            console.log('valid data:', payload)
        }
    }


    next() {
        // this.carousel.next();
        this.props.next()
    }
    previous() {
        // this.carousel.prev();
        this.props.back()
    }
    
    buttonClick2(feilds, type) {
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }
        try {
        console.log('got it now')
        let ele_name = '';
        let ele_val = '';
        let ele_id = 0;
        let ele_text = '';

        let { InsuranceDetailsSchema, addonSchema, basicSumInsuredSchema, tariff_mapped, additionalProcedureSchema, additionalPackageSchema, estimateBreakupFormatSchema, Insuranceerrors,ailmentSchema,includesSchema,interimSchema,preexistingConditionsSchema, nmePopupSchema, room_percentage } = this.state;
        let { basic_info, counselling_details } = this.props
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild['name'] === type.type) {
                ele_name = feild['name'];
                ele_val = feild['value'];
                ele_text = feild['text'] || null;
                ele_id = feild['id'];
            }
        })

        if (ele_name === 'tpa_name') {
            InsuranceDetailsSchema.map((feild, key) => {
                if (ele_val) {
                    if (feild['name'] === 'insurance_company_name') {
                        InsuranceDetailsSchema[key]['disable'] = (counselling_details && counselling_details['insurance_company_name'])&&slug==='view-finanical-counselling' ? true : false;
                        if((slug=='finanical-counselling') || (slug=='recounselling') || (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling')){
                            InsuranceDetailsSchema[key]['text'] = counselling_details && counselling_details['insurance_company_name'];
                            InsuranceDetailsSchema[key]['value'] = counselling_details && counselling_details['insurance_company_id'];
                        }
                        this.setState({isModalShown: false});
                    }
                } else {
                    if (feild['name'] === 'insurance_company_name') {
                        InsuranceDetailsSchema[key]['disable'] = false;
                        InsuranceDetailsSchema[key]['text'] = null;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }

                }
                if (feild['name'] === 'care_management') {
                    InsuranceDetailsSchema[key]['disable'] = (counselling_details && counselling_details['care_management']) ? true : true;
                    InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['care_management']) ? counselling_details['care_management_name'] : null;
                    InsuranceDetailsSchema[key]['value'] = (counselling_details && counselling_details['care_management']) ? counselling_details['care_management'] : null;
                }

                if (feild['name'] === 'estimate_type') {
                    InsuranceDetailsSchema[key]['visible'] = (counselling_details && counselling_details['estimate_type_name']) ? true : false;
                    InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['estimate_type_name']) ? counselling_details['estimate_type_name'] : null;
                    InsuranceDetailsSchema[key]['value'] = (counselling_details && counselling_details['estimate_type_name']) ? counselling_details['estimate_type'] : null;
                }
                if (feild['name'] === 'ins_package_name') {
                    InsuranceDetailsSchema[key]['visible'] = (counselling_details && counselling_details['package_id']) ? true : false;
                    InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['package_name']) ? counselling_details['package_name'] : null;
                    // InsuranceDetailsSchema[key]['value'] =(counselling_details && counselling_details['package_id']) ? counselling_details['package_id'] : null;
                }
                // if (feild['name'] === 'date_of_surgery') {
                //     InsuranceDetailsSchema[key]['visible'] = false;
                //     InsuranceDetailsSchema[key]['text'] = null;
                //     InsuranceDetailsSchema[key]['value'] = null;
                // }
                if (feild['name'] === 'ins_surgery_procedure_name') {
                    InsuranceDetailsSchema[key]['visible'] = (counselling_details && counselling_details['surgery_procedure_id']) ? true : false;
                    InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['procedure_name']) ? counselling_details['procedure_name'] : null;
                }
                if (feild['name'] === 'ins_surgery_procedure_amount') {
                    InsuranceDetailsSchema[key]['visible'] = false;
                    // InsuranceDetailsSchema[key]['value'] = null;
                }
                if (feild['name'] === 'ins_surgery_percent') {
                    InsuranceDetailsSchema[key]['visible'] = false;
                    InsuranceDetailsSchema[key]['text'] = null;
                    InsuranceDetailsSchema[key]['value'] = null;
                }

                basicSumInsuredSchema.map((feild, key) => {
                    if (feild['name'] === 'ins_package_difference') {
                        basicSumInsuredSchema[key]['visible'] = (counselling_details && parseFloat(counselling_details['package_differance'])!==0) ?true : false;;
                        basicSumInsuredSchema[key]['value'] =  (counselling_details && parseFloat(counselling_details['package_differance'])!==0) ?counselling_details['package_differance']: null;;
                    }
                    if (feild['name'] === 'ins_select_difference') {
                        basicSumInsuredSchema[key]['visible'] = (counselling_details && counselling_details['package_differance']!=="0.00" )?false:true ;
                        // basicSumInsuredSchema[key]['visible'] =(counselling_details && counselling_details['pro_rata_differance']) ?true : false;

                        // basicSumInsuredSchema[key]['value'] = null;
                    }
                    if (!ele_val || ele_val === null || ele_val === '' || ele_val === undefined) {
                        if((slug=='finanical-counselling') || slug === 'recounselling'){
                            basicSumInsuredSchema.map((feild, key) => {
                                if (feild.name === 'ins_room_eligible'  && feild.type === 'group') {
                                    let { data } = feild;
                                    data.map((sub_feild, sub_key) => {
                                        if (sub_feild.name === 'ins_room_eligible_percent') {
                                            basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                        }
                                        if (sub_feild.name === 'ins_room_eligible_amount') {
                                            // room_amount = Math.round(basic_sum_insured * (roomPercentage / 100));
                                            basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                        }
                                    });
                                }
                            });
                        }
                    }
                    // if (feild['name'] === "ins_room_difference_amount") {
                    //     basicSumInsuredSchema[key]['visible'] = false;
                    //     basicSumInsuredSchema[key]['value'] = null;
                    // }
                    // if (feild['name'] === "ins_pro_rata_difference_amount") {
                    //     basicSumInsuredSchema[key]['visible'] = false;
                    //     basicSumInsuredSchema[key]['value'] = null;
                    // }
                })

            })
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema, tpa_name: ele_val, 'basicSumInsuredSchema': basicSumInsuredSchema }));
        }
        if (ele_name === 'insurance_company_name') {
            InsuranceDetailsSchema.map((feild, key) => {
                if (ele_val) {
                    if (feild['name'] === 'care_management') {
                        InsuranceDetailsSchema[key]['disable'] = false
                        InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['care_management']) ? counselling_details['care_management_text'] : null;
                        InsuranceDetailsSchema[key]['value'] = (counselling_details && counselling_details['care_management']) ? counselling_details['care_management'] : null;
                    }
                    if (feild['name'] === 'insurance_company_name') {
                        this.setState({ tariff_mapped: feild['tariff_mapped'] ? feild['tariff_mapped'] : counselling_details['tariff_mapped'], insurance_company_mou_flag: feild['insurance_company_mou_flag'] ?  feild['insurance_company_mou_flag'] : null, insuranceCompanyName: InsuranceDetailsSchema[key]['text'] ? InsuranceDetailsSchema[key]['text'] : null, isModalShown: false });
                    }
                } else {
                    if (feild['name'] === 'care_management') {
                        InsuranceDetailsSchema[key]['disable'] = true
                        InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['care_management']) ? counselling_details['care_management_name'] : null;
                        InsuranceDetailsSchema[key]['value'] = (counselling_details && counselling_details['care_management']) ? counselling_details['care_management'] : null;
                    }
                }


                // if (feild['name'] === 'estimate_type') {
                //     InsuranceDetailsSchema[key]['visible'] = false;
                //     InsuranceDetailsSchema[key]['text'] = null;
                //     InsuranceDetailsSchema[key]['value'] = null;
                // }
                if (feild['name'] === 'ins_package_name') {
                    InsuranceDetailsSchema[key]['visible'] = (counselling_details && counselling_details['package_id']) ? true : false;
                    InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['package_name']) ? counselling_details['package_name'] : null;
                    InsuranceDetailsSchema[key]['value'] = (counselling_details && counselling_details['package_id']) ? counselling_details['package_id'] : null;
                }
                // if (feild['name'] === 'date_of_surgery') {
                //     InsuranceDetailsSchema[key]['visible'] = false;
                //     InsuranceDetailsSchema[key]['text'] = null;
                //     InsuranceDetailsSchema[key]['value'] = null;
                // }
                if (feild['name'] === 'ins_surgery_procedure_name') {
                    InsuranceDetailsSchema[key]['visible'] = (counselling_details && counselling_details['surgery_procedure_id']) ? true : false;
                    InsuranceDetailsSchema[key]['text'] = (counselling_details && counselling_details['procedure_name']) ? counselling_details['procedure_name'] : null;
                    // InsuranceDetailsSchema[key]['value'] = (counselling_details && counselling_details['surgery_procedure_id']) ? counselling_details['surgery_procedure_id'] : null;
                }
                if (feild['name'] === 'ins_surgery_procedure_amount') {
                    InsuranceDetailsSchema[key]['visible'] = false;
                    InsuranceDetailsSchema[key]['value'] = null;
                }
                if (feild['name'] === 'ins_surgery_percent') {
                    InsuranceDetailsSchema[key]['visible'] = false;
                    InsuranceDetailsSchema[key]['text'] = null;
                    InsuranceDetailsSchema[key]['value'] = null;
                }

            });
            if (!ele_val || ele_val === null || ele_val === '' || ele_val === undefined) {
                if((slug=='finanical-counselling') || slug === 'recounselling'){
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild.name === 'ins_room_eligible'  && feild.type === 'group') {
                            let { data } = feild;
                            data.map((sub_feild, sub_key) => {
                                if (sub_feild.name === 'ins_room_eligible_percent') {
                                    basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                }
                                if (sub_feild.name === 'ins_room_eligible_amount') {
                                    // room_amount = Math.round(basic_sum_insured * (roomPercentage / 100));
                                    basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                }
                            });
                        }
                    });
                }
            }
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema, "basicSumInsuredSchema": basicSumInsuredSchema }));
        }

        if (ele_name === 'type_insurance') {
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'employer_name_company') {
                    // corporate
                    if (ele_val !== '' && ele_val == '2') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        localStorage.setItem('insuranceType', InsuranceDetailsSchema[4].value);
                        this.setState({ showPreExConditions: false })
                    }
                    // retail
                    if (ele_val !== '' && ele_val == '1') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        localStorage.setItem('insuranceType', InsuranceDetailsSchema[4].value);
                        this.setState({ showPreExConditions: true })
                    }
                    if (ele_val == '' || ele_val == null) {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        this.setState({ showPreExConditions: false })
                    }
                }
            })
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema }));
        }

        if (ele_name === 'insurance_status') {
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'reason_if_denied') {
                    if (ele_val && ele_val == '2') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                    }
                    else {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    // if (ele_val == '' || ele_val == null) {
                    //     InsuranceDetailsSchema[key]['visible'] = false;
                    // }
                }
            })
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema }));
        }

        if (ele_name === 'care_management') {
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema: [],los: null , status: false } })
            const { getconfigurations,getMasterconsutations } = networkList;

            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            try {
                postService(getconfigurations, 'GET', 'null').then(res => {
                    if (res) {
                        if (res.status) {
                            if (res.data.length > 0) {
                                this.setState({ configuration: res.data[0].data })
                                if (res.data[0].data.length > 0) {
                                    res.data[0].data.map((feilds, key) => {
                                        if (feilds.config_name === 'Ins-Physician Fees Room') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.header === 18) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 1) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema });
                                                                }
                                                                
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        if (feilds.config_name === 'Ins-Physician Fees ICU') {
                                            // addonSchema.map((subTable, key) => {
                                            //     if (subTable.header === 18) {
                                            //         let table_body = subTable.Specification.table_body;
                                            //         table_body.map((feild, table_key) => {
                                            //             if (feild.id === 2) {
                                            //                 let row = feild.feilds;
                                            //                 row.map((sub_feild, sub_table_key) => {
                                            //                     if (sub_feild.name === 'percentage') {
                                            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                            //                         this.setState({ addonSchema: addonSchema });
                                            //                     }
                                            //                 })
                                            //             }
                                            //         })
                                            //     }
                                            // })
                                            const Insu_Physician_Fees_ICU = feilds.bill_tracking_percent;
                                            this.setState({ Insu_Physician_Fees_ICU: Insu_Physician_Fees_ICU })
                                        }
                                        if (feilds.config_name === 'Additional  package1') {
                                            const additional_package_percent1 = feilds.bill_tracking_percent;
                                            this.setState({ additional_package_percent1: additional_package_percent1 })
                                        }
                                        if (feilds.config_name === 'Additional  package2') {
                                            const additional_package_percent2 = feilds.bill_tracking_percent;
                                            this.setState({ additional_package_percent2: additional_package_percent2 })
                                            this.highestPackage();
                                        }

                                    })
                                }
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'No service available',
                                });
                            }
                        } else {

                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong ',
                            });
                        }
                    }
                });
            } catch (error) {
                Modal.error({
                    title: 'Error message',
                    content: 'Oops! something went wrong. Please,try again later'
                });
            }
          let  payload = {
                "payment_type": 2,
                "tariff_mapped": this.state.tariff_mapped?this.state.tariff_mapped:counselling_details['tariff_mapped'],
                "procedure_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                "unit_id": user_unit_id
            }
            try {
                postService(getMasterconsutations, 'POST', {data:payload}).then(res => {
                    if (res) {
                        if (res.status) {
                            if (res.data.length > 0) {
                                this.setState({ consutations: res.data })
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'No service available',
                                });
                            }
                        } 
                    }
                });
            } catch (error) {
                Modal.error({
                    title: 'Error message',
                    content: 'Oops! something went wrong. Please,try again later'
                });
            }

            InsuranceDetailsSchema.map((feild, key) => {
                if (feild.name === 'icu_stay') {
                    InsuranceDetailsSchema[key]['value'] = null
                    // InsuranceDetailsSchema[key]['disable'] = true;
                }
                if (feild.name === 'room_stay') {
                    InsuranceDetailsSchema[key]['value'] = null
                    // InsuranceDetailsSchema[key]['disable'] = true;
                }
                // if (feild.name === 'room_opted') {
                //     InsuranceDetailsSchema[key]['value'] = null
                // }
                if (feild.name === 'length_of_stay') {
                    InsuranceDetailsSchema[key]['value'] = null
                }
                if (feild['name'] === 'ins_package_name') {
                    InsuranceDetailsSchema[key]['value'] = null;
                }
                if (feild['name'] === 'estimate_type') {
                    InsuranceDetailsSchema[key]['value'] = null;
                    InsuranceDetailsSchema[key]['text'] = null;
                }
            })

            if (ele_val == '1') {    // 1 - medical, 2 - surgical
                addonSchema.map((subTable, key) => {
                    if (subTable.name === 'ins_surgical_charges') {
                        addonSchema[key].visible = false;
                        let table_body = subTable.Specification.table_body;
                        let header_amount = 0;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                            })
                        })
                    }
                    if (subTable.name === 'ins_medical_charges') {
                        addonSchema[key].visible = true;
                    }
                    if (subTable.name === 'ot_cath_pharmacy') {
                        addonSchema[key].visible = false;
                    }
                    if (subTable.name === 'ot_charges') {
                        addonSchema[key].visible = false;
                    }
                    if (subTable.name === 'ot_equipment') {
                        addonSchema[key].visible = false;
                    }
                })
                additionalPackageSchema[0]['visible'] = false;
            }
            else {
                addonSchema.map((subTable, key) => {
                    if (subTable.name === 'ins_surgical_charges') {
                        addonSchema[key].visible = true;
                    }
                    if (subTable.name === 'ins_medical_charges') {
                        addonSchema[key].visible = false;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                            })
                        })
                    }
                    if (subTable.name === 'ot_cath_pharmacy') {
                        addonSchema[key].visible = true;
                    }
                    if (subTable.name === 'ot_charges') {
                        addonSchema[key].visible = true;
                    }
                    if (subTable.name === 'ot_equipment') {
                        addonSchema[key].visible = true;
                    }
                })
                additionalPackageSchema[0]['visible'] = false;
            }



            addonSchema.map((subTable, key) => {

                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                        }
                        if (sub_feild.name === 'qty') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                        }
                        if (sub_feild.name === 'rate') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                        }
                        if (sub_feild.name === 'percentage') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                        }
                        if (sub_feild.name === 'amount') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                        }
                    })
                })
            })
            InsuranceDetailsSchema.map((feild, key) => {
                // surgery
                if (ele_val == '2') {
                    if (feild['name'] === 'estimate_type') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    // if (feild['name'] === 'package_name') {
                    //     InsuranceDetailsSchema[key]['visible'] = true;
                    //     InsuranceDetailsSchema[key]['value'] = null;
                    // }
                    if (feild['name'] === 'date_of_surgery') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_name') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        // InsuranceDetailsSchema[key]['value'] = null;
                        // InsuranceDetailsSchema[key]['text'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_amount') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_percent') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'icu_stay') {
                        InsuranceDetailsSchema[key]['disable'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'room_stay') {
                        InsuranceDetailsSchema[key]['disable'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }

                    addonSchema.map((feild, key) => {
                        if (feild['name'] == 'surgical_charges') {
                            addonSchema[key]['visible'] = true;
                        }
                        if (feild['name'] == 'medical_charges') {
                            addonSchema[key]['visible'] = false;
                        }
                    })
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_select_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_room_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_pro_rata_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                    })
                    // if( feild['id'] > ele_id){
                    //     InsuranceDetailsSchema[key]['value'] = null;
                    // }
                    this.setState({ showPackage: false, showAddprocedure: true })
                }
                // medical
                if (ele_val == '1') {
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true, status: false } })
                    if (feild['name'] === 'estimate_type') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                        InsuranceDetailsSchema[key]['text'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_amount') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_percent') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    if (feild['name'] === 'icu_stay') {
                        InsuranceDetailsSchema[key]['disable'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'room_stay') {
                        InsuranceDetailsSchema[key]['disable'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }

                    addonSchema.map((feild, key) => {
                        if (feild['name'] == 'surgical_charges') {
                            addonSchema[key]['visible'] = false;
                        }
                        if (feild['name'] == 'medical_charges') {
                            addonSchema[key]['visible'] = true;
                        }
                    })
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_select_difference') {
                            basicSumInsuredSchema[key]['visible'] = true;
                        }
                        if (feild['name'] === "ins_room_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = true;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_pro_rata_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = true;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                    })
                    // if( feild['id'] > ele_id){
                    //     InsuranceDetailsSchema[key]['value'] = null;
                    // }
                    this.setState({ showPackage: false, showAddprocedure: false })
                }
                if (ele_val == '' || ele_val == null) {
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true, status: false } })
                    if (feild['name'] === 'estimate_type') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    if (feild['name'] === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        // InsuranceDetailsSchema[key]['value'] = null;
                        // InsuranceDetailsSchema[key]['text'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_amount') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_percent') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    addonSchema.map((feild, key) => {
                        if (feild['name'] == 'surgical_charges') {
                            addonSchema[key]['visible'] = false;
                        }
                        if (feild['name'] == 'medical_charges') {
                            addonSchema[key]['visible'] = false;
                        }
                    })
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_select_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_room_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_pro_rata_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                    })
                    this.setState({ showPackage: false })
                }
            })
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'base_price') {
                    estimateBreakupFormatSchema[key]['visible'] = false;
                    estimateBreakupFormatSchema[key]['value'] = null;
                    estimateBreakupFormatSchema[key]['text'] = null;
                }
                if (feild['name'] === 'ins_total_estimate_amount') {
                    estimateBreakupFormatSchema[key]['visible'] = false;
                    estimateBreakupFormatSchema[key]['value'] = null;
                    estimateBreakupFormatSchema[key]['text'] = null;
                }
            })
            this.setState({ loadding: false, hideingEstimatbutton: true, showEstimate: true })
            this.clearEstimate_table();
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema, 'addonSchema': addonSchema, 'basicSumInsuredSchema': basicSumInsuredSchema, estimateBreakupFormatSchema }));
        }
        if (ele_name === 'estimate_type') {
            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema: [],los: null , status: false } })
            InsuranceDetailsSchema.map((feild, key) => {
                // package
                if (ele_val == '1' || ele_val === 'Package') {
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false, status: false } })
                    if (feild['name'] === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'icu_stay') {
                        InsuranceDetailsSchema[key]['disable'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'room_stay') {
                        InsuranceDetailsSchema[key]['disable'] = true;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_percent') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        if (basic_info.counselling_type_id === 1) {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['disable'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                        }
                    }
                    if (feild['name'] === 'ins_surgery_procedure_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        if (basic_info.counselling_type_id === 1) {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['disable'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                        }
                    }
                    if (feild['name'] === 'ins_surgery_procedure_amount') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        if (basic_info.counselling_type_id === 1) {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['disable'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                        }
                    }
                    if (feild['name'] === 'ins_surgery_percent') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        if (basic_info.counselling_type_id === 1) {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['disable'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                        }
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = null;
                    }

                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['visible'] = true;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_select_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_room_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_pro_rata_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                    })
                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild['name'] === 'base_price') {
                            estimateBreakupFormatSchema[key]['visible'] = true;
                            estimateBreakupFormatSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_total_estimate_amount') {
                            estimateBreakupFormatSchema[key]['visible'] = true;
                            estimateBreakupFormatSchema[key]['value'] = null;
                        }
                    })
                    this.setState({ showPackage: true, hideingEstimatbutton: false })
                    addonSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                // if (sub_feild.name === 'percentage') {
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                // }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                            })
                        })
                    })
                    additionalPackageSchema[0]['visible'] = true;
                }
                // non package
                if (ele_val == '2') {
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true, status: false } })
                    if (feild['name'] === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'icu_stay') {
                        InsuranceDetailsSchema[key]['disable'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'room_stay') {
                        InsuranceDetailsSchema[key]['disable'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_percent') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'ins_surgery_procedure_amount') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                        if (basic_info.counselling_type_id === 1) {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['disable'] = true;
                        } else {
                            InsuranceDetailsSchema[key]['value'] = null;
                            InsuranceDetailsSchema[key]['disable'] = false;
                        }
                    }
                    if (feild['name'] === 'ins_surgery_procedure_name') {
                        InsuranceDetailsSchema[key]['visible'] = true;
                        // InsuranceDetailsSchema[key]['value'] = null;
                        InsuranceDetailsSchema[key]['disable'] = false;
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    if (feild['name'] === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_select_difference') {
                            basicSumInsuredSchema[key]['visible'] = true;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_room_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_pro_rata_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }

                    })
                    this.setState({ showPackage: false })
                    addonSchema.map((subTable, key) => {
                        let table_name = subTable.name;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                    }
                                }
                            })
                        })
                    })
                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_total_estimate_amount') {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                            estimateBreakupFormatSchema[key]['value'] = null;
                        }
                    })
                    additionalPackageSchema[0]['visible'] = false;
                }
                if (ele_val == '' || ele_val == null) {
                    if (feild['name'] === 'ins_package_name') {
                        InsuranceDetailsSchema[key]['visible'] = false;
                    }
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild['name'] === 'ins_package_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === 'ins_select_difference') {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_room_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }
                        if (feild['name'] === "ins_pro_rata_difference_amount") {
                            basicSumInsuredSchema[key]['visible'] = false;
                            basicSumInsuredSchema[key]['value'] = null;
                        }

                    })
                }
            })
            if (parseFloat(ele_val) === 1 || ele_val === 'Package') {
                // 1 - package, 2 - non-package
                additionalPackageSchema[0]['visible'] = true;
                this.setState({ loadding: false, hideingEstimatbutton: false, showEstimate: true })
            }
            else {
                this.setState({ loadding: false, hideingEstimatbutton: true, showEstimate: true })
                // hideing_estimatetable = 1;   
            }
            additionalProcedureSchema[0]['visible'] = true;
            this.clearEstimate_table()
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema, 'basicSumInsuredSchema': basicSumInsuredSchema, 'additionalProcedureSchema': additionalProcedureSchema, estimateBreakupFormatSchema }));
        }
        if (ele_name === 'ins_package_name') {
            this.clearEstimate_table()
            let pack = false;
            let length_of_stay = null;
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'estimate_type') {
                    if (parseFloat(feild['value']) === 1) { // 1 - package, 2 - non-package
                        pack = true;
                    }
                }
                if (feild['name'] === 'ins_package_name') {
                    if (feild['value'] !== '' && feild['value'] !== null && feild['value'] !== undefined) {
                        length_of_stay = feild['length_of_stay'];
                    } else {
                        length_of_stay = 0;
                    }
                    // let initialpackage=[]
                    // let obj={
                    //     'id':0,
                    //     'package_name':ele_text,
                    //     'package_id':ele_val,
                    //     'package_amount':0
                    // }

                    // initialpackage.push(obj)
                    // this.setState({allPackage:initialpackage})
                }
            })

            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'length_of_stay') {
                    if (pack) {
                        InsuranceDetailsSchema[key]['value'] = length_of_stay;
                         hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: length_of_stay , status: true } })
                    }
                    else {
                        InsuranceDetailsSchema[key]['value'] = null;
                    }
                }
                if (feild['name'] === 'icu_stay') {
                    InsuranceDetailsSchema[key]['disable'] = true;
                    InsuranceDetailsSchema[key]['value'] = null;
                }
                if (feild['name'] === 'room_stay') {
                    InsuranceDetailsSchema[key]['disable'] = true;
                    InsuranceDetailsSchema[key]['value'] = null;
                }
            })

            additionalPackageSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                additionalPackageSchema[key].Specification.add_more = true;
                table_body.length=0;
            })
            additionalPackageSchema[0]['visible'] = false;
            additionalProcedureSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                additionalProcedureSchema[key].Specification.add_more = true;
                table_body.length=0;
            })
            additionalProcedureSchema[0]['visible'] = false;
            ailmentSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                ailmentSchema[key].Specification.add_more = true;
                table_body.map((feild, table_key) => {
                    if (table_body.length > 0) {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'ins_ail_surgery_procedure_name') {
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    this.total_suming();
                                }
                            })
                       
                    }
                })
            })
            includesSchema.map((subTable, key) => {
                if (includesSchema[key].id === 1) {
                    if (includesSchema[key].Specification.table_body.length > 0) {
                        includesSchema[key].Specification.table_body.length = 0;
                    }
                } else {
                    includesSchema.splice(key, 1);
                }
            })

            interimSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                interimSchema[key].Specification.add_more = true;
                table_body.map((feild, table_key) => {
                    if (table_body.length > 0) {
                        if (table_key === 0) {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                }
                                if (sub_feild.name === 'approx_bill_amount') {
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = false;
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = false;
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                }
                                if (sub_feild.name === 'amount') {
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = false;
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = false;
                                    interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                }
                            })
                        }
                        else {
                            interimSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                })
            })
            interimSchema[0]['visible'] = false;
            ailmentSchema[0]['visible'] = false;
            this.setState((state) => ({ 'InsuranceDetailsSchema': InsuranceDetailsSchema, package_id: ele_val,additionalPackageSchema:JSON.parse(JSON.stringify(additionalPackageSchema)),additionalProcedureSchema,ailmentSchema,includesSchema,interimSchema,preexistingConditionsSchema }), () => {
                if (ele_val === ele_text) {

                } else {
                    this.getExcludesIncludes(parseInt(ele_val), ele_text, 0);
                }
                this.total_suming();
                additionalPackageSchema[0]['visible'] = true;
                additionalProcedureSchema[0]['visible'] = true;
                interimSchema[0]['visible'] = true;
                ailmentSchema[0]['visible'] = true;
                let This = this;
                setTimeout(function () {
                    This.setState((state) => ({  additionalPackageSchema: additionalPackageSchema,additionalProcedureSchema:additionalProcedureSchema,ailmentSchema,interimSchema}))
                    This.total_suming();
                            }, 1000);
            });
           
        }
        if (ele_name === 'ins_surgery_procedure_name') {
            if (ele_val !== '' && ele_val !== null && ele_val !== undefined) {
                // additionalProcedureSchema[0]['visible'] = true;
                let amount, room_id, room_value = 0;
                let { getServicePricesById } = networkList;
                if (ele_val !== 0 && ele_val !== '' && ele_val !== null && ele_val !== undefined) {
                    postService(getServicePricesById, 'POST', { data: { service_id: ele_val } }).then(res => {
                        if (res) {
                            res.data.map((feild, key) => {
                                if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                    console.log('got it sur amount', feild)
                                    amount = parseFloat(feild.amount);
                                    InsuranceDetailsSchema.map((feild, key) => {
                                        if (feild['name'] === 'ins_surgery_procedure_amount') {
                                            feild['text'] = amount;
                                            feild['value'] = amount;
                                        }
                                    })
                                    this.setState({ InsuranceDetailsSchema: InsuranceDetailsSchema });
                                    // this.sumingProcedureAmounts();
                                    this.total_suming();
                                }
                            })
                        }
                    });
                }
                else {
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: 'Please select room',
                    // });
                }
            }
            else {
                additionalProcedureSchema[0]['visible'] = false;
            }
        }
        if (ele_name === 'icu_stay') {
            if (ele_val === '' || ele_val === undefined || ele_val === null || isNaN(ele_val)) {
                ele_val = 0;
            }
            let total_stay = 0;
            let pack = false;
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'estimate_type') {
                    if (InsuranceDetailsSchema[key]['value'] !== '' && InsuranceDetailsSchema[key]['value'] != undefined && parseFloat(InsuranceDetailsSchema[key]['value']) === 1 && InsuranceDetailsSchema[key]['value'] != null && !isNaN(parseFloat(InsuranceDetailsSchema[key]['value']))) {
                        pack = true;
                    }
                }
                if (feild['name'] === 'room_stay') {
                    if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
                        total_stay = parseFloat(ele_val) + parseFloat(feild['value']);
                        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: total_stay , status: true } });
                        console.log('LOSLOSSTAY1', this.state);
                    }
                    else {
                        total_stay = parseFloat(ele_val);
                        console.log('LOSLOSSTAY2', total_stay)
                        if(total_stay === 0) {
                            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema: [],los: null , status: false } })
                        }
                        else{
                        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: total_stay , status: true } })
                        }
                    }
                    this.internsivistAndasstInternsivist(ele_val);
                }
            })
            //hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: total_stay , status: true } })


            this.setState({ InsuranceDetailsSchema: InsuranceDetailsSchema })

            // InsuranceDetailsSchema.map((feild, key) => {
            //     if (feild['name'] === 'length_of_stay') {
            //         InsuranceDetailsSchema[key]['value'] = null;
            //     }
            // })

            if (total_stay !== '' && !isNaN(total_stay) && total_stay !== undefined && total_stay !== null) {
                InsuranceDetailsSchema.map((feild, key) => {
                    if (feild['name'] === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = total_stay;
                    }
                })
                this.setState({ InsuranceDetailsSchema: InsuranceDetailsSchema });

            }
        }
        if (ele_name === 'room_stay') {
            if (ele_val === '' || ele_val === undefined || ele_val === null || isNaN(ele_val)) {
                ele_val = 0;
            }
            let total_stay = 0;
            let pack = false;
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'estimate_type') {
                    if (InsuranceDetailsSchema[key]['value'] !== '' && InsuranceDetailsSchema[key]['value'] !== undefined && parseFloat(InsuranceDetailsSchema[key]['value']) === 1 && InsuranceDetailsSchema[key]['value'] !== null && !isNaN(parseFloat(InsuranceDetailsSchema[key]['value']))) {
                        pack = true;
                    }
                }
                if (feild['name'] === 'icu_stay') {
                    if (feild['value'] !== '' && feild['value'] !== null && feild['value'] !== undefined && !isNaN(feild['value'])) {
                        total_stay = parseFloat(ele_val) + parseFloat(feild['value']);
                        console.log('LOSLOSSTAY3', total_stay);
                        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: total_stay , status: true } })
                    }
                    else {
                        total_stay = parseFloat(ele_val);
                        console.log('LOSLOSSTAY4', total_stay)
                        hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: total_stay , status: true } })
                    }
                }
            })
            this.setState((state) => ({ InsuranceDetailsSchema: InsuranceDetailsSchema }),() => {
                this.getMrd(ele_val);
            })


            if (total_stay !== '' && !isNaN(total_stay) && total_stay !== undefined && total_stay !== null) {
                InsuranceDetailsSchema.map((feild, key) => {
                    if (feild['name'] === 'length_of_stay') {
                        InsuranceDetailsSchema[key]['value'] = total_stay;
                        if(InsuranceDetailsSchema[key]['value'] === 0) {
                            hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema: [],los: null , status: false } })
                        }
                    }
                })
                this.setState({ InsuranceDetailsSchema: InsuranceDetailsSchema })
            }
            if (!pack) {
                let qty_for_room_stay = [{ header: 1 }, { header: 2 }, { header: 4 }, { header: 6 }, { header: 8 }, { header: 9 }, { header: 10 }, { header: 11 }, { header: 12 }, { header: 16 },{header:15}];
                addonSchema.map((subTable, key) => {
                    qty_for_room_stay.map((room_stay, room_stay_key) => {
                        if (subTable.header === room_stay.header) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                let rate;
                                let qty;
                                if (table_key === 0) {
                                    if (feild.key_word !== 'intensivist') {
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.table === 'general_equipment_charges' || sub_feild.table === 'ot_equipment' || sub_feild.table === 'procedure_charges' || sub_feild.table === 'blood_bank_charges' || sub_feild.table === 'ot_cath_pharmacy' || sub_feild.table === 'ot_charges') {
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                    qty = 1;
                                                }
                                            } else if (sub_feild.row_group === 'dietician') {
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
                                                    qty = total_stay;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * rate;
                                                    }
                                                }

                                            }
                                            else {
                                                if(sub_feild.table==='isolation_charges' && sub_feild.row_group==='ins_room_isolation_charges' ){
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val;
                                                        qty = ele_val;
                                                    }
                                                }else{
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val;
                                                        qty = ele_val;
                                                    }  
                                                }
                                               
                                            }

                                            if (sub_feild.name === 'rate') {
                                                rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * rate;
                                                }
                                            }
                                        })
                                    }

                                }
                                if (table_key === 1) {
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.table === 'ins_physiotherapy_diet_charges' || sub_feild.table === 'ot_charges') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(ele_val) * rate;
                                                }
                                            }
                                        }
                                    })
                                }

                            })
                        }
                    })
                })

            }
            else {
                addonSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        if (table_key === 0) {
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                }
                            })
                        }
                    })
                })

                // InsuranceDetailsSchema.map((feild, key) => {
                //     if (feild['name'] === 'length_of_stay') {
                //         InsuranceDetailsSchema[key]['value'] = null;
                //     }
                // })
            }
        }
        // erroremployer_name_company errormemployer_name_company errormemployer_name_company
        let formFeilds = InsuranceDetailsSchema;
        if (Insuranceerrors.length > 0) {
            Insuranceerrors.map((index) => {
                InsuranceDetailsSchema.map((item, key) => {
                    if (item['name'] === ele_name && item['id'] === index['id']) {
                        document.getElementById("errorm" + item['name']).style.display = "none";
                    }
                })
            })
        }

        // let error1 = this.validateModalFeilds(formFeilds);
        this.setState((state) => ({
            'basicSumInsuredSchema': basicSumInsuredSchema,
            'InsuranceDetailsSchema': InsuranceDetailsSchema,
            'addonSchema': addonSchema, additionalPackageSchema,
        }),
            () => {
                let { InsuranceDetailsSchema } = this.state;
                let obj = {}
                InsuranceDetailsSchema.map((feild, key) => {
                    if (feild['name'] === 'care_management') {
                        obj[feild['name']] = feild['value'];
                    }
                    if (feild['name'] === 'estimate_type') {
                        obj[feild['name']] = feild['value']
                    }
                    if (feild['name'] === 'ins_surgery_procedure_name') {
                        obj[feild['name']] = (feild['selected_option'] && feild['selected_option']['id']) ? feild['selected_option']['id'] : null;
                        obj['service_id'] = feild['text']

                    }
                })

                if (ele_name === 'care_management' && obj['care_management'] && obj['care_management'] == 1) {
                    this.updateDefaultEstimates(obj);
                } else {
                    if (ele_name === 'ins_surgery_procedure_name' && obj['care_management'] && obj['care_management'] == 2 && obj['estimate_type'] && obj['estimate_type'] == 2 && obj['ins_surgery_procedure_name']) {
                        this.updateDefaultEstimates(obj);
                    }
                }
            });
        } catch (error) {
            Modal.error({
                title: 'Error message',
                content: 'Oops! something went wrong. Please,try again later'
            });
        }

        console.log('InsuranceDetailsSchemadd', InsuranceDetailsSchema);
    }

    buttonClick3(feilds, type) {
        this.setState((state) => ({ 'basicSumInsuredSchema': feilds }),
            () => {
                this.insurance_total(type.type);

            });
    }

    updateDefaultEstimates(obj) {
        try {
            let { addonSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, basicSumInsuredSchema, nmePopupSchema } = this.state;
            let { basic_info,counselling_details } = this.props;
            // default Response
            // this.setState({ 'loadding': true });
            let { slug } = this.props.match.params;
            // let disabled = false;
            // const params = new URLSearchParams(this.props.location);
            const params = new URLSearchParams(this.props.location.search);
            const rid = params.get('rid');
            const cd = params.get('cd');
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
                slug = 'recounselling';
                // if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE']) ){
                //     console.log('ttest');
                //  }else{
                //      slug = 'finanical-counselling'; 
                //  }
            }
            else if (slug === 'view-finanical-counselling') {
                slug = 'view-finanical-counselling';
            }
            else {
                slug = 'finanical-counselling';
            }

            let { ins_surgery_procedure_name, care_management } = obj ? obj : {};
            let payload = {}
            if (care_management == 1) {
                payload = {
                    "payment_type": 2,
                    "tariff_mapped": this.state.tariff_mapped,
                    "procedure_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                    "unit_id": user_unit_id
                }
            } else {
                payload = {
                    "procedure_id": obj['service_id'] ? obj['service_id'] : null,
                    // "service_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                    // "service_id": obj['service_id'] ?  obj['service_id']: null,
                    "payment_type": 2,
                    // "tariff_mapped": 2,
                    "unit_id":user_unit_id
                }
            }

            if (slug === 'finanical-counselling' || (slug === 'recounselling' && counselling_details===null) || (slug === 'recounselling' && counselling_details&&counselling_details['care_management'] !== care_management) || (slug === 'recounselling' && counselling_details&& obj['service_id']&&counselling_details['surgery_procedure_id']!==obj['service_id'])) {
                // this.setState({ 'loadding': true });
                postService('getMasterRoutineEstimates', 'POST', { "data": payload }).then(res => {
                    console.log('getMasterRoutineEstimates', res)
                    if (res) {
                        if (res['status']) {
                            InsuranceDetailsSchema.map((feild, key) => {
                                if (feild.name === 'icu_stay') {
                                    InsuranceDetailsSchema[key]['value'] = res['icu_stay'];
                                }
                                if (feild.name === 'room_stay') {
                                    InsuranceDetailsSchema[key]['value'] = res['room_stay'];
                                }

                                if (feild.name === 'length_of_stay') {
                                    InsuranceDetailsSchema[key]['value'] = res['icu_stay'] + res['room_stay'];
                                    hideInEXStore.dispatch({ type: 'SET_NME_POPUPS_SCHEMA', data: { nmePopupSchema,los: InsuranceDetailsSchema[key]['value'] , status: true } });
                                }
                            })
                            this.setState({ 'InsuranceDetailsSchema': InsuranceDetailsSchema, 'MasterRoutineEstimates': res, loadding: false }, () => {
                                this.setData(res)
                            })
                        }
                    }


                })
            }



        }
        catch (error) {
            console.log(error);
            this.setState({ 'loadding': false, 'MasterRoutineEstimates': [] });

        }

        // this.setState({ 'loadding': false});
    }

    setData(response) {
        // console.clear();
        let { addonSchema, basicSumInsuredSchema, InsuranceDetailsSchema, MasterRoutineEstimates } = this.state;
        try {
            let { data } = MasterRoutineEstimates;
            let selected_room = null;
            let care_management = null
            let icu_stay,room_stay=null;
            basicSumInsuredSchema.map((feild, key) => {
               
                if (feild.name === 'ins_room_eligible_ward') {
                    if (feild.data[0].name == 'ins_room_eligible_ward_names') {
                        selected_room = feild.data[0].value;
                    }
                }
                if (feild.name === 'ins_upgrade_room' && selected_room && selected_room !== '') {
                    if (feild.data[0].name == 'ins_upgrade_room_names') {
                        selected_room = feild.data[0].value?feild.data[0].value:selected_room;

                    }
                }
                if (feild['name'] === 'icu_opted') {
                    if (icu_stay !== '' && icu_stay !== undefined && icu_stay !== null && !isNaN(icu_stay) && icu_stay !== 0) {
                        basicSumInsuredSchema[key]['visible'] = true;
                        basicSumInsuredSchema[key]['disable'] = false;
                        basicSumInsuredSchema[key]['value'] = null;
                        basicSumInsuredSchema[key]['text'] = null;
                    }

                }
            })
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'care_management') {
                    care_management = feild['value'];
                }
                if (feild.name === 'icu_stay') {
                    icu_stay = feild.value
               }
               if (feild.name === 'room_stay') {
                    room_stay = feild.value
               }
            })
            let los = 0;
            if (icu_stay && room_stay) {
                los = parseFloat(icu_stay) + parseFloat(room_stay);
            }else{
                los = icu_stay?parseFloat(icu_stay):0 + room_stay?parseFloat(room_stay):0; 
            }
            data.map((table_data, key) => {
                let { sub_header_id, header_id, room_data, info } = table_data;
                let current_room = room_data.find((data) => (data.id == selected_room || data.room_id == selected_room));
                addonSchema.map((subTable, key) => {
                    let { header } = subTable;
                    let table_name = subTable.name
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        let is_selected = false;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.sub_header && header === header_id && sub_header_id === sub_feild.sub_header) {
                                console.log(current_room, header, sub_feild.sub_header, header_id, sub_header_id)
                                is_selected = true;
                            }
                            else{
                                if ((sub_feild.table === 'ot_cath_pharmacy' && care_management == 1) || (sub_feild.table === 'ot_equipment' && care_management == 1) || (sub_feild.table === 'ot_charges' && care_management == 1)) {

                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }

                                }
                                else{
                                    if(sub_feild.table ==='isolation_charges' && sub_feild.row_group ==='ins_icu_isolation_charges'){
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay ? parseFloat(icu_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ? parseFloat(icu_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=false
                                        }
                                    }
                                    if(sub_feild.table ==='isolation_charges' && sub_feild.row_group ==='ins_room_isolation_charges'){
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =  room_stay ? parseFloat(room_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] =  room_stay ? parseFloat(room_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=false
                                        }
                                    }
                                    
                                }
                            }
                            if (is_selected) {
                                if (sub_feild.tooltip === null && info !== null) {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["tooltip"] = info;
                                    if(sub_feild.table==='ot_charges' && sub_feild.name==='routine'&& info !== null){
                                        let user_data = JSON.parse(Storage.get('user_data'));
                                        let user_unit_id = user_data.unitid;
                                        let service_id,room_upgrade_reason,uprade_room_id;
                                    postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 9, sub_header_id: 18, tariff_mapped: this.state.tariff_mapped  } }).then(res => {
                                        if (res.status && res.data.length>0) {
                                           if(info=='0.5' || info=='1'){
                                           service_id=res.data[0].id;
                                        }else{
                                             service_id=res.data[2].id;
                                        }
                                        basicSumInsuredSchema.map((feild, key) => {
                                            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                                let { data } = feild;
                                                data.map((sub_feild, sub_key) => {
                                                    if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                                        console.log('ins_room_eligible_ward_amount:', sub_feild)
                                                        selected_room = sub_feild.value; //note
                                                    }
                                                    // if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                                    //     selected_room = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                    // }
                                                })
                                            }
                                
                                            if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                                let { data } = feild;
                                                data.map((sub_feild, sub_key) => {
                                                    if (sub_feild.name === 'ins_upgrade_room_names') {
                                                        uprade_room_id = sub_feild.value ? sub_feild.value : null;
                                                    }
                                
                                                })
                                            }
                                            if (feild.name === "ins_room_upgrade_reason") {
                                                room_upgrade_reason = feild.value ? feild.value : null;
                                                if (room_upgrade_reason == 3) {
                                                    selected_room = uprade_room_id
                                                }
                                            }
                                        })
                                        postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                                            if (response.status) {
                                                console.log('responseresponseresponse', response)
                                                if (response.data.length > 0) {
                                                    let amount,rate;
                                                    let data_value = 0;
                                                    response.data.map((feild, key) => {
                                                        if (feild.room_id == selected_room) {
                                                            amount = parseFloat(feild.amount);
                                                            addonSchema.map((subTable, key) => {
                                                                if (subTable.name === 'ot_charges') {
                                                                    let table_body = subTable.Specification.table_body;
                                                                    table_body.map((feild, table_key) => {
                                                                        let row = feild.feilds;
                                                                        if (feild.key_word === 'ot_inst_disinfec') {
                                                                            row.map((sub_feild, sub_table_key) => {
                                                                                if (sub_feild.name === "qty") {
                                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                                                }
                                                                                if (sub_feild.name === "rate") {
                                                                                    rate=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount+rate
                                                                                }
                                                                                if (sub_feild.name === "amount") {
                                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount+rate
                                                                                }
                                                                            })
                                                                        }
                                                                    })
                                                                }
                                                            })
                                                            this.setState({ addonSchema: addonSchema });
                                                            this.total_suming();
                                                            // this.sumingProcedureAmounts();
                                                        }
                                                    })
                                                }
                                                else {
                                                    Modal.error({
                                                        title: 'Error message',
                                                        content: 'No amount for the selected room',
                                                    });
                                                }
                                            }
                                            else {
                                                Modal.error({
                                                    title: 'Error message',
                                                    content: 'Something went wrong',
                                                });
                                            }
                                        })
                                    }
                                    else {
                                        Modal.error({
                                            title: 'Error message',
                                            content: 'No service available',
                                        });
                                    }
                            
                                    })
                                }
                                }
                                if ((sub_feild.table === 'ot_cath_pharmacy' && care_management == 1) || (sub_feild.table === 'ot_equipment' && care_management == 1) || (sub_feild.table === 'ot_charges' && care_management == 1)) {

                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }

                                } else {

                                    if (sub_feild.table === 'icu_pharmacy_charges' || sub_feild.table === 'icu_investigation_charges' || (sub_feild.table ==='isolation_charges' && sub_feild.row_group ==='ins_icu_isolation_charges')) {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay ? parseFloat(icu_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ? parseFloat(icu_stay) : 0;
                                        }
                                    } else if (sub_feild.table === 'room_investigation_charges' || sub_feild.table === 'ip_pharmacy_charges' || (sub_feild.table ==='isolation_charges' && sub_feild.row_group ==='ins_room_isolation_charges')) {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_stay ? parseFloat(room_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = room_stay ? parseFloat(room_stay) : 0;
                                        }
                                    }
                                    else if (sub_feild.row_group === 'dietician') {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = los;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = los;
                                        }
                                    } else {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 1;
                                        }
                                    }
                                    if (sub_feild.name === 'rate') {
                                        if (sub_feild.table === 'icu_pharmacy_charges' || sub_feild.table === 'icu_investigation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =icu_stay ? parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0 : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ?  parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0: 0
                                            }
                                            else{
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0  
                                            }
                                    }
                                    if (sub_feild.row_group === 'dietician') {
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = current_room['amount'] ? parseFloat(current_room['amount']) * parseFloat(los) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = current_room['amount'] ? parseFloat(current_room['amount']) * parseFloat(los) : 0
                                        }
                                    } else {
                                        if (sub_feild.name === 'amount') {
                                            if (sub_feild.table === 'icu_pharmacy_charges' || sub_feild.table === 'icu_investigation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay ? parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0 : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ? parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0 : 0
                                            }
                                            else{
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0 
                                            }
                                        }
                                    }
                                }

                            }
                        })
                    })
                })
            })
            if (room_stay !== '' && room_stay !== undefined && room_stay !== null && !isNaN(room_stay) && room_stay !== 0) {
                let qty_for_room_stay = [{ header: 1 }, { header: 2 }, { header: 4 }];

                addonSchema.map((subTable, key) => {
                    qty_for_room_stay.map((room_stays, room_stay_key) => {
                        if (subTable.header === room_stays.header) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                if (table_key === 0) {
                                    let row = feild.feilds;
                                    let rate;
                                    if (feild.key_word !== 'intensivist') {
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_stay;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(room_stay) * rate;
                                                }
                                            }
                                        })
                                    }

                                }
                            })
                        }
                    })
                })
            }
            this.getMrd(los);
            this.setState(({ 'loadding': false, 'addonSchema': addonSchema }), () => {
                this.total_suming()

            });
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    insurance_total(type) {
        try {
        let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        let { counselling_details } = this.props;
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
            if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE']) ){
                console.log('ttest');
             }else{
                 slug = 'finanical-counselling'; 
             }
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }
        let { basicSumInsuredSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, addonSchema, total_estimate_amount, inital_package_amount, ailmentSchema, nme_total_amount, exclude_total_amount, basicsuminsureerrors, additionalProcedureSchema, additionalPackageSchema, room_upgrade_reasons,includesSchema,interimSchema,basic_info,insurance_total_estimation_date } = this.state;
        let care_management = null,
            icu_stay = 0,
            room_stay = 0,
            length_of_stay = 0,
            estimate_type = null,
            package_amount = 0,
            surgery_amount = 0,
            basic_sum_insured = 0, top_up_amount = 0, balance_sum_insured = 0,
            copay_percentage = 0, copay_amount = 0,
            room_percentage = 0, room_amount = 0,
            room_eligible_ward_amount = 0,
            room_upgrade_ward_amount = 0,
            room_upgrade_reason = null,
            icu_percentage = 0, icu_amount = 0,
            icu_eligible_amount = 0,
            icu_differance = 0,
            room_eligible_package_amount = 0,
            room_upgrade_package_amount = 0,
            package_difference = 0,
            pro_rata_difference = 0,
            room_diferance = 0,
            percentage_calculate = 0,
            pro_total_cost = 0,
            room_difference = 0,
            ins_select_difference = null,
            ins_surgery_procedure_name_id = 0,
            additional_packages_amount = 0,
            ins_icu_type = 0,
            inital_package_amounts=0,
            room_dif_percentage=0,
            icu_dif_percentage=0,
            estimated_admission_date=null
        let ele_name = '';

        let package_base_price = 0;

        InsuranceDetailsSchema.map((feild, key) => {
            if (feild.name === 'estimated_admission_date') {
                estimated_admission_date = feild.value ? feild.value : null;
            }
            if (feild.name === 'care_management') {
                care_management = feild.value ? feild.value : null;
            }
            if (feild.name === "estimate_type") {
                estimate_type = feild.value ? feild.value : null;
            }
            if (feild.name === 'icu_stay') {
                icu_stay = feild.value ? parseInt(feild.value) : 0;
            }
            if (feild.name === 'room_stay') {
                room_stay = feild.value ? parseInt(feild.value) : 0;
            }
            if (feild.name === 'length_of_stay') {
                length_of_stay = room_stay + icu_stay;
            }
            if (feild.name === 'ins_package_name') {

                package_amount = feild.amount ? parseInt(feild.amount) : 0;
            }

            if (feild.name === 'ins_surgery_procedure_name') {
                ins_surgery_procedure_name_id = feild.value ? parseInt(feild.value) : 0;
            }
            if (feild.name === 'ins_surgery_procedure_amount') {
                surgery_amount = feild.value ? parseInt(feild.value) : 0;
            }
        })

        basicSumInsuredSchema.map((feild, key) => {
            let {insurance_company_mou_flag, insuranceCompanyName, isModalShown} = this.state;
            if (feild.name === 'basic_sum_insured') {
                basic_sum_insured = feild.value ? parseFloat(feild.value) : 0;
            }
            if (feild.name === 'top_up_amount') {
                top_up_amount = feild.value ? parseFloat(feild.value) : 0;
            }
            if (feild.name === 'balance_sum_insured') {
                balance_sum_insured = feild.value ? parseFloat(feild.value) : 0;
            }

            // copay_percentage = 0, copay_amount = 0,


            if (feild.name === 'ins_room_eligible'  && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_percent') {

                        room_percentage = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                    }
                    if (sub_feild.name === 'ins_room_eligible_amount') {
                        room_amount = Math.round(basic_sum_insured * (room_percentage / 100));
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = room_amount;
                    }


                });
                if((insurance_company_mou_flag === '1' || insurance_company_mou_flag === 1) && !isModalShown && room_percentage){
                    Modal.info({
                        title: `Info`,
                        content: `As per MoU with '${insuranceCompanyName}', please select eligible ward group as single or lower only.`,
                        zIndex: '1022'
                    });
                    this.setState({ isModalShown: true });
                    return;
                }
            }

            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_ward_names') {
                        room_eligible_package_amount = sub_feild.package_charges ? parseFloat(sub_feild.package_charges) : 0;
                    }
                    if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                        room_eligible_ward_amount = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                    }
                })
                if (estimate_type == 2 || estimate_type == null) {
                       
                    
                    // addonSchema.map((subTable, key) => {
                    //         if (subTable.name === 'room_charges') {
                    //             let table_body = subTable.Specification.table_body;
                    //             table_body.map((feild, table_key) => {
                    //                 if (table_key === 0) {
                    //                     let row = feild.feilds;
                    //                     let qty;
                    //                     row.map((sub_feild, sub_table_key) => {
                    //                         if (sub_feild.name === 'qty') {
                    //                             qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                    //                             if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                    //                                 qty = 0;
                    //                             }
                    //                         }
                    //                         if (sub_feild.name === 'rate') {
                    //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_eligible_ward_amount;
                    //                         }
                    //                         if (sub_feild.name === 'amount') {
                    //                             if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(room_eligible_ward_amount);
                    //                             }
                    //                         }
                    //                     })
                    //                 }
                    //             })
                    //         }
                    //     })
                   
                    // this.sumingProcedureAmounts();

                    basicSumInsuredSchema.map((item, key) => {
                        if (item.name === 'ins_upgrade_room' && item.type && item.type === 'group') {
                            let { data } = item;
                            data.map((sub_feild, sub_key) => {
                                if (sub_feild.name === 'ins_upgrade_room_names') {
                                    room_upgrade_ward_amount =sub_feild['value']? sub_feild['amount']? parseFloat(sub_feild['amount']) : 0:0;
                                    room_upgrade_package_amount = sub_feild.package_charges ? parseFloat(sub_feild.package_charges) : 0;
                                }
                                if (sub_feild.name === 'ins_upgrade_room_amount') {
                                    room_upgrade_ward_amount = room_upgrade_ward_amount ? parseFloat(room_upgrade_ward_amount) : 0;
                                    basicSumInsuredSchema[key]['data'][sub_key]['value'] = room_upgrade_ward_amount;
                                }
                            })
                        }
                        if (item.name === "ins_room_upgrade_reason" ) {
                            if (room_upgrade_ward_amount) {
                                room_upgrade_reason = item.value ? item.value : null;
                                basicSumInsuredSchema[key]['visible'] = true;
                            } else {
                                room_upgrade_reason =0;
                                basicSumInsuredSchema[key]['visible'] = false;
                                basicSumInsuredSchema[key]['value']=null;
                                basicSumInsuredSchema[key]['text']=null;
                            }
                        }
                    })
                    if(room_upgrade_reason==3 &&  moment(insurance_total_estimation_date).isAfter(estimated_admission_date)){
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        let qty,rate;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {
                                                qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                    qty = 0;
                                                }
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_upgrade_ward_amount?room_upgrade_ward_amount :room_eligible_ward_amount;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"]=room_upgrade_ward_amount?room_upgrade_ward_amount :room_eligible_ward_amount;
                                                rate=room_upgrade_ward_amount?room_upgrade_ward_amount :room_eligible_ward_amount;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = (parseFloat(qty) * (parseFloat(rate)));
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = (parseFloat(qty) * (parseFloat(rate)));
                                                }
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }else{
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        let qty;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {
                                                qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                    qty = 0;
                                                }
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_eligible_ward_amount;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(room_eligible_ward_amount);
                                                }
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                }


            }

            if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_upgrade_room_names') {
                        room_upgrade_ward_amount =sub_feild['value']? sub_feild['amount']? parseFloat(sub_feild['amount']) : 0:0;
                        room_upgrade_package_amount = sub_feild.package_charges ? parseFloat(sub_feild.package_charges) : 0;
                    }
                    if (sub_feild.name === 'ins_upgrade_room_amount') {
                        room_upgrade_ward_amount = room_upgrade_ward_amount ? parseFloat(room_upgrade_ward_amount) : 0;
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = room_upgrade_ward_amount;
                    }
                })
            }

            if (feild.name === "ins_room_upgrade_reason" ) {
                if (room_upgrade_ward_amount) {
                    room_upgrade_reason = feild.value ? feild.value : null;
                    basicSumInsuredSchema[key]['visible'] = true;
                } else {
                    room_upgrade_reason =0;
                    basicSumInsuredSchema[key]['visible'] = false;
                    basicSumInsuredSchema[key]['value']=null;
                    basicSumInsuredSchema[key]['text']=null;
                }
                if (room_upgrade_reason == 3 && type==="ins_upgrade_room_names"){
                    this.setState((state) =>({ inital_package_amount:room_upgrade_package_amount}), () => {
                        this.setState({inital_package_amount:room_upgrade_package_amount});
                        this.total_suming();
                    });
                }
                this.setState({ room_upgrade_reasons: room_upgrade_reason })
                if (room_upgrade_reason == 3 && type==="ins_room_upgrade_reason" ) {

                    if (estimate_type == 2 ) {

                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        let qty,rate;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {
                                                qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                    qty = 0;
                                                }
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_upgrade_ward_amount?room_upgrade_ward_amount :room_eligible_ward_amount;
                                                rate=room_upgrade_ward_amount?room_upgrade_ward_amount :room_eligible_ward_amount;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * (parseFloat(rate));
                                                }
                                            }
                                        })
                                    }
                                })
                            }
                        })
                        // this.sumingProcedureAmounts();
                    }
                    if(estimate_type==1  ){
                        this.setState({ inital_package_amount:room_upgrade_package_amount});
                        if(slug === 'recounselling'){
                            const { getconfigurations } = networkList;

                            let user_data = JSON.parse(Storage.get('user_data'));
                            let user_unit_id = user_data.unitid;
                            try {
                                postService(getconfigurations, 'GET', 'null').then(res => {
                                    if (res) {
                                        if (res.status) {
                                            if (res.data.length > 0) {
                                                this.setState({ configuration: res.data[0].data })
                                                if (res.data[0].data.length > 0) {
                                                    res.data[0].data.map((feilds, key) => {
                                                        if (feilds.config_name === 'Ins-Physician Fees Room') {
                                                            addonSchema.map((subTable, key) => {
                                                                if (subTable.header === 18) {
                                                                    let table_body = subTable.Specification.table_body;
                                                                    table_body.map((feild, table_key) => {
                                                                        if (feild.id === 1) {
                                                                            let row = feild.feilds;
                                                                            row.map((sub_feild, sub_table_key) => {
                                                                                if (sub_feild.name === 'percentage') {
                                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                                    this.setState({ addonSchema: addonSchema });
                                                                                }
                                                                            })
                                                                        }
                                                                    })
                                                                }
                                                            })
                                                        }
                                                        if (feilds.config_name === 'Ins-Physician Fees ICU') {
                                                            addonSchema.map((subTable, key) => {
                                                                if (subTable.header === 18) {
                                                                    let table_body = subTable.Specification.table_body;
                                                                    table_body.map((feild, table_key) => {
                                                                        if (feild.id === 2) {
                                                                            let row = feild.feilds;
                                                                            row.map((sub_feild, sub_table_key) => {
                                                                                if (sub_feild.name === 'percentage') {
                                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                                    this.setState({ addonSchema: addonSchema });
                                                                                }
                                                                            })
                                                                        }
                                                                    })
                                                                }
                                                            })
                                                            const Insu_Physician_Fees_ICU = feilds.bill_tracking_percent;
                                                            this.setState({ Insu_Physician_Fees_ICU: Insu_Physician_Fees_ICU })
                                                        }
                                                        if (feilds.config_name === 'Additional  package1') {
                                                            const additional_package_percent1 = feilds.bill_tracking_percent;
                                                            this.setState({ additional_package_percent1: additional_package_percent1 })
                                                            this.highestPackage();
                                                        }
                                                        if (feilds.config_name === 'Additional  package2') {
                                                            const additional_package_percent2 = feilds.bill_tracking_percent;
                                                            this.setState({ additional_package_percent2: additional_package_percent2 })
                                                            this.highestPackage();
                                                        }
                
                                                    })
                                                }
                                            }
                                            else {
                                                Modal.error({
                                                    title: 'Error message',
                                                    content: 'No service available',
                                                });
                                            }
                                        } else {
                
                                            Modal.error({
                                                title: 'Error message',
                                                content: 'Something went wrong ',
                                            });
                                        }
                                    }
                                });
                            } catch (error) {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'Oops! something went wrong. Please,try again later'
                                });
                            }
                        }
                        // this.setState({ total_estimate_amount: room_upgrade_package_amount });
                        inital_package_amounts=room_upgrade_package_amount
                      
                    }
                }else{
                    if(estimate_type==1 && type==="ins_room_upgrade_reason"){
                        console.log(room_eligible_package_amount);
                        this.setState({ inital_package_amount:room_eligible_package_amount});
                        // this.setState({ total_estimate_amount: room_eligible_package_amount });
                        inital_package_amounts=room_eligible_package_amount
                        this.highestPackage();
                    } 
                }

            }
            

            if (feild.name === 'ins_icu_eligible' && feild.type === 'group') {

                if((icu_stay==='' || icu_stay===0 ||icu_stay===null||icu_stay===undefined)&&estimate_type!=1){
                    feild.visible=false;
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_icu_percent') { 
                            sub_feild.visible=false;
                        } 
                        if (sub_feild.name === 'ins_icu_amount') {
                            sub_feild.visible=false;
                        }
                    });
                }else{
                    if(estimate_type==1){
                        feild.visible=true;
                        let { data } = feild;
                        feild.rules=[];
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_percent') {
                                sub_feild.visible=true;
                                icu_percentage = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                sub_feild.visible=true;
                                console.log('he,', basic_sum_insured, icu_percentage)
                                icu_amount = Math.round(basic_sum_insured * (icu_percentage / 100));
                                if (estimate_type === 1) {
        
                                }
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = icu_amount;
        
                            }
                        })
                    }else{
                        feild.visible=true;
                        feild.rules=[
                            {
                                test: (value) => {
                                    return (value !== null && value.length > 0);
                                },
                                message: 'Please Enter Room Eligibility %'
                            }
                        ];
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_percent') {
                                sub_feild.visible=true;
                                icu_percentage = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                sub_feild.visible=true;
                                console.log('he,', basic_sum_insured, icu_percentage)
                                icu_amount = Math.round(basic_sum_insured * (icu_percentage / 100));
                                if (estimate_type === 1) {
        
                                }
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = icu_amount;
        
                            }
                        })
                    }
                    
                }
                
            }

            if (feild.name === 'ins_icu'  && feild.type === 'group') {
                if((icu_stay==='' || icu_stay===0 ||icu_stay===null||icu_stay===undefined)&&estimate_type!=1){
                    feild.visible=false;
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_icu_type') {
                            sub_feild.visible=false
                        }
                        if (sub_feild.name === 'ins_icu_amount') {
                            sub_feild.visible=false
                        }
                    })
                }else{
                 
                        feild.visible=true;
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_icu_type') {
                                sub_feild.visible=true
                                icu_eligible_amount = sub_feild['amount'] ? parseFloat(sub_feild['amount']) : 0;
                                ins_icu_type = sub_feild['value'] ? parseFloat(sub_feild['value']) : 0;
                                // basicSumInsuredSchema[key]['data'][sub_key]['text']=sub_feild['amount']&&sub_feild['text']
                            }
                            if (sub_feild.name === 'ins_icu_amount') {
                                sub_feild.visible=true
                                if (ins_icu_type !== 0 && ins_icu_type !== '') {
                                    icu_eligible_amount = icu_eligible_amount ? parseFloat(icu_eligible_amount) : 0;
                                    basicSumInsuredSchema[key]['data'][sub_key]['value'] = icu_eligible_amount;
                                } else {
                                    basicSumInsuredSchema[key]['data'][sub_key]['value'] = 0;
                                    icu_eligible_amount = 0;
                                }
        
                            }
                        })
                   
                    
                }
               
                if ((estimate_type == 2 && type==='ins_icu_type')|| (estimate_type == null && type==='ins_icu_type')) {
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === 'room_charges') {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                if (table_key === 1) {
                                    let row = feild.feilds;
                                    let qty;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === 'qty') {
                                            qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                            if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                qty = 0;
                                            }
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =icu_stay!==0? icu_eligible_amount:0;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(icu_eligible_amount);
                                                this.total_suming();
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    })
                    let amount = 0;
                    addonSchema.map((subTable, key) => {
                        if (subTable.name !== 'ins_surgical_charges' && subTable.name !== 'ins_medical_charges') {
                            let table_body = subTable.Specification.table_body;
                            let header_amount = 0;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                        amount = parseFloat(amount) + parseFloat(sub_feild.value);
                                        header_amount = parseFloat(header_amount) + parseFloat(sub_feild.value);
                                    }
                                })
                            })
                            addonSchema[key]['header_amount'] = header_amount;
                        }
                    })

                    // this.sumingProcedureAmounts();
                }
                

            }

            if (feild.name === "ins_icu_difference") {
                if((icu_stay==='' || icu_stay===0 ||icu_stay===null||icu_stay===undefined)&&estimate_type!=1){
                    feild.visible=false;
                }else{
                        feild.visible=true;
                        if (ins_icu_type !== 0 && ins_icu_type !== '') {
                            if (estimate_type == 1) {
                                icu_differance = Math.round((icu_eligible_amount - icu_amount));
                                basicSumInsuredSchema[key]['value'] = (icu_differance && icu_differance > 0) ? icu_differance : 0;
                                basicSumInsuredSchema[key]['disable'] = true;
                            } else {
                                icu_differance = Math.round((icu_eligible_amount - icu_amount) * icu_stay);
                                basicSumInsuredSchema[key]['value'] = (icu_differance && icu_differance > 0) ? icu_differance : 0;
                                basicSumInsuredSchema[key]['disable'] = true;
                            }
                        } else {
                            basicSumInsuredSchema[key]['value'] = 0;
                            basicSumInsuredSchema[key]['disable'] = true;
                        }
                    }
                
            }
            if (feild.name === "ins_select_difference") {
               
                if (estimate_type == 1) {
                    basicSumInsuredSchema[key]['visible'] = false;
                } else {
                    if (room_upgrade_reason == 3) {
                        
                        basicSumInsuredSchema[key]['visible'] = true;
                        ins_select_difference = feild.value ? feild.value : null
                    } else {
                        basicSumInsuredSchema[key]['visible'] = false;
                    }
                }
            }
            if (feild.name === "ins_room_difference_amount") {
                if (room_upgrade_reason == 3) {
                    // pay by patientd
                    room_difference = Math.round((room_upgrade_ward_amount - room_amount) * room_stay) + Math.round((icu_eligible_amount - icu_amount) * icu_stay);
                    if( icu_amount>icu_eligible_amount){
                        room_difference = Math.round((room_upgrade_ward_amount - room_amount) * room_stay)  
                    }
                } else {
                    room_difference = 0
                }
                if (ins_select_difference == '1') {
                    basicSumInsuredSchema[key]['value'] = (room_difference && room_difference > 0) ? room_difference : 0;
                    basicSumInsuredSchema[key]['disable'] = true;
                    basicSumInsuredSchema[key]['visible'] = true;

                }
                else {
                    basicSumInsuredSchema[key]['visible'] = false;
                    basicSumInsuredSchema[key]['value']=0;
                }

            }

            if (feild.name === "ins_pro_rata_difference_amount") {

                let amount = 0
                if (room_upgrade_reason == 3) {

                    // pay by patient
                    pro_rata_difference = (room_upgrade_ward_amount - room_amount) * room_stay;
                    room_diferance = parseFloat(room_upgrade_ward_amount) - parseFloat(room_amount);
                    icu_differance = parseFloat(icu_eligible_amount) - parseFloat(icu_amount);
                   
                    // const total_upgrate_room_icu = room_dif_per + icu_differance;
                    // const total_room_icu = room_amount + icu_amount;
                    room_dif_percentage=room_diferance!==0 &&room_amount!==0 &&room_diferance>0?(room_diferance/room_amount):0;
                    icu_dif_percentage=icu_differance!==0&&icu_amount!==0 &&icu_dif_percentage>0? (icu_differance/icu_amount):0;
                    if(icu_dif_percentage<0){
                        icu_dif_percentage=0;
                    }
                    if(room_dif_percentage<0){
                        room_dif_percentage=0;
                    }
                    // else{
                    //     icu_dif_percentage=0  
                    // }
            if(room_dif_percentage!==0&&icu_dif_percentage!==0) {
                percentage_calculate=((room_dif_percentage+icu_dif_percentage)/2)*100;
            }else if(room_dif_percentage!==0 && icu_dif_percentage===0){
                percentage_calculate=room_dif_percentage*100
            }else{
                if(icu_dif_percentage!==0 && room_dif_percentage==0){
                    percentage_calculate=icu_dif_percentage*100
                }else{
                    percentage_calculate=0;
                }
              
            }
                    // percentage_calculate = (parseFloat(total_upgrate_room_icu) / parseFloat(total_room_icu)) * 100;
                } else {
                    pro_rata_difference = 0
                }
                if (ins_select_difference == '2') {
                    // pro_rata_difference = feild.value ? feild.value : null;
                    basicSumInsuredSchema[key]['value'] = (pro_rata_difference && pro_rata_difference > 0) ? pro_rata_difference : 0;
                    basicSumInsuredSchema[key]['disable'] = true;
                    basicSumInsuredSchema[key]['visible'] = true;
                } else {
                    basicSumInsuredSchema[key]['visible'] = false;
                }
                if (percentage_calculate !== null) {

                    addonSchema.map((subTable, key) => {
                        if (subTable.name !== 'room_charges'
                            // && subTable.name !== 'room_investigation_charges'
                            // && subTable.name !== 'icu_investigation_charges'
                            && subTable.name !== 'ip_pharmacy_charges'
                            && subTable.name !== 'icu_pharmacy_charges'
                            && subTable.name !== 'ot_cath_pharmacy'

                        ) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                        amount = parseFloat(amount) + parseFloat(sub_feild.value);
                                        // pro_total_cost = pro_total_cost + parseFloat(amount)
                                    }
                                })
                            })
                        }
                    })
                    if (percentage_calculate !== null) {
                        if (parseFloat(percentage_calculate) > 70) {
                            percentage_calculate = 70;
                            console.log('percentage_calculate >70:', percentage_calculate, pro_total_cost, amount)
                        }
                        pro_total_cost =percentage_calculate!==0? Math.round((amount * (parseFloat(percentage_calculate) / 100)).toFixed(2)):0;
                    }
                    basicSumInsuredSchema[key]['value'] = (pro_total_cost) + (room_difference ? room_difference !== 'NAN'&& room_difference>0 ?(room_difference): 0 : 0);
                    basicSumInsuredSchema[key]['text'] = (pro_total_cost) + (room_difference ? room_difference !== 'NAN'&& room_difference>0 ? (room_difference) : 0 : 0);     
                  
                    // basicSumInsuredSchema[key]['value'] = Math.round(pro_total_cost);
                    // basicSumInsuredSchema[key]['text'] = Math.round(pro_total_cost);

                    console.log('final pro rata:', pro_total_cost,percentage_calculate,amount)
                } else {
                    basicSumInsuredSchema[key]['value'] = 0;
                    basicSumInsuredSchema[key]['text'] = 0;
                    basicSumInsuredSchema[key]['disable'] = true;
                }
                if (estimate_type == 1 || ins_select_difference !== '2' || room_upgrade_reason != 3) {
                    basicSumInsuredSchema[key]['value'] = 0;
                    basicSumInsuredSchema[key]['text'] = 0;
                }

            }
            if (feild.name === "ins_package_difference") {
                if (estimate_type == 1) {
                if (room_upgrade_reason == 3) {
                    // pay by patient                    
                    package_difference = room_upgrade_package_amount - room_eligible_package_amount;
                    basicSumInsuredSchema[key]['disable'] = true;
                    basicSumInsuredSchema[key]['visible'] = true;
                } else {
                    package_difference = 0
                }
                basicSumInsuredSchema[key]['value'] = (package_difference && package_difference > 0) ? package_difference : 0;
            }
            }
            if (feild.name === 'ins_ailment_capping' && type==='ins_ailment_capping') {
                if (feild.value == '1') {
                    ailmentSchema[0]['visible'] = true;
                    this.setState({ showAilment: true,  ailmentSchema:ailmentSchema})
                   
                }
                else {
                    ailmentSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        ailmentSchema[key].Specification.add_more = true;
                        table_body.map((feild, table_key) => {
                            if (table_body.length > 0) {
                                if (table_key === 0) {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'ins_ail_surgery_procedure_name') {
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    })
                                }
                                else {
                                    ailmentSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                        })
                    })
                    ailmentSchema[0]['visible'] = false;
                    this.setState({ showAilment: false, ailmentSchema })
                    this.total_suming();
                }
                if (feild.value == '' || feild.value == null) {
                    this.setState({ showAilment: false })
                }
            }
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'base_price' && (feild['value'] === '' || feild['value'] === null || feild['value'] === undefined || feild['value'] === 0)) {
                    if (estimate_type == 1) {
                        if (room_eligible_package_amount && room_eligible_package_amount !== null && room_eligible_package_amount !== undefined && room_eligible_package_amount !== '') {
                            estimateBreakupFormatSchema[key]['value'] = room_eligible_package_amount;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                            estimateBreakupFormatSchema[key]['visible'] = true;
                            this.setState({ total_estimate_amount: room_eligible_package_amount });
                        }
                    } else {
                        estimateBreakupFormatSchema[key]['value'] = 0
                        estimateBreakupFormatSchema[key]['visible'] = false;
                    }
                }
                if (feild['name'] === 'ins_total_estimate_amount' && (feild['value'] === '' || feild['value'] === null || feild['value'] === undefined || feild['value'] === 0)) {
                    if (estimate_type == 1) {
                        if (room_eligible_package_amount && room_eligible_package_amount !== null && room_eligible_package_amount !== undefined && room_eligible_package_amount !== '') {
                            estimateBreakupFormatSchema[key]['value'] = room_eligible_package_amount
                            estimateBreakupFormatSchema[key]['disable'] = true;
                            estimateBreakupFormatSchema[key]['visible'] = true;
                            this.setState({ total_estimate_amount: room_eligible_package_amount });
                        }

                    } else {
                        estimateBreakupFormatSchema[key]['visible'] = false;
                    }

                }

            })
            // load sur-pro amount on top section
            if (feild.name === 'ins_ailment_capping') {
                let amount, room_id, room_value = 0;
                basicSumInsuredSchema.map((feild, key) => {
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                console.log('ins_room_eligible_ward_amount:', sub_feild)
                                room_id = sub_feild['id']; //note
                                room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                        })
                    }
                })

                if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                    postService('getServicePricesById', 'POST', { data: { service_id: ins_surgery_procedure_name_id } }).then(res => {
                        if (res) {

                            res.data.map((feild, key) => {
                                if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                    amount = feild.amount;
                                    InsuranceDetailsSchema.map((feild, key) => {
                                        if (feild.name === 'ins_surgery_procedure_amount') {
                                            InsuranceDetailsSchema[key]['value'] = amount ? amount : 0
                                        }
                                    })

                                }
                            })
                        }

                    });
                }
                else {
                }
            }

        })

        let formFeilds = InsuranceDetailsSchema;
        if (type !== '' && type !== null && type !== undefined) {
            if (basicsuminsureerrors.length > 0) {
                basicsuminsureerrors.map((index) => {
                    basicSumInsuredSchema.map((item, key) => {
                        if (item['type'] === 'group' && item['id'] === index['id']) {
                            if (type === 'ins_room_eligible_percent' && item['id'] === 22) {
                                document.getElementById("errorm" + item['name']).style.display = "none";
                            }
                            if (type === 'ins_icu_percent' && item['id'] === 9) {
                                document.getElementById("errorm" + item['name']).style.display = "none";
                            }
                            if (type === 'ins_icu_type' && item['id'] === 54) {
                                document.getElementById("errorm" + item['name']).style.display = "none";
                            }
                        }
                        else {
                            if (item['name'] === type && item['id'] === index['id']) {
                                document.getElementById("errorm" + item['name']).style.display = "none";
                            }
                        }

                    })
                })
            }
        }

        if (type === 'ins_upgrade_room_names') {
            if (room_upgrade_reasons == 3) {
                this.setData();
                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            // if (table_name === 'room_charges') {
                            //     if (sub_feild.name === 'qty') {
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //     }
                            //     if (sub_feild.name === 'rate') {
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //     }
                            //     if (sub_feild.name === 'amount') {
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //     }
                            // }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'Routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'Routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ip_pharmacy_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine_drugs_implants') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_room_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_pharmacy_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine_drugs_implants') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }

                            if (table_name === 'general_equipment_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'ins_dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ins_hospital_services') {
                                // if (feild.key_word === 'mrd') {
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'room_isolation_charges') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }

                                }
                            }
                            if (table_name === 'ins_physiotherapy_diet_charges') {
                                // if (feild.key_word === 'dietician') {
                                //     if (sub_feild.name === 'dietician') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                // if (feild.key_word === 'routine') {
                                //     if (sub_feild.name === 'routine') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                //     }
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ins_physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'surgical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })
                this.setState((state) => ({ 'addonSchema': addonSchema }));
                this.total_suming();
            }

        }
        if (type === 'ins_room_upgrade_reason' && slug === 'finanical-counselling') {
            if (room_upgrade_reason == 3) {

                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    table_body.length=0;
                })
                additionalPackageSchema[0]['visible'] = false;
                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    table_body.length=0;
                })
                additionalProcedureSchema[0]['visible'] = false;
                ailmentSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    ailmentSchema[key].Specification.add_more = true;
                    table_body.length=0;
                })
                interimSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    interimSchema[key].Specification.add_more = true;
                    table_body.length=0;
                })
                interimSchema[0]['visible'] = false;
                this.setData();
                this.total_suming();
            }
        }

        this.setState((state) => ({ 'basicSumInsuredSchema': basicSumInsuredSchema, 'InsuranceDetailsSchema': InsuranceDetailsSchema, 'addonSchema': addonSchema, additionalPackageSchema, additionalProcedureSchema,includesSchema:includesSchema,includesSchema:includesSchema,additionalPackageSchema:additionalPackageSchema }), () => {

            // calculate difference amount

            let { basicSumInsuredSchema, preexistingConditionsSchema, ailmentSchema, total_estimate_amount,nmePopupSchema,nme_total_amount } = this.state
            let balance_sum_insured = 0, ins_copay_amount = 0, ins_ailment_capping = 0, nme = 0, diff_amount = 0, ins_ailment_capping_amount = 0;
            let ins_select_difference = 0,final_approval_amount=0;
            basicSumInsuredSchema.map((item, key) => {
                if (item.name === 'balance_sum_insured') {
                    balance_sum_insured = basicSumInsuredSchema[key]['value'];
                    balance_sum_insured = item.value;
                }
                if (item.name === 'ins_co_pay' && item.type && item.type === 'group') {

                    let { data } = item;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_copay_percent') {
                            copay_percentage = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                        }
                        let copay_amounttotal = 0;
                        if (sub_feild.name === 'ins_copay_amount') {
                            copay_amounttotal =
                                (parseFloat(total_estimate_amount) - parseFloat(nme_total_amount)) * (parseFloat(copay_percentage) / 100)
                            copay_amount = !isNaN(copay_amounttotal) ? copay_amounttotal : 0
                            if (estimate_type == 1) {
                                additionalPackageSchema.map((subTable, key) => {
                                    if (subTable.visible) {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            let row = feild.feilds;
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                                    additional_packages_amount = parseFloat(additional_packages_amount) + parseFloat(sub_feild.value);
                                                }
                                            })
                                        })
                                    }
                                })
                                package_base_price = (inital_package_amount ? parseFloat(inital_package_amount) : 0) + (additional_packages_amount ? parseFloat(additional_packages_amount) : 0);
                                copay_amounttotal = ((parseFloat(package_base_price) + parseFloat(exclude_total_amount)) - parseFloat(nme_total_amount)) * (parseFloat(copay_percentage) / 100)
                                copay_amount = !isNaN(copay_amounttotal) ? copay_amounttotal : 0
                            }
                            if (counselling_details !== null && counselling_details['copay_amount'] !== null  && slug !== 'finanical-counselling') {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = Math.round(copay_amount) ? Math.round(copay_amount) : counselling_details['copay_amount'];
                            } else {
                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = Math.round(copay_amount);
                            }
                            estimateBreakupFormatSchema.map((feild, key) => {
                                if (feild['name'] === 'co_pay_amount') {
                                    // estimateBreakupFormatSchema[key]['value'] = parseFloat(pro_total_cost) + (room_difference ? room_difference !== 'NAN' ? parseFloat(room_difference) : 0 : 0);   
                                    estimateBreakupFormatSchema[key]['value'] = Math.round(copay_amount)
                                    estimateBreakupFormatSchema[key]['disable'] = true;
                                }
                            })
                        }
                    })
                }
                if (item.name === 'ins_co_pay' && item.type && item.type === 'group') {
                    let { data } = item;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_copay_amount') {
                            ins_copay_amount = parseFloat(basicSumInsuredSchema[key]["data"][1].value);
                        }
                    })
                }
                if (item.name === "ins_select_difference") {
                    ins_select_difference = item.value ? item.value : null
                }
                if (ins_select_difference == 1) {
                    if (item.name === 'ins_room_difference_amount') {
                        diff_amount = item.value
                    }
                } else {
                    if (item.name === 'ins_pro_rata_difference_amount') {
                        diff_amount = item.value
                    }
                }

                if (item['name'] === 'ins_ailment_capping') {
                    ins_ailment_capping = item['value']
                    if (ins_ailment_capping === null) {
                        ins_ailment_capping = 2;
                    }
                }
                if (item['name'] === "ins_package_difference") {
                    package_difference= parseFloat(basicSumInsuredSchema[key]['value']) ;
                    
                }
                if (item.name === "ins_room_upgrade_reason" ) {
                    room_upgrade_reason = item.value ? item.value : null;
                    if(type==="ins_room_upgrade_reason"){
                    if (room_upgrade_ward_amount) {
                        basicSumInsuredSchema[key]['visible'] = true;
                    } else {
                        basicSumInsuredSchema[key]['visible'] = false;
                    }
                    this.setState({ room_upgrade_reasons: room_upgrade_reason })
                    if (room_upgrade_reason == 3  ) {
    
                        if (estimate_type == 2) {
    
                            addonSchema.map((subTable, key) => {
                                if (subTable.name === 'room_charges') {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        if (table_key === 0) {
                                            let row = feild.feilds;
                                            let qty;
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.name === 'qty') {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_upgrade_ward_amount;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(room_upgrade_ward_amount);
                                                    }
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                            // this.sumingProcedureAmounts();
                        }
                        if(estimate_type==1){
                            this.setState({ inital_package_amount:room_upgrade_package_amount});
                            // this.setState({ total_estimate_amount: room_upgrade_package_amount });
                            basicSumInsuredSchema.map((filed, key) => {
                            if (filed.name === 'ins_co_pay' && filed.type && filed.type === 'group') {

                                let { data } = filed;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_copay_percent') {
                                        copay_percentage = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                    }
                                    let copay_amounttotal = 0;
                                    if (sub_feild.name === 'ins_copay_amount') {
                                        copay_amounttotal =
                                            (parseFloat(room_upgrade_package_amount) - parseFloat(nme_total_amount)) * (parseFloat(copay_percentage) / 100)
                                        copay_amount = !isNaN(copay_amounttotal) ? copay_amounttotal : 0
                                        if (estimate_type == 1) {
                                            additionalPackageSchema.map((subTable, key) => {
                                                if (subTable.visible) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                                                additional_packages_amount = parseFloat(additional_packages_amount) + parseFloat(sub_feild.value);
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                            package_base_price = (room_upgrade_package_amount ? parseFloat(room_upgrade_package_amount) : 0) + (additional_packages_amount ? parseFloat(additional_packages_amount) : 0);
                                            copay_amounttotal = ((parseFloat(package_base_price) + parseFloat(exclude_total_amount)) - parseFloat(nme_total_amount)) * (parseFloat(copay_percentage) / 100)
                                            copay_amount = !isNaN(copay_amounttotal) ? copay_amounttotal : 0
                                        }
                                        if (counselling_details !== null && counselling_details['copay_amount'] !== null) {
                                            basicSumInsuredSchema[key]['data'][sub_key]['value'] = Math.round(copay_amount) ? Math.round(copay_amount) : counselling_details['copay_amount'];
                                        } else {
                                            basicSumInsuredSchema[key]['data'][sub_key]['value'] = Math.round(copay_amount);
                                        }
                                        estimateBreakupFormatSchema.map((feild, key) => {
                                            if (feild['name'] === 'co_pay_amount') {
                                                // estimateBreakupFormatSchema[key]['value'] = parseFloat(pro_total_cost) + (room_difference ? room_difference !== 'NAN' ? parseFloat(room_difference) : 0 : 0);   
                                                estimateBreakupFormatSchema[key]['value'] = Math.round(copay_amount)
                                                estimateBreakupFormatSchema[key]['disable'] = true;
                                            }
                                        })
                                    }
                                })
                            }
                           
                        });
                        estimateBreakupFormatSchema.map((feild, key) => {
                            if (feild['name'] === 'base_price') {
                                estimateBreakupFormatSchema[key]['value']=room_upgrade_package_amount;
                            }
                            if (feild['name'] === 'ins_total_estimate_amount') {
                                estimateBreakupFormatSchema[key]['value']=room_upgrade_package_amount;
                            }
                        });

                        }
    
                    }else{
                        if(estimate_type==1){
                            this.setState({ inital_package_amount:room_eligible_package_amount});
                            // this.setState({ total_estimate_amount: room_eligible_package_amount });
                            basicSumInsuredSchema.map((filed, key) => {
                                if (filed.name === 'ins_co_pay' && filed.type && filed.type === 'group') {
    
                                    let { data } = filed;
                                    data.map((sub_feild, sub_key) => {
                                        if (sub_feild.name === 'ins_copay_percent') {
                                            copay_percentage = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                        }
                                        let copay_amounttotal = 0;
                                        if (sub_feild.name === 'ins_copay_amount') {
                                            copay_amounttotal =
                                                (parseFloat(room_eligible_package_amount) - parseFloat(nme_total_amount)) * (parseFloat(copay_percentage) / 100)
                                            copay_amount = !isNaN(copay_amounttotal) ? copay_amounttotal : 0
                                            if (estimate_type == 1) {
                                                additionalPackageSchema.map((subTable, key) => {
                                                    if (subTable.visible) {
                                                        let table_body = subTable.Specification.table_body;
                                                        table_body.map((feild, table_key) => {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                                                    additional_packages_amount = parseFloat(additional_packages_amount) + parseFloat(sub_feild.value);
                                                                }
                                                            })
                                                        })
                                                    }
                                                })
                                                package_base_price = (room_eligible_package_amount ? parseFloat(room_eligible_package_amount) : 0) + (additional_packages_amount ? parseFloat(additional_packages_amount) : 0);
                                                copay_amounttotal = ((parseFloat(package_base_price) + parseFloat(exclude_total_amount)) - parseFloat(nme_total_amount)) * (parseFloat(copay_percentage) / 100)
                                                copay_amount = !isNaN(copay_amounttotal) ? copay_amounttotal : 0
                                            }
                                            if (counselling_details !== null && counselling_details['copay_amount'] !== null) {
                                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = Math.round(copay_amount) ? Math.round(copay_amount) : counselling_details['copay_amount'];
                                            } else {
                                                basicSumInsuredSchema[key]['data'][sub_key]['value'] = Math.round(copay_amount);
                                            }
                                            estimateBreakupFormatSchema.map((feild, key) => {
                                                if (feild['name'] === 'co_pay_amount') {
                                                    // estimateBreakupFormatSchema[key]['value'] = parseFloat(pro_total_cost) + (room_difference ? room_difference !== 'NAN' ? parseFloat(room_difference) : 0 : 0);   
                                                    estimateBreakupFormatSchema[key]['value'] = Math.round(copay_amount)
                                                    estimateBreakupFormatSchema[key]['disable'] = true;
                                                }
                                            })
                                        }
                                    })
                                }
                            });
                            estimateBreakupFormatSchema.map((feild, key) => {
                                if (feild['name'] === 'base_price') {
                                    estimateBreakupFormatSchema[key]['value']=room_eligible_package_amount;
                                }
                                if (feild['name'] === 'ins_total_estimate_amount') {
                                    estimateBreakupFormatSchema[key]['value']=room_eligible_package_amount;
                                }
                            });
                        }
                        if (estimate_type == 2 ) {
                            addonSchema.map((subTable, key) => {
                                if (subTable.name === 'room_charges') {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        if (table_key === 0) {
                                            let row = feild.feilds;
                                            let qty;
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.name === 'qty') {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_eligible_ward_amount;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(room_eligible_ward_amount);
                                                    }
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                            // this.sumingProcedureAmounts();
                        } 
                    }
                    additionalPackageSchema[0]['visible'] = true;
                    additionalProcedureSchema[0]['visible'] = true;
                    interimSchema[0]['visible'] = true;
                    let This = this;
                    setTimeout(function () {
                        This.setState((state) => ({  additionalPackageSchema: additionalPackageSchema,additionalProcedureSchema:additionalProcedureSchema,ailmentSchema,interimSchema}))
                        This.total_suming();
                                }, 1000);
                            }
                
                }
            })
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'estimated_nme_amount') {
                    nme = feild['value'] ? feild['value'] : 0;
                }
                if (feild['name'] === 'ins_total_estimate_amount') {
                    total_estimate_amount = feild['value']
                        ? feild['value'] : total_estimate_amount;
                }
            });

            let preExistingamount = 0;
            let preExistingstatus = false;
            preexistingConditionsSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.id === 2) {
                            if (sub_feild.name === 'sum_insured_for_four_years_back') {
                                preExistingamount = sub_feild.value;
                            }
                            if (sub_feild.name === 'consider_si') {
                                preExistingstatus = sub_feild.value;
                            }
                        }

                    })
                })
            })

            ailmentSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                ins_ailment_capping_amount = parseFloat(ins_ailment_capping_amount) + parseFloat(sub_feild.value);
                            }
                        })
                    })
                }
            })
            if (preExistingamount && preExistingstatus === true) {

                balance_sum_insured = preExistingamount;
            }
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'final_approval_amount') {
                    final_approval_amount = feild['value']
                        ? feild['value'] :0;
                }
            })  
            if (balance_sum_insured && total_estimate_amount && (balance_sum_insured < total_estimate_amount) && final_approval_amount==0) {  
                estimateBreakupFormatSchema.map((feild, key) => {
                    if(estimate_type==1){
                    if (feild['name'] === 'difference_amount') {
                        estimateBreakupFormatSchema[key]['value'] =(package_difference) ?package_difference:0
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
            }else{
                if (feild['name'] === 'difference_amount') {
                    estimateBreakupFormatSchema[key]['value'] = (Math.round(parseFloat(total_estimate_amount) - parseFloat(balance_sum_insured) + parseFloat(ins_copay_amount)))
                    estimateBreakupFormatSchema[key]['disable'] = true;
                }
            }
                })
            }
            if (ins_ailment_capping == 1 && final_approval_amount==0) {
                if (balance_sum_insured && total_estimate_amount && (balance_sum_insured > total_estimate_amount)) {
                    estimateBreakupFormatSchema.map((feild, key) => {
                        if(estimate_type==1 ){
                        if (feild['name'] === 'difference_amount') {
                            estimateBreakupFormatSchema[key]['value'] = (package_difference && package_difference > 0) ? package_difference : (Math.round(parseFloat(total_estimate_amount) - parseFloat(ins_ailment_capping_amount)))
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                    }
                    else{
                        if (feild['name'] === 'difference_amount') {
                            estimateBreakupFormatSchema[key]['value'] = (Math.round(parseFloat(total_estimate_amount) - parseFloat(ins_ailment_capping_amount)))
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                    }
                    })
                }
            }
            if (ins_ailment_capping == 2 && final_approval_amount==0) {
                if (balance_sum_insured && total_estimate_amount && (balance_sum_insured > total_estimate_amount)) {
                    estimateBreakupFormatSchema.map((feild, key) => {
                        if(estimate_type==1 ){
                        if (feild['name'] === 'difference_amount') {
                            estimateBreakupFormatSchema[key]['value'] =(package_difference && package_difference > 0) ? package_difference : 0;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                    }else{
                        if (feild['name'] === 'difference_amount') {
                            estimateBreakupFormatSchema[key]['value'] = (Math.round(parseFloat(copay_amount) + parseFloat(nme) + parseFloat(diff_amount)))
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                    }
                    })
                }
            }
            this.setState({ estimateBreakupFormatSchema })

            if (type === 'ins_room_eligible_percent') {
                this.getstaticDropdown(type);
            }
            
        })
    } catch (error) {
        Modal.error({
            title: 'Error message',
            content: 'Oops! something went wrong. Please,try again later'
        });
    }
    }
   
    getExcludesIncludes(pack_id, pack_name, intial) {
        try {
        let { inc_excludes_pack_id, inc_excludes_packages_ids, includesSchema, excludesSchema, tariff_mapped, packages_IN_EX, additionalPackageSchema,slugforexcludedropdown } = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let newData = [];
        let { counselling_details } = this.props;
        let { exculude_options } = this.state;
        if (intial === 0) {
            if (packages_IN_EX) {
                if (!isNaN(pack_id)) {
                    inc_excludes_packages_ids.length = 0;
                    packages_IN_EX.length = 0;
                    includesSchema.map((subTable, key) => {
                        subTable['title'] = '';
                        subTable['name'] = '';
                        if (includesSchema[key].id === 1) {
                            if (includesSchema[key].Specification.table_body.length > 0) {
                                includesSchema[key].Specification.table_body.length = 0;
                            }
                        } else {
                            includesSchema.splice(1, includesSchema.length)
                        }
                    })

                    additionalPackageSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        additionalPackageSchema[key].Specification.add_more = true;
                        table_body.map((feild, table_key) => {
                            additionalPackageSchema[key].Specification.table_body.length = 0;
                            if (table_body.length > 0) {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'ins_additional_package_name') {
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                })
                                additionalPackageSchema[key].Specification.table_body.splice(table_key, 1)
                            }
                        })
                    })
                    this.setState({ includesSchema, exludesconcatdata: [], additionalPackageSchema });
                    optionsStore.dispatch({ type: 'options_data', 'data': [] });
                    if (Array.isArray(inc_excludes_packages_ids) ? !inc_excludes_packages_ids.includes(pack_id) : inc_excludes_packages_ids !== pack_id) {
                        inc_excludes_packages_ids.push(parseInt(pack_id));
                        let obj = {
                            'pack_id': pack_id,
                            'pack_name': pack_name
                        }
                        packages_IN_EX.push(obj);
                        console.log(packages_IN_EX);
                        Promise.all([
                            postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped} }).then(res => res),
                            postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 2, tariff_mapped:this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,status:slugforexcludedropdown === 'view-finanical-counselling'?0:1} }).then(res => res)
                        ]).then(([includesResponse, excludesResponse]) => {
                            if (includesResponse && includesResponse.status) {
                                if (includesResponse.data.length > 0) {
                                    let includes_data = includesResponse.data;
                                    includesSchema.map((subTable, key) => {
                                        includes_data.map((ex_data, ex_key) => {
                                            let last_id = 1;
                                            if (includesSchema[key].Specification.table_body.length > 0) {
                                                let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                last_id = last_element['id'];
                                            }

                                            let obj = {
                                                "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                id: last_id + 1,
                                                input_feild: [],
                                                text: "Highend",
                                                'key_word': 'add_more',
                                                type: "text"
                                            }
                                            obj['feilds'].map((feild, feild_key) => {
                                                obj['feilds'][feild_key]['id'] = last_id + 1;

                                                if (feild.name === 'item_service') {
                                                    obj['feilds'][feild_key]['value'] = ex_data.service;
                                                    obj['feilds'][feild_key]['title'] = ex_data.service;
                                                }
                                                if (feild.name === 'item_package') {
                                                    obj['feilds'][feild_key]['value'] = pack_name;
                                                    obj['feilds'][feild_key]['title'] = pack_name;
                                                }
                                            })
                                            subTable['Specification']['table_body'].push(obj);
                                        })
                                    })
                                    includesResponse.data.map((item, key) => {
                                        newData.push({
                                            "package_id": parseInt(pack_id),
                                            'service_id': item['id'],
                                            'service_nam': item['service'],
                                            "qty": 0,
                                            "rate": 5,
                                            "amount": 5,

                                        })

                                    });
                                }
                            }
                            if (excludesResponse && excludesResponse.status) {
                                if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                    let excludes_data = excludesResponse.data;
                                    console.log('excludes_data', excludes_data);
                                    excludes_data.map((ex_data, key) => {
                                        excludes_data[key]['package_id'] = pack_id;
                                        excludes_data[key]['package_name'] = pack_name;
                                        excludes_data[key]['unit_id'] = user_unit_id;
                                        excludes_data[key]['payment_type'] = 2;
                                        excludes_data[key]['tariff_mapped'] = this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped;
                                        excludes_data[key]['service_name'] = ex_data.service + ' - ' + pack_name;
                                    })

                                    let new_exculude_options = exculude_options.concat(excludes_data);
                                    const exludesconcat = this.state.exludesconcatdata;
                                    let exludesconcatdata = exludesconcat.concat(excludes_data);
                                    console.log(exludesconcatdata);

                                    this.setState({ exludesconcatdata })
                                    optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                    // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });



                                }
                            }
                        })
                        this.setState({
                            inc_excludes_pack_id: inc_excludes_pack_id,
                            includes_data: newData,
                            includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids, exculude_options, additionalPackageSchema
                        });
                        // console.log('exculude_options',exludesconcatdata);
                        this.total_suming();
                    }

                } else {
                    if (packages_IN_EX) {
                        let last_id
                        packages_IN_EX.map((item, key) => {
                            if (item['pack_name'] === pack_name) {
                                const index = inc_excludes_packages_ids.indexOf(item['pack_id']);
                                last_id = item['pack_id'];
                                if (index > -1) {
                                    inc_excludes_packages_ids.splice(index, 1);
                                    packages_IN_EX.splice(index, 1);

                                    includesSchema.map((subTable, key) => {
                                        subTable['title'] = '';
                                        subTable['name'] = '';
                                        if (includesSchema[key].id === 1) {
                                            if (includesSchema[key].Specification.table_body.length > 0) {
                                                includesSchema[key].Specification.table_body.length = 0;
                                            }
                                        } else {
                                            includesSchema.splice(1, includesSchema.length)
                                        }
                                    })
                                    this.setState({ includesSchema, exludesconcatdata: [] });
                                    optionsStore.dispatch({ type: 'options_data', 'data': [] });
                                }

                            }
                        });
                        let table_data = excludesTableStore.getState();

                        table_data.map((body, key) => {
                            // body['feilds'].map((feild, feild_key) => {
                            if (body['feilds'][0].name === 'excludes_service_id') {
                                let { selected_option } = body['feilds'][0];
                                if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                                    table_data.splice(key, 1);
                                    excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                                }
                            }

                            // })

                        })
                        table_data.map((body, key) => {
                            // body['feilds'].map((feild, feild_key) => {
                            if (body['feilds'][0].name === 'excludes_service_id') {
                                let { selected_option } = body['feilds'][0];
                                if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                                    table_data.splice(key, 1);
                                    excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                                }
                            }

                            // })

                        })
                    }
                    if (packages_IN_EX) {
                        packages_IN_EX.map((ele, key) => {
                            Promise.all([
                                postService('getMasterIncludesDropDown', 'POST', { data: { package_id: ele.pack_id, package_name: ele.pack_name, unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res),
                                postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [ele.pack_id], package_name: [ele.pack_name], unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,status:slugforexcludedropdown === 'view-finanical-counselling'?0:1 } }).then(res => res)
                            ]).then(([includesResponse, excludesResponse]) => {
                                if (includesResponse && includesResponse.status) {
                                    if (includesResponse.data.length > 0) {
                                        let includes_data = includesResponse.data;
                                        includesSchema.map((subTable, key) => {
                                            includes_data.map((ex_data, ex_key) => {
                                                let last_id = 1;
                                                if (includesSchema[key].Specification.table_body.length > 0) {
                                                    let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                    last_id = last_element['id'];
                                                }

                                                let obj = {
                                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                    id: last_id + 1,
                                                    input_feild: [],
                                                    text: "Highend",
                                                    'key_word': 'add_more',
                                                    type: "text"
                                                }
                                                obj['feilds'].map((feild, feild_key) => {
                                                    obj['feilds'][feild_key]['id'] = last_id + 1;

                                                    if (feild.name === 'item_service') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.service;
                                                        obj['feilds'][feild_key]['title'] = ex_data.service;
                                                    }
                                                    if (feild.name === 'item_package') {
                                                        obj['feilds'][feild_key]['value'] = ele.pack_name;
                                                        obj['feilds'][feild_key]['title'] = ele.pack_name;
                                                    }
                                                })
                                                subTable['Specification']['table_body'].push(obj);
                                            })
                                        })
                                        includesResponse.data.map((item, key) => {
                                            newData.push({
                                                "package_id": parseInt(pack_id),
                                                'service_id': item['id'],
                                                'service_nam': item['service'],
                                                "qty": 0,
                                                "rate": 5,
                                                "amount": 5,

                                            })

                                        });
                                    }
                                }
                                if (excludesResponse && excludesResponse.status) {
                                    if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                        let excludes_data = excludesResponse.data;
                                        console.log('excludes_data', excludes_data);
                                        excludes_data.map((ex_data, key) => {
                                            excludes_data[key]['package_id'] = ele.pack_id;
                                            excludes_data[key]['package_name'] = ele.pack_name;
                                            excludes_data[key]['unit_id'] = user_unit_id;
                                            excludes_data[key]['payment_type'] = 2;
                                            excludes_data[key]['tariff_mapped'] = this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped;
                                            excludes_data[key]['service_name'] = ex_data.service + ' - ' + ele.pack_name;
                                        })

                                        let new_exculude_options = exculude_options.concat(excludes_data);
                                        const exludesconcat = this.state.exludesconcatdata;
                                        let exludesconcatdata = exludesconcat.concat(excludes_data);
                                        console.log(exludesconcatdata);

                                        this.setState({ exludesconcatdata })
                                        optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                        // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });



                                    }
                                }
                            })
                            this.setState({
                                inc_excludes_pack_id: inc_excludes_pack_id,
                                includes_data: newData,
                                includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids, exculude_options, packages_IN_EX
                            });
                            // console.log('exculude_options',exludesconcatdata);
                            this.total_suming();

                        });
                    }
                }
            }
            else {
                if (!isNaN(pack_id)) {
                    if (Array.isArray(inc_excludes_packages_ids) ? !inc_excludes_packages_ids.includes(pack_id) : inc_excludes_packages_ids !== pack_id) {
                        inc_excludes_packages_ids.push(parseInt(pack_id));
                        let obj = {
                            'pack_id': pack_id,
                            'pack_name': pack_name
                        }
                        packages_IN_EX.push(obj);
                        console.log(packages_IN_EX);
                        Promise.all([
                            postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 2, tariff_mapped:this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res),
                            postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,status:slugforexcludedropdown === 'view-finanical-counselling'?0:1} }).then(res => res)
                        ]).then(([includesResponse, excludesResponse]) => {
                            if (includesResponse && includesResponse.status) {
                                if (includesResponse.data.length > 0) {
                                    let includes_data = includesResponse.data;
                                    includesSchema.map((subTable, key) => {
                                        includes_data.map((ex_data, ex_key) => {
                                            let last_id = 1;
                                            if (includesSchema[key].Specification.table_body.length > 0) {
                                                let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                last_id = last_element['id'];
                                            }

                                            let obj = {
                                                "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                id: last_id + 1,
                                                input_feild: [],
                                                text: "Highend",
                                                'key_word': 'add_more',
                                                type: "text"
                                            }
                                            obj['feilds'].map((feild, feild_key) => {
                                                obj['feilds'][feild_key]['id'] = last_id + 1;

                                                if (feild.name === 'item_service') {
                                                    obj['feilds'][feild_key]['value'] = ex_data.service;
                                                    obj['feilds'][feild_key]['title'] = ex_data.service;
                                                }
                                                if (feild.name === 'item_package') {
                                                    obj['feilds'][feild_key]['value'] = pack_name;
                                                    obj['feilds'][feild_key]['title'] = pack_name;
                                                }
                                            })
                                            subTable['Specification']['table_body'].push(obj);
                                        })
                                    })
                                    includesResponse.data.map((item, key) => {
                                        newData.push({
                                            "package_id": parseInt(pack_id),
                                            'service_id': item['id'],
                                            'service_nam': item['service'],
                                            "qty": 0,
                                            "rate": 5,
                                            "amount": 5,

                                        })

                                    });
                                }
                            }
                            if (excludesResponse && excludesResponse.status) {
                                if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                    let excludes_data = excludesResponse.data;
                                    console.log('excludes_data', excludes_data);
                                    excludes_data.map((ex_data, key) => {
                                        excludes_data[key]['package_id'] = pack_id;
                                        excludes_data[key]['package_name'] = pack_name;
                                        excludes_data[key]['unit_id'] = user_unit_id;
                                        excludes_data[key]['payment_type'] = 2;
                                        excludes_data[key]['tariff_mapped'] = this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped;
                                        excludes_data[key]['service_name'] = ex_data.service + ' - ' + pack_name;
                                    })

                                    let new_exculude_options = exculude_options.concat(excludes_data);
                                    const exludesconcat = this.state.exludesconcatdata;
                                    let exludesconcatdata = exludesconcat.concat(excludes_data);
                                    console.log(exludesconcatdata);

                                    this.setState({ exludesconcatdata })
                                    optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                    // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });



                                }
                            }
                        })
                        this.setState({
                            inc_excludes_pack_id: inc_excludes_pack_id,
                            includes_data: newData,
                            includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids, exculude_options
                        });
                        // console.log('exculude_options',exludesconcatdata);
                        this.total_suming();
                    }

                }
            }
        } else {
            if (!isNaN(pack_id)) {
                if (Array.isArray(inc_excludes_packages_ids) ? !inc_excludes_packages_ids.includes(pack_id) : inc_excludes_packages_ids !== pack_id) {
                    inc_excludes_packages_ids.push(parseInt(pack_id));
                    let obj = {
                        'pack_id': pack_id,
                        'pack_name': pack_name
                    }
                    packages_IN_EX.push(obj);
                    console.log(packages_IN_EX);
                    Promise.all([
                        postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res),
                        postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,status:slugforexcludedropdown === 'view-finanical-counselling'?0:1 } }).then(res => res)
                    ]).then(([includesResponse, excludesResponse]) => {
                        if (includesResponse && includesResponse.status) {
                            if (includesResponse.data.length > 0) {
                                let includes_data = includesResponse.data;
                                includesSchema.map((subTable, key) => {
                                    includes_data.map((ex_data, ex_key) => {
                                        let last_id = 1;
                                        if (includesSchema[key].Specification.table_body.length > 0) {
                                            let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                            last_id = last_element['id'];
                                        }

                                        let obj = {
                                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                            id: last_id + 1,
                                            input_feild: [],
                                            text: "Highend",
                                            'key_word': 'add_more',
                                            type: "text"
                                        }
                                        obj['feilds'].map((feild, feild_key) => {
                                            obj['feilds'][feild_key]['id'] = last_id + 1;

                                            if (feild.name === 'item_service') {
                                                obj['feilds'][feild_key]['value'] = ex_data.service;
                                                obj['feilds'][feild_key]['title'] = ex_data.service;
                                            }
                                            if (feild.name === 'item_package') {
                                                obj['feilds'][feild_key]['value'] = pack_name;
                                                obj['feilds'][feild_key]['title'] = pack_name;
                                            }
                                        })
                                        subTable['Specification']['table_body'].push(obj);
                                    })
                                })
                                includesResponse.data.map((item, key) => {
                                    newData.push({
                                        "package_id": parseInt(pack_id),
                                        'service_id': item['id'],
                                        'service_nam': item['service'],
                                        "qty": 0,
                                        "rate": 5,
                                        "amount": 5,

                                    })

                                });
                            }
                        }
                        if (excludesResponse && excludesResponse.status) {
                            if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                let excludes_data = excludesResponse.data;
                                console.log('excludes_data', excludes_data);
                                excludes_data.map((ex_data, key) => {
                                    excludes_data[key]['package_id'] = pack_id;
                                    excludes_data[key]['package_name'] = pack_name;
                                    excludes_data[key]['unit_id'] = user_unit_id;
                                    excludes_data[key]['payment_type'] = 2;
                                    excludes_data[key]['tariff_mapped'] = this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped;
                                    excludes_data[key]['service_name'] = ex_data.service + ' - ' + pack_name;
                                })

                                let new_exculude_options = exculude_options.concat(excludes_data);
                                const exludesconcat = this.state.exludesconcatdata;
                                let exludesconcatdata = exludesconcat.concat(excludes_data);
                                console.log(exludesconcatdata);

                                this.setState({ exludesconcatdata })
                                optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });



                            }
                        }
                    })
                    this.setState({
                        inc_excludes_pack_id: inc_excludes_pack_id,
                        includes_data: newData,
                        includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids, exculude_options
                    });
                    // console.log('exculude_options',exludesconcatdata);
                    this.total_suming();
                }

            }
        }
    } catch (error) {
        Modal.error({
            title: 'Error message',
            content: 'Oops! something went wrong. Please,try again later'
        });
    }
    }
    getMrd(los) {
        try {
        let { addonSchema, InsuranceDetailsSchema, basicSumInsuredSchema } = this.state
        let length_of_stay, room_id = null;
        // InsuranceDetailsSchema.map((feild, key) => {
        //     if (feild['name'] === 'length_of_stay') {
        //         length_of_stay = parseInt(feild['value']);
        //     }
        //     if (feild['name'] === 'room_opted') {
        //         room_id = parseInt(feild['room_id']);
        //     }
        // })
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild.name === 'length_of_stay') {
                length_of_stay = parseInt(feild['value']?feild['value']:los);
            }
        })
        basicSumInsuredSchema.map((feild, key) => {
            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                        room_id = sub_feild['id']; //note
                        // room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                    }
                })
            }
        })
        if (length_of_stay !== 0 && length_of_stay !== '' && length_of_stay !== null && length_of_stay !== undefined) {
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 14, sub_header_id: 23, tariff_mapped: this.state.tariff_mapped } }).then(res => {
                if (res.status) {
                    if (res.data.length > 1) {
                        let service_id = res.data[0].id;
                        if (length_of_stay > 1) {
                            service_id = res.data[1].id;
                        }
                        postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                            if (response.status) {
                                if (response.data.length > 0) {
                                    let amount;
                                    let data_value = 0;

                                    response.data.map((feild, key) => {
                                        if (feild.room_id === room_id) {
                                            amount = parseFloat(feild.amount);
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.name === 'ins_hospital_services') {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        data_value = 1;
                                                        let row = feild.feilds;
                                                        if (feild.key_word === 'mrd') {
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === "qty") {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                                }

                                                                if (sub_feild.name === "rate") {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                                }
                                                                if (sub_feild.name === "amount") {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(1);
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                            this.setState({ addonSchema: addonSchema });
                                            // this.sumingProcedureAmounts();
                                            this.total_suming();
                                        }
                                    })
                                }
                                // else {
                                //     Modal.error({
                                //         title: 'Error message',
                                //         content: 'No amount for the selected room',
                                //     });
                                // }
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'Something went wrong ',
                                });
                            }
                        })
                    }
                    else {
                        Modal.error({
                            title: 'Error message',
                            content: 'No service available',
                        });
                    }
                }
                // else {
                //     Modal.error({
                //         title: 'Error message',
                //         content: 'Something went wrong',
                //     });
                // }
            })
        }
        
    } catch (error) {
        Modal.error({
            title: 'Error message',
            content: 'Oops! something went wrong. Please,try again later'
        });
    }
    }

    getstaticDropdown(type) {
        try {
        const { getInsurancePackagePricesById, getInsuranceNonPackageRoomsByUnitId, getServicePricesById } = networkList;
        let care_management = null, room_obj_data = {},
            tarif_id = null, user_data = null, package_id = null,
            estimate_type = null, room_eligible_amount = 0;

        let url = null, payload = {};
        let room_id = null, room_text = null, room_amount = 0, room_package_charges = 0;
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let { basicSumInsuredSchema, InsuranceDetailsSchema, inital_package_amount, addonSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, total_estimate_amount, insurance_company_mou_flag, insuranceCompanyName, isModalShown } = this.state;
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild.name === 'care_management') {
                care_management = feild.value ? feild.value : null;
            }
            if (feild.name === "estimate_type") {
                estimate_type = feild.value ? feild.value : null;
            }
            if (feild.name === "insurance_company_name") {
                tarif_id = feild['tariff_mapped'] ? feild['tariff_mapped'] : null;
            }
            if (feild.name === 'ins_package_name') {
                package_id = feild['value'] ? feild['value'] : null
            }
        })
    

        basicSumInsuredSchema.map((feild, key) => {
            if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_amount') {
                        room_eligible_amount = sub_feild['value'] ? sub_feild['value'] : 0
                    }
                })
            }
        })
        // basic_sum_insured
        // if (type === 'basic_sum_insured') {
        if (room_eligible_amount !== 0) {
            if (type === 'ins_room_eligible_percent') {
                if (care_management == 2 && estimate_type == 1) {
                    url = getInsurancePackagePricesById;
                    payload = {
                        "package_id": package_id,
                        "unit_id": user_data['unitid'],
                        "payment_type": 2
                    }

                } else {
                    url = getInsuranceNonPackageRoomsByUnitId;
                    payload = {
                        "tariff_id": tarif_id ? parseInt(tarif_id) : null,
                        "unit_id": user_data['unitid'],
                        "payment_type": 2,
                        "room_type": 0,
                    }
                }
                let room_amount_array = [];
                this.setState({ loadding: false })
                postService(url, 'POST', {
                    "data": payload
                }).then(res => {

                    // console.clear();

                    if (res.status) {
                        this.setState({ loadding: false })
                        let { data } = res;
                        const validRoomTypes = ["General Ward", "Triple", "Day Care", "Twin Sharing", "Single Room"];
                        const validRoomTypes2 = ["General", "Twin", "Day Care", "Triple","Single"];
                        data.map((room, key) => {
                            const roomCharges = parseFloat(room['amount'] || room['room_charges']);
                            const roomName = room['room_name'];
                            if (insurance_company_mou_flag === '1' || insurance_company_mou_flag === 1) {
                                if ((validRoomTypes.includes(roomName) || validRoomTypes2.includes(roomName)) && roomCharges <= parseFloat(room_eligible_amount)) {
                                    room_amount_array.push(room);
                                }
                            } else {
                                if (parseFloat(room['amount'] || room['room_charges']) <= parseFloat(room_eligible_amount)) {
                                    room_amount_array.push(room)
                                }
                            }
                            
                        });
                        let room_data = null;
                        if (room_amount_array.length > 0) {
                            room_amount_array = room_amount_array.sort((a, b) => parseFloat(a['amount'] || a['room_charges']) - parseFloat(b['amount'] || b['room_charges']));
                            console.log(room_amount_array, room_eligible_amount);
                            room_data = room_amount_array[room_amount_array.length - 1];
                            room_id = room_data['room_id'];
                            room_text = room_data['room_name'];
                            room_amount = room_data['amount'] || room_data['room_charges'];
                            room_package_charges = room_data['package_charges'];
                        }
                       
                        basicSumInsuredSchema.map((feild, key) => {
                            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                let { data } = feild;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = room_id;
                                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = room_text;
                                        basicSumInsuredSchema[key]['data'][sub_key]['amount'] = room_amount;
                                        basicSumInsuredSchema[key]['data'][sub_key]['option_data'] = room_data;
                                        basicSumInsuredSchema[key]['data'][sub_key]['percentage'] =100;
                                        basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = room_package_charges;
                                        inital_package_amount = room_package_charges;
                                        room_obj_data = room_data
                                        this.setState({ inital_package_amount })
                                        this.insurance_total();
                                            this.total_suming()
                                    }
                                    if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = room_amount ? parseFloat(room_amount) : 0;
                                        localStorage.setItem('room_eligible_ward_cost', room_amount)
                                        this.setData();
                                        this.insurance_total();
                                        this.total_suming()
                                    }
                                })
                            }
                            if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                let { data } = feild;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_upgrade_room_names') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                                        basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                                    }
                                    if (sub_feild.name === 'ins_upgrade_room_amount') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                                    }
                                })
                            }
                            if (feild.name === "ins_room_upgrade_reason") {
                                basicSumInsuredSchema[key]['value'] = null;
                                basicSumInsuredSchema[key]['text'] = null;
                                basicSumInsuredSchema[key]['visible'] = false;
                            }
                            if (feild.name === 'ins_icu_eligible' && feild.type && feild.type === 'group') {
                                let { data } = feild;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_icu_percent') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'ins_icu_amount') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                    }
                                })

                            }

                            if (feild.name === 'ins_icu' && feild.type && feild.type === 'group') {
                                let { data } = feild;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_icu_type') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                        // basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;


                                    }
                                    if (sub_feild.name === 'ins_icu_amount') {
                                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                                    }
                                })
                            }


                            if (feild.name === "ins_icu_difference") {
                                if (estimate_type == 1) {
                                    basicSumInsuredSchema[key]['value'] = null;
                                    basicSumInsuredSchema[key]['disable'] = true;
                                } else {
                                    basicSumInsuredSchema[key]['value'] = null
                                    basicSumInsuredSchema[key]['disable'] = true;
                                }
                            }
                            if (feild.name === "ins_select_difference") {
                                basicSumInsuredSchema[key]['visible'] = false;
                            }
                            if (feild.name === "ins_room_difference_amount") {
                                basicSumInsuredSchema[key]['value'] = null;
                                basicSumInsuredSchema[key]['disable'] = true;
                                basicSumInsuredSchema[key]['visible'] = false;
                            }

                            if (feild.name === "ins_pro_rata_difference_amount") {
                                basicSumInsuredSchema[key]['value'] = null;
                                basicSumInsuredSchema[key]['disable'] = true;
                                basicSumInsuredSchema[key]['visible'] = false;
                            }


                        })
                        estimateBreakupFormatSchema.map((feild, key) => {
                            if (feild['name'] === 'base_price') {
                                if (estimate_type == 1) {
                                    if (room_package_charges && room_package_charges !== null && room_package_charges !== undefined && room_package_charges !== '') {
                                        estimateBreakupFormatSchema[key]['value'] = room_package_charges;
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                    }
                                } else {
                                    estimateBreakupFormatSchema[key]['value'] = 0
                                    estimateBreakupFormatSchema[key]['visible'] = false;
                                }
                            }
                            if (feild['name'] === 'ins_total_estimate_amount') {
                                if (estimate_type == 1) {
                                    if (room_package_charges && room_package_charges !== null && room_package_charges !== undefined && room_package_charges !== '') {
                                        // estimateBreakupFormatSchema[key]['value'] = room_package_charges // total amount 21-02-2023
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                        // this.setState({ total_estimate_amount: room_package_charges }); // total amount 21-02-2023
                                    }

                                } else {
                                    estimateBreakupFormatSchema[key]['visible'] = false;
                                }

                            }

                        })
                    }
                })
            }
        } else {
            basicSumInsuredSchema.map((feild, key) => {
                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_room_eligible_ward_names') {
                            basicSumInsuredSchema[key]['data'][sub_key]['value'] = '';
                            basicSumInsuredSchema[key]['data'][sub_key]['text'] = '';
                            basicSumInsuredSchema[key]['data'][sub_key]['amount'] = '';
                            basicSumInsuredSchema[key]['data'][sub_key]['option_data'] = '';
                            basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = '';
                        }
                        if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                            basicSumInsuredSchema[key]['data'][sub_key]['value'] = room_amount ? parseFloat(room_amount) : 0;
                            localStorage.setItem('room_eligible_ward_cost', room_amount)

                        }
                    })
                }
            })
        }



        localStorage.setItem('type_of_package', estimate_type)
        this.setState((state) => ({ 'basicSumInsuredSchema': basicSumInsuredSchema, 'ins_room_eligible_ward': payload, 'room_obj_data': room_obj_data, 'estimateBreakupFormatSchema': estimateBreakupFormatSchema, additionalProcedureSchema, additionalPackageSchema }), () => {
            this.insurance_total();
            this.total_suming()
           

        })
    } catch (error) {
        Modal.error({
            title: 'Error message',
            content: 'Oops! something went wrong. Please,try again later'
        });
    }
    }

    buttonClick4(feilds, type) {
        // diffence amount
        try {
        // console.clear();
              let ele_name = '',
            ele_val = '',
            ele_id = 0,
            final_approval_amount = 0,
            discount = 0,
            ins_copay_amount = 0,
            ins_ailment_capping = 0,
            nme = 0,
            care_management=0,
            estimate_type=0,
            package_difference=0;
        // total_estimate_amount=0;

        let { estimateBreakupFormatSchema, basicSumInsuredSchema, total_estimate_amount, esterrors,InsuranceDetailsSchema } = this.state;
        if(type){
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === type.type) {
                    ele_name = feild['name'];
                    ele_val = feild['value'];
                    ele_id = feild['id'];
                }
                if (feild['name'] === 'estimated_nme_amount') {
                    nme = feild['value'] ? feild['value'] : 0;
                }
                if (feild['name'] === 'discount') {
                    discount = feild['value'] ? feild['value'] : 0;
                }
                if (feild['name'] === 'ins_total_estimate_amount') {
                    total_estimate_amount = feild['value']
                        ? feild['value'] : total_estimate_amount;
                }
                if (feild['name'] === 'final_approval_amount') {
                    final_approval_amount = feild['value']
                        ? feild['value'] :0;
                }
            })

            if (ele_name === 'signature_of_patient_attendant') {
                estimateBreakupFormatSchema.map((feild, key) => {
                    if (feild['name'] === 'attendant_name') {
                        if (ele_val !== '' && ele_val == '1') {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                        }
                        if (ele_val !== '' && ele_val == '2') {
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        }
                        if (ele_val == '' || ele_val == null) {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                        }
                    }
                    if (feild['name'] === 'relation') {
                        if (ele_val !== '' && ele_val == '1') {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                        }
                        if (ele_val !== '' && ele_val == '2') {
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        }
                        if (ele_val == '' || ele_val == null) {
                            estimateBreakupFormatSchema[key]['visible'] = false;
                        }
                    }
                })
            }
            if (ele_name === 'final_approval_amount') {
                final_approval_amount = ele_val
            }
        }
        estimateBreakupFormatSchema.map((feild, key) => {
            if (feild['name'] === 'estimated_nme_amount') {
                nme = feild['value'] ? feild['value'] : 0;
            }
            if (feild['name'] === 'discount') {
                discount = feild['value'] ? feild['value'] : 0;
            }
            if (feild['name'] === 'ins_total_estimate_amount') {
                total_estimate_amount = feild['value']
                    ? feild['value'] : total_estimate_amount;
            }
            if (feild['name'] === 'final_approval_amount') {
                final_approval_amount = feild['value']
                    ? feild['value'] :0;
            }
            if (feild['name'] === 'final_approval_amount') {
                final_approval_amount = feild['value']
                    ? feild['value'] :0;
            }
        })  
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild.name === 'care_management') {
                care_management = feild.value ? feild.value : null;
            }
            if (feild.name === "estimate_type") {
                estimate_type = feild.value ? feild.value : null;
            }
        })

        basicSumInsuredSchema.map((feild, key) => {
            if (feild.name === 'ins_co_pay' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_copay_amount') {
                        ins_copay_amount = parseFloat(basicSumInsuredSchema[key]["data"][1].value);
                    }
                })
            }
            if (feild.name === "ins_package_difference") {
                package_difference= parseFloat(basicSumInsuredSchema[key]['value']) ;
                
            }
            if (feild['name'] === 'ins_ailment_capping') {
                ins_ailment_capping = feild['value']
                if (ins_ailment_capping === null) {
                    ins_ailment_capping = 2;
                }
            }
        })


        if (final_approval_amount!=='0.00' && final_approval_amount!==0 && final_approval_amount!==null && final_approval_amount!==undefined) {
            if (ins_ailment_capping == 1) {
                estimateBreakupFormatSchema.map((feild, key) => {
                    if(estimate_type==1){
                        if (feild['name'] === 'difference_amount') {
                            estimateBreakupFormatSchema[key]['value'] =(package_difference && package_difference > 0) ? package_difference : 0;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                    }else{
                        if (feild['name'] === 'difference_amount') {
                            estimateBreakupFormatSchema[key]['value'] = (Math.round(parseFloat(total_estimate_amount) - parseFloat(final_approval_amount)))
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }  
                    }
                    
                })
            }
            if (ins_ailment_capping == 2) {
                estimateBreakupFormatSchema.map((feild, key) => {
                    if(estimate_type==1){
                    if (feild['name'] === 'difference_amount') {
                        estimateBreakupFormatSchema[key]['value'] =(package_difference && package_difference > 0) ? package_difference  :0;
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                }else{
                    if (feild['name'] === 'difference_amount') {
                        estimateBreakupFormatSchema[key]['value'] = (Math.round(parseFloat(total_estimate_amount) - parseFloat(final_approval_amount) + parseFloat(nme) + parseFloat(ins_copay_amount) - parseFloat(discount)))
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                }
                })
            }
        }
        else{
            this.insurance_total();
        }
        if (esterrors.length > 0) {
            esterrors.map((index) => {
                estimateBreakupFormatSchema.map((item, key) => {
                    if (item['name'] === ele_name && item['id'] === index['id']) {
                        document.getElementById("errorm" + item['name']).style.display = "none";
                    }
                })
            })
        }

        this.setState((state) => ({ 'estimateBreakupFormatSchema': estimateBreakupFormatSchema }));
    } catch (error) {
        Modal.error({
            title: 'Error message',
            content: 'Oops! something went wrong. Please,try again later'
        });
    }
    }

    print = () => {
        this
            .props
            .history
            .push(`/settings/Print_Patient_copy_Insurance_Clearance`)
    }

    print2 = () => {
        this
            .props
            .history
            .push(`/settings/Fc_Patient_copy_Patient_Consent_Form`)
    }

    preview_submit() {
        let generatedLink = this.generateLink()
        this.setState({signatureModal: true, generatedLink})
    }

    final_submit() {
        // try {
            this.setState({ loadding: true,finalSubmit:true })
            let { addonSchema, basicSumInsuredSchema, estimateBreakupFormatSchema, InsuranceDetailsSchema, ailmentSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, interimSchema, preexistingConditionsSchema, includes_data, nmePopupSchema,inital_package_amount,exludesiders, isGenerateSign, generatedLink, signatureSchema,nmeInfo } = this.state;
            let { basic_info } = this.props;
            let estimate_data = [];
            let additional_packages = [];
            let additional_procedures = [];
            let ailment = [];
            let interim = [];
            let pre_ex_conditions = [];
            let temp_obj = {}
            let excludes_data = [];
            let nmedata = [];
            this.setState({ loadding: true })
            addonSchema.map((subTable, key) => {
                if (subTable.name !== 'ins_surgical_charges' && subTable.name !== 'ins_medical_charges'&& subTable.visible) {
                    let table_header = subTable.header;
                    let table_body = subTable.Specification.table_body;
                    temp_obj[table_header] = subTable.header_amount;
                    table_body.map((feild, table_key) => {
                        let service, qty, rate, amount, sub_header;
                        let key_word = feild.key_word;
                        let row = feild.feilds;
                        if (key_word !== 'ot_hours') {
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action') {
                                    if (sub_table_key === 0) {
                                        sub_header = parseFloat(sub_feild.sub_header);
                                        if (sub_feild.element === 'text') {
                                            service = parseFloat(sub_feild.service);
                                        }
                                        else {
                                            service = parseFloat(sub_feild.value);
                                        }
                                    }
                                    if (sub_table_key === 1) {
                                        qty = parseFloat(sub_feild.value);
                                    }
                                    if (sub_table_key === 2) {
                                        rate = parseFloat(sub_feild.value);
                                    }
                                    if (sub_table_key === 3) {
                                        amount = parseFloat(sub_feild.value);
                                    }
                                }
                            })
                        }
                        else {
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action') {
                                    if (sub_table_key === 1) {
                                        service = parseFloat(sub_feild.service);
                                        sub_header = parseFloat(sub_feild.sub_header);
                                        qty = null;
                                    }
                                    if (sub_table_key === 2) {
                                        rate = parseFloat(sub_feild.value);
                                    }
                                    if (sub_table_key === 3) {
                                        amount = parseFloat(sub_feild.value);
                                    }
                                }
                            })
                        }

                        let obj = {
                            key_word: key_word,
                            header: table_header,
                            sub_header: sub_header,
                            service: service,
                            qty: qty,
                            rate: rate,
                            amount: amount
                        }

                        if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                        }
                        else {
                            if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                                estimate_data.push(obj);
                            }
                        }
                    })
                }
                else {
                    if (subTable.visible) {
                        let table_header = subTable.header;
                        let table_body = subTable.Specification.table_body;
                        temp_obj[table_header] = subTable.header_amount;
                        table_body.map((feild, table_key) => {
                            let service, percentage, amount, sub_header;
                            let key_word = feild.key_word;
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_table_key === 0) {
                                    service = parseFloat(sub_feild.service);
                                    sub_header = parseFloat(sub_feild.sub_header);
                                }
                                if (sub_table_key === 1) {
                                    percentage = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            })
                            let obj = {
                                key_word: key_word,
                                header: table_header,
                                sub_header: sub_header,
                                service: service,
                                qty: percentage,
                                rate: null,
                                amount: amount
                            }
                            if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                                estimate_data.push(obj);
                            }
                        })
                    }
                }
            })
            additionalPackageSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let package_id,discount_amount,actual_price, percentage;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    package_id = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 1) {
                                    actual_price = parseFloat(sub_feild.value);
                                }
                                if(sub_table_key === 2){
                                    percentage = parseFloat(sub_feild.value);
                                }
                                if(sub_table_key === 3){
                                    discount_amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                        let obj = {
                            package_id: package_id,
                            amount: discount_amount,
                            additional_type: 1,
                            package_percentage : percentage,
                            actual_price:actual_price
                        }
                        if (package_id !== '' && package_id !== null && package_id !== undefined && !isNaN(package_id) && discount_amount !== '' && discount_amount !== null && discount_amount !== undefined && !isNaN(discount_amount)) {
                            additional_packages.push(obj);
                        }
                    })
                }
            })

            additionalProcedureSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let procedure_id, amount, percentage;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            console.log('enter', sub_feild)
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    procedure_id = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 1) {
                                    amount = parseFloat(sub_feild.value);
                                }
                                // if (sub_table_key === 2) {
                                //     percentage = parseFloat(sub_feild.value);
                                // }
                            }
                        })
                        let obj = {
                            procedure_id: procedure_id,
                            amount: amount,
                            additional_type: 2
                            // percentage: percentage
                        }
                        if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            additional_procedures.push(obj);
                        }
                    })
                }
            })

            ailmentSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let surgery, surgery_amount, percentage;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    surgery = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 1) {
                                    surgery_amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                        let obj = {
                            surgery: surgery,
                            surgery_amount: surgery_amount,
                            additional_type: 2
                            // percentage: percentage
                        }
                        if (surgery !== '' && surgery !== null && surgery !== undefined && !isNaN(surgery) && surgery_amount !== '' && surgery_amount !== null && surgery_amount !== undefined && !isNaN(surgery_amount)) {
                            ailment.push(obj);
                        }
                    })
                }
            })
            if (nmePopupSchema !== undefined) {
                nmePopupSchema.map((subTable, key) => {
                    console.log('rowssss1=====', subTable)
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let obj = {
                            "nme_id": '',
                            "nme_name": null,
                            "nme_rate": 0,
                            "nme_total_amount": 0,
                            "nme_quantity": 1,
                            "nme_description":'',
                            "nme_tariff": null,
                        }
                        let nme_amount, nme_name, nme_rate, nme_quantity, nme_id, nme_tariff;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {

                            // if (sub_feild.name === "department") {
                            //     obj['nme_id'] = sub_feild.id;
                            //     obj['nme_name'] = sub_feild.text;
                            // }
                            if (sub_feild.name === "nme_id") {
                                obj['nme_id'] = sub_feild.value;
                                // obj['nme_name'] = sub_feild.text;
                            }
                            if (sub_feild.name === "department") {
                                // obj['nme_id'] = sub_feild.value;
                                obj['nme_name'] = sub_feild.text;
                            }
                            if (sub_feild.name === "description") {
                                obj['nme_description'] = sub_feild.value;
                              
                            }
                            if (sub_feild.name === 'tariff') {
                                obj['nme_tariff'] = sub_feild.text;
                            }
                            // if (sub_feild.name === 'rate') {
                            //     obj['nme_rate'] = sub_feild.value;

                            // }
                            if (sub_feild.name === 'rate') {
                                obj['nme_rate'] = sub_feild.value;

                            }
                            if (sub_feild.name === 'amount') {
                                obj['nme_amount'] = sub_feild.value;

                            }

                            // if (sub_feild.name !== 'action') {
                            // }
                        })
                        nmedata.push(obj);
                    })

                })

            }

            interimSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let interim_amount, aprox_bill, case_no;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    interim_amount = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 1) {
                                    aprox_bill = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    case_no = parseFloat(sub_feild.value);
                                }
                            }
                        })
                        let obj = {
                            interim_amount: interim_amount,
                            aprox_bill: aprox_bill,
                            additional_type: 2,
                            case_no: case_no
                        }
                        if (interim_amount && interim_amount !== undefined && !isNaN(interim_amount) && aprox_bill && aprox_bill !== undefined && !isNaN(aprox_bill) && case_no) {
                            interim.push(obj);
                        }
                    })
                }
            })
            let sum_insured_four_years_back = 0;
            let consider_si_four_years_back = 0;
            console.log('preexistingConditionsSchema', preexistingConditionsSchema)
            preexistingConditionsSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let condition_name, onset_data, sum_insured_onset_data, consder_si;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_feild.id === 2) {
                                    if (sub_table_key === 0) {
                                        condition_name = sub_feild.value;
                                    }
                                    if (sub_table_key === 1) {
                                        onset_data = '';
                                        sum_insured_four_years_back = sub_feild.value;
                                    }
                                    if (sub_table_key === 2) {
                                        consider_si_four_years_back = sub_feild.value ? 1 : 0;
                                    }

                                } else {
                                    if (sub_table_key === 0) {
                                        condition_name = sub_feild.value;
                                    }
                                    if (sub_table_key === 1) {
                                        onset_data = sub_feild.value;
                                    }
                                    if (sub_table_key === 2) {
                                        sum_insured_onset_data = sub_feild.value;
                                    }
                                    if (sub_table_key === 3) {
                                        consder_si = sub_feild.value ? 1 : 0;
                                    }
                                }

                            }
                        })
                        let obj = {
                            condition_name: condition_name,
                            onset_data: onset_data,
                            // additional_type: 2,
                            sum_insured_onset_data: sum_insured_onset_data,
                            consder_si: consder_si
                        }
                        if (condition_name && condition_name !== undefined && onset_data && onset_data !== undefined && sum_insured_onset_data && consder_si) {
                            pre_ex_conditions.push(obj);
                        }
                    })
                }
            })
            console.log(pre_ex_conditions);
            let room_opted_amount = 0;
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'estimate_type' && feild['value'] == 1) {
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                            let { data } = feild;
                            data.map((sub_feild, sub_key) => {
                                if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                    room_opted_amount = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                }
                            })
                        }
                    })
                }
            })
            console.log(basicSumInsuredSchema);
            if (InsuranceDetailsSchema[11]['value'] == 2) {
                if (InsuranceDetailsSchema[12]['value'] == 1) {
                    let table_data = excludesTableStore.getState();
                    if(table_data.length==0){
                        exludesiders&&exludesiders.map((body, key) =>{
                            let obj = {
                                "package_id": null,
                                "service_id": null,
                                "service_name": null,
                                "qty": 0,
                                "rate": 0,
                                "amount": 0
                            }
                            obj['package_id']=body.package_id;
                            obj['service_id']=body.service
                            obj['service_name']=body.service_name
                            obj['qty']=body.qty
                            obj['rate']=body.rate
                            obj['amount']=parseInt(body.amount);

                            excludes_data.push(obj);
                        })
                    }else{
                        table_data.map((body, key) => {
                            let obj = {
                                "package_id": null,
                                "service_id": null,
                                "service_name": null,
                                "qty": 0,
                                "rate": 0,
                                "amount": 0
                            }
    
                            body['feilds'].map((feild, feild_key) => {
    
                                if (feild.name === 'excludes_service_id') {
                                            obj = {
                                                "package_id": feild.package_id ? feild.package_id : null,
                                                "service_id": feild.value ? feild.value : null,
                                                "service_name": feild.text ?feild.text: null,
                                            }
                                    
                                }
                                if (feild.name === 'qty') {
                                    obj[feild.name] = feild.value;
                                }
                                if (feild.name === 'rate') {
                                    obj[feild.name] = feild.value;
    
                                }
                                if (feild.name === 'amount') {
                                    obj[feild.name] = feild.value;
                                }
                                // }
    
                            })
                            excludes_data.push(obj);
                        })  
                    }
                    if (includes_data.length > 0) {
                        includes_data = includes_data;
                    } else {
                        includes_data = [];
                        excludes_data = [];
                    }

                } else {
                    includes_data = [];
                    excludes_data = [];
                }

            }
            else {
                includes_data = [];
                excludes_data = [];
            }
            console.log('manifs', basicSumInsuredSchema)
            let formFeilds = InsuranceDetailsSchema;
            let est = estimateBreakupFormatSchema;
            let basicsuminsure = basicSumInsuredSchema;
            let error1 = this.validateModalFeilds(formFeilds)
            let inerror1 = [];
            let basicerror3 = [];
            let esterror2 = [];
            let ailmenterror4 = [];
            if (error1.length > 0) {
                this.setState({ Insuranceerrors: error1 })
                error1.map((item) => {
                    inerror1.push(item[false]);
                });
            } else {
                inerror1.push(true);
                this.setState({ Insuranceerrors: [] })
            }
            let error2 = this.validateModalFeilds(est)
            if (error2.length > 0) {
                this.setState({ esterrors: error2 })
                error2.map((item) => {
                    esterror2.push(item[false]);
                });
            } else {
                esterror2.push(true);
                this.setState({ esterrors: [] })
            }
            let error3 = this.validateModalFeilds(basicsuminsure);
            if (error3.length > 0) {
                this.setState({ basicsuminsureerrors: error3 })
                error3.map((item) => {
                    basicerror3.push(item[false]);
                });
            } else {
                basicerror3.push(true);
                this.setState({ basicsuminsureerrors: [] })
            }
            let error4 = this.validateailment(ailmentSchema);
            if (error4.length > 0) {
                this.setState({ ailmenteerrors: error4 })
                error4.map((item) => {
                    ailmenterror4.push(item[false]);
                });
            } else {
                ailmenterror4.push(true);
                this.setState({ ailmenteerrors: [] })
            }
            if (esterror2.includes(false)) {
                document.getElementById("wizard").scrollToBottom = 0;
            }
            if (ailmenterror4.includes(false)) {
                document.getElementById("wizard").scrollTop = 950;
            }
            if (basicerror3.includes(false)) {
                document.getElementById("wizard").scrollTop = 524;
            }
            if (inerror1.includes(false)) {
                document.getElementById("wizard").scrollTop = 0;
            }
            // if(error3.includes(false)){
            //     document.getElementById("wizard").scrollTop=600;
            // }
            let error5 = this.validateModalFeilds(signatureSchema)
            let signError = []
            if (error5.length > 0) {
                error5.map((item) => {
                    signError.push(item[false]);
                });
            } else {
                signError.push(true);
            }
            let patient_Willing = this.state.patient_digsign_willing;
            let patient_willing = patient_Willing === true ? 'yes' : 'no';
            let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified'));
            let rnTypeResponse = JSON.parse(Storage.get('counselling_view'));
            let counsellerName = JSON.parse(Storage.get('user_data'));
            let payerResponse=null
            if(rnTypeResponse&&rnTypeResponse.length!==0){
                payerResponse = rnTypeResponse[0].rn_payer_response;
            } else {
                payerResponse = null;
            }
            let payload = {
                "patient_unwilling": patient_willing,
                "fc_checklist_verified": patientCheckIn,
                "counselling_date": basic_info['counselling_date'],
                "token_no": basic_info['token_no'],
                "token_display_number": basic_info['token_display_number'],
                "counselling_type_id": basic_info['counselling_type_id'],
                "counsellor_id": basic_info['counsellor_id'],
                "ip_no": basic_info['ip_no'],
                "umr_no": basic_info['umr_no'],
                "patient_name": basic_info['patient_name'],
                "age": basic_info['age'],
                "gender": basic_info['gender'],
                "phone_no": basic_info['phone_no'],
                "marital_status": basic_info['marital_status'],
                "doctor_id": basic_info['doctor_id'],
                "speciality_id": basic_info['speciality_id'],
                "address": basic_info['address'],
                "payment_type": basic_info['payment_type'],
                "comments_data": basic_info['comments_data'],
                "service_id": basic_info['service_id'],
                "form_id": basic_info['form_id'],
                "payment_change_reason": basic_info['payment_change_reason'],
                "token_is_icu":basic_info['token_is_icu'],
                "token_doctor_id":basic_info['token_doctor_id'],
                "token_doctor_name":basic_info['token_doctor_name'],
                "token_doctor_speciality":basic_info['token_doctor_speciality'],
                "nme_extra_amount":nmeInfo,
                // "whatsapp_phno":basic_info['whatsapp_number'],


                "estimated_admission_date": InsuranceDetailsSchema[0]['value'] ? InsuranceDetailsSchema[0]['value'] : InsuranceDetailsSchema[0]['text'],
                "actual_admission_date": InsuranceDetailsSchema[1]['value'] ? InsuranceDetailsSchema[1]['value'] : null,
                "diagnosis": InsuranceDetailsSchema[2]['value'],
                "type_of_patient": InsuranceDetailsSchema[3]['value'],
                "type_of_insurance": InsuranceDetailsSchema[4]['value'],
                "insurance_status": InsuranceDetailsSchema[5]['value'] ? InsuranceDetailsSchema[5]['value'].toString() : '',
                "insurance_denied_reason": InsuranceDetailsSchema[6]['value'],
                "tpa_name": InsuranceDetailsSchema[7]['value'],
                // "tpa_name": 1,
                "insurance_company": InsuranceDetailsSchema[8]['value'] ? InsuranceDetailsSchema[8]['value'].toString() : '',
                "policy_number": InsuranceDetailsSchema[9]['value'],
                "corporate_name": InsuranceDetailsSchema[10]['value'],
                "care_management": InsuranceDetailsSchema[11]['value'] ? InsuranceDetailsSchema[11]['value'].toString() : '',
                "estimate_type": InsuranceDetailsSchema[12]['value'],

                "date_of_surgery": InsuranceDetailsSchema[13]['value'],
                "surgery_procedure_name": InsuranceDetailsSchema[14]['procedure_id']?InsuranceDetailsSchema[14]['procedure_id']:InsuranceDetailsSchema[14]['value'] ? parseInt(InsuranceDetailsSchema[14]['value']) : null,
                "surgery_procedure_id":InsuranceDetailsSchema[14]['procedure_id']?InsuranceDetailsSchema[14]['procedure_id']: InsuranceDetailsSchema[14]['value'],
                "surgery_procedure_amount": InsuranceDetailsSchema[15]['value'],
                "surgery_procedure_percent": InsuranceDetailsSchema[16]['value'],
                "package_name": InsuranceDetailsSchema[17]['value'],
                "package_id": InsuranceDetailsSchema[17]['value'],
                // "surgery_procedure_id": InsuranceDetailsSchema[17]['value'],
                // "package_amt": InsuranceDetailsSchema[21]['value'],

                "icu_stay": InsuranceDetailsSchema[18]['value'],
                "room_stay": InsuranceDetailsSchema[19]['value'],
                "length_of_stay": InsuranceDetailsSchema[20]['value'] ? InsuranceDetailsSchema[20]['value'].toString() : '',
                // "date_of_surgery": InsuranceDetailsSchema[17]['value'],
                // "surgery_procedure_name": InsuranceDetailsSchema[18]['value'] ? parseInt(InsuranceDetailsSchema[18]['value']) : null,
                // "surgery_procedure_id": InsuranceDetailsSchema[17]['value'],
                // "surgery_procedure_amount": InsuranceDetailsSchema[19]['value'],
                // "surgery_procedure_percent": InsuranceDetailsSchema[20]['value'],

                "basic_sum_insured": basicSumInsuredSchema[0]['value'],
                "buffer_top_up": basicSumInsuredSchema[1]['value'],
                "balance_sum_insured": basicSumInsuredSchema[2]['value'],
                "copay_percent": basicSumInsuredSchema[3]['data'][0]['value'],
                "copay_amount": basicSumInsuredSchema[3]['data'][1]['value'],
                "room_eligible_percent": basicSumInsuredSchema[4]['data'][0]['value'],
                "room_eligible_amount": basicSumInsuredSchema[4]['data'][1]['value'],
                "room_eligible_ward": basicSumInsuredSchema[5]['data'][0]['value'],
                "room_eligible_ward_name": basicSumInsuredSchema[5]['data'][0]['text'],
                "package_amount": inital_package_amount,
                "main_package_percent":basicSumInsuredSchema[5]['data'][0]['percentage'],
                "main_package_actual_price":basicSumInsuredSchema[5]['data'][0]['package_charges'],
                "room_eligible_ward_amount": basicSumInsuredSchema[5]['data'][1]['value'] ? basicSumInsuredSchema[5]['data'][1]['value'].toString() : '',
                "upgrade_room":  basicSumInsuredSchema[6]['data'][0]['value']?basicSumInsuredSchema[6]['data'][0]['value']:basicSumInsuredSchema[6]['data'][0]['value'],
                "upgrade_room_name": basicSumInsuredSchema[6]['data'][0]['text'],
                "upgrade_room_amount": basicSumInsuredSchema[6]['data'][1]['value'],
                "upgrade_package_price":basicSumInsuredSchema[6]['data'][0]['package_charges'],
                "room_upgrade_reason": basicSumInsuredSchema[7]['value'] ? basicSumInsuredSchema[7]['value'].toString() : '',
                "room_upgrade_reason_name": basicSumInsuredSchema[7]['text'],
                "icu_eligible_percent": basicSumInsuredSchema[8]['data'][0]['value'],
                "icu_eligible_amount": basicSumInsuredSchema[8]['data'][1]['value'],
                "icu_ward": basicSumInsuredSchema[9]['data'][0]['value'] ? basicSumInsuredSchema[9]['data'][0]['value'].toString() : '',
                "icu_ward_name": basicSumInsuredSchema[9]['data'][0]['text'],
                // "icu_ward_id": basicSumInsuredSchema[9]['data'][0]['value']?basicSumInsuredSchema[9]['data'][0]['value'].toString():'',
                "icu_ward_amt": basicSumInsuredSchema[9]['data'][1]['value'],
                "icu_difference_amt": basicSumInsuredSchema[10]['value'],
                "room_differance": basicSumInsuredSchema[12]['value'],
                "pro_rata_differance": basicSumInsuredSchema[13]['value'],
                "package_differance":basicSumInsuredSchema[14]['value'],
                "ailment_capping_status": basicSumInsuredSchema[15]['value'] ? parseInt(basicSumInsuredSchema[15]['value']) : '',
                "ailment_capping_amount": this.state.ailment_capping_amount,
                "sum_insured_four_years_back": sum_insured_four_years_back,
                "consider_si_four_years_back": consider_si_four_years_back,
                "additional_packages": additional_packages,
                "additional_procedures": additional_procedures,
                "nmes_data": nmedata,
                // "pre_existing_condition": pre_existing_condition,
                // "interm_approval": interm_approval,
                "ailment_capping": ailment,
                "interm_approval": interim,
                "pre_existing_condition": pre_ex_conditions,
                "excludes_data": excludes_data,
                "includes_data": includes_data,
                "base_price": estimateBreakupFormatSchema[0]['value'],
                "excludes": estimateBreakupFormatSchema[1]['value'],
                "initial_approval_amount": estimateBreakupFormatSchema[2]['value'],
                // "copay_amount": estimateBreakupFormatSchema[3]['value'],
                "nme_amount": estimateBreakupFormatSchema[4]['value'],
                "actual_nme_amount": estimateBreakupFormatSchema[5]['value'],
                "final_bill_amount": estimateBreakupFormatSchema[6]['value'],
                "discount": estimateBreakupFormatSchema[7]['value'],
                "final_approval": estimateBreakupFormatSchema[8]['value'],
                "extra_deduction": estimateBreakupFormatSchema[9]['value'],
                "remarks": estimateBreakupFormatSchema[10]['value'],
                "differance_amount": estimateBreakupFormatSchema[11]['value'],
                // "total_Estimate_amount": this.state.total_estimate_amount,
                //estimateBreakupFormatSchema[11]['value'],
                //  "total_Estimate_amount": this.state.total_estimate_amount,
                "total_Estimate_amount": estimateBreakupFormatSchema[12]['value'],
                "signature_of": estimateBreakupFormatSchema[13]['value'],
                "attendant_name": estimateBreakupFormatSchema[14]['value'],
                "patient_relation": estimateBreakupFormatSchema[15]['value'],
                "name_of_the_fc": JSON.parse(localStorage.getItem('user')),
                "patient_attender_signature": null,
                "counsellor_signature": null,
                "covid_status":basic_info['covid_status']?basic_info['covid_status']:null,
                'rn_payer_response': payerResponse || null,

                "header_amount": {
                    "room_charges": addonSchema[0]['header_amount'],
                    "room_investigation_charges": addonSchema[1]['header_amount'],
                    "icu_investigation_charges": addonSchema[2]['header_amount'],
                    "ip_pharmacy_charges": addonSchema[3]['header_amount'],
                    "icu_pharmacy_charges": addonSchema[4]['header_amount'],
                    "ot_cath_pharmacy": addonSchema[5]['header_amount'],
                    "drug_admin_charges": 0,
                    "general_equipment_charges": addonSchema[6]['header_amount'],
                    "ot_charges": addonSchema[7]['header_amount'],
                    "ot_equipment": addonSchema[8]['header_amount'],
                    "procedure_charges": addonSchema[9]['header_amount'],
                    "blood_bank_charges": addonSchema[10]['header_amount'],
                    "cross_consultation_charges": addonSchema[11]['header_amount'],
                    "hospital_services": addonSchema[12]['header_amount'],
                    "isolation_charges": addonSchema[13]['header_amount'],
                    "physiotherapy_diet_charges": addonSchema[14]['header_amount'],
                    "surgical_charges": addonSchema[15]['header_amount'],
                    "medical_charges": addonSchema[16]['header_amount']
                },
                "estimation": estimate_data,
                "is_digital_sig_required": isGenerateSign,
                "digital_sig_number": basic_info['phone_no'],
                //"digital_sig_weblink": patient_willing === 'yes' ? 'no' : 'yes',
                "digital_sig_weblink": patient_willing === 'yes' || null ? 'no' : 'yes',
                "counseller_name": counsellerName.username,
            };
            let digiSignPhone;
            signatureSchema.map((feild, fei_key) => {
                if(feild["name"] === "phonenumber"){
                    digiSignPhone = feild["value"]
                    payload["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] : basic_info['phone_no']
                }
            })

            console.log('final_submit payload', payload)
            // return
    
            if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && !signError.includes(false) ) {
                try {
                    
                    const Userlogobj = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "create Financial Councelling - Request",
                            "date": new Date(),
                            "meta": payload
                        }
                    }
                    userTrackService(Userlogobj);
                    localStorage.removeItem('est_admis_date')
                    postService('getconfigurations', 'GET', 'null').then(res => {
                        if (res.status) {
                            if (res.data.length > 0) {
                                if (res.data[0].data.length > 0) {
                                    res.data[0].data.map((feilds, key) => {
                                        if (feilds.config_name === 'Print Waiting Time') {
                                         localStorage.setItem('printTimeWait',feilds.bill_tracking_percent);
                                        }
                                    })
                                }
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'No service available',
                                });
                            }
                        } 
                        else {
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong',
                            });
                        }
                    });
                    
                    postService('createFinancialCouncelling', 'POST', { "data": payload }).then(res => {
                        if (res['status']) {
                            localStorage.removeItem('completed_counselling_date');
                            hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                            const UserlogobjRes = {
                                "data": {
                                    "user": JSON.parse(localStorage.getItem('user')),
                                    "action": "create Financial Councelling - Response",
                                    "date": new Date(),
                                    "meta": res
                                }
                            }
                            userTrackService(UserlogobjRes);
                            Storage.store('current_print', res.data);
                            Storage.store('CounID', res.data.counselling_id)
                            localStorage.removeItem('insuranceType');
                            let counselling_id=res.data.counselling_id
                            let user_data = JSON.parse(localStorage.getItem('user_data'));
                            const unit_id =user_data ? user_data.unitid:'';
                            let payload={
                                "umr_no": basic_info['umr_no'],
                                "unit_id": unit_id,
                                "comment": estimateBreakupFormatSchema[10]['value'],
                                "comment_from": "counselling form",
                                "call_log": false,
                                "call_log_eda": null,
                                "call_back_date": null,
                                "call_log_surgery_date": null,
                                "call_log_category": null,
                                "call_log_ip_no": null,
                                "call_log_reason": null,
                                "admission_id": "",
                                "doctor_id": basic_info['token_doctor_id'],
                                "is_iccu": null,
                                "ip_no": basic_info['ip_no']
                            }
                            postService('addCounsellorComments', 'POST', { 'data': payload }).then(res => {
                                if (res.status) {
                                    this.setState({ preview_modal:false,preview_PatientCheckin_model:false });
                                    let This=this
                                    const id = `insurancePreview`;
                                    const input = document.getElementById(id);
                                    let doctor_cd = this.state.preview_data.doctor_id;
                                    if(input !==null && input !=='' && input !==undefined){
                                        html2PDF(input, {   
                                            image: { type: 'png', quality: 0.20 },
                                            jsPDF: { format: 'a4', },
                                            html2canvas: {
                                                scrollX: 0,
                                                scrollY: -window.scrollY,
                                                useCORS: true,
                                            },
                                            imageType: 'image/jpeg',
                                            output: './images/generate.pdf',
                                            success: function(pdf) {
                                                const blob = pdf.output('blob');
                                                // const blob2 = pdf.output('blob');
                                                const form_data = new FormData();
                                                console.log("input++++++++++",input)
                                                form_data.append('upfile', blob);
                                                form_data.append("umr", basic_info['umr_no']);
                                                // form_data.append("phone_no",basic_info['phone_no']);
                                                form_data.append("counselling_id", counselling_id);
                                                form_data.append("doctor_name", basic_info['doctor_name']);
                                                form_data.append("patient_name",basic_info['patient_name']);
                                                form_data.append("counselling_date",basic_info['counselling_date']);
                                                form_data.append("speciality_id", basic_info['speciality_id']);
                                                form_data.append("doctor_cd", doctor_cd);
                                                form_data.append("is_digital_sig_required", isGenerateSign);
                                                form_data.append("phone_no", digiSignPhone);
                                                form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                                                formDataPostService('fileUploadforFinancialCounselling', 'POST', form_data).then(res => {
                                                    if (res.status) {
                                                    localStorage.setItem('completed_counselling_date',moment());
                                                    console.log("input+-+-+-+-",);    
                                                    This.props.next();
                                                        This.setState({ loadding: false });
                                                        console.log("input!!!!!!!!");
                                                        // Modal.success({
                                                        //     title: `success`,
                                                        //     content: `${res.message}`,
                                                        //     zIndex: '1022'
                                                        // });
                                                }
                                            });
                                                // pdf.save(this.output);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                        else {
                                    this.setState({ loadding: false })
                                    let that=this
                                    localStorage.setItem('completed_counselling_date',moment());
                                    Storage.store('current_print', res.data);
                                    Modal.warning({
                                        title: 'Unable to process',
                                        content: res.message?res.message:'Oops, something went wrong. Please,try again later',
                                        zIndex:'1035',
                                        onOk() {
                                            that.props.next();
                                                }
                                    });
                        }
                    })
                } catch (error) {
                    console.log(error);
                    this.setState((state) => ({ 'loadding': false }))
                    Modal.error({
                        title: 'Error message',
                        content: 'Oops, something went wrong. Please,try again later'
                    });
                }
            }
            else {
                console.log('error:', error1, error2)
                this.setState({ loadding: false })
            }
            return
        // } catch (error) {
        //     Modal.error({
        //         title: 'Error message',
        //         content: 'Oops! something went wrong. Please,try again later'
        //     });
        // }

    }
    Preview() {
        try {
            let { addonSchema, basicSumInsuredSchema, estimateBreakupFormatSchema, InsuranceDetailsSchema, ailmentSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, interimSchema, preexistingConditionsSchema, includes_data, nmePopupSchema, package_amt, inital_package_amount,exludesiders, isGenerateSign, generatedLink, digital_sig_imgpath,slugforexcludedropdown,patient_digsign_willing} = this.state;
            let { basic_info } = this.props;
            let estimate_data = [];
            let additional_packages = [];
            let additional_procedures = [];
            let ailment = [];
            let interim = [];
            let pre_ex_conditions = [];
            let temp_obj = {}
            let excludes_data = [];
            let nmedata = [];

            if (generatedLink !== null && digital_sig_imgpath !== null && patient_digsign_willing === true) {
                console.log('Siae', generatedLink,digital_sig_imgpath,patient_digsign_willing )
                this.handleCheckboxChange();
            }
            if (generatedLink === null && digital_sig_imgpath !== null && patient_digsign_willing === true) {
                console.log('Siae2', generatedLink,digital_sig_imgpath,patient_digsign_willing )
                this.handleCheckboxChange();
            }

            addonSchema.map((subTable, key) => {
                if (subTable.name !== 'ins_surgical_charges' && subTable.name !== 'ins_medical_charges') {
                    let table_header = subTable.header;
                    let table_body = subTable.Specification.table_body;
                    temp_obj[table_header] = subTable.header_amount;
                    table_body.map((feild, table_key) => {
                        let service, qty, rate, amount, sub_header;
                        let key_word = feild.key_word;
                        let row = feild.feilds;
                        if (key_word !== 'ot_hours') {
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action') {
                                    if (sub_table_key === 0) {
                                        sub_header = parseFloat(sub_feild.sub_header);
                                        if (sub_feild.element === 'text') {
                                            service = parseFloat(sub_feild.service);
                                        }
                                        else {
                                            service = parseFloat(sub_feild.value);
                                        }
                                    }
                                    if (sub_table_key === 1) {
                                        qty = parseFloat(sub_feild.value);
                                    }
                                    if (sub_table_key === 2) {
                                        rate = parseFloat(sub_feild.value);
                                    }
                                    if (sub_table_key === 3) {
                                        amount = parseFloat(sub_feild.value);
                                    }
                                }
                            })
                        }
                        else {
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action') {
                                    if (sub_table_key === 1) {
                                        service = parseFloat(sub_feild.service);
                                        sub_header = parseFloat(sub_feild.sub_header);
                                        qty = null;
                                    }
                                    if (sub_table_key === 2) {
                                        rate = parseFloat(sub_feild.value);
                                    }
                                    if (sub_table_key === 3) {
                                        amount = parseFloat(sub_feild.value);
                                    }
                                }
                            })
                        }

                        let obj = {
                            key_word: key_word,
                            header: table_header,
                            sub_header: sub_header,
                            service: service,
                            qty: qty,
                            rate: rate,
                            amount: amount
                        }

                        if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                        }
                        else {
                            if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                                estimate_data.push(obj);
                            }
                        }
                    })
                }
                else {
                    if (subTable.visible) {
                        let table_header = subTable.header;
                        let table_body = subTable.Specification.table_body;
                        temp_obj[table_header] = subTable.header_amount;
                        table_body.map((feild, table_key) => {
                            let service, percentage, amount, sub_header;
                            let key_word = feild.key_word;
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_table_key === 0) {
                                    service = parseFloat(sub_feild.service);
                                    sub_header = parseFloat(sub_feild.sub_header);
                                }
                                if (sub_table_key === 1) {
                                    percentage = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            })
                            let obj = {
                                key_word: key_word,
                                header: table_header,
                                sub_header: sub_header,
                                service: service,
                                qty: percentage,
                                rate: null,
                                amount: amount
                            }
                            if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                                estimate_data.push(obj);
                            }
                        })
                    }
                }
            })

            additionalPackageSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let package_id,discount_amount,actual_price, percentage,package_name;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    package_id = parseFloat(sub_feild.value);
                                    package_name=sub_feild.text;
                                }
                                if (sub_table_key === 1) {
                                    actual_price = parseFloat(sub_feild.value);
                                }
                                if(sub_table_key === 2){
                                    percentage = parseFloat(sub_feild.value);
                                }
                                if(sub_table_key === 3){
                                    discount_amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                        let obj = {
                            package_id: package_id,
                            package_name:package_name,
                            amount: discount_amount,
                            additional_type: 1,
                            package_percentage : percentage,
                            actual_price:actual_price
                        }
                        if (package_id !== '' && package_id !== null && package_id !== undefined && !isNaN(package_id) && discount_amount !== '' && discount_amount !== null && discount_amount !== undefined && !isNaN(discount_amount)) {
                            additional_packages.push(obj);
                        }
                    })
                }
            })

            additionalProcedureSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let procedure_id, amount, percentage, procedure_name;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            console.log('enter', sub_feild)
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    procedure_id = parseFloat(sub_feild.value);
                                    procedure_name = sub_feild.text;
                                }
                                if (sub_table_key === 1) {
                                    amount = parseFloat(sub_feild.value);
                                }
                              
                            }
                        })
                        let obj = {
                            procedure_id: procedure_id,
                            amount: amount,
                            additional_type: 2,
                            procedure_name: procedure_name
                            // percentage: percentage
                        }
                        if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            additional_procedures.push(obj);
                        }
                    })
                }
            })

            ailmentSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let surgery, surgery_amount, percentage;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    surgery = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 1) {
                                    surgery_amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                        let obj = {
                            surgery: surgery,
                            surgery_amount: surgery_amount,
                            additional_type: 2
                            // percentage: percentage
                        }
                        if (surgery !== '' && surgery !== null && surgery !== undefined && !isNaN(surgery) && surgery_amount !== '' && surgery_amount !== null && surgery_amount !== undefined && !isNaN(surgery_amount)) {
                            ailment.push(obj);
                        }
                    })
                }
            })
            if (nmePopupSchema !== undefined) {
                nmePopupSchema.map((subTable, key) => {
                    console.log('nem_data_view===========================', subTable)
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let obj = {
                            "nme_id": null,
                            "nme_name": null,
                            "nme_rate": 0,
                            "nme_total_amount": 0,
                            "nme_quantity": 0,
                            "nme_tariff": null,
                        }
                        let nme_amount, nme_name, nme_rate, nme_quantity, nme_id, nme_tariff;
                        let row = feild.feilds;
                        console.log('rowssss2=====', row)
                        row.map((sub_feild, sub_table_key) => {

                            if (sub_feild.name === "department") {
                                obj['nme_id'] = sub_feild.id;
                                obj['nme_name'] = sub_feild.text;
                            }
                            if (sub_feild.name === 'tariff') {
                                obj['nme_tariff'] = sub_feild.text;

                            }
                            if (sub_feild.name === 'amount') {
                                obj['nme_quantity'] = sub_feild.value;
                            }
                            if (sub_feild.name === 'rate') {
                                obj['nme_rate'] = sub_feild.value;

                            }
                            if (sub_feild.name === 'amount') {
                                obj['nme_amount'] = sub_feild.value;

                            }

                            if (sub_feild.name !== 'action') {
                              
                            }
                        })

                        nmedata.push(obj);
                       console.log('nmeDATA=====', nmedata);

                    })

                })

            }

            interimSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let interim_amount, aprox_bill, case_no;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    interim_amount = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 1) {
                                    aprox_bill = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    case_no = parseFloat(sub_feild.value);
                                }
                            }
                        })
                        let obj = {
                            interim_amount: interim_amount,
                            aprox_bill: aprox_bill,
                            additional_type: 2,
                            case_no: case_no
                        }
                        if (interim_amount && interim_amount !== undefined && !isNaN(interim_amount) && aprox_bill && aprox_bill !== undefined && !isNaN(aprox_bill) && case_no) {
                            interim.push(obj);
                        }
                    })
                }
            })
            let sum_insured_four_years_back = 0;
            let consider_si_four_years_back = 0;
            console.log('preexistingConditionsSchema', preexistingConditionsSchema)
            preexistingConditionsSchema.map((subTable, key) => {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let condition_name, onset_data, sum_insured_onset_data, consder_si;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_feild.id === 2) {
                                    if (sub_table_key === 0) {
                                        condition_name = sub_feild.value;
                                    }
                                    if (sub_table_key === 1) {
                                        onset_data = '';
                                        sum_insured_four_years_back = sub_feild.value;
                                    }
                                    if (sub_table_key === 2) {
                                        consider_si_four_years_back = sub_feild.value ? 1 : 0;
                                    }

                                } else {
                                    if (sub_table_key === 0) {
                                        condition_name = sub_feild.value;
                                    }
                                    if (sub_table_key === 1) {
                                        onset_data = sub_feild.value;
                                    }
                                    if (sub_table_key === 2) {
                                        sum_insured_onset_data = sub_feild.value;
                                    }
                                    if (sub_table_key === 3) {
                                        consder_si = sub_feild.value ? 1 : 0;
                                    }
                                }

                            }
                        })
                        let obj = {
                            condition_name: condition_name,
                            onset_data: onset_data,
                            // additional_type: 2,
                            sum_insured_onset_data: sum_insured_onset_data,
                            consder_si: consder_si
                        }
                        if (condition_name && condition_name !== undefined && onset_data && onset_data !== undefined && sum_insured_onset_data && consder_si) {
                            pre_ex_conditions.push(obj);
                        }
                    })
                }
            })
            console.log(pre_ex_conditions);
            let room_opted_amount = 0;
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'estimate_type' && feild['value'] == 1) {
                    basicSumInsuredSchema.map((feild, key) => {
                        if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                            let { data } = feild;
                            data.map((sub_feild, sub_key) => {
                                if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                    room_opted_amount = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                }
                            })
                        }
                    })
                }
            })
            console.log(basicSumInsuredSchema);
            if (InsuranceDetailsSchema[11]['value'] == 2) {
                if (InsuranceDetailsSchema[12]['value'] == 1) {
                   
                    let table_data = excludesTableStore.getState();
                    if(table_data.length==0){
                        exludesiders && exludesiders.length>0 && exludesiders.map((item,index)=>{
                            item['service_id']=item.service
                        })
                        excludes_data=exludesiders?exludesiders:[]
                    }else{
                        table_data && table_data.length>0 && table_data.map((body, key) => {
                            let obj = {
                                "package_id": null,
                                "service_id": null,
                                "service_name": null,
                                "qty": 0,
                                "rate": 0,
                                "amount": 0
                            }
    
                            body['feilds'].map((feild, feild_key) => {
    
                                if (feild.name === 'excludes_service_id') {
                                   
                                            obj = {
                                                "package_id": feild.package_id ? feild.package_id : null,
                                                "service_id": feild.value ? feild.value : null,
                                                "service_name": feild.text ?feild.text: null,
                                            }
    
                                }
                                if (feild.name === 'qty') {
                                    obj[feild.name] = feild.value;
                                }
                                if (feild.name === 'rate') {
                                    obj[feild.name] = feild.value;
    
                                }
                                if (feild.name === 'amount') {
                                    obj[feild.name] = feild.value;
                                }
    
                            })
                            excludes_data.push(obj);
                        })  
                    }
                   
                  
                    if (includes_data.length > 0) {
                        includes_data = includes_data;
                    } else {
                        includes_data = [];
                        excludes_data = [];
                    }

                } else {
                    includes_data = [];
                    excludes_data = [];
                }

            }
            else {
                includes_data = [];
                excludes_data = [];
            }
            console.log('manifs', basicSumInsuredSchema)
            let formFeilds = InsuranceDetailsSchema;
            let est = estimateBreakupFormatSchema;
            let basicsuminsure = basicSumInsuredSchema;
            let error1 = this.validateModalFeilds(formFeilds)
            let inerror1 = [];
            let basicerror3 = [];
            let esterror2 = [];
            let ailmenterror4 = [];
            if (error1.length > 0) {
                this.setState({ Insuranceerrors: error1 })
                error1.map((item) => {
                    inerror1.push(item[false]);
                });
            } else {
                inerror1.push(true);
                this.setState({ Insuranceerrors: [] })
            }
            let error2 = this.validateModalFeilds(est)
            if (error2.length > 0) {
                this.setState({ esterrors: error2 })
                error2.map((item) => {
                    esterror2.push(item[false]);
                });
            } else {
                esterror2.push(true);
                this.setState({ esterrors: [] })
            }
            let error3 = this.validateModalFeilds(basicsuminsure);
            if (error3.length > 0) {
                this.setState({ basicsuminsureerrors: error3 })
                error3.map((item) => {
                    basicerror3.push(item[false]);
                });
            } else {
                basicerror3.push(true);
                this.setState({ basicsuminsureerrors: [] })
            }
            let error4 = this.validateailment(ailmentSchema);
            if (error4.length > 0) {
                this.setState({ ailmenteerrors: error4 })
                error4.map((item) => {
                    ailmenterror4.push(item[false]);
                });
            } else {
                ailmenterror4.push(true);
                this.setState({ ailmenteerrors: [] })
            }
            if (esterror2.includes(false)) {
                document.getElementById("wizard").scrollToBottom = 0;
            }
            if (ailmenterror4.includes(false)) {
                document.getElementById("wizard").scrollTop = 950;
            }
            if (basicerror3.includes(false)) {
                document.getElementById("wizard").scrollTop = 524;
            }
            if (inerror1.includes(false)) {
                document.getElementById("wizard").scrollTop = 0;
            }
            // if(error3.includes(false)){
            //     document.getElementById("wizard").scrollTop=600;
            // }
            let error5 = this.validateModalFeilds(signatureSchema["feilds"])
            let signError = []
            if (error5.length > 0) {
                error5.map((item) => {
                    signError.push(item[false]);
                });
            } else {
                signError.push(true);
            }
            if (signError.includes(false)) {
                document.getElementById("wizard").scrollToBottom = 0;
            }

            let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified'));
            let rnTypeResponse = JSON.parse(Storage.get('counselling_view'));
            let payerResponse=null
            if(rnTypeResponse&&rnTypeResponse.length!==0){
                payerResponse = rnTypeResponse[0].rn_payer_response;
            } else {
                payerResponse = null;
            }
            let data = {
                "fc_checklist_verified": patientCheckIn,
                "counselling_date": basic_info['counselling_date'],
                "token_no": basic_info['token_no'],
                "token_display_number": basic_info['token_display_number'],
                "counselling_type_id": basic_info['counselling_type_id'],
                "counsellor_id": basic_info['counsellor_id'],
                "ip_no": basic_info['ip_no'],
                "umr_no": basic_info['umr_no'],
                "patient_name": basic_info['patient_name'],
                "age": basic_info['age'],
                "gender": basic_info['gender'],
                "phone_no": basic_info['phone_no'],
                "marital_status": basic_info['marital_status'],
                "doctor_id": basic_info['doctor_id'],
                "speciality_id": basic_info['speciality_id'],
                "address": basic_info['address'],
                "payment_type": basic_info['payment_type'],
                "comments_data": basic_info['comments_data'],
                "service_id": basic_info['service_id'],
                "form_id": basic_info['form_id'],
                "payment_change_reason": basic_info['payment_change_reason'],
                "counselling_type_name": basic_info['counselling_type_name'],
                "doctor_name": basic_info['doctor_name'],
                "speciality_name": basic_info['speciality_name'],
                "payment_name": basic_info['payment_name'],
                // "whatsapp_phno":basic_info['whatsapp_number'],

                "e_date_of_admission": InsuranceDetailsSchema[0]['value'] ? InsuranceDetailsSchema[0]['value'] : InsuranceDetailsSchema[0]['text'],
                "actual_admission_date": InsuranceDetailsSchema[1]['value'] ? InsuranceDetailsSchema[1]['value'] : null,
                "diagnosis": InsuranceDetailsSchema[2]['value'],
                "type_of_patient": InsuranceDetailsSchema[3]['value'],
                "type_of_insurance": InsuranceDetailsSchema[4]['value'],
                "insurance_status": InsuranceDetailsSchema[5]['value'] ? InsuranceDetailsSchema[5]['value'].toString() : '',
                "insurance_status_name": InsuranceDetailsSchema[5]['text'],
                "insurance_denied_reason": InsuranceDetailsSchema[6]['value'],
                "tpa_name": InsuranceDetailsSchema[7]['text'],
                "insurance_company": InsuranceDetailsSchema[8]['value'] ? InsuranceDetailsSchema[8]['value'].toString() : '',
                "insurance_company_name": InsuranceDetailsSchema[8]['text'],
                "policy_number": InsuranceDetailsSchema[9]['value'],
                "corporate_name": InsuranceDetailsSchema[10]['value'],
                "care_management": InsuranceDetailsSchema[11]['value'] ? InsuranceDetailsSchema[11]['value'].toString() : '',
                "care_management_name": InsuranceDetailsSchema[11]['text'],
                "estimate_type": InsuranceDetailsSchema[12]['value'],
                "estimate_type_name": InsuranceDetailsSchema[12]['text'],
                "surgery_name": InsuranceDetailsSchema[14]['text'],
                "date_of_surgery": InsuranceDetailsSchema[13]['value'],
                "surgery_procedure_name": InsuranceDetailsSchema[14]['value'] ? parseInt(InsuranceDetailsSchema[14]['value']) : null,
                "surgery_procedure_id": InsuranceDetailsSchema[14]['value'],
                "surgery_procedure_amount": InsuranceDetailsSchema[15]['value'],
                "surgery_procedure_percent": InsuranceDetailsSchema[16]['value'],
                "package_name": InsuranceDetailsSchema[17]['text'],
                "package_id": InsuranceDetailsSchema[17]['value'],
                "package_amt": inital_package_amount,


                "icu_stay": InsuranceDetailsSchema[18]['value'],
                "room_stay": InsuranceDetailsSchema[19]['value'],
                "length_of_stay": InsuranceDetailsSchema[20]['value'] ? InsuranceDetailsSchema[20]['value'].toString() : '',
                // "date_of_surgery": InsuranceDetailsSchema[17]['value'],
                // "surgery_procedure_name": InsuranceDetailsSchema[18]['value'] ? parseInt(InsuranceDetailsSchema[18]['value']) : null,
                // "surgery_procedure_id": InsuranceDetailsSchema[17]['value'],
                // "surgery_procedure_amount": InsuranceDetailsSchema[19]['value'],
                // "surgery_procedure_percent": InsuranceDetailsSchema[20]['value'],

                "basic_sum_insured": basicSumInsuredSchema[0]['value'],
                "buffer_top_up": basicSumInsuredSchema[1]['value'],
                "balance_sum_insured": basicSumInsuredSchema[2]['value'],
                "copay_percent": basicSumInsuredSchema[3]['data'][0]['value'],
                // "copay_amount": basicSumInsuredSchema[3]['data'][1]['value'],
                "room_eligible_percent": basicSumInsuredSchema[4]['data'][0]['value'],
                "room_eligible_amount": basicSumInsuredSchema[4]['data'][1]['value'],
                "room_eligible_ward": basicSumInsuredSchema[5]['data'][0]['value'],
                "room_eligible_ward_name": basicSumInsuredSchema[5]['data'][0]['text'],
                "package_amount": basicSumInsuredSchema[5]['data'][0]['package_charges'],
                "room_eligible_ward_amount": basicSumInsuredSchema[5]['data'][1]['value'] ? basicSumInsuredSchema[5]['data'][1]['value'].toString() : '',
                "upgrade_room": basicSumInsuredSchema[6]['data'][0]['value'] ? basicSumInsuredSchema[6]['data'][0]['value'].toString() : '',
                "upgrade_room_name": basicSumInsuredSchema[6]['data'][0]['text'],
                "upgrade_room_amount": basicSumInsuredSchema[6]['data'][1]['value'],
                "room_upgrade_reason": basicSumInsuredSchema[7]['value'] ? basicSumInsuredSchema[7]['value'].toString() : '',
                "room_upgrade_reason_name": basicSumInsuredSchema[7]['text'],
                "icu_eligible_percent": basicSumInsuredSchema[8]['data'][0]['value'],
                "icu_eligible_amount": basicSumInsuredSchema[8]['data'][1]['value'],
                "icu_ward": basicSumInsuredSchema[9]['data'][0]['value'] ? basicSumInsuredSchema[9]['data'][0]['value'].toString() : '',
                "icu_ward_name": basicSumInsuredSchema[9]['data'][0]['text'],
                // "icu_ward_id": basicSumInsuredSchema[9]['data'][0]['value']?basicSumInsuredSchema[9]['data'][0]['value'].toString():'',
                "icu_ward_amt": basicSumInsuredSchema[9]['data'][1]['value'],
                "icu_difference_amt": basicSumInsuredSchema[10]['value'],
                "room_differance": basicSumInsuredSchema[12]['value'],
                "pro_rata_differance": basicSumInsuredSchema[13]['value'],
                "ailment_capping_status": basicSumInsuredSchema[15]['value'] ? parseInt(basicSumInsuredSchema[15]['value']) : '',
                "ailment_capping_amount": this.state.ailment_capping_amount,
                "ailment_capping_status_name": basicSumInsuredSchema[15]['text'],
                "sum_insured_four_years_back": sum_insured_four_years_back,
                "consider_si_four_years_back": consider_si_four_years_back,

                "additional_packages": additional_packages,
                "additional_procedures": additional_procedures,
                "nmes_data": nmedata,
                // "pre_existing_condition": pre_existing_condition,
                // "interm_approval": interm_approval,
                "ailment_capping": ailment,
                "interm_approval": interim,
                "pre_existing_condition": pre_ex_conditions,
                "excludes_data": excludes_data,
                "includes_data": includes_data,
                "base_price": estimateBreakupFormatSchema[0]['value'],
                "excludes": estimateBreakupFormatSchema[1]['value'],
                "initial_approval_amount": estimateBreakupFormatSchema[2]['value'],
                "copay_amount": estimateBreakupFormatSchema[3]['value'],
                "nme_amount": estimateBreakupFormatSchema[4]['value'],
                "actual_nme_amount": estimateBreakupFormatSchema[5]['value'],
                "final_bill_amount": estimateBreakupFormatSchema[6]['value'],
                "discount": estimateBreakupFormatSchema[7]['value'],
                "final_approval": estimateBreakupFormatSchema[8]['value'],
                "extra_deduction": estimateBreakupFormatSchema[9]['value'],
                "remarks": estimateBreakupFormatSchema[10]['value'],
                "differance_amount": estimateBreakupFormatSchema[11]['value'],
                // "total_Estimate_amount": this.state.total_estimate_amount,
                //estimateBreakupFormatSchema[11]['value'],
                //  "total_Estimate_amount": this.state.total_estimate_amount,
                "total_Estimate_amount": estimateBreakupFormatSchema[12]['value'],
                "signature_of": estimateBreakupFormatSchema[13]['value'],
                "attendant_name": estimateBreakupFormatSchema[14]['value'],
                "patient_relation": estimateBreakupFormatSchema[15]['value'],
                "name_of_the_fc": JSON.parse(localStorage.getItem('user')),
                "patient_attender_signature": null,
                "counsellor_signature": null,
                "covid_status":basic_info['covid_status']?basic_info['covid_status']:null,
                'rn_payer_response': payerResponse || null,

                "header_amount": {
                    "room_charges": addonSchema[0]['header_amount'],
                    "room_investigation_charges": addonSchema[1]['header_amount'],
                    "icu_investigation_charges": addonSchema[2]['header_amount'],
                    "ip_pharmacy_charges": addonSchema[3]['header_amount'],
                    "icu_pharmacy_charges": addonSchema[4]['header_amount'],
                    "ot_cath_pharmacy": addonSchema[5]['header_amount'],
                    "drug_admin_charges": 0,
                    "general_equipment_charges": addonSchema[6]['header_amount'],
                    "ot_charges": addonSchema[7]['header_amount'],
                    "ot_equipment": addonSchema[8]['header_amount'],
                    "procedure_charges": addonSchema[9]['header_amount'],
                    "blood_bank_charges": addonSchema[10]['header_amount'],
                    "cross_consultation_charges": addonSchema[11]['header_amount'],
                    "hospital_services": addonSchema[12]['header_amount'],
                    "isolation_charges": addonSchema[13]['header_amount'],
                    "physiotherapy_diet_charges": addonSchema[14]['header_amount'],
                    "surgical_charges": addonSchema[15]['header_amount'],
                    "medical_charges": addonSchema[16]['header_amount']
                },
                "estimation": estimate_data,
                "isGenerateSign": isGenerateSign,
                "generatedLink": generatedLink,
            };
            // if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && !signError.includes(false) && digital_sig_imgpath || patient_digsign_willing === true) {
                if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && !signError.includes(false)) {    
            try {
                    if(estimateBreakupFormatSchema[4]['value']==0 || estimateBreakupFormatSchema[4]['value']==null || estimateBreakupFormatSchema[4]['value']==undefined || estimateBreakupFormatSchema[4]['value']===''){
                        hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:true} })
                        // Modal.error({
                        //     title: 'Error message',
                        //     content: 'Please add the NME amount',
                        //     onOk: function () {
                        //         window.scrollTo(0, 0);
                        //     }
                        // });
                    }else if (slugforexcludedropdown == 'finanical-counselling' && (data.fc_checklist_verified === 'no' || data.fc_checklist_verified === null)) {
                        Modal.error({
                          title: 'Error message',
                          content: 'Please verify the FC checklist',
                          onOk: function () {
                            window.scrollTo(0, 0);
                          },
                        });
                      } else{
                        this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
                    }
                    
                    // postService('createFinancialCouncelling', 'POST', { "data": payload }).then(res => {
                    //     if (res['status']) {
                    //         this.setState({ loadding: false })
                    //         Storage.store('current_print', res.data);
                    //         this.props.next();
                    //     }
                    //     else {
                    //         this.setState({ loadding: false })
                    //         console.log('fail', res);
                    //         Modal.error({
                    //             title: 'Error message',
                    //             content: 'Oops! something went wrong. Please,try again later'
                    //         });
                    //     }
                    // })
                } catch (error) {
                    console.log(error);
                    this.setState((state) => ({ 'loadding': false }))
                    Modal.error({
                        title: 'Error message',
                        content: 'Oops, something went wrong. Please,try again later'
                    });
                }
            }
            // else if(!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && generatedLink && !digital_sig_imgpath){
            //     console.log('INSUR',digital_sig_imgpath,generatedLink )
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please Add Digital Signature',
            //     });
            // }else if(!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && !generatedLink){
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please Send Link For Digital Signature',
            //     });
            // }

            // else if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing !== true) {
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please Add Digital Signature or check Patient unwilling/unavailable Checkbox',
            //     });
            // } 
            // else if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && digital_sig_imgpath !== null && patient_digsign_willing !== true) {
            //     this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            //     console.log("document.getElementById(id)", document.getElementById('previewcash'));
            // } else if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && digital_sig_imgpath === null && patient_digsign_willing !== false) {
            //     this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            //     console.log("document.getElementById(id)", document.getElementById('previewcash'));
            // } 
            // else if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && generatedLink === null && digital_sig_imgpath !== null && patient_digsign_willing !== false) {
            //     this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            //     console.log("document.getElementById(id)", document.getElementById('previewcash'));
            // }
            // else if (!inerror1.includes(false) && !esterror2.includes(false) && !basicerror3.includes(false) && !ailmenterror4.includes(false) && generatedLink === null && digital_sig_imgpath === null && patient_digsign_willing !== true) {
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please Send Digital Signature or Check Patient unwilling/unavailable',
            //     });
            // }
            else {
                console.log('error:', error1, error2)
                this.setState({ loadding: false })
            }
            return
        } 
        catch (error) {
            Modal.error({
                title: 'Error message',
                content: 'Oops! something went wrong. Please,try again later'
            });
        }

    }

    handleChange(data) {
        try {
        let { addonSchema, additionalPackageSchema, InsuranceDetailsSchema, basicSumInsuredSchema, additionalProcedureSchema, ailmentSchema, interimSchema, preexistingConditionsSchema, estimateBreakupFormatSchema, ailmenteerrors, additional_package_percent1, additional_package_percent2, additional_package_percent3, allPackage } = this.state;
        const { getServicePricesById } = networkList;
        let { counselling_details } = this.props;

        let amount, room_id, room_value = 0, room_upgrade_reason = 0, uprade_room_id;

        if (Array.isArray(data)) {
            addonSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                console.log('table_name', table_name)
                // if (table_name === 'ot_charges') {
                //     let table_body = subTable.Specification.table_body;
                //     addonSchema[key].Specification.table_body = table_body.concat(data);
                // }
                // else {
                    if (subTable.name === table_name) {
                        let table_body = subTable.Specification.table_body;
                        addonSchema[key].Specification.table_body = table_body.concat(data);
                    }
                // }
            })

            additionalPackageSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.table_body = table_body.concat(data);
                }
            })

            additionalProcedureSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.table_body = table_body.concat(data);
                }
            })
            ailmentSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    ailmentSchema[key].Specification.table_body = table_body.concat(data);
                }
            })
            interimSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    interimSchema[key].Specification.table_body = table_body.concat(data);
                }
            })
            preexistingConditionsSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    preexistingConditionsSchema[key].Specification.table_body = table_body.concat(data);
                }
            })
        }
        else {
            if (data.table === 'ot_charges') {
                if (data.service_id !== '' && data.service_id !== undefined) {
                    postService(getServicePricesById, 'POST', { data: { service_id: data.service_id } }).then(res => {
                        if (res) {
                            basicSumInsuredSchema.map((feild, key) => {
                                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                    let { data } = feild;
                                    data.map((sub_feild, sub_key) => {
                                        if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                            room_id = sub_feild.value; //note
                                        }
                                        if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                            room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                        }
                                    })
                                }
                            })
                            res.data.map((feild, key) => {
                                console.log(res.data)
                                if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                    amount = feild.amount;
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.name === data.table) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["service"] = data.service_id
                                                    }
                                                    if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                        // addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                        // data.service_id
                                                    }
                                                    if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;

                                                    }
                                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                    }
                                                })
                                            })
                                        }
                                    })
                                    this.setState({ addonSchema: addonSchema });
                                    this.total_suming();
                                }
                            })
                           
                        }
                    });
                    this.otInstDisinfecAmounts(data);
                } else {
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === data.table) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                let rate, qty = null;
                                if (data.value === "") {
                                    data.value = 0;
                                }
                                row.map((sub_feild, sub_table_key) => {
                                    if (data.name === "qty") {
                                        if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                            if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                            }
                                            if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                rate = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                if (rate === '' && rate === null && rate === undefined) {
                                                    rate = 0;
                                                }
                                            }
                                            if (rate !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(rate) * parseFloat(data.value);
                                            }
                                        }
                                    }
                                    if (data.name === "rate") {
                                        if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                            if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                                if (qty === '' && qty === null && qty === undefined) {
                                                    qty = 0;
                                                }
                                            }
                                            if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                            }
                                            if (qty !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(data.value);
                                            }
                                        }
                                    }

                                })
                            })
                        }
                    })
                    this.setState({ addonSchema: addonSchema });
                    this.total_suming();
                }

            }
            else {
                if (data.element === 'input') {
                    if (data.table === 'ins_surgical_charges' || data.table === 'ins_medical_charges') {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === "percentage" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                        if(sub_feild.name==='amount'&& sub_feild.row_group === data.row && sub_feild.id === data.id){
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=data.value
                                        }
                                    })
                                })
                            }
                        })
                    }
                    else if(data.tableName === "additional_procedure" && data.name==='amount'){
                        let room_id, room_value = 0;
    
                        basicSumInsuredSchema.map((feild, key) => {
                            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                let { data } = feild;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                        room_id = sub_feild['id']; //note
                                        room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                    }
                                })
                            }
                            if (feild.name === "ins_room_upgrade_reason") {
                                room_upgrade_reason = feild.value ? feild.value : null;
                                if(room_upgrade_reason==3){
                                    basicSumInsuredSchema.map((feild, key) => {
                                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                        let { data } = feild;
                                        data.map((sub_feild, sub_key) => {
                                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                                room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                room_id = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                            }
                                          
                                        })
                                    }
                                })
                                }
                            }
                        })
                            if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                        additionalProcedureSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            if (amount === undefined) { amount = 0; }
                                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(data.value);
                                            this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                            // this.sumingProcedureAmounts();
                                            this.total_suming();
                                        }
                                    })
                                })
                            }
                        })
                    }
                    }
                    else if(data.tableName === 'ailment_capping'&& data.name==='amount'){
                        let room_id, room_value = 0;
    
                        basicSumInsuredSchema.map((feild, key) => {
                            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                let { data } = feild;
                                data.map((sub_feild, sub_key) => {
                                    if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                        room_id = sub_feild['id']; //note
                                        room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                    }
                                })
                            }
                            if (feild.name === "ins_room_upgrade_reason") {
                                room_upgrade_reason = feild.value ? feild.value : null;
                                if(room_upgrade_reason==3){
                                    basicSumInsuredSchema.map((feild, key) => {
                                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                        let { data } = feild;
                                        data.map((sub_feild, sub_key) => {
                                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                                room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                room_id = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                            }
                                          
                                        })
                                    }
                                })
                                }
                            }
                        })
                            if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                        ailmentSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            if (amount === undefined) { amount = 0; }
                                            ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(data.value);
                                            this.setState({ ailmentSchema: ailmentSchema });
                                            this.total_suming();
                                        }
                                    })
                                })
                            }
                        })
                    }
                    }
                    else if (data.table === 'ins_drug_admin_charges' && data.id === 1) {
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: data.header, sub_header_id: data.sub_header, tariff_mapped: this.state.tariff_mapped } }).then(res => {
                            if (res.status) {
                                if (res.data.length > 0) {
                                    postService('getServicePricesById', 'POST', { data: { service_id: res.data[0].id } }).then(response => {
                                        if (response.status) {
                                            if (response.data.length > 0) {
                                                let amount, room_id = null;
                                                let data_value = 0;
                                                basicSumInsuredSchema.map((feild, key) => {
                                                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                                        let { data } = feild;
                                                        data.map((sub_feild, sub_key) => {
                                                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                                                room_id = sub_feild['id']; //note
                                                            }
                                                        })
                                                    }
                                                })
                                                response.data.map((feild, key) => {
                                                    if (feild.room_id === room_id) {
                                                        amount = parseFloat(feild.amount);

                                                        addonSchema.map((subTable, key) => {
                                                            if (subTable.name === data.table) {
                                                                let table_body = subTable.Specification.table_body;
                                                                table_body.map((feild, table_key) => {
                                                                    if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
                                                                        data_value = data.value;
                                                                    }
                                                                    let row = feild.feilds;
                                                                    row.map((sub_feild, sub_table_key) => {
                                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data_value;
                                                                        }
                                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                                        }
                                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(data_value);
                                                                        }
                                                                    })
                                                                })
                                                            }
                                                        })
                                                        this.setState({ addonSchema: addonSchema });
                                                        this.total_suming();
                                                    }
                                                })
                                            }
                                            // else {
                                            //     Modal.error({
                                            //         title: 'Error message',
                                            //         content: 'No amount for the selected room',
                                            //     });
                                            // }
                                        }
                                        else {
                                            Modal.error({
                                                title: 'Error message',
                                                content: 'Something went wrong',
                                            });
                                        }
                                    })
                                }
                                else {
                                    Modal.error({
                                        title: 'Error message',
                                        content: 'No service available',
                                    });
                                }
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'Something went wrong ',
                                });
                            }
                        })
                    }
                    else if (data.table === 'interim') {
                        interimSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (data.name === sub_feild['name'] && data.id === sub_feild['id']) {
                                            interimSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                    })
                                })
                            }
                        })
                    }
                    else if (data.table === 'pre_ex_conditions') {
                        let sum_insured_for_four_years_back = 0
                        preexistingConditionsSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (data.name === sub_feild['name'] && data.id === sub_feild['id']) {
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                        if (data.name === 'sum_insured_for_four_years_back' && data.id === sub_feild['id']) {
                                            sum_insured_for_four_years_back = data.value
                                        }
                                    })
                                })
                            }
                        })

                    }
                    else {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    let rate, qty = null;
                                    if (data.value === "") {
                                        data.value = 0;
                                    }
                                    row.map((sub_feild, sub_table_key) => {
                                        if (data.name === "qty") {
                                            if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                                if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                                }
                                                if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    rate = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                    if (rate === '' && rate === null && rate === undefined) {
                                                        rate = 0;
                                                    }
                                                }
                                                if (rate !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(rate) * parseFloat(data.value);
                                                }
                                            }
                                        }
                                        if (data.name === "rate") {
                                            if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                                if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                                    if (qty === '' && qty === null && qty === undefined) {
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                                }
                                                if (qty !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(data.value);
                                                }
                                            }
                                        }

                                    })
                                })
                            }
                        })
                        this.total_suming();
                    }
                }
                else {
                    let qty = 1;
                    if (data.table === 'pre_ex_conditions') {
                        console.log('enter', preexistingConditionsSchema)
                        preexistingConditionsSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                console.log('enter', data.table)
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        console.log('loop', data.name === sub_feild['name'] && data.id === sub_feild['id'])
                                        if (data.name === sub_feild['name'] && data.id === sub_feild['id']) {
                                            console.log('innner', data.value)
                                            preexistingConditionsSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                    })
                                })
                            }
                        })
                    }
                    else if (data.name === 'ins_ail_surgery_procedure_name') {
                            const { getInsurancePackagePricesByProcedureName } = networkList;
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        postService(getInsurancePackagePricesByProcedureName, 'POST', { "data": { "procedure_name": data.text, "unit_id": user_unit_id,tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,mode_of_payment:2 } }).then(res => {
                                if (res['status']) {
                                    basicSumInsuredSchema.map((feild, key) => {
                                        if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                            let { data } = feild;
                                            data.map((sub_feild, sub_key) => {
                                                if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                                    console.log('ins_room_eligible_ward_amount:', sub_feild)
                                                    room_id = sub_feild.value; //note
                                                    
                                                }
                                                if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                                    room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                }
                                                
                                            })
                                        }
                                        if (feild.name === "ins_room_upgrade_reason") {
                                            room_upgrade_reason = feild.value ? feild.value : null;
                                            if(room_upgrade_reason==3){
                                                basicSumInsuredSchema.map((feild, key) => {
                                                if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                                    let { data } = feild;
                                                    data.map((sub_feild, sub_key) => {
                                                        if (sub_feild.name === 'ins_upgrade_room_names') {
                                                            room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                            room_id = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                        }
                                                      
                                                    })
                                                }
                                            })
                                            }
                                        }
                                    })
    
                                    if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                                        if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                            let ailment_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                           let amount = ailment_amount[0].package_charges;
                                            ailmentSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            console.log('enter1:', sub_feild.name === "amount", sub_feild.row_group === data.row, sub_feild.id === data.id)
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                if (amount === undefined) { amount = 0; }
                                                                console.log('inside')
                                                                ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                                                                ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true
                                                                this.setState({ ailmentSchema: ailmentSchema });
                                                                this.total_suming();
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        }else{
                                            ailmentSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            console.log('enter1:', sub_feild.name === "amount", sub_feild.row_group === data.row, sub_feild.id === data.id)
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                                ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=false
                                                                this.setState({ ailmentSchema: ailmentSchema });
                                                                this.total_suming();
                                                            }
                                                        })
                                                    })
                                                }
                                            })   
                                        }
    
                                    }
                                    else {
                                        Modal.error({
                                            title: 'Error message',
                                            content: 'No amount for the selected room',
                                        });
                                    }
                                }else{
                                    ailmentSchema.map((subTable, key) => {
                                        if (subTable.name === data.table) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    console.log('enter1:', sub_feild.name === "amount", sub_feild.row_group === data.row, sub_feild.id === data.id)
                                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                        ailmentSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=false
                                                        this.setState({ ailmentSchema: ailmentSchema });
                                                        this.total_suming();
                                                    }
                                                })
                                            })
                                        }
                                    })  
                                } 
                            });
                            if (ailmenteerrors.length > 0) {
                                ailmenteerrors.map((index) => {
                                    ailmentSchema.map((subTable, key) => {
                                        if (subTable.name === data.table) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild['name'] === "ins_ail_surgery_procedure_name" && data.id === index['id']) {
                                                        document.getElementById("errormalment" + index['id']).style.display = "none";
                                                    }
                                                })
                                            })
                                        }
                                    })



                                })
                            }
                    }
                    else if (data.name === 'ins_additional_package_name') {
                        const { getInsurancePackagePricesById } = networkList;
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        let pack_id = data.value;
                        let pack_name = data.text;

                        postService(getInsurancePackagePricesById, 'POST', { "data": { "package_id": data.value, "unit_id": user_unit_id } }).then(res => {
                            if (res['status']) {
                                basicSumInsuredSchema.map((feild, key) => {
                                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                        let { data } = feild;
                                        data.map((sub_feild, sub_key) => {
                                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                                console.log('ins_room_eligible_ward_amount:', sub_feild)
                                                room_id = sub_feild.value; //note
                                            }
                                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                                room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                            }
                                        })
                                    }
                                    if (feild.name === "ins_room_upgrade_reason") {
                                        room_upgrade_reason = feild.value ? feild.value : null;
                                        if(room_upgrade_reason==3){
                                            basicSumInsuredSchema.map((feild, key) => {
                                            if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                                let { data } = feild;
                                                data.map((sub_feild, sub_key) => {
                                                    if (sub_feild.name === 'ins_upgrade_room_names') {
                                                        room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                        room_id = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                    }
                                                  
                                                })
                                            }
                                        })
                                        }
                                    }
                                })

                                if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                                        if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                            let Package_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                            amount = Package_amount[0].package_charges;
                                            let package_dynamic_percent = 0
                                            additionalPackageSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        // if (table_key == 0) {
                                                        //     package_dynamic_percent = additional_package_percent1;
                                                        // } else {
                                                        //     package_dynamic_percent = additional_package_percent2;
                                                        // }
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if (sub_feild.name === "ins_additional_package_name" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                            }
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                if (amount === undefined ) { amount = 0; } else {
                                                                    // additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseInt(package_dynamic_percent) * parseFloat(amount) / 100;
                                                                    // console.log(package_dynamic_percent, amount, parseInt(package_dynamic_percent) * parseFloat(amount) / 100)
                                                                    let obj = {
                                                                        'id': table_key + 1,
                                                                        'package_name': data.text,
                                                                        'package_id': data.value,
                                                                        'package_amount': amount
                                                                    }
                                                                    allPackage.push(obj); 
                                                                }
                                                               
                                                                this.setState({ additionalPackageSchema: additionalPackageSchema, allPackage });
                                                                this.getExcludesIncludes(parseInt(pack_id), pack_name, 1);
                                                                // this.getExcludesIncludes(pack_id, pack_name);
                                                                this.highestPackage();
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        }

                                }
                                else {
                                    Modal.error({
                                        title: 'Error message',
                                        content: 'No amount for the selected room',
                                    });
                                }
                            } 
                        });

                    }
                    else if (data.name === 'ins_add_procedure_name') {
                        const { getInsurancePackagePricesByProcedureName } = networkList;
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        let pack_id = data.value;
                        let pack_name = data.text;

                       
                            postService(getInsurancePackagePricesByProcedureName, 'POST', { "data": { "procedure_name": data.text, "unit_id": user_unit_id,tariff_mapped:this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,mode_of_payment:2 } }).then(res => {
                                if (res['status']) {
                                    basicSumInsuredSchema.map((feild, key) => {
                                        if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                            let { data } = feild;
                                            data.map((sub_feild, sub_key) => {
                                                if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                                    console.log('ins_room_eligible_ward_amount:', sub_feild)
                                                    room_id = sub_feild.value; //note
                                                }
                                                if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                                    room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                }
                                            })
                                        }
                                        if (feild.name === "ins_room_upgrade_reason") {
                                            room_upgrade_reason = feild.value ? feild.value : null;
                                            if(room_upgrade_reason==3){
                                                basicSumInsuredSchema.map((feild, key) => {
                                                if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                                    let { data } = feild;
                                                    data.map((sub_feild, sub_key) => {
                                                        if (sub_feild.name === 'ins_upgrade_room_names') {
                                                            room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                            room_id = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                                        }
                                                      
                                                    })
                                                }
                                            })
                                            }
                                        }
                                    })
                                    if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                                        if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                           let procedure_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                           amount = procedure_amount[0].package_charges;
                                           additionalProcedureSchema.map((subTable, key) => {
                                               if (subTable.name === data.table) {
                                                   let table_body = subTable.Specification.table_body;
                                                   table_body.map((feild, table_key) => {
                                                       let row = feild.feilds;
                                                       row.map((sub_feild, sub_table_key) => {
                                                           console.log('enter1:', sub_feild.name === "amount", sub_feild.row_group === data.row, sub_feild.id === data.id)
                                                           if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id ) {
                                                               if (amount === undefined) { amount = 0; }
                                                               console.log('inside')
                                                               additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                                                               additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true
                                                               this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                               this.total_suming();
                                                           }
                                                       })
                                                   })
                                               }
                                           })                                                                            
                                        }else{
                                            additionalProcedureSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            console.log('enter1:', sub_feild.name === "amount", sub_feild.row_group === data.row, sub_feild.id === data.id)
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id ) {
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true
                                                                this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                                this.total_suming();
                                                            }
                                                        })
                                                    })
                                                }
                                            }) 
                                        }
                                    }
                                    else {
                                        Modal.error({
                                            title: 'Error message',
                                            content: 'No amount for the selected room',
                                        });
                                    }
                                }else{
                                    additionalProcedureSchema.map((subTable, key) => {
                                        if (subTable.name === data.table) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    console.log('enter1:', sub_feild.name === "amount", sub_feild.row_group === data.row, sub_feild.id === data.id)
                                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        if (amount === undefined) { amount = 0; }
                                                        additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                        additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                        this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                        this.total_suming();
                                                    }
                                                })
                                            })
                                        }
                                    })  
                                } 
                            });
                           
                       
                    }
                    else if (data.name === 'ins_room_eligible_ward' && data.type && data.type === 'group') {

                        // let amount, room_id, room_value = 0;
                        // let { data1 } = data;
                        // data1.map((sub_feild, sub_key) => {
                        //     if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                        //         room_id = sub_feild['value']; //note
                        //         room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                        //     }
                        // })

                        // if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                        //     postService(getServicePricesById, 'POST', { data: { service_id: data.value } }).then(res => {
                        //         if (res) {
                        //             res.data.map((feild, key) => {
                        //                 if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                        //                     amount = feild.amount;

                        //                     additionalProcedureSchema.map((subTable, key) => {
                        //                         // if (subTable.name === data.table) {
                        //                             let table_body = subTable.Specification.table_body;
                        //                             table_body.map((feild, table_key) => {
                        //                                 let row = feild.feilds;
                        //                                 row.map((sub_feild, sub_table_key) => {
                        //                                     if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                        //                                         if (amount === undefined) { amount = 0; }
                        //                                         console.log('inside')
                        //                                         additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                        //                                         this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                        //                                         this.sumingProcedureAmounts();
                        //                                         this.total_suming();
                        //                                     }
                        //                                 })
                        //                             })
                        //                         // }
                        //                     })
                        //                 }
                        //             })
                        //         }
                        //         else {
                        //             Modal.error({
                        //                 title: 'Error message',
                        //                 content: 'No amount for the selected room',
                        //             });
                        //         }
                        //     });
                        // }
                        // else {
                        //     Modal.error({
                        //         title: 'Error message',
                        //         content: 'Please select room',
                        //     });
                        // }
                    }
                    else {
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id } }).then(res => {
                            console.log('got it res', res)
                            if (res.status) {
                                basicSumInsuredSchema.map((feild, key) => {
                                    // if (feild['name'] === 'room_opted') {
                                    //     room_id = feild['room_id'];
                                    // }
                                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                                        let { data } = feild;
                                        data.map((sub_feild, sub_key) => {
                                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                                console.log('ins_room_eligible_ward_amount:', sub_feild)
                                                room_id = sub_feild.value; //note
                                            }
                                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                                room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                                            }
                                        })
                                    }

                                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                                        let { data } = feild;
                                        data.map((sub_feild, sub_key) => {
                                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                                uprade_room_id = sub_feild.value ? sub_feild.value : null;
                                            }

                                        })
                                    }
                                    if (feild.name === "ins_room_upgrade_reason") {
                                        room_upgrade_reason = feild.value ? feild.value : null;
                                        if (room_upgrade_reason == 3) {
                                            room_id = uprade_room_id
                                        }
                                    }
                                })
                                res.data.map((feild, key) => {
                                    if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        amount = feild.amount;

                                        addonSchema.map((subTable, key) => {
                                            if (subTable.name === data.table) {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;

                                                            }
                                                            else {
                                                                qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                                            }
                                                        }
                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                        this.setState({ addonSchema: addonSchema });
                                        this.total_suming();
                                        this.insurance_total();
                                    }
                                })
                            }
                        });
                    }
                }
            }
        }


        this.setState({ addonSchema: addonSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, basicSumInsuredSchema: basicSumInsuredSchema, interimSchema: interimSchema, preexistingConditionsSchema: preexistingConditionsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema });
        if(data && data.name && data.name !== 'ins_additional_package_name'){
            this.total_suming();
        }
        this.insurance_total();
    }
    catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }
    otInstDisinfecAmounts(data) {
        try {
        let { medicationDetailsSchema, addonSchema, basicSumInsuredSchema } = this.state;
        let procedure_amount = 0;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let service_id
        let room_id,room_upgrade_reason, uprade_room_id,room_value = 0;
        let ot_inst_disinfec= 0;
        addonSchema.map((subTable, key) => {
            if (subTable.name === 'ot_charges') {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    if (feild.key_word === 'highend' || feild.key_word==='add_more' ) {
                        row.map((sub_feild, sub_table_key) => {
                            if ( sub_feild.name!=='ot_hours'&& sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                            if (sub_feild.name === "qty") {
                                ot_inst_disinfec=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["charges"];
                            }
                        }
                           
                        })
                    }

                })
            }
        })
        addonSchema.map((subTable, key) => {
            if (subTable.name === 'ot_charges') {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    let rates=0;
                    if (feild.key_word === 'ot_inst_disinfec') {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "rate") {
                                rates=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = rates!==null?Math.abs(rates-(ot_inst_disinfec?ot_inst_disinfec:0)):ot_inst_disinfec?ot_inst_disinfec:0;
                            }
                            if (sub_feild.name === "amount") {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = rates!==null?Math.abs(rates-(ot_inst_disinfec?ot_inst_disinfec:0)):ot_inst_disinfec?ot_inst_disinfec:0;
                            }
                        })
                    }
                  

                })
            }
        })
        this.setState({ addonSchema: addonSchema });
        this.total_suming();
        postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 9, sub_header_id: 18, tariff_mapped: this.state.tariff_mapped  } }).then(res => {
            if (res.status && res.data.length>0) {
               if(data.text=='OT - 1 HOUR' || data.text=='OT - 1/2 HOUR'){
               service_id=res.data[0].id;
            }else{
                 service_id=res.data[2].id;
            }
            basicSumInsuredSchema.map((feild, key) => {
                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_room_eligible_ward_names') {
                            console.log('ins_room_eligible_ward_amount:', sub_feild)
                            room_id = sub_feild.value; //note
                        }
                        if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                            room_value = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                        }
                    })
                }
    
                if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_upgrade_room_names') {
                            uprade_room_id = sub_feild.value ? sub_feild.value : null;
                        }
    
                    })
                }
                if (feild.name === "ins_room_upgrade_reason") {
                    room_upgrade_reason = feild.value ? feild.value : null;
                    if (room_upgrade_reason == 3) {
                        room_id = uprade_room_id
                    }
                }
            })
               
            postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                if (response.status) {
                    if (response.data.length > 0) {
                        let amount,rate;
                        let data_value = 0;
                        response.data.map((feild, key) => {
                            if (feild.room_id == room_id) {
                                amount = parseFloat(feild.amount);
                                addonSchema.map((subTable, key) => {
                                    if (subTable.name === 'ot_charges') {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            let row = feild.feilds;
                                            if (feild.key_word === 'ot_inst_disinfec') {
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild.name === "qty") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                    }
                                                    if (sub_feild.name === "rate") {
                                                        rate=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                        console.log('amount_test',amount,'rate',rate)
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.abs(parseFloat(amount)+(rate?parseFloat(rate):0));
                                                    }
                                                    if (sub_feild.name === "amount") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.abs(parseFloat(amount)+(rate?parseFloat(rate):0))
                                                    }
                                                })
                                            }
                                            if (feild.key_word === 'highend' || feild.key_word === 'add_more') {
                                                row.map((sub_feild, sub_table_key) => {
                                                    if ( sub_feild.name!=='ot_hours'&& sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    if (sub_feild.name === "qty") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["charges"]=amount;
                                                    }
                                                }
                                                   
                                                })
                                            }
                                        })
                                    }
                                })
                                this.setState({ addonSchema: addonSchema });
                                this.total_suming();
                                // this.sumingProcedureAmounts();
                            }
                        })
                    }
                    else {
                        Modal.error({
                            title: 'Error message',
                            content: 'No amount for the selected room',
                        });
                    }
                }
                else {
                    Modal.error({
                        title: 'Error message',
                        content: 'Something went wrong',
                    });
                }
            })
        }
        else {
            Modal.error({
                title: 'Error message',
                content: 'No service available',
            });
        }

        })
        

        this.setState({ addonSchema: addonSchema });
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }
    highestPackage(data) {
        try {
        let { additionalPackageSchema, allPackage, additional_package_percent1, additional_package_percent2 ,basicSumInsuredSchema,inital_package_amount} = this.state;
        let hightpricesort = allPackage;
        let { counselling_details } = this.props;
        let package_amt=0,room_upgrade_reason=0,room_upgrade_package_amount=0;
        if (Array.isArray(data)) {
            
            hightpricesort  =hightpricesort&& hightpricesort.filter(item => item.id !== data[0]['id']);
            hightpricesort = hightpricesort&& hightpricesort.sort((a, b) => b.package_amount - a.package_amount); 
        }else{
            hightpricesort = hightpricesort&&hightpricesort.sort((a, b) => b.package_amount - a.package_amount);
            hightpricesort&&hightpricesort.map((item,key)=>{
                item.id=key+1;
            }) 
        }
        let amount = 0;
        let package_dynamic_percent;
       
        if(counselling_details){
            package_amt=counselling_details['main_package_actual_price']?counselling_details['main_package_actual_price']:0;
            basicSumInsuredSchema.map((feild, key) => {
                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                package_amt=  basicSumInsuredSchema[key]['data'][sub_key]['package_charges']; 
                            }
                        })
                    }
                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                           
                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                room_upgrade_package_amount = basicSumInsuredSchema[key]['data'][sub_key]['package_charges'];
                            }
                            
                        })
                    }
                    if (feild.name === "ins_room_upgrade_reason") {
                        room_upgrade_reason = feild.value ? feild.value : null;
                        this.setState({ room_upgrade_reasons: room_upgrade_reason })
                        if (room_upgrade_reason == 3) {
                            package_amt=room_upgrade_package_amount;
                        }
        
                    }
                })
                // additional_package_percent1, additional_package_percent2
        }else{
            basicSumInsuredSchema.map((feild, key) => {
                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                package_amt=  basicSumInsuredSchema[key]['data'][sub_key]['package_charges']; 
                            }
                        })
                    }
                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                room_upgrade_package_amount = basicSumInsuredSchema[key]['data'][sub_key]['package_charges'];
                            }
                            
                        })
                    }
                    if (feild.name === "ins_room_upgrade_reason") {
                        room_upgrade_reason = feild.value ? feild.value : null;
                        this.setState({ room_upgrade_reasons: room_upgrade_reason })
                        if (room_upgrade_reason == 3) {
                            package_amt=room_upgrade_package_amount;
                        }
        
                    }
                })
              
        }
       
        if(hightpricesort.length===0){
            let inital_amount = 0;
            inital_amount = parseInt(100) * parseFloat(package_amt) / 100;
            hightpricesort.length=0
            basicSumInsuredSchema.map((feild, key) => {
                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_room_eligible_ward_names') {
                            console.log('percentage',100)
                            basicSumInsuredSchema[key]['data'][sub_key]['percentage'] =100;
                        }
                        
                    })
                }
            })
            this.setState((state) => ({ inital_package_amount: Math.round(Number(inital_amount)),allPackage:hightpricesort,basicSumInsuredSchema}), () => {;
            this.total_suming();
            });
        }
        
        if (hightpricesort&&parseInt(hightpricesort[0].package_amount) <= parseInt(package_amt)) {
            let inital_amount = 0;
            inital_amount = parseInt(100) * parseFloat(package_amt) / 100;
            additionalPackageSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    hightpricesort.map((item, package_key) => {
                        if (table_key == 0) {
                            package_dynamic_percent = additional_package_percent1;
                        } else {
                            package_dynamic_percent = additional_package_percent2;
                        }
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "ins_additional_package_name" && table_key === package_key) {
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = item.package_id;
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = item.package_name;
                            }
                            if (sub_feild.name === "actualprice" && table_key === package_key) {
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = item.package_amount;
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = item.package_amount;
                            }
                            if (sub_feild.name === "percentage" && table_key === package_key) {
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.round(Number(package_dynamic_percent));
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = Math.round(Number(package_dynamic_percent));
                            }
                            if (sub_feild.name === "amount" && table_key === package_key) {
                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.round(Number(package_dynamic_percent)) * Math.round(Number(item.package_amount)) / 100;
                                console.log(package_dynamic_percent, amount, parseInt(package_dynamic_percent) * parseFloat(amount) / 100)
                                this.setState({ additionalPackageSchema: additionalPackageSchema, allPackage });

                            }
                        })
                    })
                })

            })
            basicSumInsuredSchema.map((feild, key) => {
                if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                    let { data } = feild;
                    data.map((sub_feild, sub_key) => {
                        if (sub_feild.name === 'ins_room_eligible_ward_names') {
                            console.log('percentage',100)
                            basicSumInsuredSchema[key]['data'][sub_key]['percentage'] =100;
                            // basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = inital_amount;
                        }
                        
                    })
                }
            })
            this.setState((state)=>({ inital_package_amount: Math.round(Number(inital_amount)),allPackage:hightpricesort,basicSumInsuredSchema}),()=>{
            this.total_suming();
            });
        } else {
            if (hightpricesort&&hightpricesort.length===2&&parseInt(hightpricesort[1].package_amount) <= parseInt(package_amt)) {
                let inital_amount = 0;
                inital_amount = parseInt(additional_package_percent1) * parseFloat(package_amt) / 100;
                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        hightpricesort.map((item, package_key) => {
                            if (table_key == 0) {
                                package_dynamic_percent = 100;
                            } else {
                                package_dynamic_percent = additional_package_percent2;
                            }
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === "ins_additional_package_name" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = item.package_id;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = item.package_name;
                                }
                                if (sub_feild.name === "actualprice" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = item.package_amount;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = item.package_amount;
                                }
                                if (sub_feild.name === "percentage" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.round(Number(package_dynamic_percent));
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = Math.round(Number(package_dynamic_percent));
                                }
                                if (sub_feild.name === "amount" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.round(Number(package_dynamic_percent)) * Math.round(Number(item.package_amount)) / 100;
                                    console.log(package_dynamic_percent, amount, parseInt(package_dynamic_percent) * parseFloat(amount) / 100)
                                    this.setState({ additionalPackageSchema: additionalPackageSchema, allPackage });

                                }
                            })
                        })
                    })

                })
                basicSumInsuredSchema.map((feild, key) => {
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['percentage'] =additional_package_percent1;
                            }
                            
                        })
                    }
                })
                this.setState((state)=>({ inital_package_amount: Math.round(Number(inital_amount)),allPackage:hightpricesort,basicSumInsuredSchema }),()=>{
                    this.total_suming();
                });
             
            }
            else {
                let inital_amount = 0;
                if(hightpricesort.length===1){
                    inital_amount =parseInt(additional_package_percent1)* parseFloat(package_amt) / 100;
                }else{
                    inital_amount = parseInt(additional_package_percent2) * parseFloat(package_amt) / 100;
                }
               
                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        hightpricesort.map((item, package_key) => {
                            if (table_key == 0) {
                                package_dynamic_percent = 100;
                            } else if (table_key == 1) {
                                package_dynamic_percent = additional_package_percent1;
                            } else {
                                package_dynamic_percent = additional_package_percent2;
                            }
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === "ins_additional_package_name" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = item.package_id;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = item.package_name;
                                }
                                if (sub_feild.name === "actualprice" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = item.package_amount;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = item.package_amount;
                                }
                                if (sub_feild.name === "percentage" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.round(Number(package_dynamic_percent));
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = Math.round(Number(package_dynamic_percent));
                                }
                                if (sub_feild.name === "amount" && table_key === package_key) {
                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.round(Number(package_dynamic_percent)) * Math.round(Number(item.package_amount)) / 100;
                                    console.log(package_dynamic_percent, amount, parseInt(package_dynamic_percent) * parseFloat(amount) / 100)
                                    this.setState({ additionalPackageSchema: additionalPackageSchema, allPackage:hightpricesort });

                                }
                                
                            })
                        })
                    })

                })
                basicSumInsuredSchema.map((feild, key) => {
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_names') {
                                basicSumInsuredSchema[key]['data'][sub_key]['percentage'] =additional_package_percent2;
                            }
                            
                        })
                    }
                })
                this.setState((state)=>({ inital_package_amount: Math.round(Number(inital_amount)),allPackage:hightpricesort,basicSumInsuredSchema }),()=>{
                    this.total_suming();
                });
                
            }
        }
    }catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }
    
    deleteRow(data) {
        try {
        let { addonSchema, additionalPackageSchema, additionalProcedureSchema, ailmentSchema, packages_IN_EX, inc_excludes_packages_ids, includesSchema, exculude_options, inc_excludes_pack_id,slugforexcludedropdown } = this.state;
        let {counselling_details}=this.props
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let table_name = data[0].feilds[0].table;
        let last_id = data[0].feilds[0].id;
        let newData = [];
        let ot_inst_disinfec=0;
        if (Array.isArray(data)) {
            addonSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            addonSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })
            if(table_name==='ot_charges'){
                ot_inst_disinfec= data[0].feilds[1].charges;
                addonSchema.map((subTable, key) => {
                    if (subTable.name === 'ot_charges') {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            let rates=0;
                            if (feild.key_word === 'ot_inst_disinfec') {
                                row.map((sub_feild, sub_table_key) => {
                                   
                                    if (sub_feild.name === "rate") {
                                        rates=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = rates-ot_inst_disinfec
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = rates-ot_inst_disinfec
                                    }
                                })
                            }
                        
    
                        })
                    }
                })
                this.total_suming();
            }

            additionalPackageSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            let { feilds } = feild
                            feilds.map((input_data) => {
                                console.log('inc_excludes_packages_ids', input_data, excludesTableStore.getState(), optionsStore.getState());
                                if (input_data['name'] === 'ins_additional_package_name') {
                                    if (packages_IN_EX) {
                                        packages_IN_EX.map((item, key) => {
                                            if (item['pack_id'] === input_data['value']) {
                                                const index = inc_excludes_packages_ids.indexOf(item['pack_id']);
                                                if (index > -1) {
                                                    inc_excludes_packages_ids.splice(index, 1);
                                                    packages_IN_EX.splice(index, 1);

                                                    includesSchema.map((subTable, key) => {
                                                        subTable['title'] = '';
                                                        subTable['name'] = '';
                                                        if (includesSchema[key].id === 1) {
                                                            if (includesSchema[key].Specification.table_body.length > 0) {
                                                                includesSchema[key].Specification.table_body.length = 0;
                                                            }
                                                        } else {
                                                            includesSchema.splice(1, includesSchema.length)
                                                        }
                                                    })
                                                    this.setState({ includesSchema, exludesconcatdata: [] });
                                                    optionsStore.dispatch({ type: 'options_data', 'data': [] });



                                                }

                                            }
                                        });
                                    }
                                    if (packages_IN_EX) {
                                        packages_IN_EX.map((ele, key) => {
                                            Promise.all([
                                                postService('getMasterIncludesDropDown', 'POST', { data: { package_id: ele.pack_id, package_name: ele.pack_name, unit_id: user_unit_id, payment_type: 2,tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res),
                                                postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [ele.pack_id], package_name: [ele.pack_name], unit_id: user_unit_id, payment_type: 2, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,status:slugforexcludedropdown === 'view-finanical-counselling'?0:1 } }).then(res => res)
                                            ]).then(([includesResponse, excludesResponse]) => {
                                                if (includesResponse && includesResponse.status) {
                                                    if (includesResponse.data.length > 0) {
                                                        let includes_data = includesResponse.data;
                                                        includesSchema.map((subTable, key) => {
                                                            includes_data.map((ex_data, ex_key) => {
                                                                let last_id = 1;
                                                                if (includesSchema[key].Specification.table_body.length > 0) {
                                                                    let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                                    last_id = last_element['id'];
                                                                }

                                                                let obj = {
                                                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                                    id: last_id + 1,
                                                                    input_feild: [],
                                                                    text: "Highend",
                                                                    'key_word': 'add_more',
                                                                    type: "text"
                                                                }
                                                                obj['feilds'].map((feild, feild_key) => {
                                                                    obj['feilds'][feild_key]['id'] = last_id + 1;

                                                                    if (feild.name === 'item_service') {
                                                                        obj['feilds'][feild_key]['value'] = ex_data.service;
                                                                        obj['feilds'][feild_key]['title'] = ex_data.service;
                                                                    }
                                                                    if (feild.name === 'item_package') {
                                                                        obj['feilds'][feild_key]['value'] = ele.pack_name;
                                                                        obj['feilds'][feild_key]['title'] = ele.pack_name;
                                                                    }
                                                                })
                                                                subTable['Specification']['table_body'].push(obj);
                                                            })
                                                        })
                                                        includesResponse.data.map((item, key) => {
                                                            newData.push({
                                                                "package_id": parseInt(ele.pack_id),
                                                                'service_id': item['id'],
                                                                'service_nam': item['service'],
                                                                "qty": 0,
                                                                "rate": 5,
                                                                "amount": 5,

                                                            })

                                                        });
                                                    }
                                                }
                                                if (excludesResponse && excludesResponse.status) {
                                                    if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                                        let excludes_data = excludesResponse.data;
                                                        console.log('excludes_data', excludes_data);
                                                        excludes_data.map((ex_data, key) => {
                                                            excludes_data[key]['package_id'] = ele.pack_id;
                                                            excludes_data[key]['package_name'] = ele.pack_name;
                                                            excludes_data[key]['unit_id'] = user_unit_id;
                                                            excludes_data[key]['payment_type'] = 1;
                                                            excludes_data[key]['tariff_mapped'] =  this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped;
                                                            excludes_data[key]['service_name'] = ex_data.service + ' - ' + ele.pack_name;
                                                        })

                                                        let new_exculude_options = exculude_options.concat(excludes_data);
                                                        const exludesconcat = this.state.exludesconcatdata;
                                                        let exludesconcatdata = exludesconcat.concat(excludes_data);
                                                        console.log(exludesconcatdata);

                                                        this.setState({ exludesconcatdata })
                                                        optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                                        // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });



                                                    }
                                                }
                                            })
                                            this.setState({
                                                inc_excludes_pack_id: inc_excludes_pack_id,
                                                includes_data: newData,
                                                includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids, exculude_options, packages_IN_EX
                                            });
                                            // console.log('exculude_options',exludesconcatdata);
                                            this.total_suming();

                                        });
                                    }

                                    this.updateExcludesTable(input_data['value'], data[0].id);
                                    let new_option_array = []
                                    let options_data = optionsStore.getState();
                                    options_data.map((data) => {
                                        if (data['package_id'] !== input_data['value']) {
                                            new_option_array.push(data)
                                        }
                                    })
                                    optionsStore.dispatch({ type: 'options_data', 'data': new_option_array });
                                }
                            })

                            console.log('inc_excludes_packages_ids', feild, last_id);
                            additionalPackageSchema[key].Specification.table_body.splice(table_key, 1);
                            this.total_suming();
                        }
                    })
                    this.highestPackage(data)
                }
            })
           
            


            // additionalPackageSchema.map((subTable, key) => {
            //     if (subTable.name === table_name) {
            //         let table_body = subTable.Specification.table_body;
            //         table_body.map((feild, table_key) => {
            //             if (feild.id === last_id) {
            //                 additionalPackageSchema[key].Specification.table_body.splice(table_key, 1);
            //             }
            //         })
            //     }
            // })
            additionalProcedureSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            additionalProcedureSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })

            ailmentSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            ailmentSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })
        }
        this.setState({ addonSchema: addonSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, ailmentSchema: ailmentSchema }, () => {
            this.total_suming();
            this.highestPackage(data)
        })
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }

    updateExcludesTable(last_id, id) {
        try {
        let { includearrya, inc_excludes_pack_id, includesSchema,slugforexcludedropdown } = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let {counselling_details}=this.props
        let newData = [];
        let dopulicatearray = [];
        if (includearrya) {
            const index = includearrya.map(item => item.id).indexOf(id + 1);
            if (index > -1) {
                includearrya.splice(index, 1);
                includesSchema.map((subTable, key) => {
                    subTable['title'] = '';
                    subTable['name'] = '';
                    if (includesSchema[key].id === 1) {
                        if (includesSchema[key].Specification.table_body.length > 0) {
                            includesSchema[key].Specification.table_body.length = 0;
                        }
                    } else {
                        includesSchema.splice(1, includesSchema.length)
                    }
                })
                this.setState({ includesSchema });
            }
        }
        if (includearrya.length > 0) {
            includearrya.map((data, key) => {
                Promise.all([
                    postService('getMasterIncludesDropDown', 'POST', { data: { package_id: data.package_id, package_name: data.name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res),
                    postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [data.package_id], package_name: [data.name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped,status:slugforexcludedropdown === 'view-finanical-counselling'?0:1 } }).then(res => res)
                ]).then(([includesResponse, excludesResponse]) => {
                    if (includesResponse && includesResponse.status) {
                        if (includesResponse.data.length > 0) {
                            let includes_data = includesResponse.data;
                            dopulicatearray = JSON.parse(JSON.stringify(includesSchema));
                            dopulicatearray.map((subTable, key) => {
                                if (dopulicatearray[key].id === 1) {
                                    if (dopulicatearray[key].Specification.table_body.length > 0) {
                                        dopulicatearray[key].Specification.table_body.length = 0;
                                    }
                                } else {
                                    dopulicatearray.splice(1, dopulicatearray.length)
                                }
                            })
                            dopulicatearray.map((subTable, key) => {
                                subTable['id'] = key + 2;
                                subTable['header'] = data.package_id;
                                subTable['title'] = data.name;
                                subTable['name'] = data.name;
                                includes_data.map((ex_data, ex_key) => {
                                    let last_id = 1;
                                    if (dopulicatearray[key].Specification.table_body.length > 0) {
                                        let last_element = dopulicatearray[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                        last_id = last_element ? last_element['id'] : 0;
                                    }
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                        id: last_id + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    obj['feilds'].map((feild, feild_key) => {
                                        obj['feilds'][feild_key]['id'] = last_id + 1;

                                        if (feild.name === 'item_service') {
                                            obj['feilds'][feild_key]['value'] = ex_data.id;
                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                        }
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                })
                                includesSchema.push(subTable);
                                console.log(includesSchema)
                            })
                        }

                        includesResponse.data.map((item, key) => {
                            newData.push({
                                "package_id": parseInt(data.package_id),
                                'service_id': item['id'],
                                'service_nam': item['service'],
                                "qty": 0,
                                "rate": 5,
                                "amount": 5,

                            })

                        });
                    }


                    if (excludesResponse && excludesResponse.status) {
                        let table_data = excludesTableStore.getState();
                        table_data.map((body, key) => {
                            body['feilds'].map((feild, feild_key) => {
                                if (feild.name === 'excludes_service_id') {
                                    let { selected_option } = feild;
                                    if (selected_option && selected_option['package_id']) {
                                        table_data.splice(0, table_data.length);
                                        excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                                    }
                                }

                            })

                        })
                        if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                            let excludes_data = excludesResponse.data;
                            console.log('excludes_data', excludes_data);
                            excludes_data.map((ex_data, key) => {
                                excludes_data[key]['package_id'] = data.package_id;
                                excludes_data[key]['unit_id'] = user_unit_id;
                                excludes_data[key]['payment_type'] = 1;
                                excludes_data[key]['tariff_mapped'] =  this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped;
                            })
                            let { exculude_options } = this.state;
                            let new_exculude_options = exculude_options.concat(excludes_data);
                            optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });

                        }
                    }
                    // this.total_suming();
                    this.props.excludes(excludesSchema, includesSchema)

                })
            })
            console.log(includesSchema)
            this.setState({
                inc_excludes_pack_id: inc_excludes_pack_id, includes_data: newData,
                includesSchema: includesSchema
            });
        }


        let table_data = excludesTableStore.getState();
        // let table_data=[];
        table_data.map((body, key) => {
            // body['feilds'].map((feild, feild_key) => {
            if (body['feilds'][0].name === 'excludes_service_id') {
                let { selected_option } = body['feilds'][0];
                if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                    table_data.splice(key, 1);
                    excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                }
            }

            // })

        })
        table_data.map((body, key) => {
            // body['feilds'].map((feild, feild_key) => {
            if (body['feilds'][0].name === 'excludes_service_id') {
                let { selected_option } = body['feilds'][0];
                if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                    table_data.splice(key, 1);
                    excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                }
            }

            // })

        })

        console.log('inc_excludes_packages_ids', excludesTableStore.getState())

        // excludesTableStore,excludesUpdateTableStore
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }
    total_suming() {
        // // calculate total estimation
        try {
            let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        let { counselling_details } = this.props;
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
            if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE']) ){
                console.log('ttest');
             }else{
                 slug = 'finanical-counselling'; 
             }
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }
        let { addonSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, InsuranceDetailsSchema, basicSumInsuredSchema, view_details, ailmentSchema, nmePopupSchema, inital_package_amount, nme_total_amount, exclude_total_amount, fc1_total_estimate_amount, total_estimate_amount,Insu_Physician_Fees_ICU,consutations } = this.state;
        let amount = 0;
        let additional_packages_amount = 0;
        let additional_procedures_amount = 0;
        let ailment_amount = 0;
        let base_percentage_amount = 0;
        let surgeon_charges = 0;
        let surgeon_charges_=0;
        let room_amount = 0;
        let surgery_procedure_amount = 0;
        let pack = false;
        let excludes_amount = 0;
        let nme_amount = this.state.nmeInfo;
        let total_amount = 0;
        let room_stay=0;
        let icu_stay=0;
        let room_id,room_upgrade_reason=0;


        if (excludes_amount === 0) {
            let table_data = excludesTableStore.getState();
            if (table_data.length > 0) {
                table_data.map((body, key) => {
                    body['feilds'].map((feild, feild_key) => {
                        if (feild.name === 'amount') {
                            excludes_amount = parseFloat(excludes_amount) + parseFloat(feild.value?feild.value:0);
                        }
                    })
                })
            }
        }
        if (nme_amount !== 0) {
            console.log('nmePopupSchema',nmePopupSchema);
            if (nmePopupSchema !== undefined) {
                if (nmePopupSchema.length > 0) {
                    nmePopupSchema.map((subTable, key) => {
                        if (subTable.visible) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                console.log('ROWS_TABLE_DATA', row);
                                row.map((sub_feild, sub_table_key) => {
                                    console.log('ROWS_TABLE_DATA:::', sub_feild, this.state.nmeInfo);
                                    if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                        console.log('NMEDATA::::', parseFloat(nme_amount),parseFloat(sub_feild.value),parseFloat(this.state.nmeInfo));
                                        nme_amount = parseFloat(nme_amount) + parseFloat(sub_feild.value);
                                    }
                                })
                            })
                        }
                    })
                }
            }
        }
        let packagehideing = 0;
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild['name'] === 'ins_package_name') {
                if (parseFloat(feild.value) !== null && parseFloat(feild.value) !== '' && parseFloat(feild.value) !== undefined && !isNaN(parseFloat(feild.value))) {
                    pack = true;
                }
                else {
                    pack = false;
                }
            }
            if (feild['name'] === 'ins_surgery_procedure_amount') {
                if (parseFloat(feild.value) !== null && parseFloat(feild.value) !== '' && parseFloat(feild.value) !== undefined && !isNaN(parseFloat(feild.value))) {
                    surgery_procedure_amount = parseFloat(InsuranceDetailsSchema[key]['value']);
                }
            }
            if (feild['name'] === 'estimate_type') {
                if (feild.value == 1) {
                    packagehideing = 1;
                }
            }
            if(feild['name']==='icu_stay'){
                icu_stay=feild.value;
            }
            if(feild['name']==='room_stay'){
                room_stay=feild.value;
            }
        })
        basicSumInsuredSchema.map((feild, key) => {
            if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {

                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_amount') {
                        room_amount = parseFloat(basicSumInsuredSchema[key]['data'][sub_key]['value']);
                    }
                })
            }
            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_ward_names') {
                        console.log('ins_room_eligible_ward_amount:', sub_feild)
                        room_id = sub_feild.value; //note
                        
                    }
                    
                })
            }
            if (feild.name === "ins_room_upgrade_reason") {
                room_upgrade_reason = feild.value ? feild.value : null;
                if(room_upgrade_reason==3){
                    basicSumInsuredSchema.map((feild, key) => {
                    if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_upgrade_room_names') {
                                room_id = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                          
                        })
                    }
                })
                }
            }
        })

        if (!pack) {
            room_amount = 0;
        }

        addonSchema.map((subTable, key) => {
            if (subTable.name !== 'ins_surgical_charges' && subTable.name !== 'ins_medical_charges') {
                let table_body = subTable.Specification.table_body;
                let header_amount = 0;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                            amount = parseFloat(amount) + parseFloat(sub_feild.value);
                            header_amount = parseFloat(header_amount) + parseFloat(sub_feild.value);
                        }
                    })
                })
                addonSchema[key]['header_amount'] = header_amount;
            }
        })

        additionalPackageSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                if(table_body.length>0){
                    table_body.map((feild, table_key) => {
                    
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                additional_packages_amount = parseFloat(additional_packages_amount) + parseFloat(sub_feild.value);
                            }
                        })
                    })
                }else{
                    additional_packages_amount=0;
                }
                
            }
        })

        additionalProcedureSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                            additional_procedures_amount = parseFloat(additional_procedures_amount) + parseFloat(sub_feild.value);
                        }
                    })
                })
            }
        })

        ailmentSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                            ailment_amount = parseFloat(ailment_amount) + parseFloat(sub_feild.value);
                        }
                    })
                })
            }
            else{
                ailment_amount=0;
            }
        })

        // base_percentage_amount = parseFloat(additional_packages_amount) + parseFloat(base_price);
        addonSchema.map((subTable, key) => {
            if (subTable.name === 'ins_surgical_charges' || subTable.name === 'ins_medical_charges') {

                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    let header_amount = 0;
                    let anaesthetist_amount = 0;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        if (feild.id === 1 &&  feild.key_word==='additional_surgeon_fees') {
                            row.map((sub_feild, sub_table_key) => {
                                
                                if (sub_feild.name === "amount") {
                                    surgeon_charges_=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                    if(surgeon_charges_===null||surgeon_charges_===''|| surgeon_charges_===undefined){
                                        surgeon_charges_=0;
                                    }
                                    header_amount = parseFloat(header_amount) + parseFloat(surgeon_charges_);
                                    // amount = parseFloat(amount) + parseFloat(surgeon_charges_);
                                }
                            })
                        }
                       else if (feild.id === 2   &&  feild.key_word==='surgeon') {
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === 'percentage' && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                    let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(amount);
                                    surgeon_charges = Math.round(total_charges * (sub_feild.value / 100));
                                }
                                if (sub_feild.name === "amount") {
                                    // surgeon_charges=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                    // if(surgeon_charges===null||surgeon_charges===''|| surgeon_charges===undefined){
                                    //     surgeon_charges=0;
                                    // }
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = surgeon_charges;
                                    header_amount = parseFloat(header_amount) + parseFloat(surgeon_charges);
                                    surgeon_charges=surgeon_charges+ surgeon_charges_;
                                    amount = parseFloat(amount) + parseFloat(surgeon_charges);
                                }
                            })
                        }
                        else if (feild.id === 1   &&  feild.key_word!=='additional_surgeon_fees') {
                            if(slug==='finanical-counselling' || slug==='recounselling'){
                                if(room_id!==0&&room_id!==null){
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'percentage' && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                        // let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(amount);
                                        // surgeon_charges = Math.round(total_charges * (sub_feild.value / 100));
                                        if(room_stay!==0&&room_stay!=='0'&&room_stay!==null ){
                                            let cosutation_amount=consutations.length>0&&consutations.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                            let rm_amount = cosutation_amount.length>0?cosutation_amount[0].amount:0;
                                            surgeon_charges = Math.round( (room_stay* (sub_feild.value))*rm_amount);  
                                        }
                                        if(icu_stay!==0 && icu_stay!=='0'&&icu_stay!==null){
                                            let cosutation_amount=consutations.length>0&&consutations.filter(item=>parseFloat(item.room_id)===parseFloat(13)) 
                                            let icu_amount = cosutation_amount.length>0?cosutation_amount[0].amount:0;
                                            surgeon_charges += Math.round( (icu_stay* (Insu_Physician_Fees_ICU))*icu_amount); 
                                        }
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = surgeon_charges;
                                        header_amount = parseFloat(header_amount) + parseFloat(surgeon_charges);
                                        amount = parseFloat(amount) + parseFloat(surgeon_charges);
                                    }
                                
                                })
                            }
                            else{
                                header_amount=0 ;
                            }
                            }else{
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "amount") {
                                        surgeon_charges=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]!==null?addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]:0
                                       header_amount = parseFloat(header_amount) + parseFloat(surgeon_charges);
                                        amount = parseFloat(amount) + parseFloat(surgeon_charges);
                                    }
                                }) 
                            }
                           
                        }
                        else {
                            if(feild.id === 2   &&  feild.key_word==='in_asst_physician_fees'){
                                if(slug==='finanical-counselling' || slug==='recounselling'){
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "asst_physician_fees") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"]=false;
                                        
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"]=false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=0;
                                        
                                    }
                                })
                            }else{
                                let total_surgeon_extra_charges = 0;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "asst_physician_fees") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"]=true;
                                        
                                    }
                                    if (sub_feild.name === "amount") {
                                        total_surgeon_extra_charges= addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]!==null?addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]:0;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"]=true;
                                        header_amount = parseFloat(header_amount) + parseFloat(total_surgeon_extra_charges);
                                        amount = parseFloat(amount) + parseFloat(total_surgeon_extra_charges);
                                    }
                                })
                            }
                                // addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=0;
                            }else{
                                let total_surgeon_extra_charges = 0;
                            let this_value;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === 'percentage' && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                    this_value = sub_feild.value
                                    total_surgeon_extra_charges = Math.round(surgeon_charges * (sub_feild.value / 100));
                                    if (sub_feild.id === 4) {
                                        anaesthetist_amount = total_surgeon_extra_charges;
                                    }
                                }
                                if (sub_feild.name === "amount" && parseFloat(this_value) !== null && parseFloat(this_value) !== '' && parseFloat(this_value) !== undefined && !isNaN(parseFloat(this_value))) {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_surgeon_extra_charges;
                                    header_amount = parseFloat(header_amount) + parseFloat(total_surgeon_extra_charges);
                                    amount = parseFloat(amount) + parseFloat(total_surgeon_extra_charges);
                                }
                            })
                            }
                        }
                    })
                    addonSchema[key]['header_amount'] = header_amount;
                }
            }
        })

        estimateBreakupFormatSchema.map((feild, key) => {
            if (feild['name'] === 'base_price') {

                if (parseFloat(additional_packages_amount) !== null && parseFloat(additional_packages_amount) !== '' && parseFloat(additional_packages_amount) !== undefined && !isNaN(parseFloat(additional_packages_amount)) && parseFloat(inital_package_amount) !== null && parseFloat(inital_package_amount) !== '' && parseFloat(inital_package_amount) !== undefined && !isNaN(parseFloat(inital_package_amount))) {
                    estimateBreakupFormatSchema[key]['value'] = Math.round(Number(additional_packages_amount)) + Math.round(Number(inital_package_amount)) + Math.round(Number(additional_procedures_amount));
                    // estimateBreakupFormatSchema[key]['value'] = parseFloat(additional_packages_amount) + parseFloat(additional_procedures_amount) + parseFloat(room_amount) + parseFloat(surgery_procedure_amount);
                }
                else {
                    estimateBreakupFormatSchema[key]['value'] = 0;
                }
            }
            if (feild['name'] === 'excludes') {
                if (packagehideing === 1) {
                    estimateBreakupFormatSchema[key]['value'] = parseFloat(excludes_amount) ? parseFloat(excludes_amount) : parseFloat(exclude_total_amount);
                    excludes_amount=parseFloat(excludes_amount) ? parseFloat(excludes_amount) : parseFloat(exclude_total_amount)
                    // this.setState({ exclude_total_amount: excludes_amount ? excludes_amount : exclude_total_amount });
                }
                else {
                    estimateBreakupFormatSchema[key]['value'] = 0;
                    this.setState({ exclude_total_amount: 0 });

                }
            }

            if (feild['name'] === 'estimated_nme_amount') {
                // estimateBreakupFormatSchema[key]['value'] = parseFloat(nme_amount)?parseFloat(nme_amount):parseFloat(nme_total_amount);
                estimateBreakupFormatSchema[key]['value'] = parseFloat(nme_amount) && parseFloat(nme_amount);

                this.setState({ nme_total_amount: parseFloat(nme_amount) && parseFloat(nme_amount) });
            }

            if (feild['name'] === 'ins_total_estimate_amount') {
                if (parseFloat(additional_packages_amount) !== null && parseFloat(additional_packages_amount) !== '' && parseFloat(additional_packages_amount) !== undefined && !isNaN(parseFloat(additional_packages_amount)) && parseFloat(additional_procedures_amount) !== null && parseFloat(additional_procedures_amount) !== '' && parseFloat(additional_procedures_amount) !== undefined && parseFloat(room_amount) !== null && parseFloat(room_amount) !== '' && parseFloat(room_amount) !== undefined && !isNaN(parseFloat(room_amount)) && parseFloat(amount) !== null && parseFloat(amount) !== ''
                    && parseFloat(amount) !== undefined && !isNaN(parseFloat(amount))) {
                    if (packagehideing === 1) {
                        // const estimatrBrakupAmount = parseFloat(additional_packages_amount) + parseFloat(additional_procedures_amount) + parseFloat(ailment_amount) + parseFloat(excludes_amount) + parseFloat(nme_amount) + parseFloat(inital_package_amount)
                        // estimateBreakupFormatSchema[key]['value'] = parseFloat(additional_packages_amount) + parseFloat(additional_procedures_amount)  + parseFloat(amount) + parseFloat(ailment_amount) + parseFloat(excludes_amount) + parseFloat(nme_amount) + parseFloat(inital_package_amount);
                        if (inital_package_amount === undefined) {
                            inital_package_amount = 0;
                        }
                        excludes_amount = excludes_amount ? excludes_amount : exclude_total_amount;
                        estimateBreakupFormatSchema[key]['value'] = Math.round(Number(additional_packages_amount)) + Math.round(Number(additional_procedures_amount)) + Math.round(Number(ailment_amount)) + Math.round(Number(excludes_amount)) + Math.round(Number(nme_amount)) + Math.round(Number(inital_package_amount));
                        // total_amount = parseFloat(amount);
                        total_amount = Math.round(Number(additional_packages_amount)) + Math.round(Number(additional_procedures_amount)) + Math.round(Number(ailment_amount)) + Math.round(Number(excludes_amount)) + Math.round(Number(nme_amount)) + Math.round(Number(inital_package_amount));
                        if (total_amount !== 0 && total_amount !== '0') {
                            fc1_total_estimate_amount = total_estimate_amount!==0?total_estimate_amount:total_amount;
                        }

                        this.insurance_total()
                    } else {

                        // const estimatrBrakupAmount = parseFloat(amount) + parseFloat(ailment_amount) + parseFloat(nme_amount);
                        // estimateBreakupFormatSchema[key]['value'] = !isNaN(estimatrBrakupAmount) ? estimatrBrakupAmount : 0;
                        estimateBreakupFormatSchema[key]['value'] = Math.round(Number(amount)) + Math.round(Number(ailment_amount)) + Math.round(Number(nme_amount)+Math.round(Number(additional_procedures_amount)));
                        total_amount = Math.round(Number(amount)) + Math.round(Number(ailment_amount)) + Math.round(Number(nme_amount)+Math.round(Number(additional_procedures_amount)));
                        if (total_amount !== 0 && total_amount !== '0') {
                            fc1_total_estimate_amount = total_estimate_amount!==0?total_estimate_amount:total_amount;
                        }
                        // total_amount = !isNaN(estimatrBrakupAmount) ? estimatrBrakupAmount : 0
                        this.insurance_total()
                        // total_amount = parseFloat(additional_packages_amount) + parseFloat(additional_procedures_amount) + parseFloat(surgery_procedure_amount) + parseFloat(amount) + parseFloat(ailment_amount) + parseFloat(excludes_amount) + parseFloat(nme_amount) + parseFloat(inital_package_amount);;
                    }


                    // estimateBreakupFormatSchema[key]['value'] = parseFloat(additional_packages_amount) + parseFloat(additional_procedures_amount) + parseFloat(room_amount) + parseFloat(surgery_procedure_amount) + parseFloat(amount) + parseFloat(ailment_amount)+ parseFloat(excludes_amount) +parseFloat(nme_amount)+parseFloat(inital_package_amount);
                }
                else {
                    estimateBreakupFormatSchema[key]['value'] = 0;
                    total_amount = 0;
                    fc1_total_estimate_amount=0;


                }
            }
        })

        this.setState((state) => ({ addonSchema: addonSchema, total_estimate_amount: total_amount, estimateBreakupFormatSchema: estimateBreakupFormatSchema, ailment_capping_amount: ailment_amount, fc1_total_estimate_amount }), () => {
            // this.insurance_total();

        })
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
        // this.setState({ addonSchema: addonSchema, total_estimate_amount: total_amount, estimateBreakupFormatSchema: estimateBreakupFormatSchema, ailment_capping_amount: ailment_amount });
    }

    loadMore = (ele) => {
        try {
        let { basicSumInsuredSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, addonSchema, total_estimate_amount, tariff_mapped } = this.state;
        // this.setState({loadding: true})
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let care_management = null;
        let estimate_type = null;
        let total_stay = 0
        let icu_value = 0
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild.name === 'care_management') {
                care_management = feild.value ? feild.value : null;
            }
            if (feild.name === "estimate_type") {
                estimate_type = feild.value ? feild.value : null;
            }
            if (feild['name'] === 'room_stay') {
                if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
                    total_stay =feild['value']? parseFloat(feild['value']):0;
                }
                else {
                    total_stay = feild['value']?parseFloat(feild['value']):0;
                }
            }
            if (feild['name'] === 'icu_stay') {
                if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
                    icu_value = feild['value']?parseFloat(feild['value']):0;
                }
                else {
                    icu_value = feild['value']?parseFloat(feild['value']):0;
                }
            }
        })
        // this.setState({loadding: true})
        // medical data fill in estimate table

        // surgical data fill in estimate table
        if (care_management == 2) {    // 1 - medical, 2 - surgical

            let { configuration } = this.state;
            if (configuration.length > 0) {
                configuration.map((feilds, key) => {
                    if (feilds.config_name === 'Ins-Surgeon') {
                        addonSchema.map((subTable, key) => {
                            if (subTable.header === 17) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (feild.id === 1) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                this.setState({ addonSchema: addonSchema, loadding: false });
                                            }
                                           
                                        })
                                    }
                                    if (feild.id === 2) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'percentage') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                this.setState({ addonSchema: addonSchema, loadding: false });
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                    if (feilds.config_name === 'Ins-Asst Surgeon') {
                        addonSchema.map((subTable, key) => {
                            if (subTable.header === 17) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (feild.id === 3) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'percentage') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                this.setState({ addonSchema: addonSchema, loadding: false });
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                    if (feilds.config_name === 'Ins-Anaesthetist') {
                        addonSchema.map((subTable, key) => {
                            if (subTable.header === 17) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (feild.id === 4) {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'percentage') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                this.setState({ addonSchema: addonSchema, loadding: false });
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }
        // ICU Stay data fill in estimate table
        if (estimate_type == 2 || estimate_type == null) { // 1 - package
            this.internsivistAndasstInternsivist(icu_value);
            this.insurance_total();
            // let qty_for_icu_stay = [
            //     { header: 1, key: 1 },
            //     { header: 1, key: 2 },
            //     { header: 1, key: 3 },
            //     { header: 3, key: 0 },
            //     { header: 5, key: 0 }];

            // addonSchema.map((subTable, key) => {
            //     qty_for_icu_stay.map((icu_stay, icu_stay_key) => {
            //         if (subTable.header === icu_stay.header) {
            //             let table_body = subTable.Specification.table_body;
            //             table_body.map((feild, table_key) => {
            //                 if (table_key === icu_stay.key) {
            //                     let row = feild.feilds;
            //                     let rate;
            //                     row.map((sub_feild, sub_table_key) => {
            //                         if (sub_feild.name === 'qty') {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_value;
            //                         }
            //                         if (sub_feild.name === 'rate') {
            //                             rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
            //                         }
            //                         if (sub_feild.name === 'amount') {
            //                             if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
            //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(icu_value) * rate;
            //                             }
            //                         }
            //                     })
            //                 }
            //             })
            //         }
            //     })
            // })

            // if (total_stay != '' && !isNaN(total_stay) && total_stay != undefined && total_stay != null) {
            //     InsuranceDetailsSchema.map((feild, key) => {
            //         if (feild['name'] === 'length_of_stay') {
            //             InsuranceDetailsSchema[key]['value'] = total_stay;
            //         }
            //     })
            // }

            // Promise.all([
            //     postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 1, sub_header_id: 3, tariff_mapped: tariff_mapped ? tariff_mapped : null } }).then(res => res),
            //     postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 1, sub_header_id: 4, tariff_mapped: tariff_mapped ? tariff_mapped : null } }).then(res => res)
            // ]).then(([internsivist, asstInternsivist]) => {
            //     if (internsivist.status) {
            //         if (internsivist.data.length > 0) {
            //             postService('getServicePricesById', 'POST', { data: { service_id: internsivist.data[0].id } }).then(res => {
            //                 if (res['status']) {
            //                     let room_id, amount;

            //                     res.data.map((feild, key) => {
            //                         if (feild.room_name === 'ICCU') {
            //                             amount = feild.amount;

            //                             addonSchema.map((subTable, key) => {
            //                                 if (subTable.header === 1) {
            //                                     let table_body = subTable.Specification.table_body;
            //                                     table_body.map((feild, table_key) => {
            //                                         if (feild.id === 3) {
            //                                             let row = feild.feilds;
            //                                             let qty;
            //                                             row.map((sub_feild, sub_table_key) => {
            //                                                 if (sub_feild.name === "qty") {
            //                                                     qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
            //                                                     if (qty === '' && qty === null && qty === undefined) {
            //                                                         qty = 0;
            //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
            //                                                     }
            //                                                 }
            //                                                 if (sub_feild.name === "rate") {
            //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
            //                                                 }
            //                                                 if (qty !== null && sub_feild.name === "amount") {
            //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(amount);
            //                                                 }
            //                                             })
            //                                         }
            //                                     })
            //                                 }
            //                             })
            //                             this.setState({ addonSchema: addonSchema });
            //                         }
            //                     })
            //                 }
            //             })
            //         }
            //     }
            //     if (asstInternsivist.status) {
            //         postService('getServicePricesById', 'POST', { data: { service_id: asstInternsivist.data[0].id } }).then(res => {
            //             if (res['status']) {
            //                 let room_id, amount;
            //                 // InsuranceDetailsSchema.map((feild, key) => {
            //                 //     if (feild['name'] === 'room_opted') {
            //                 //         room_id = feild['room_id'];
            //                 //     }
            //                 // })

            //                 res.data.map((feild, key) => {
            //                     if (feild.room_name === 'ICCU') {
            //                         amount = feild.amount;

            //                         addonSchema.map((subTable, key) => {
            //                             if (subTable.header === 1) {
            //                                 let table_body = subTable.Specification.table_body;
            //                                 table_body.map((feild, table_key) => {
            //                                     if (feild.id === 4) {
            //                                         let row = feild.feilds;
            //                                         let qty;
            //                                         row.map((sub_feild, sub_table_key) => {
            //                                             if (sub_feild.name === "qty") {
            //                                                 qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
            //                                                 if (qty === '' && qty === null && qty === undefined) {
            //                                                     qty = 0;
            //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
            //                                                 }
            //                                             }
            //                                             if (sub_feild.name === "rate") {
            //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
            //                                             }
            //                                             if (qty !== null && sub_feild.name === "amount") {
            //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(amount);
            //                                             }
            //                                         })
            //                                     }
            //                                 })
            //                             }
            //                         })
            //                         this.setState({ addonSchema: addonSchema });
            //                     }
            //                 })
            //             }
            //         })
            //     }
            // })
        }
        else {
            addonSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (table_key === 1 || table_key === 2 || table_key === 3) {
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                            }
                        }
                    })
                })
            })
            this.setState({ addonSchema: addonSchema })
        }
        this.insurance_total();
        this.setState({ showEstimate: ele, InsuranceDetailsSchema: InsuranceDetailsSchema })
        this.total_suming();
        this.insurance_total();
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }

    internsivistAndasstInternsivist(ele_val) {
        try {
        let { addonSchema ,InsuranceDetailsSchema} = this.state;
        let {counselling_details}=this.props
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let qty_for_icu_stay = [
            { header: 1, key: 1 },
            { header: 1, key: 2 },
            { header: 1, key: 3 },
            { header: 3, key: 0 },
            { header: 5, key: 0 },
            { header: 15, key: 1 },
            { header: 16, key: 0 }];

            let total_stay = 0;
            InsuranceDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'room_stay') {
                    if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
                        total_stay = ele_val?parseFloat(ele_val):0 + parseFloat(feild['value']);
                    }
                    else {
                        total_stay = parseFloat(ele_val);
                    }
                }
            })
        addonSchema.map((subTable, key) => {
            qty_for_icu_stay.map((icu_stay, icu_stay_key) => {
                if (subTable.header === icu_stay.header) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (table_key === icu_stay.key) {
                            let row = feild.feilds;
                            let rate;
                            let qty;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.row_group === 'dietician') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
                                        qty=total_stay;
                                    }
                                    

                                }else if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = !isNaN(ele_val) ? ele_val : 0;
                                    qty=ele_val;
                                }
                                if (sub_feild.name === 'rate') {
                                    rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                }
                                if (sub_feild.name === 'amount') {
                                    if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty*rate;
                                    }
                                }
                            })
                        }
                    })
                }
            })
        })

        Promise.all([
            postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 1, sub_header_id: 3, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res),
            postService('getServicesByHeaderId', 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: 1, sub_header_id: 4, tariff_mapped: this.state.tariff_mapped?parseInt(this.state.tariff_mapped):counselling_details.tariff_mapped } }).then(res => res)
        ]).then(([internsivist, asstInternsivist]) => {
            if (internsivist.status) {
                if (internsivist.data.length > 0) {
                    postService('getServicePricesById', 'POST', { data: { service_id: internsivist.data[0].id } }).then(res => {
                        if (res['status']) {
                            let room_id, amount;
                            // medicationDetailsSchema.map((feild, key) => {
                            //     if (feild['name'] === 'room_opted') {
                            //         room_id = feild['room_id'];
                            //     }
                            // })

                            res.data.map((feild, key) => {
                                if (feild.room_name === 'ICCU') {
                                    amount = feild.amount;
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.header === 1) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 3) {
                                                    let row = feild.feilds;
                                                    let qty;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === "qty") {
                                                            // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                                            qty = ele_val;

                                                            if (qty === '' && qty === null && qty === undefined) {
                                                                qty = 0;
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
                                                            } else {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                                            }
                                                        }
                                                        if (sub_feild.name === "rate") {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (qty !== null && sub_feild.name === "amount") {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(amount);
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                    this.setState({ addonSchema: addonSchema });
                                    this.total_suming();
                                    this.insurance_total();
                                }
                            })
                        }
                    })
                }
            }
            if (asstInternsivist.status) {
                postService('getServicePricesById', 'POST', { data: { service_id: asstInternsivist.data[0].id } }).then(res => {
                    if (res['status']) {
                        let room_id, amount;
                        // medicationDetailsSchema.map((feild, key) => {
                        //     if (feild['name'] === 'room_opted') {
                        //         room_id = feild['room_id'];
                        //     }
                        // })

                        res.data.map((feild, key) => {
                            if (feild.room_name === 'ICCU') {
                                amount = feild.amount;

                                addonSchema.map((subTable, key) => {
                                    if (subTable.header === 1) {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            if (feild.id === 4) {
                                                let row = feild.feilds;
                                                let qty;
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild.name === "qty") {
                                                        // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                                        qty = ele_val;
                                                        if (qty === '' && qty === null && qty === undefined) {
                                                            qty = 0;
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
                                                        } else {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                                        }
                                                    }
                                                    if (sub_feild.name === "rate") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                    }
                                                    if (qty !== null && sub_feild.name === "amount") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(amount);
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                                this.setState({ addonSchema: addonSchema });
                                this.total_suming();
                                this.insurance_total();
                            }
                        })
                    }
                })
            }
        })
        this.total_suming();
        // this.insurance_total();
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }

    clearEstimate_table = () => {
        try {
        let { addonSchema, estimateBreakupFormatSchema, basicSumInsuredSchema } = this.state
        estimateBreakupFormatSchema.map((feild, key) => {
            feild.value = null;
            feild.text = null;
        })

        basicSumInsuredSchema.map((feild, key) => {
            feild.value = null;
            feild.text = null;
            if (feild['name'] === 'ins_package_difference') {
                basicSumInsuredSchema[key]['value'] = null;
            }
            if (feild['name'] === 'ins_select_difference') {
                basicSumInsuredSchema[key]['value'] = null;
            }
            if (feild['name'] === "ins_room_difference_amount") {
                basicSumInsuredSchema[key]['value'] = null;
            }
            if (feild['name'] === "ins_pro_rata_difference_amount") {
                basicSumInsuredSchema[key]['value'] = null;
            }
            if (feild.name === 'ins_co_pay' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_copay_percent') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;

                    }
                    if (sub_feild.name === 'ins_copay_amount') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;

                    }
                })
            }
            if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_percent') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null
                    }
                    if (sub_feild.name === 'ins_room_eligible_amount') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                    }
                })
            }
            if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_room_eligible_ward_names') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = null;
                    }
                    if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['package_charges'] = null;


                    }
                })
            }
            if (feild.name === 'ins_upgrade_room' && feild.type && feild.type === 'group') {
                let { data } = feild;
                // feild.data.length=0;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_upgrade_room_names') {
                        basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                    }
                    if (sub_feild.name === 'ins_upgrade_room_amount') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = 0;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                    }
                })
            }
            if (feild.name === 'ins_icu_eligible' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_icu_percent') {

                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                    }
                    if (sub_feild.name === 'ins_icu_amount') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                    }
                })
            }
            if (feild.name === 'ins_icu' && feild.type && feild.type === 'group') {
                let { data } = feild;
                data.map((sub_feild, sub_key) => {
                    if (sub_feild.name === 'ins_icu_type') {
                        basicSumInsuredSchema[key]['data'][sub_key]['amount'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;
                    }
                    if (sub_feild.name === 'ins_icu_amount') {
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = null;
                        basicSumInsuredSchema[key]['data'][sub_key]['value'] = 0;
                        basicSumInsuredSchema[key]['data'][sub_key]['text'] = null;

                    }
                })
            }
            this.setState({ basicSumInsuredSchema: JSON.parse(JSON.stringify(basicSumInsuredSchema)) });
        })
        addonSchema.map((subTable, key) => {
            let table_name = subTable.name
            addonSchema[key].header_amount = 0;
            let table_body = subTable.Specification.table_body;
            table_body.map((feild, table_key) => {
                let row = feild.feilds;
                row.map((sub_feild, sub_table_key) => {
                    // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                    // }

                    if (table_name === 'room_charges') {
                        if (sub_feild.name === 'qty') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                        if (sub_feild.name === 'rate') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                        if (sub_feild.name === 'amount') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                    }
                    if (table_name === 'room_investigation_charges') {
                        addonSchema[key].Specification.add_more = true;
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'Routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_room_highend_investigations') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'icu_investigation_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'Routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_icu_highend_investigations') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'ip_pharmacy_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine_drugs_implants') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_room_highend_drugs_implants') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'icu_pharmacy_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine_drugs_implants') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_icu_highend_drugs_implants') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'ot_cath_pharmacy') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_ot_cath_highend_drugs_implants') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }

                    if (table_name === 'general_equipment_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_general_highend_equipments') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'ot_charges') {

                        if (feild.key_word === 'ot_inst_disinfec') {
                            if (sub_feild.name === 'ot_inst_disinfec') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            }

                        }
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_ot_hours') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'ot_equipment') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_ot_equipments') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'procedure_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_surgery_procedure_name') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'blood_bank_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_blood_components') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'cross_consultation_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'ins_dept_for_corss_consultations') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'ins_hospital_services') {
                        if (feild.key_word === 'mrd') {
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'seropositive') {
                            if (sub_feild.name === 'seropositive') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'isolation_charges') {
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'ins_room_isolation_charges') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_icu_isolation_charges') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }

                        }
                    }
                    if (table_name === 'ins_physiotherapy_diet_charges') {
                        if (feild.key_word === 'dietician') {
                            if (sub_feild.name === 'dietician') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'routine') {
                            if (sub_feild.name === 'routine') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                        }
                        if (feild.key_word === 'highend') {
                            if (sub_feild.name === 'ins_physiotherapys') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'qty') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'rate') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'amount') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            }
                            if (sub_feild.name === 'action') {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                            }
                        }
                        if (feild.key_word === 'add_more') {
                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                        }
                    }
                    if (table_name === 'surgical_charges') {
                        if (sub_feild.name === 'qty') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                        if (sub_feild.name === 'percentage') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                        if (sub_feild.name === 'amount') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                    }
                    if (table_name === 'medical_charges') {
                        if (sub_feild.name === 'qty') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                        if (sub_feild.name === 'percentage') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                        if (sub_feild.name === 'amount') {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                        }
                    }
                })
            })
        })
        estimateBreakupFormatSchema.map((item, ikey) => {
            if (item.name === 'base_price') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
                estimateBreakupFormatSchema[ikey]['text'] = null;

                // estimateBreakupFormatSchema[ikey]['visible'] = false;  
            }
            if (item.name === 'excludes') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'initial_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'co_pay_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'estimated_nme_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'actual_nme_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'discount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'final_approval_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'extra_deduction_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'remarks') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'difference_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'ins_total_estimate_amount') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
                estimateBreakupFormatSchema[ikey]['text'] = null;
            }
            if (item.name === 'signature_of_patient_attendant') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'attendant_name') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'relation') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'Signature_of_FC') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }
            if (item.name === 'Name_of_the_FC') {
                estimateBreakupFormatSchema[ikey]['value'] = null;
            }

        })
        this.setState({ addonSchema: addonSchema, estimateBreakupFormatSchema: JSON.parse(JSON.stringify(estimateBreakupFormatSchema)), total_estimate_amount: 0, inital_package_amount: 0 })
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }

    generateLink() {
        let { basic_info, } = this.props;
        // console.log("generateLink", basic_info);
        const currentTime = new Date();
        const expirationTime = new Date(currentTime.getTime() + 60000*5); // 5 minute expiration
    
        const year = expirationTime.getFullYear();
        const month = ('0' + (expirationTime.getMonth() + 1)).slice(-2);
        const day = ('0' + expirationTime.getDate()).slice(-2);
        const hours = ('0' + expirationTime.getHours()).slice(-2);
        const minutes = ('0' + expirationTime.getMinutes()).slice(-2);
        let { ui_base_url } = networkList;
        const generatedLink = `${ui_base_url}/digital-signature/${basic_info["token_no"]}`;
        return generatedLink;
    }
    // sendLink() {
    //     let {digital_sig_imgpath, patient_digsign_willing,enableCheckBox} = this.state;
    //     let generatedLink = this.generateLink()
    //     setTimeout(() => {
    //         this.setState({ enableCheckBox: true });
    //     }, 120);
    //     if (generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing === true) {
    //         this.handleCheckboxChange();
    //     }
    //     this.setState({signatureModal: false, generatedLink, isGenerateSign: "yes", digital_sig_imgpath: null, patient_digsign_willing: false},  () => this.api_sendLink())
    // }
    sendLink() {
        let { digital_sig_imgpath, patient_digsign_willing, enableCheckBox, nme_total_amount} = this.state;
        console.log('nme_amount',nme_total_amount);
        let generatedLink = this.generateLink();
        setTimeout(() => {
            this.setState({ enableCheckBox: true });
        }, 120000);
        if (((digital_sig_imgpath || patient_digsign_willing === false)) && (generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing === false)) {
            if(nme_total_amount==0 || nme_total_amount==null || nme_total_amount==undefined || nme_total_amount===''){
            //hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
            }
            else {
                this.api_sendLink();
            }
        }
        if (generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing === true) {
            if(nme_total_amount==0 || nme_total_amount==null || nme_total_amount==undefined || nme_total_amount===''){
                hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:true} })
                }
                else {
                    this.handleCheckboxChange();
                }
            //this.handleCheckboxChange();
        } 
        this.setState({signatureModal: false, generatedLink, isGenerateSign: "yes", digital_sig_imgpath: null, patient_digsign_willing: false});
    }
    

    api_sendLink() {
        //let {basic_info} = this.props
        //let {generatedLink, signatureSchema, preview_data} = this.state
        let { addonSchema, basicSumInsuredSchema, estimateBreakupFormatSchema, InsuranceDetailsSchema, ailmentSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, interimSchema, preexistingConditionsSchema, includes_data, nmePopupSchema, package_amt, inital_package_amount,exludesiders, isGenerateSign, generatedLink, digital_sig_imgpath,patient_digsign_willing } = this.state;
        let { basic_info } = this.props;
        let estimate_data = [];
        let additional_packages = [];
        let additional_procedures = [];
        let ailment = [];
        let interim = [];
        let pre_ex_conditions = [];
        let temp_obj = {}
        let excludes_data = [];
        let nmedata = [];
        addonSchema.map((subTable, key) => {
            if (subTable.name !== 'ins_surgical_charges' && subTable.name !== 'ins_medical_charges') {
                let table_header = subTable.header;
                let table_body = subTable.Specification.table_body;
                temp_obj[table_header] = subTable.header_amount;
                table_body.map((feild, table_key) => {
                    let service, qty, rate, amount, sub_header;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    if (key_word !== 'ot_hours') {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    if (sub_feild.element === 'text') {
                                        service = parseFloat(sub_feild.service);
                                    }
                                    else {
                                        service = parseFloat(sub_feild.value);
                                    }
                                }
                                if (sub_table_key === 1) {
                                    qty = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }
                    else {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 1) {
                                    service = parseFloat(sub_feild.service);
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    qty = null;
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }

                    let obj = {
                        key_word: key_word,
                        header: table_header,
                        sub_header: sub_header,
                        service: service,
                        qty: qty,
                        rate: rate,
                        amount: amount
                    }

                    if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        estimate_data.push(obj);
                    }
                    else {
                        if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                        }
                    }
                })
            }
            else {
                if (subTable.visible) {
                    let table_header = subTable.header;
                    let table_body = subTable.Specification.table_body;
                    temp_obj[table_header] = subTable.header_amount;
                    table_body.map((feild, table_key) => {
                        let service, percentage, amount, sub_header;
                        let key_word = feild.key_word;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_table_key === 0) {
                                service = parseFloat(sub_feild.service);
                                sub_header = parseFloat(sub_feild.sub_header);
                            }
                            if (sub_table_key === 1) {
                                percentage = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 2) {
                                amount = parseFloat(sub_feild.value);
                            }
                        })
                        let obj = {
                            key_word: key_word,
                            header: table_header,
                            sub_header: sub_header,
                            service: service,
                            qty: percentage,
                            rate: null,
                            amount: amount
                        }
                        if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                        }
                    })
                }
            }
        })

        additionalPackageSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let package_id,discount_amount,actual_price, percentage,package_name;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                package_id = parseFloat(sub_feild.value);
                                package_name=sub_feild.text;
                            }
                            if (sub_table_key === 1) {
                                actual_price = parseFloat(sub_feild.value);
                            }
                            if(sub_table_key === 2){
                                percentage = parseFloat(sub_feild.value);
                            }
                            if(sub_table_key === 3){
                                discount_amount = parseFloat(sub_feild.value);
                            }
                        }
                    })
                    let obj = {
                        package_id: package_id,
                        package_name:package_name,
                        amount: discount_amount,
                        additional_type: 1,
                        package_percentage : percentage,
                        actual_price:actual_price
                    }
                    if (package_id !== '' && package_id !== null && package_id !== undefined && !isNaN(package_id) && discount_amount !== '' && discount_amount !== null && discount_amount !== undefined && !isNaN(discount_amount)) {
                        additional_packages.push(obj);
                    }
                })
            }
        })

        additionalProcedureSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let procedure_id, amount, percentage, procedure_name;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        console.log('enter', sub_feild)
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                procedure_id = parseFloat(sub_feild.value);
                                procedure_name = sub_feild.text;
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                          
                        }
                    })
                    let obj = {
                        procedure_id: procedure_id,
                        amount: amount,
                        additional_type: 2,
                        procedure_name: procedure_name
                        // percentage: percentage
                    }
                    if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_procedures.push(obj);
                    }
                })
            }
        })

        ailmentSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let surgery, surgery_amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                surgery = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 1) {
                                surgery_amount = parseFloat(sub_feild.value);
                            }
                        }
                    })
                    let obj = {
                        surgery: surgery,
                        surgery_amount: surgery_amount,
                        additional_type: 2
                        // percentage: percentage
                    }
                    if (surgery !== '' && surgery !== null && surgery !== undefined && !isNaN(surgery) && surgery_amount !== '' && surgery_amount !== null && surgery_amount !== undefined && !isNaN(surgery_amount)) {
                        ailment.push(obj);
                    }
                })
            }
        })
        if (nmePopupSchema !== undefined) {
            nmePopupSchema.map((subTable, key) => {
                console.log('rowssss3=====', subTable)
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let obj = {
                        "nme_id": null,
                        "nme_name": null,
                        "nme_rate": 0,
                        "nme_total_amount": 0,
                        "nme_quantity": 0,
                        "nme_tariff":'',
                    }
                    let nme_amount, nme_name, nme_rate, nme_quantity, nme_id, nme_tariff;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {

                        if (sub_feild.name === "department") {
                            obj['nme_id'] = sub_feild.id;
                            obj['nme_name'] = sub_feild.text;
                        }
                        if (sub_feild.name === 'tariff') {
                            obj['nme_tariff'] = sub_feild.value;

                        }
                        if (sub_feild.name === 'amount') {
                            obj['nme_quantity'] = sub_feild.value;
                        }
                        if (sub_feild.name === 'rate') {
                            obj['nme_rate'] = sub_feild.value;

                        }
                        if (sub_feild.name === 'amount') {
                            obj['nme_amount'] = sub_feild.value;

                        }

                        if (sub_feild.name !== 'action') {
                          
                        }
                    })

                    nmedata.push(obj);
                   

                })

            })

        }

        interimSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let interim_amount, aprox_bill, case_no;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                interim_amount = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 1) {
                                aprox_bill = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 2) {
                                case_no = parseFloat(sub_feild.value);
                            }
                        }
                    })
                    let obj = {
                        interim_amount: interim_amount,
                        aprox_bill: aprox_bill,
                        additional_type: 2,
                        case_no: case_no
                    }
                    if (interim_amount && interim_amount !== undefined && !isNaN(interim_amount) && aprox_bill && aprox_bill !== undefined && !isNaN(aprox_bill) && case_no) {
                        interim.push(obj);
                    }
                })
            }
        })
        let sum_insured_four_years_back = 0;
        let consider_si_four_years_back = 0;
        console.log('preexistingConditionsSchema', preexistingConditionsSchema)
        preexistingConditionsSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let condition_name, onset_data, sum_insured_onset_data, consder_si;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_feild.id === 2) {
                                if (sub_table_key === 0) {
                                    condition_name = sub_feild.value;
                                }
                                if (sub_table_key === 1) {
                                    onset_data = '';
                                    sum_insured_four_years_back = sub_feild.value;
                                }
                                if (sub_table_key === 2) {
                                    consider_si_four_years_back = sub_feild.value ? 1 : 0;
                                }

                            } else {
                                if (sub_table_key === 0) {
                                    condition_name = sub_feild.value;
                                }
                                if (sub_table_key === 1) {
                                    onset_data = sub_feild.value;
                                }
                                if (sub_table_key === 2) {
                                    sum_insured_onset_data = sub_feild.value;
                                }
                                if (sub_table_key === 3) {
                                    consder_si = sub_feild.value ? 1 : 0;
                                }
                            }

                        }
                    })
                    let obj = {
                        condition_name: condition_name,
                        onset_data: onset_data,
                        // additional_type: 2,
                        sum_insured_onset_data: sum_insured_onset_data,
                        consder_si: consder_si
                    }
                    if (condition_name && condition_name !== undefined && onset_data && onset_data !== undefined && sum_insured_onset_data && consder_si) {
                        pre_ex_conditions.push(obj);
                    }
                })
            }
        })
        console.log(pre_ex_conditions);
        let room_opted_amount = 0;
        InsuranceDetailsSchema.map((feild, key) => {
            if (feild['name'] === 'estimate_type' && feild['value'] == 1) {
                basicSumInsuredSchema.map((feild, key) => {
                    if (feild.name === 'ins_room_eligible_ward' && feild.type && feild.type === 'group') {
                        let { data } = feild;
                        data.map((sub_feild, sub_key) => {
                            if (sub_feild.name === 'ins_room_eligible_ward_amount') {
                                room_opted_amount = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                        })
                    }
                })
            }
        })
        console.log(basicSumInsuredSchema);
        if (InsuranceDetailsSchema[11]['value'] == 2) {
            if (InsuranceDetailsSchema[12]['value'] == 1) {
               
                let table_data = excludesTableStore.getState();
                if(table_data.length==0){
                    exludesiders && exludesiders.length>0 && exludesiders.map((item,index)=>{
                        item['service_id']=item.service
                    })
                    excludes_data=exludesiders?exludesiders:[]
                }else{
                    table_data && table_data.length>0 && table_data.map((body, key) => {
                        let obj = {
                            "package_id": null,
                            "service_id": null,
                            "service_name": null,
                            "qty": 0,
                            "rate": 0,
                            "amount": 0
                        }

                        body['feilds'].map((feild, feild_key) => {

                            if (feild.name === 'excludes_service_id') {
                               
                                        obj = {
                                            "package_id": feild.package_id ? feild.package_id : null,
                                            "service_id": feild.value ? feild.value : null,
                                            "service_name": feild.text ?feild.text: null,
                                        }

                            }
                            if (feild.name === 'qty') {
                                obj[feild.name] = feild.value;
                            }
                            if (feild.name === 'rate') {
                                obj[feild.name] = feild.value;

                            }
                            if (feild.name === 'amount') {
                                obj[feild.name] = feild.value;
                            }

                        })
                        excludes_data.push(obj);
                    })  
                }
               
              
                if (includes_data.length > 0) {
                    includes_data = includes_data;
                } else {
                    includes_data = [];
                    excludes_data = [];
                }

            } else {
                includes_data = [];
                excludes_data = [];
            }

        }
        else {
            includes_data = [];
            excludes_data = [];
        }
        console.log('manifs', basicSumInsuredSchema)
        let formFeilds = InsuranceDetailsSchema;
        let est = estimateBreakupFormatSchema;
        let basicsuminsure = basicSumInsuredSchema;
        let error1 = this.validateModalFeilds(formFeilds)
        let inerror1 = [];
        let basicerror3 = [];
        let esterror2 = [];
        let ailmenterror4 = [];
        if (error1.length > 0) {
            this.setState({ Insuranceerrors: error1 })
            error1.map((item) => {
                inerror1.push(item[false]);
            });
        } else {
            inerror1.push(true);
            this.setState({ Insuranceerrors: [] })
        }
        let error2 = this.validateModalFeilds(est)
        if (error2.length > 0) {
            this.setState({ esterrors: error2 })
            error2.map((item) => {
                esterror2.push(item[false]);
            });
        } else {
            esterror2.push(true);
            this.setState({ esterrors: [] })
        }
        let error3 = this.validateModalFeilds(basicsuminsure);
        if (error3.length > 0) {
            this.setState({ basicsuminsureerrors: error3 })
            error3.map((item) => {
                basicerror3.push(item[false]);
            });
        } else {
            basicerror3.push(true);
            this.setState({ basicsuminsureerrors: [] })
        }
        let error4 = this.validateailment(ailmentSchema);
        if (error4.length > 0) {
            this.setState({ ailmenteerrors: error4 })
            error4.map((item) => {
                ailmenterror4.push(item[false]);
            });
        } else {
            ailmenterror4.push(true);
            this.setState({ ailmenteerrors: [] })
        }
        if (esterror2.includes(false)) {
            document.getElementById("wizard").scrollToBottom = 0;
        }
        if (ailmenterror4.includes(false)) {
            document.getElementById("wizard").scrollTop = 950;
        }
        if (basicerror3.includes(false)) {
            document.getElementById("wizard").scrollTop = 524;
        }
        if (inerror1.includes(false)) {
            document.getElementById("wizard").scrollTop = 0;
        }
        // if(error3.includes(false)){
        //     document.getElementById("wizard").scrollTop=600;
        // }
        let error5 = this.validateModalFeilds(signatureSchema["feilds"])
        let signError = []
        if (error5.length > 0) {
            error5.map((item) => {
                signError.push(item[false]);
            });
        } else {
            signError.push(true);
        }
        if (signError.includes(false)) {
            document.getElementById("wizard").scrollToBottom = 0;
        }

        let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified'));
        let rnTypeResponse = JSON.parse(Storage.get('counselling_view'));
        let payerResponse=null
        if(rnTypeResponse&&rnTypeResponse.length!==0){
            payerResponse = rnTypeResponse[0].rn_payer_response;
        } else {
            payerResponse = null;
        }
        let data = {
            "fc_checklist_verified": patientCheckIn,
            "counselling_date": basic_info['counselling_date'],
            "token_no": basic_info['token_no'],
            "token_display_number": basic_info['token_display_number'],
            "counselling_type_id": basic_info['counselling_type_id'],
            "counsellor_id": basic_info['counsellor_id'],
            "ip_no": basic_info['ip_no'],
            "umr_no": basic_info['umr_no'],
            "patient_name": basic_info['patient_name'],
            "age": basic_info['age'],
            "gender": basic_info['gender'],
            "phone_no": basic_info['phone_no'],
            "marital_status": basic_info['marital_status'],
            "doctor_id": basic_info['doctor_id'],
            "speciality_id": basic_info['speciality_id'],
            "address": basic_info['address'],
            "payment_type": basic_info['payment_type'],
            "comments_data": basic_info['comments_data'],
            "service_id": basic_info['service_id'],
            "form_id": basic_info['form_id'],
            "payment_change_reason": basic_info['payment_change_reason'],
            "counselling_type_name": basic_info['counselling_type_name'],
            "doctor_name": basic_info['doctor_name'],
            "speciality_name": basic_info['speciality_name'],
            "payment_name": basic_info['payment_name'],
            // "whatsapp_phno":basic_info['whatsapp_number'],

            "e_date_of_admission": InsuranceDetailsSchema[0]['value'] ? InsuranceDetailsSchema[0]['value'] : InsuranceDetailsSchema[0]['text'],
            "actual_admission_date": InsuranceDetailsSchema[1]['value'] ? InsuranceDetailsSchema[1]['value'] : null,
            "diagnosis": InsuranceDetailsSchema[2]['value'],
            "type_of_patient": InsuranceDetailsSchema[3]['value'],
            "type_of_insurance": InsuranceDetailsSchema[4]['value'],
            "insurance_status": InsuranceDetailsSchema[5]['value'] ? InsuranceDetailsSchema[5]['value'].toString() : '',
            "insurance_status_name": InsuranceDetailsSchema[5]['text'],
            "insurance_denied_reason": InsuranceDetailsSchema[6]['value'],
            "tpa_name": InsuranceDetailsSchema[7]['text'],
            "insurance_company": InsuranceDetailsSchema[8]['value'] ? InsuranceDetailsSchema[8]['value'].toString() : '',
            "insurance_company_name": InsuranceDetailsSchema[8]['text'],
            "policy_number": InsuranceDetailsSchema[9]['value'],
            "corporate_name": InsuranceDetailsSchema[10]['value'],
            "care_management": InsuranceDetailsSchema[11]['value'] ? InsuranceDetailsSchema[11]['value'].toString() : '',
            "care_management_name": InsuranceDetailsSchema[11]['text'],
            "estimate_type": InsuranceDetailsSchema[12]['value'],
            "estimate_type_name": InsuranceDetailsSchema[12]['text'],
            "surgery_name": InsuranceDetailsSchema[14]['text'],
            "date_of_surgery": InsuranceDetailsSchema[13]['value'],
            "surgery_procedure_name": InsuranceDetailsSchema[14]['value'] ? parseInt(InsuranceDetailsSchema[14]['value']) : null,
            "surgery_procedure_id": InsuranceDetailsSchema[14]['value'],
            "surgery_procedure_amount": InsuranceDetailsSchema[15]['value'],
            "surgery_procedure_percent": InsuranceDetailsSchema[16]['value'],
            "package_name": InsuranceDetailsSchema[17]['text'],
            "package_id": InsuranceDetailsSchema[17]['value'],
            "package_amt": inital_package_amount,


            "icu_stay": InsuranceDetailsSchema[18]['value'],
            "room_stay": InsuranceDetailsSchema[19]['value'],
            "length_of_stay": InsuranceDetailsSchema[20]['value'] ? InsuranceDetailsSchema[20]['value'].toString() : '',
            // "date_of_surgery": InsuranceDetailsSchema[17]['value'],
            // "surgery_procedure_name": InsuranceDetailsSchema[18]['value'] ? parseInt(InsuranceDetailsSchema[18]['value']) : null,
            // "surgery_procedure_id": InsuranceDetailsSchema[17]['value'],
            // "surgery_procedure_amount": InsuranceDetailsSchema[19]['value'],
            // "surgery_procedure_percent": InsuranceDetailsSchema[20]['value'],

            "basic_sum_insured": basicSumInsuredSchema[0]['value'],
            "buffer_top_up": basicSumInsuredSchema[1]['value'],
            "balance_sum_insured": basicSumInsuredSchema[2]['value'],
            "copay_percent": basicSumInsuredSchema[3]['data'][0]['value'],
            // "copay_amount": basicSumInsuredSchema[3]['data'][1]['value'],
            "room_eligible_percent": basicSumInsuredSchema[4]['data'][0]['value'],
            "room_eligible_amount": basicSumInsuredSchema[4]['data'][1]['value'],
            "room_eligible_ward": basicSumInsuredSchema[5]['data'][0]['value'],
            "room_eligible_ward_name": basicSumInsuredSchema[5]['data'][0]['text'],
            "package_amount": basicSumInsuredSchema[5]['data'][0]['package_charges'],
            "room_eligible_ward_amount": basicSumInsuredSchema[5]['data'][1]['value'] ? basicSumInsuredSchema[5]['data'][1]['value'].toString() : '',
            "upgrade_room": basicSumInsuredSchema[6]['data'][0]['value'] ? basicSumInsuredSchema[6]['data'][0]['value'].toString() : '',
            "upgrade_room_name": basicSumInsuredSchema[6]['data'][0]['text'],
            "upgrade_room_amount": basicSumInsuredSchema[6]['data'][1]['value'],
            "room_upgrade_reason": basicSumInsuredSchema[7]['value'] ? basicSumInsuredSchema[7]['value'].toString() : '',
            "room_upgrade_reason_name": basicSumInsuredSchema[7]['text'],
            "icu_eligible_percent": basicSumInsuredSchema[8]['data'][0]['value'],
            "icu_eligible_amount": basicSumInsuredSchema[8]['data'][1]['value'],
            "icu_ward": basicSumInsuredSchema[9]['data'][0]['value'] ? basicSumInsuredSchema[9]['data'][0]['value'].toString() : '',
            "icu_ward_name": basicSumInsuredSchema[9]['data'][0]['text'],
            // "icu_ward_id": basicSumInsuredSchema[9]['data'][0]['value']?basicSumInsuredSchema[9]['data'][0]['value'].toString():'',
            "icu_ward_amt": basicSumInsuredSchema[9]['data'][1]['value'],
            "icu_difference_amt": basicSumInsuredSchema[10]['value'],
            "room_differance": basicSumInsuredSchema[12]['value'],
            "pro_rata_differance": basicSumInsuredSchema[13]['value'],
            "ailment_capping_status": basicSumInsuredSchema[15]['value'] ? parseInt(basicSumInsuredSchema[15]['value']) : '',
            "ailment_capping_amount": this.state.ailment_capping_amount,
            "ailment_capping_status_name": basicSumInsuredSchema[15]['text'],
            "sum_insured_four_years_back": sum_insured_four_years_back,
            "consider_si_four_years_back": consider_si_four_years_back,

            "additional_packages": additional_packages,
            "additional_procedures": additional_procedures,
            "nmes_data": nmedata,
            // "pre_existing_condition": pre_existing_condition,
            // "interm_approval": interm_approval,
            "ailment_capping": ailment,
            "interm_approval": interim,
            "pre_existing_condition": pre_ex_conditions,
            "excludes_data": excludes_data,
            "includes_data": includes_data,
            "base_price": estimateBreakupFormatSchema[0]['value'],
            "excludes": estimateBreakupFormatSchema[1]['value'],
            "initial_approval_amount": estimateBreakupFormatSchema[2]['value'],
            "copay_amount": estimateBreakupFormatSchema[3]['value'],
            "nme_amount": estimateBreakupFormatSchema[4]['value'],
            "actual_nme_amount": estimateBreakupFormatSchema[5]['value'],
            "final_bill_amount": estimateBreakupFormatSchema[6]['value'],
            "discount": estimateBreakupFormatSchema[7]['value'],
            "final_approval": estimateBreakupFormatSchema[8]['value'],
            "extra_deduction": estimateBreakupFormatSchema[9]['value'],
            "remarks": estimateBreakupFormatSchema[10]['value'],
            "differance_amount": estimateBreakupFormatSchema[11]['value'],
            // "total_Estimate_amount": this.state.total_estimate_amount,
            //estimateBreakupFormatSchema[11]['value'],
            //  "total_Estimate_amount": this.state.total_estimate_amount,
            "total_Estimate_amount": estimateBreakupFormatSchema[12]['value'],
            "signature_of": estimateBreakupFormatSchema[13]['value'],
            "attendant_name": estimateBreakupFormatSchema[14]['value'],
            "patient_relation": estimateBreakupFormatSchema[15]['value'],
            "name_of_the_fc": JSON.parse(localStorage.getItem('user')),
            "patient_attender_signature": null,
            "counsellor_signature": null,
            "covid_status":basic_info['covid_status']?basic_info['covid_status']:null,
            "rn_payer_response": payerResponse || null,

            "header_amount": {
                "room_charges": addonSchema[0]['header_amount'],
                "room_investigation_charges": addonSchema[1]['header_amount'],
                "icu_investigation_charges": addonSchema[2]['header_amount'],
                "ip_pharmacy_charges": addonSchema[3]['header_amount'],
                "icu_pharmacy_charges": addonSchema[4]['header_amount'],
                "ot_cath_pharmacy": addonSchema[5]['header_amount'],
                "drug_admin_charges": 0,
                "general_equipment_charges": addonSchema[6]['header_amount'],
                "ot_charges": addonSchema[7]['header_amount'],
                "ot_equipment": addonSchema[8]['header_amount'],
                "procedure_charges": addonSchema[9]['header_amount'],
                "blood_bank_charges": addonSchema[10]['header_amount'],
                "cross_consultation_charges": addonSchema[11]['header_amount'],
                "hospital_services": addonSchema[12]['header_amount'],
                "isolation_charges": addonSchema[13]['header_amount'],
                "physiotherapy_diet_charges": addonSchema[14]['header_amount'],
                "surgical_charges": addonSchema[15]['header_amount'],
                "medical_charges": addonSchema[16]['header_amount']
            },
            "estimation": estimate_data,
            "isGenerateSign": isGenerateSign,
            "generatedLink": generatedLink,
        };
        let estimationPreview = JSON.stringify(data);
        console.log('Preview_Insurance', estimationPreview);
        let obj = {
            "patient_name": basic_info['patient_name'],
            "phone_no": basic_info['phone_no'],
            "digital_sig_number": basic_info['phone_no'],
            "digital_sig_weblink": generatedLink,
            "token_id": basic_info['token_no'],
            "preview_data": estimationPreview
        }
        // signatureSchema.map((feild, fei_key) => {
        //     if(feild["name"] === "phonenumber"){
        //         obj["digital_sig_number"] = feild["value"]
        //     }
        // })
        // console.log("api_sendLink obj", obj);
        // return
        postService(sendDigitalSignLink, "POST", {data: obj}).then(res => {
            if(res.status){
                Modal.success({
                    title: 'Success message',
                    content: res.message ? res.message : 'Sent Link Successfully',
                });
            }else{
                Modal.success({
                    title: 'Error message',
                    content: res.message ? res.message : '',
                }); 
            }
        })
    }

    getDigitalSign = (type) => {
        let {basic_info} = this.props
        //let {generatedLink, signatureSchema, } = this.state
        let {generatedLink, signatureSchema, digital_sig_imgpath, patient_digsign_willing} = this.state;
        let obj = {
            "patient_name": basic_info['patient_name'],
            "phone_no": basic_info['phone_no'],
            "digital_sig_number": basic_info['phone_no'],
            "digital_sig_weblink": generatedLink,
            "token_id": basic_info['token_no'],
        }
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                obj["digital_sig_number"] = feild["value"]
            }
        })
        // console.log("getDigitalSign obj", obj);
        // return
        postService(getDigitalSignInfoByToken, "POST", {data: obj}).then(res => {
            if(res.status){
                if(res.data && res.data.length){
                    if(type === "refresh"){
                        if (generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing === true) {
                            this.handleCheckboxChange();
                        }
                        this.setState({digital_sig_imgpath: res.data[0]["digital_sig_imgpath"]})
                    }else if(type === "preview"){
                        this.setState({digital_sig_imgpath: res.data[0]["digital_sig_imgpath"], patient_digsign_willing: res.data[0]["patient_digsign_willing"] === 'yes'}, () => this.Preview())
                    }
                }
            }
        })
    }

    onChange = (event) => {
        const {signatureSchema} = this.state;
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                signatureSchema[fei_key]["value"] = event.target.value
            }
        })
        this.setState({signatureSchema})
    }

    previewAttachments = (file) => {
        this.setState({isPreviewAttachments: true, previewFile: file})
    }

    validateMobileNumber = (number) => {
        const mobilePattern = /^\d{10}$/; // Matches a 10-digit number
        
        return mobilePattern.test(number);
    };

    onChangeGenerateSign = (event) => {
        let {preview_data, generatedLink, signatureSchema,} = this.state
        let errors = [];

        signatureSchema.map((feild, key) => {
            if (feild['name'] === 'phonenumber') {
                signatureSchema[key]['errors'] = [];
                feild.rules.map((rule, rkey) => {
                    if (feild['value'] === null || feild['value'] === "") {
                        signatureSchema[key]['errors'].push({ 'message': rule.message });
                        errors.push(false);
                    }else {
                        signatureSchema[key]['errors'] = [];
                        let isvalid = this.validateMobileNumber(feild['value'])
                        if(!isvalid){
                            errors.push(false);
                            signatureSchema[key]['errors'].push({ 'message': "Please Enter Valid Phone Number" });
                        }
                    }
                })
            }
        })
        if(!errors.includes(false)){
            this.setState({isGenerateSign: event, signatureModal: false}, () => this.final_submit())
        }
        this.setState((state) => ({ signatureSchema: signatureSchema }));
    }

    // handleCheckboxChange = () => {
    //     let { basic_info } = this.props;
    //     console.log('check', basic_info);
    //     const { patient_digsign_willing } = this.state;
    //     console.log('check2', patient_digsign_willing);
    //     const patientWilling = patient_digsign_willing ? 'no' : 'yes';
    //     this.setState(
    //         { patient_digsign_willing: !patient_digsign_willing, errorMessage: '' },
    //         () => {
    //           postService('getPatientWilling', 'POST', {
    //             data: { "token_id": basic_info['token_no'], "patient_digsign_willing": patientWilling }
    //           })
    //             .then((response) => {
    //                 // if(patientWilling === 'yes'){
    //                     let This=this
    //                     const id = `insurancePreview`;
    //                     const input = document.getElementById(id);
    //                     let digiSignPhone;
    //                     console.log('PDF:::::', this.state, signatureSchema);
    //                     signatureSchema.map((feild, fei_key) => {
    //                         if(feild["name"] === "phonenumber"){
    //                             digiSignPhone = feild["value"]
    //                             console.log('PHONE:::', digiSignPhone);
    //                             //payload["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] : null
    //                         }
    //                     })
    //                     console.log("input=======",input);
    //                     if(input !==null && input !=='' && input !==undefined) {
    //                         console.log("input12212++++++++++",input)
    //                         html2PDF(input, {   
    //                             image: { type: 'png', quality: 0.20 },
    //                             jsPDF: { format: 'a4', },
    //                             html2canvas: {
    //                                 scrollX: 0,
    //                                 scrollY: -window.scrollY,
    //                                 useCORS: true,
    //                             },
    //                             imageType: 'image/jpeg',
    //                             output: './images/generate.pdf',
    //                             success: function(pdf) {
    //                                 const blob = pdf.output('blob');
    //                                 // const blob2 = pdf.output('blob');
    //                                 const form_data = new FormData();
    //                                 console.log("input++++++++++",input)
    //                                 form_data.append('upfile', blob);
    //                                 form_data.append("umr", basic_info['umr_no']);
    //                                 // form_data.append("phone_no",basic_info['phone_no']);
    //                                 //form_data.append("counselling_id", counselling_id);
    //                                 form_data.append("doctor_name", basic_info['doctor_name']);
    //                                 form_data.append("patient_name",basic_info['patient_name']);
    //                                 //form_data.append("counselling_date",basic_info['counselling_date']);
    //                                 //form_data.append("speciality_id", basic_info['speciality_id']);
    //                                 //form_data.append("is_digital_sig_required", isGenerateSign);
    //                                 form_data.append("phone_no", 9985769433);
    //                                 form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))
            
    //                                 formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
    //                                     if (res.status) {
    //                                     localStorage.setItem('completed_counselling_date',moment());
    //                                     console.log("input+-+-+-+-",);  
    //                                     //This.props.next();
    //                                         This.setState({ loadding: false });
    //                                         console.log("input!!!!!!!!");
    //                                         // Modal.success({
    //                                         //     title: `success`,
    //                                         //     content: `${res.message}`,
    //                                         //     zIndex: '1022'
    //                                         // });
    //                                 }
    //                             });
    //                                 // pdf.save(this.output);
    //                             }
    //                         });
    //                     }
    //                 // }
    //             })
    //             .catch((error) => {
    //               // Handle any errors that occur during the POST request
    //               console.error('POST request error', error);
    //             });
          
    //           if (!patient_digsign_willing) {
    //             this.setState({ otp: Array(this.props.length).fill('') });
    //           }
    //         }
    //       );
    //   };
    handleCheckboxChange = () => {
    let { basic_info } = this.props;
    console.log('check', basic_info);
    const { patient_digsign_willing, signatureSchema} = this.state;
    console.log('check2', patient_digsign_willing);
    const patientWilling = patient_digsign_willing ? 'no' : 'yes';
  
this.setState(
    { patient_digsign_willing: !patient_digsign_willing, errorMessage: '', otpSent: false},
    () => {
      postService('getPatientWilling', 'POST', {
        data: { "token_id": basic_info['token_no'], "patient_digsign_willing": patientWilling }
      })
        .then((response) => {
            if(patientWilling === 'yes'){
                console.log('digiSignPhone:::::', patientWilling);
            let This=this
            const id = `insurancePreview`;
            const input = document.getElementById(id);
            let digiSignPhone;
                signatureSchema.forEach((field, fei_key) => {
                    if (field.name === "phonenumber") {
                        digiSignPhone = field.value;
                    }
                });
            let speciality_id = this.state.preview_data.speciality_id;
            if(input !==null && input !=='' && input !==undefined) {
                html2PDF(input, {   
                    image: { type: 'png', quality: 0.20 },
                    jsPDF: { format: 'a4', },
                    html2canvas: {
                        scrollX: 0,
                        scrollY: -window.scrollY,
                        useCORS: true,
                    },
                    imageType: 'image/jpeg',
                    output: './images/generate.pdf',
                    success: function(pdf) {
                        const blob = pdf.output('blob');
                        // const blob2 = pdf.output('blob');
                        const form_data = new FormData();
                        console.log("input++++++++++",input)
                        form_data.append('upfile', blob);
                        form_data.append("umr", basic_info['umr_no']);
                        // form_data.append("phone_no",basic_info['phone_no']);
                        //form_data.append("counselling_id", counselling_id);
                        form_data.append("doctor_name", basic_info['doctor_name']);
                        form_data.append("patient_name",basic_info['patient_name']);
                        //form_data.append("counselling_date",basic_info['counselling_date']);
                        form_data.append("speciality_id", speciality_id);
                        //form_data.append("is_digital_sig_required", isGenerateSign);
                        form_data.append("phone_no", digiSignPhone);
                        form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                        formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
                            if (res.status) {
                            localStorage.setItem('completed_counselling_date',moment());
                            console.log("input+-+-+-+-",);    
                            //This.props.next();
                                This.setState({ loadding: false });
                                console.log("input!!!!!!!!");
                                // Modal.success({
                                //     title: `success`,
                                //     content: `${res.message}`,
                                //     zIndex: '1022'
                                // });
                        }
                    });
                        // pdf.save(this.output);
                    }
                });
            }
        }
          // Handle the response from the POST request
          console.log('POST request successful', response);
          // Add further code to handle the response data
        })
        .catch((error) => {
          // Handle any errors that occur during the POST request
          console.error('POST request error', error);
        });
  
      if (!patient_digsign_willing) {
        this.setState({ otp: Array(this.props.length).fill('') });
      }
    }
  );
  
  };

      roundAmount(amount) {

        if (amount < 50) {
          return Math.floor(amount / 100) * 100;
        } else {
          return Math.round(amount / 100) * 100;
        }
      }
          
  ///////
  handleChangeOTP = (index, value) => {
    const newOTP = [...this.state.otp];
    console.log('OTP::::::', newOTP);
    newOTP[index] = value;
    this.setState({ otp: newOTP, errorMessage: ''}, () =>{
        this.handleValidate();
    });
  };

// handleValidate = () => {
//     try {
//         // Get the encrypted OTP from localStorage
//         const encryptedOtp = localStorage.getItem('encryptedOtp');
//         if (!encryptedOtp) {
//             // Handle error if encrypted OTP is not found in localStorage
//             console.error('Encrypted OTP not found in localStorage');
//             return;
//         }
//         // Join the OTP digits array into a single string
//         const userEnteredOtp = this.state.otp.join("");
//         console.log(userEnteredOtp.length);
//         // Compare the user's entered OTP with the encrypted OTP stored in localStorage
//         let isOtpCorrect = bcrypt.compareSync(userEnteredOtp, encryptedOtp);
//         if (isOtpCorrect) {
//             // If OTP is correct, display success message or perform further actions
//             console.log("OTP is correct");
//             Modal.success({
//                 title: 'Success message',
//                 content: 'OTP Validated Successfully.'
//             })
//             this.setState({ errorMessage: '',showButtons: true, showInputFeilds: false, showLinks: true});
//         } else {
//             if(!isOtpCorrect){
//                 this.setState({ errorMessage: 'Invalid OTP. Please try again.', showButtons: false});
//             console.log("OTP is incorrect");
//             }else{
//                 this.setState({ errorMessage: '', showButtons: false});
//                 console.log("OTP is incorrect");
//             }
           
//         }
//     } catch (error) {
//         console.log(error);
//     }
// };
handleValidate = () => {
    try {
        let { counselling_details,basic_info } = this.props;
        let { signatureSchema } = this.state;
        // Get the encrypted OTP from localStorage
        const encryptedOtp = localStorage.getItem('encryptedOtp');
        if (!encryptedOtp) {
            // Handle error if encrypted OTP is not found in localStorage
            console.error('Encrypted OTP not found in localStorage');
            return;
        }
        // Join the OTP digits array into a single string
        const userEnteredOtp = this.state.otp.join("");
        console.log(userEnteredOtp.length);
        // Compare the user's entered OTP with the encrypted OTP stored in localStorage
        let isOtpCorrect = bcrypt.compareSync(userEnteredOtp, encryptedOtp);
        if (isOtpCorrect) {
            let ID = localStorage.getItem('otpid');
                    let payload = {
            "token_id": this.props.basic_info.token_no,
            "umr": this.props.basic_info.umr_no,
            "resId": ID,
            "create_date": moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        };
            postService('generateOTP', 'POST', { "data": payload }).then(res => {
                if (res.status) {
                    let createdDate = res.created_date;
                    Modal.success({
                        title: 'Success message',
                        content: 'OTP Validated Successfully.'
                    })
                    this.setState({ errorMessage: '',showButtons: true, showInputFeilds: false, showLinks: true, patient_validate: true,createdDate});
                                    let This=this
                const id = `insurancePreview`;
                const input = document.getElementById(id);
                let digiSignPhone;
                signatureSchema.map((feild, fei_key) => {
                    if(feild["name"] === "phonenumber"){
                        digiSignPhone = feild["value"]
                        //payload["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] : null
                    }
                })
                console.log("input=======",input);
                let speciality_id = this.state.preview_data.speciality_id;
                if(input !==null && input !=='' && input !==undefined){
                    console.log("input12212++++++++++",input)
                    html2PDF(input, {   
                        image: { type: 'png', quality: 0.20 },
                        jsPDF: { format: 'a4', },
                        html2canvas: {
                            scrollX: 0,
                            scrollY: -window.scrollY,
                            useCORS: true,
                        },
                        imageType: 'image/jpeg',
                        output: './images/generate.pdf',
                        success: function(pdf) {
                            const blob = pdf.output('blob');
                            // const blob2 = pdf.output('blob');
                            const form_data = new FormData();
                            console.log("input++++++++++",input)
                            form_data.append('upfile', blob);
                            form_data.append("umr", basic_info['umr_no']);
                            // form_data.append("phone_no",basic_info['phone_no']);
                            //form_data.append("counselling_id", counselling_id);
                            form_data.append("doctor_name", basic_info['doctor_name']);
                            form_data.append("patient_name",basic_info['patient_name']);
                            //form_data.append("counselling_date",basic_info['counselling_date']);
                            form_data.append("speciality_id",speciality_id);
                            //form_data.append("is_digital_sig_required", isGenerateSign);
                            form_data.append("phone_no", digiSignPhone);
                            form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                            formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
                                if (res.status) {
                                localStorage.setItem('completed_counselling_date',moment());
                                console.log("input+-+-+-+-",);    
                                //This.props.next();
                                    This.setState({ loadding: false });
                                    console.log("input!!!!!!!!");
                                    // Modal.success({
                                    //     title: `success`,
                                    //     content: `${res.message}`,
                                    //     zIndex: '1022'
                                    // });
                            }
                        });
                            // pdf.save(this.output);
                        }
                    });
                }
                    localStorage.removeItem('encryptedOtp');
                    localStorage.removeItem('otpid');
                } else {
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
            // Modal.success({
            //     title: 'Success message',
            //     content: 'OTP Validated Successfully.'
            // })
            // this.setState({ errorMessage: '',showButtons: true, showInputFeilds: false, showLinks: true});
        } else {
            if(!isOtpCorrect){
                this.setState({ errorMessage: 'Invalid OTP. Please try again.', showButtons: false});
            console.log("OTP is incorrect");
            }else{
                this.setState({ errorMessage: '', showButtons: false});
                console.log("OTP is incorrect");
            }
           
        }
    } catch (error) {
        console.log(error);
    }
};

getOtp = () => {
    try {
        let { counselling_details,basic_info } = this.props;
        let { signatureSchema } = this.state;
        console.log('PROPSSSS::::::', this.props);
        let payload = {
            "token_id": this.props.basic_info.token_no,
            "umr": this.props.basic_info.umr_no,
            "ip_no": this.props.basic_info.ip_no,
            "phone_number": this.props.basic_info.phone_no,
            "resId": null
        };
        postService('generateOTP', 'POST', { "data": payload }).then(res => {
            if (res.status) {
                console.log('Response:', res);
                localStorage.setItem('encryptedOtp', res.encryptedOtp);
                localStorage.setItem('otpid', res.patientOTPforValidationRes.insertedId);
                this.setState({showInputFeilds: true, otpLink: true, loading: false, otpSent: true});
                Modal.success({
                    title: 'Success message',
                    content: 'OTP Send Successfully.'
                })

                // let This=this
                // const id = `insurancePreview`;
                // const input = document.getElementById(id);
                // let digiSignPhone;
                // signatureSchema.map((feild, fei_key) => {
                //     if(feild["name"] === "phonenumber"){
                //         digiSignPhone = feild["value"]
                //         //payload["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] : null
                //     }
                // })
                // console.log("input=======",input);
                // if(input !==null && input !=='' && input !==undefined){
                //     console.log("input12212++++++++++",input)
                //     html2PDF(input, {   
                //         image: { type: 'png', quality: 0.20 },
                //         jsPDF: { format: 'a4', },
                //         html2canvas: {
                //             scrollX: 0,
                //             scrollY: -window.scrollY,
                //             useCORS: true,
                //         },
                //         imageType: 'image/jpeg',
                //         output: './images/generate.pdf',
                //         success: function(pdf) {
                //             const blob = pdf.output('blob');
                //             // const blob2 = pdf.output('blob');
                //             const form_data = new FormData();
                //             console.log("input++++++++++",input)
                //             form_data.append('upfile', blob);
                //             form_data.append("umr", basic_info['umr_no']);
                //             // form_data.append("phone_no",basic_info['phone_no']);
                //             //form_data.append("counselling_id", counselling_id);
                //             form_data.append("doctor_name", basic_info['doctor_name']);
                //             form_data.append("patient_name",basic_info['patient_name']);
                //             //form_data.append("counselling_date",basic_info['counselling_date']);
                //             //form_data.append("speciality_id", basic_info['speciality_id']);
                //             //form_data.append("is_digital_sig_required", isGenerateSign);
                //             form_data.append("phone_no", digiSignPhone);
                //             form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                //             formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
                //                 if (res.status) {
                //                 localStorage.setItem('completed_counselling_date',moment());
                //                 console.log("input+-+-+-+-",);    
                //                 //This.props.next();
                //                     This.setState({ loadding: false });
                //                     console.log("input!!!!!!!!");
                //                     // Modal.success({
                //                     //     title: `success`,
                //                     //     content: `${res.message}`,
                //                     //     zIndex: '1022'
                //                     // });
                //             }
                //         });
                //             // pdf.save(this.output);
                //         }
                //     });
                // }
                // Enable checkbox after 2 minutes
                // setTimeout(() => {
                //     this.setState({ checkboxDisabled: true });
                // }, 120000);
                this.timeoutId = setTimeout(() => {
                    this.setState({ checkboxDisabled: true });
                }, 120000);
            } else {
                Modal.error({
                    title: 'Error message',
                    content: `${res.message}`,
                });
            }
        });
    } catch (error) {
        console.log(error);
    }
};

cancelOperation = () => {
    if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null; // Reset the timeout ID
    }
    this.setState({
        preview_modal: false,
        preview_PatientCheckin_model: false,
        errorMessage: '',
        otp: Array(this.props.length).fill(''),
        showInputFeilds: false,
        showButtons: false,
        patient_digsign_willing: false,
        showLinks: false,
        otpLink: false,
        otpSent: false,
        patient_validate: false,
        checkboxDisabled: false
    });
};
    render() {
        let nmeValueInfo = this.context;
        console.log('nmeValueInfo', nmeValueInfo)
        let { addonSchema, InsuranceDetailsSchema, estimateBreakupFormatSchema, interimSchema, additionalProcedureSchema, additionalPackageSchema, total_estimate_amount,
            preexistingConditionsSchema, basicSumInsuredSchema, ailmentSchema, showPreExConditions, showAilment, img, img2, view_mode, showPackage, showAddprocedure, loadding, showEstimate, hideingEstimatbutton, preview_modal, preview_PatientCheckin_model,preview_data, fc1_total_estimate_amount, isPreviewAttachments, previewFile, signatureModal, signatureSchema, generatedLink, digital_sig_imgpath,patient_digsign_willing,enableCheckBox, patient_validate, checkboxDisabled} = this.state;
        console.log('basicSumInsuredSchematt', basicSumInsuredSchema);
        losReduxStore.dispatch({ type: 'LOS_INFO', data: InsuranceDetailsSchema[20].value})
        console.log('CheckBOx', this.state);
        let { slug } = this.props.match.params;
        return (
            <div>
                <Spin spinning={loadding}>
                    {/* {loadding ? <CustomLoader /> : null} */}
                    {/* insurance form */}
                    <div className="card mx-5 mb-5 mt-0">
                        <div className="mx-5 mb-5 mt-4" id="first">
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={InsuranceDetailsSchema} buttonClick={this.buttonClick2.bind(this)} />
                        </div>
                    </div>
                    <div className="card pb-5 m-5">
                        {/* basic sum insured */}
                        <div className='px-5 pt-5'>
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={basicSumInsuredSchema} buttonClick={this.buttonClick3.bind(this)} />
                        </div>
                        {/* ailment */}
                        {showAilment ?
                            <div className="financial-table table-responsive mt-5">
                                {ailmentSchema.map((feild, key) => {
                                    if (feild.visible) {
                                        return (<React.Fragment key={key}>
                                            <div className="d-inline-flex pl-5 w-100">
                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            </div>
                                            <div className="financial-table table-responsive">
                                                <Tableantd form_table={'ailment_capping'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                            : null}
                        {/* additional procedure */}
                        {showAddprocedure ?
                            <div className="financial-table table-responsive mt-5">
                                {additionalProcedureSchema.map((feild, key) => {
                                    if (feild.visible) {
                                        return (<React.Fragment key={key}>
                                            <div className="d-inline-flex pl-5 w-100">
                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            </div>
                                            <div className="financial-table table-responsive">
                                                <Tableantd form_table={'additional_procedures'}  {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                            : null}
                        {/* additional package */}
                        {showPackage ?
                            <div className="financial-table table-responsive mt-5">
                                {additionalPackageSchema.map((feild, key) => {
                                    if (feild.visible) {
                                        return (<React.Fragment key={key}>
                                            <div className="d-inline-flex pl-5 w-100">
                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            </div>
                                            <div className="financial-table table-responsive">
                                                <Tableantd form_table={'additional_packages'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                            </div>
                            : null}
                        {/* pre existing conditions */}
                        {showPreExConditions ? <div className="financial-table table-responsive mt-5">
                            {preexistingConditionsSchema.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex pl-5 w-100">
                                            <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Tableantd {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                        </div>
                            : null}
                        {/* interim  details*/}
                        <div className="financial-table table-responsive mt-5">
                            {interimSchema.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex pl-5 w-100">
                                            <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Tableantd form_table={'interim'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                        </div>

                    </div>
                    {showEstimate && hideingEstimatbutton && slug !== 'view-finanical-counselling' && <div className="row"><button className="btn btn-success mx-auto" onClick={() => { this.loadMore(false) }}>Estimates</button></div>}
                    {/* estimation table */}
                    {showEstimate == false ? <React.Fragment>
                        <div className="card pb-5 m-5">
                            <div className="financial-table table-responsive mt-5">
                                <h1 className="text-center text-capitalize text-heading mb-0">Estimation Breakdown Charges</h1>
                                {addonSchema.map((feild, index) => {
                                    if (feild.visible) {
                                        return (<React.Fragment key={index}>
                                            <div className="d-inline-flex pl-5 w-100">
                                                <h4 className="data-label w-50" style={{ fontSize: 20 }}>{feild.title}</h4>
                                                <h4 className="data-label w-50 text-right mr-3" style={{ fontSize: 20 }}>Rs. {dollarIndianLocale.format(this.roundAmount(feild.header_amount))}</h4>
                                            </div>
                                            <div className="financial-table table-responsive">
                                                <Tableantd {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                            </div>
                                        </React.Fragment>)
                                    }
                                })}
                                <div className="clearfix px-5 total_estimate p-2">
                                    <h4 className="float-left sizeDcress">Total Estimation</h4>
                                    <h4 className="float-right sizeDcress">Rs. {total_estimate_amount !== 0 ? dollarIndianLocale.format(this.roundAmount(total_estimate_amount)) : dollarIndianLocale.format(this.roundAmount(fc1_total_estimate_amount))}</h4>
                                </div>
                            </div>
                        </div>
                    </React.Fragment> : hideingEstimatbutton == false && <React.Fragment>
                        <div className="card pb-5 m-5">
                            <div className="financial-table table-responsive mt-5">
                                <div className="clearfix px-5 total_estimate p-2">
                                    <h4 className="float-left sizeDcress">Total Estimation</h4>
                                    <h4 className="float-right sizeDcress">Rs. {total_estimate_amount !== 0 ? dollarIndianLocale.format(this.roundAmount(total_estimate_amount)) : dollarIndianLocale.format(this.roundAmount(fc1_total_estimate_amount))}</h4>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                    }

                    {/* <div className="card py-3 m-5">
                        <div className="row mx-4">
                            {signatureSchema.map((feild, fei_key) => {
                                if(feild["name"] === "phonenumber"){
                                    return (
                                        <>
                                            <div className='col-3 p-0'>
                                                <label className="data-label w-100 mb-1">{feild["title"]}</label>
                                                <Input value={feild["value"]} maxLength={10} onChange={this.onChange.bind(this)} />
                                                {feild.errors.map((error, eKey) => {
                                                    return (<small key={eKey} className="text-danger">{error.message}</small>);
                                                })}
                                            </div>
                                            <div className='col-8 text-right'>
                                                {feild["value"] 
                                                    ?  <label onClick={this.sendLink.bind(this)} style={{cursor:"pointer"}} className="text-success py-4">Click here to digitally sign the copy & Link will be shared to whatsapp with 15min validity.</label>
                                                    :  <label className="py-4">Click here to digitally sign the copy & Link will be shared to whatsapp with 15min validity.</label>
                                                }
                                            </div>
                                        </>
                                    )
                                }
                            })}
                        </div>
                        <div className='row mx-4'>
                            {generatedLink && <label className="data-label mb-1 pt-2">Signature </label>} 
                            {digital_sig_imgpath 
                                ? <img className='preview_img' alt='sign' src={`${base_url}${digital_sig_imgpath}`}></img>
                                : generatedLink && <i class="fas fa-redo-alt text-success pt-2 mt-1" style={{cursor:"pointer"}} onClick={() => this.getDigitalSign("refresh")} />
                            }
                        </div>
                    </div> */}

                    {/* breakup form */}
                    <div className="card pt-5 pb-5 m-5">
                        <div className="mx-5">
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={estimateBreakupFormatSchema} buttonClick={this.buttonClick4.bind(this)} />
                        </div>
                        <div className="mx-5 pt-4 mt-1">
                            {/* Digital sign and submit*/}
                            {/* <div className="d-flex justify-content-between mx-5 mb-5">
                                <div className="w-25">
                                    {img || view_mode ?
                                        <React.Fragment>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-50 h-50"></img>
                                        </React.Fragment>
                                        : null
                                    }
                                    {view_mode == false && <p className="mb-0 text-capitalize">{this.props.basic_info['patient_name']}</p>}
                                    {view_mode == true && <p className="mb-0 text-capitalize">{this.props.counselling_details['patient_name']}</p>}
                                    <p className="data-label w-100 mb-1">Patient/Attendant Name</p>
                                    {view_mode == false && <button className="btn btn-success text-capitalize" onClick={this.signModal.bind(this)}>Add Sign</button>}
                                </div>
                                <div className="w-25 text-right">
                                    {img2 || view_mode ?
                                        <React.Fragment>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-50 h-50"></img>
                                        </React.Fragment>
                                        : null
                                    }
                                    {view_mode == false && <p className="mb-0">{JSON.parse(localStorage.getItem('user'))}</p>}
                                    {view_mode == true && <p className="mb-0 text-capitalize">{this.props.counselling_details['counseller_name']}</p>}
                                    <p className="data-label w-100 mb-1">Counsellor Name</p>
                                    {view_mode == false && <button className="btn btn-success text-capitalize" onClick={this.sign2Modal.bind(this)}>Add Sign</button>}
                                </div>
                            </div> */}

                            {view_mode == false 
                              ?  <div className="row">
                                    {signatureSchema.map((feild, fei_key) => {
                                        if(feild["name"] === "phonenumber"){
                                            return (
                                                <>
                                                    <div className='col-3 pl-4'>
                                                        <label className="data-label w-100 mb-1">{feild["title"]}</label>
                                                        {/* <Input value={feild["value"]} maxLength={10} onChange={this.onChange.bind(this)} /> */}
                                                        <Input className='h-50' value={feild["value"]} disabled />
                                                        {feild.errors.map((error, eKey) => {
                                                            return (<small key={eKey} className="text-danger">{error.message}</small>);
                                                        })}
                                                    </div>
                                                    {/* <div className='col-9 text-right'>
                                                        {feild["value"] 
                                                            ?  <label onClick={this.sendLink.bind(this)} style={{cursor:"pointer"}} className="text-success py-4">Click here to digitally sign the copy & Link will be shared to whatsapp with 15min validity.</label>
                                                            :  <label className="py-4">Click here to digitally sign the copy & Link will be shared to whatsapp with 15min validity.</label>
                                                        }
                                                    </div> */}
                                                    <div className='col-12'>
                                                        {feild["value"] && generatedLink && <label className="data-label mx-2 mb-1 pt-2">Signature </label>} 
                                                        {digital_sig_imgpath 
                                                            ? <img className='preview_img' alt='sign' src={`${base_url}${digital_sig_imgpath}`}></img>
                                                            : feild["value"] && generatedLink && <i class="fas fa-redo-alt text-success pt-2 mt-1" style={{cursor:"pointer"}} onClick={() => this.getDigitalSign("refresh")} />
                                                        }
                                                    </div>
                                                    {/* <div style={{ position: 'absolute', top: '470px', right: '220px' }}>
                                                        {feild["value"] && generatedLink && digital_sig_imgpath === null &&  (
                                                            <label className="text-success py-4" style={{ marginLeft: '102px' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.patient_digsign_willing}
                                                                    onChange={this.handleCheckboxChange }
                                                                />
                                                                <span style={{ marginLeft: '2px' }}>patient was unwilling/unavailable to sign on digital estimate link</span>
                                                            </label>
                                                        )} 
                                                   </div> */}
                                                   {/* {enableCheckBox && (
                                                        <div style={{ position: 'absolute', top: '470px', right: '220px' }}>
                                                            {feild["value"] && generatedLink && digital_sig_imgpath === null && (
                                                                <label className="text-success py-4" style={{ marginLeft: '102px' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.patient_digsign_willing}
                                                                        onChange={this.handleCheckboxChange}
                                                                    />
                                                                    <span style={{ marginLeft: '2px' }}>patient was unwilling/unavailable to sign on digital estimate link</span>
                                                                </label>
                                                            )}
                                                        </div>
                                                    )} */}
                                                </>
                                            )
                                        }
                                    })}
                                </div>
                              : <div className="row">
                                    {signatureSchema.map((feild, fei_key) => {
                                        if(feild["name"] === "phonenumber"){
                                            return (
                                                <>
                                                    <div className='col-3'>
                                                        <label className="data-label w-80 mb-1">{feild["title"]}</label>
                                                        <Input className='h-50' value={feild["value"]} disabled />
                                                    </div>
                                                </>
                                            )
                                        }
                                    })}
                                </div>
                              }
                        </div>

                        <div className="row justify-content-center mt-4">
                            <button className="btn btn-next px-5 mx-2" onClick={this.previous.bind(this)}>Back</button>
                            {/* {view_mode == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.Preview.bind(this)}>Preview</button>} */}
                            {/* {view_mode == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={() => this.getDigitalSign("preview")}>Preview</button>} */}
                            {view_mode == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={() => this.Preview()}>Preview</button>}
                            {/* {view_mode == false && <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.final_submit.bind(this)}>Save</button>} */}
                            {view_mode && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.next.bind(this)}>Next</button>}
                        </div>
                    </div>

                    {/* patient Sign */}
                    <Modal
                        title="Patient/Attendant  Signature"
                        centered
                        visible={this.state.signModalVisible}
                        onOk={() => this.signsuccess()}
                        onCancel={() => this.signModal(false)}
                        width={1000}
                        zIndex={1012}
                    >

                        <React.Fragment>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-100 h-100"></img>
                        </React.Fragment>
                    </Modal>

                    {/* fc Sign */}
                    <Modal
                        title="Counsellor Signature"
                        centered
                        visible={this.state.signModal2Visible}
                        onOk={() => this.sign2success()}
                        onCancel={() => this.sign2Modal(false)}
                        width={1000}
                        zIndex={1012}
                    >

                        <React.Fragment>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-100 h-100"></img>
                        </React.Fragment>
                    </Modal>
                    <Modal centered visible={this.state.preview_modal} footer={null} width='100%' destroyOnClose={true}>
                        <InsurancePreview insurance_preview_data={preview_data} digital_sig_imgpath={digital_sig_imgpath} new_state_value={patient_validate} created_date={this.state.createdDate} /> 
                        <div className="fc-patient-copy">
                            <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                {/* <button className="btn d-print-none btn-success text-capitalize" onClick={() => { this.final_submit() }}  disabled={this.state.finalSubmit}>Submit</button>
                                <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({ preview_modal: false,preview_PatientCheckin_model:false})}>cancel</button> */}
                                {/* {this.state.showLinks ? null : (
                                            <div>
                                                {this.state.patient_digsign_willing === true ? null : (
                                                <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={() => this.getOtp()}>
                                                    Click here to get OTP & OTP will be shared to whatsapp with 15min validity.
                                                </label>
                                                )}
                                                <label className="text-success py-4" style={{ marginLeft: '102px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.patient_digsign_willing}
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                <span style={{ marginLeft: '2px' }}>patient was unwilling/unavailable to sign on digital estimate link</span>
                                                </label>
                                            </div>
                                            )} */}
                                              {this.state.showLinks ? null : (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {this.state.patient_digsign_willing === true ? null : (
                                                // <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={() => this.getOtp()}>
                                                //     Click here to send the OTP. The OTP will be sent to your registered mobile number.
                                                // </label>
                                                <>
                                                        {this.state.otpSent ? (
                                                            <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={this.getOtp}>
                                                            Click here to Resend OTP.
                                                        </label>
                                                        ) : (
                                                            <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={this.getOtp}>
                                                                Click here to get the OTP. The OTP will be sent to your registered mobile number
                                                            </label>
                                                        )}
                                                    </>
                                                )}
                                                {checkboxDisabled && (
                                                <label className="text-success py-4" style={{ marginLeft: '102px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.patient_digsign_willing}
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                <span style={{ marginLeft: '2px' }}>patient was unwilling or unavailable to receive the OTP.</span>
                                                </label>
                                                )}
                                            </div>
                                            )}
                            </div>
                            {(this.state.patient_digsign_willing === true || this.state.otpLink === true) ? null : (
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.cancelOperation()} 
                                            >
                                                cancel</button>
                                        {/* <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false, otpLink: false, patient_digsign_willing: false,otpSent :false, patient_validate: false,checkboxDisabled: false})} >cancel</button> */}
                                    </div>
                                    )}
                                    {this.state.showInputFeilds && (
                                        <>
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn"> 
                                    {this.state.patient_digsign_willing === true ? null : (
                                    <>
                                    {this.state.otp.map((digit, index) => (
                                        <Input
                                            key={index}
                                            placeholder='Enter OTP'
                                            style={{ width: '140px', marginLeft: '16px', textAlign:'center'}}
                                            maxLength={6}
                                            value={digit}
                                            onChange={(e) => this.handleChangeOTP(index, e.target.value)}
                                            onKeyPress={(e) => {
                                                // Allow only numeric values
                                                const pattern = /^[0-9\b]+$/;
                                                if (!pattern.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    ))}
                                    </>
                                    )}
                                        {/* <button className="btn d-print-none btn-success text-capitalize" disabled={this.state.finalSubmit} onClick={() =>this.handleValidate()}>validate</button> */}
                                    </div>
                                    {this.state.errorMessage && (
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn" style={{ color: 'red', marginTop: '10px' }}>
                                            {this.state.errorMessage}
                                        </div>
                                    )}
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                    {this.state.patient_digsign_willing === true ? null : (
                                        // <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false,otpLink: false, patient_digsign_willing: false,otpSent :false, patient_validate: false,checkboxDisabled: false})} >cancel</button>
                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.cancelOperation()}>cancel</button>
                                    )}
                                    </div>
                                    </>
                                    )}

                        </div>
                        {/* {(this.state.patient_digsign_willing === true || this.state.otpLink === true) ? null : (
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false, otpLink: false, patient_digsign_willing: false})} >cancel</button>
                                    </div>
                                    )}
                                    {this.state.showInputFeilds && (
                                        <>
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn"> 
                                    {this.state.patient_digsign_willing === true ? null : (
                                    <>
                                    {this.state.otp.map((digit, index) => (
                                        <Input
                                            key={index}
                                            placeholder='Enter OTP'
                                            style={{ width: '140px', marginLeft: '16px', textAlign:'center'}}
                                            maxLength={6}
                                            value={digit}
                                            onChange={(e) => this.handleChangeOTP(index, e.target.value)}
                                        />
                                    ))}
                                    </>
                                    )}
                                    </div>
                                    {this.state.errorMessage && (
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn" style={{ color: 'red', marginTop: '10px' }}>
                                            {this.state.errorMessage}
                                        </div>
                                    )}
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                    {this.state.patient_digsign_willing === true ? null : (
                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false,otpLink: false, patient_digsign_willing: false})} >cancel</button>
                                    )}
                                    </div>
                                    </>
                                    )} */}
                                    {/* {(this.state.showButtons || this.state.patient_digsign_willing) && (
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                        <button className="btn d-print-none btn-success text-capitalize" onClick={()=>{this.final_submit()}} disabled={this.state.finalSubmit}>Submit</button>
                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false,otpLink: false, patient_digsign_willing: false})} >cancel</button>
                                    </div>
                                    )} */}
                                    {(this.state.showButtons || this.state.patient_digsign_willing) && (
                                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                        <button className="btn d-print-none btn-success text-capitalize" onClick={()=>{this.final_submit()}} disabled={this.state.finalSubmit}>Submit</button>
                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.cancelOperation()}>
                                            cancel</button>
                                        {/* <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false,otpLink: false, patient_digsign_willing: false,otpSent :false, patient_validate: false,checkboxDisabled: false})} >cancel</button> */}
                                    </div>
                                    )}
                        
                    </Modal>
                    {/* <Modal  footer={null} width='100%' zIndex={1021} destroyOnClose={true}> */}
                    
                                {/* <button className="btn d-print-none btn-success text-capitalize" onClick={()=>{this.preview_submit()}} disabled={this.state.finalSubmit}>Submit</button> */}
                            {/* </Modal> */}
                    {/* Signature modal (to generate link)*/}
                    <Modal
                        title=""
                        centered
                        visible={signatureModal}
                        zIndex={2000}
                        footer={null}
                        bodyStyle={{padding: "30px 50px", backgroundColor:"white"}}
                    >
                        <React.Fragment>
                            <div className="row">
                                <label className=''>Do you need patient digital signature ?</label>
                            </div>
                            <div className="row my-4">
                                {signatureSchema && signatureSchema.map((feild, fei_key) => {
                                    if(feild["name"] === "phonenumber"){
                                        return (
                                            <div className=''>
                                                <label className="data-label w-500 mr-3">{feild["title"]}</label>
                                                <Input type='number' value={feild["value"]} style={{width: "50%"}} maxLength={10} onChange={(e) => this.onChange(e)} />
                                                {feild.errors.map((error, eKey) => {
                                                    return (<small key={eKey} className="text-danger">{error.message}</small>);
                                                })}
                                            </div>
                                        )
                                    }
                                })}
                            </div>
                            <div className="col-12 text-center">
                                <button className="btn btn-success px-3 mr-2" onClick={() => this.onChangeGenerateSign("yes")}>Yes</button>
                                <button className="btn btn-next px-3 mx-2" onClick={() => this.onChangeGenerateSign("no")}>No</button>
                            </div>
                        </React.Fragment>
                    </Modal>
                    <Modal 
                        visible={isPreviewAttachments} 
                        title="" 
                        footer={<div className="row m-0">
                                <div className="col-12 mx-auto text-center">
                                    <button className="btn btn-light mr-3" onClick={() => this.setState({isPreviewAttachments:false})}><i className="far fa-times-circle btn-icon"></i>Close</button>
                                </div>
                            </div>}
                        onCancel={()=>this.setState({isPreviewAttachments:false})}
                    >
                        <img alt="" style={{ width: "100%" }} src={base_url + previewFile} />
                    </Modal>
                </Spin>
            </div>
        )
    }
}

export default Insurance_form;